// ---------- Base File: Core.ts ----------
import "./Calendar.css";
import "./ContentManagement.Article.css";
import "./ContentManagement.Message.css";
import "./Control.css";
import "./Email.Viewer.css";
import "./Images.css";
import "./Markup.css";
import "./Menus.css";
import "./SourceCode.css";
import "./Toolbar.css";
import "./User interface.css";
import "./UserInterface.Icon.css";
import "./Variables.css";
import "./WebApp.ConfirmationWindow.css";
import "./WebApp.LoadingIndicator.css";
import "./WebApp.PopUp.css";
import "./WebApp.Synchronization.Center.css";
import "./WebApp.ToastBox.css";
import "./WebApp.Upload.Center.css";
import "./WebSite.Form.css";
import "./WebSite.Form.Field.BiState.css";
import "./WebSite.Form.Field.Boolean.CheckBox.css";
import "./WebSite.Form.Field.css";
import "./WebSite.Form.Field.Currency.css";
import "./WebSite.Form.Field.Date.css";
import "./WebSite.Form.Field.Date.Period.css";
import "./WebSite.Form.Field.DateTime.Period.css";
import "./WebSite.Form.Field.Expression.css";
import "./WebSite.Form.Field.File_.css";
import "./WebSite.Form.Field.Image.css";
import "./WebSite.Form.Field.Interval.css";
import "./WebSite.Form.Field.Money.css";
import "./WebSite.Form.Field.MultipleSelect.Buttons.css";
import "./WebSite.Form.Field.MultipleSelect.DropDown.css";
import "./WebSite.Form.Field.Options.DropDown.css";
import "./WebSite.Form.Field.Options.SegmentedButton.css";
import "./WebSite.Form.Field.Password.css";
import "./WebSite.Form.Field.Percentage.css";
import "./WebSite.Form.Field.Period.css";
import "./WebSite.Form.Field.RecordSet.css";
import "./WebSite.Form.Field.RecordSet.List.css";
import "./WebSite.Form.Field.Signature.css";
import "./WebSite.Form.Field.StructuredDocument.css";
import "./WebSite.Form.Field.Suggest.css";
import "./WebSite.Form.Field.Text.css";
import "./WebSite.Form.Field.Type_.css";
import "./WebSite.Form.Field.Uri.css";
import "./WebSite.Form.Section.css";
import "./WebSite.Form.Wizard.css";
import "./WebSite.NotificationCenter.css";
import "./WebSite.Object_.Filter.css";
import "./WebSite.Object_.Form.css";
import "./WebSite.Page.Component.Canvas.css";
import "./WebSite.Page.Component.Collapsible.css";
import "./WebSite.Page.Component.Consent.css";
import "./WebSite.Page.Component.Diagram.css";
import "./WebSite.Page.Component.FormBuilder.css";
import "./WebSite.Page.Component.Grid.css";
import "./WebSite.Page.Component.ImageGrid.css";
import "./WebSite.Page.Component.List.Panel.css";
import "./WebSite.Page.Component.Map.css";
import "./WebSite.Page.Component.Tab.Menu.css";
import "./WebSite.Page.Component.Tab.Panel.css";
import "./WebSite.Page.Component.Table.css";
import "./WebSite.Page.Component.TableOfContents.css";
import "./WebSite.Page.Component.UploadArea.css";
import "./WebSite.Search.css";


// ---------- File: Enumeration.ts ----------
// @ts-nocheck
export class Enumeration {
  constructor(constants) {
    this.labels = new Array();

    for (let index in constants) {
      const constant = constants[index];
      this[constant] = index;
      this.labels[index] = constant;
    }
  }

  fromText(value) {
    return this[value];
  }

  toText(value) {
    return this.labels[value];
  }
}


// ---------- File: Compression.ts ----------
// @ts-nocheck
const CRC32_TABLE = (() => {
  const table = new Uint32Array(256);

  for (let byteValue = 0; byteValue < 256; byteValue++) {
    let crcValue = byteValue;

    for (let bitIndex = 0; bitIndex < 8; bitIndex++)
      crcValue = (crcValue & 1) ? (0xEDB88320 ^ (crcValue >>> 1)) : (crcValue >>> 1);

    table[byteValue] = crcValue;
  }

  return table;
})();

function crc32(data) {
  let crc = 0xFFFFFFFF;

  for (let index = 0; index < data.length; index++)
    crc = (crc >>> 8) ^ CRC32_TABLE[(crc ^ data[index]) & 0xFF];

  return (crc ^ 0xFFFFFFFF) >>> 0;
}

async function deflateRaw(data) {
  const stream = new Blob([data]).stream().pipeThrough(new CompressionStream("deflate-raw"));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

function dosDateTime(dateTime) {
  const time = ((dateTime.getHours() & 0x1F) << 11)
    | ((dateTime.getMinutes() & 0x3F) << 5)
    | (Math.floor(dateTime.getSeconds() / 2) & 0x1F);

  const date = (((dateTime.getFullYear() - 1980) & 0x7F) << 9)
    | (((dateTime.getMonth() + 1) & 0x0F) << 5)
    | (dateTime.getDate() & 0x1F);

  return { time: time, date: date };
}

class ZipFileOptions {
  constructor() {
    this.useCompression = false;
  }
}

class ZipBuilder {
  constructor() {
    this.parts = [];
    this.entries = [];
    this.offset = 0;
  }

  async addFile(name, blob, options = new ZipFileOptions()) {
    const data = new Uint8Array(await blob.arrayBuffer());
    const compressed = options.useCompression ? await deflateRaw(data) : data;
    const compressionMethod = options.useCompression ? 8 : 0;
    const checksum = crc32(data);
    const nameBytes = new TextEncoder().encode(name);
    const dosTimestamp = dosDateTime(new Date());

    const header = new ArrayBuffer(30 + nameBytes.length);
    const view = new DataView(header);

    view.setUint32(0, 0x04034b50, true);
    view.setUint16(4, 20, true);
    view.setUint16(6, 0x0800, true);
    view.setUint16(8, compressionMethod, true);
    view.setUint16(10, dosTimestamp.time, true);
    view.setUint16(12, dosTimestamp.date, true);
    view.setUint32(14, checksum, true);
    view.setUint32(18, compressed.length, true);
    view.setUint32(22, data.length, true);
    view.setUint16(26, nameBytes.length, true);
    view.setUint16(28, 0, true);

    new Uint8Array(header, 30).set(nameBytes);

    this.entries.push({
      nameBytes: nameBytes,
      compressionMethod: compressionMethod,
      checksum: checksum,
      compressedSize: compressed.length,
      uncompressedSize: data.length,
      dosTimestamp: dosTimestamp,
      offset: this.offset
    });

    this.parts.push(new Uint8Array(header));
    this.offset += header.byteLength;

    this.parts.push(compressed);
    this.offset += compressed.length;
  }

  build() {
    const directoryStart = this.offset;

    for (const entry of this.entries) {
      const centralDirectoryHeader = new ArrayBuffer(46 + entry.nameBytes.length);
      const view = new DataView(centralDirectoryHeader);

      view.setUint32(0, 0x02014b50, true);
      view.setUint16(4, 20, true);
      view.setUint16(6, 20, true);
      view.setUint16(8, 0x0800, true);
      view.setUint16(10, entry.compressionMethod, true);
      view.setUint16(12, entry.dosTimestamp.time, true);
      view.setUint16(14, entry.dosTimestamp.date, true);
      view.setUint32(16, entry.checksum, true);
      view.setUint32(20, entry.compressedSize, true);
      view.setUint32(24, entry.uncompressedSize, true);
      view.setUint16(28, entry.nameBytes.length, true);
      view.setUint16(30, 0, true);
      view.setUint16(32, 0, true);
      view.setUint16(34, 0, true);
      view.setUint16(36, 0, true);
      view.setUint32(38, 0, true);
      view.setUint32(42, entry.offset, true);

      new Uint8Array(centralDirectoryHeader, 46).set(entry.nameBytes);

      this.parts.push(new Uint8Array(centralDirectoryHeader));
      this.offset += centralDirectoryHeader.byteLength;
    }

    const directorySize = this.offset - directoryStart;

    const endOfCentralDirectoryRecord = new ArrayBuffer(22);
    const view = new DataView(endOfCentralDirectoryRecord);

    view.setUint32(0, 0x06054b50, true);
    view.setUint16(4, 0, true);
    view.setUint16(6, 0, true);
    view.setUint16(8, this.entries.length, true);
    view.setUint16(10, this.entries.length, true);
    view.setUint32(12, directorySize, true);
    view.setUint32(16, directoryStart, true);
    view.setUint16(20, 0, true);

    this.parts.push(new Uint8Array(endOfCentralDirectoryRecord));

    return new Blob(this.parts, { type: "application/zip" });
  }
}


// ---------- File: WebSite.Page.Component.ts ----------
// @ts-nocheck
var RefreshMode = new Enumeration(["OnRequest", "ForSiblings", "Recurring"]);
var RenderScope = new Enumeration(["None", "Toolbar", "Body", "Component", "Complete"]);
export var ControlMode = new Enumeration(["display", "edit"]);

function maximumRenderScope(left, right) {
  if (left === RenderScope.Complete || right === RenderScope.Complete)
    return RenderScope.Complete;
  if (left === RenderScope.Component || right === RenderScope.Component)
    return RenderScope.Component;
  else if (left === RenderScope.Body || right === RenderScope.Body)
    return RenderScope.Body;
  else if (left === RenderScope.Toolbar || right === RenderScope.Toolbar)
    return RenderScope.Toolbar;
  else
    return RenderScope.None;
}

function ComponentWithName(name) {
  return function (component) { return component.element.dataset.HierarchicalName === name; }
}

function ComponentWithClass(class_) {
  return function (component) { return component instanceof class_; }
}

export class WebPageComponent {
  constructor(element) {
    this.element = element;
    this.visible = true;
    this.valid = true;
    this.client = new HttpClient();
    this.onSelectionChanged = null;
    this.parentComponent = null;
    this.childComponents = new Array();
    this.updatingCounter = null;
    this.determineProperties();
  }

  createToggleButton(element, subject, class_) {
    element.onclick = (event) => {
      var classSwitch = new HtmlClassSwitch(subject, class_);
      classSwitch.toggle();

      if (!classSwitch.getStatus())
        subject.clickOutsideListener = connectClickOutsideListener(subject, (event) => { element.onclick(event) })
      else if (subject.clickOutsideListener !== undefined)
        removeClickOutsideListener(subject.clickOutsideListener);
    }
  }

  determineProperties() {
    if (this.element.dataset.RefreshMode !== undefined) {
      this.refreshMode = RefreshMode.fromText(this.element.dataset.RefreshMode);

      if (this.refreshMode === RefreshMode.Recurring) {
        this.refreshInterval = this.element.dataset.RefreshInterval;

        this.refreshProcessId = window.setInterval(
          () => {
            if (document.body.contains(this.element))
              this.refresh();
            else
              window.clearInterval(this.refreshProcessId);
          },
          this.refreshInterval
        );
      }
    }

    if (this.element.dataset.Mode !== undefined)
      this.mode = ControlMode.fromText(this.element.dataset.Mode);
    else
      this.mode = ControlMode.edit;
  }

  fireDataChanged() {
    distributeEvent(new DataChangedEvent(this));
  }

  fireSelectionChangedEvent() {
    if (this.onSelectionChanged !== null)
      this.onSelectionChanged(this);
  }

  focus() {
  }

  isFocusable() {
    return this.mode === ControlMode.edit;
  }

  getValue() {
    console.warn("getValue not implemented for: " + this.constructor.name);
    return null;
  }

  setValue() {
    console.warn("setValue not implemented for: " + this.constructor.name);
  }

  getPublishedActions() {
    return [];
  }

  collectPublishedActions() {
    return [];
  }

  getAncestor(condition) {
    let result = null;
    let current = this;

    while (result === null && current !== null) {
      if (condition(current))
        result = current;
      else
        current = current.parentComponent;
    }

    return result;
  }

  getDescendant(condition) {
    const components = this.getDescendants(condition);

    if (components.length > 0)
      return components[0]
    else
      return null;
  }

  getDescendants(condition) {
    let query = new DomQuery(this.element);
    let elements = query.getDescendants((element) => {
      return element.component !== undefined && condition(element.component)
    });

    let result = new Array();

    for (const element of elements)
      result.push(element.component);

    return result;
  }

  bind() {
  }

  release() {
  }

  load(value) {
    for (const property in value) {
      const child = this.childComponents.find(element => element.name === property);

      if (child && child.mode === ControlMode.edit)
        child.load(value[property]);
    }
  }

  save() {
    const result = {};

    for (const component of this.childComponents) {
      if (component.mode === ControlMode.edit && component.name)
        result[component.name] = component.save();
    }

    return result;
  }

  invalidate() {
    this.valid = false;
    setTimeout(() => { this.revalidate(); }, 0);
  }

  async validate() {
  }

  async revalidate() {
    if (this.canValidate()) {
      await this.validate();
      this.valid = true;
      distributeEventDownHierarchy(new ComponentValidatedEvent(this), this);
    }
  }

  canValidate() {
    return (this.parentComponent === null || (this.parentComponent.valid && this.parentComponent.canValidate()));
  }

  handleEvent(event) {
    if (event instanceof CountChangedEvent)
      event.handled = true;
    else if (event instanceof ComponentValidatedEvent && !this.valid)
      this.revalidate();
  }

  addEventListener(event, handler) {
    // Override in specific descendants when the root element is not an input element
    this.element.addEventListener(event, handler);
  }

  refresh() {
  }
}

function connectClickOutsideListener(element, callback) {
  return new ClickOutsideListener([element], callback);
}

function removeClickOutsideListener(listener) {
  listener.remove();
}

export class ClickOutsideListener {
  constructor(elements, callback) {
    this.elements = elements;
    this.callback = callback;

    this.connect();
  }

  contains(source) {
    const query = new DomQuery(source);
    return this.elements.some((element) => query.hasAncestor(element));
  }

  connect() {
    this.listener = (event) => {
      const source = getEvent(event).getSource();

      if (!this.contains(source) && this.shouldHandle())
        this.callback(event);
    };

    const htmlElement = document.getElementsByTagName("html")[0];
    htmlElement.addEventListener(
      "click",
      this.listener,
      true
    );
  }

  shouldHandle() {
    // TODO: This models a modal/overlay stack. However, especially with the introduction of support for multiple elements in this listener,
    //       we should probably refactor to remove the dependency on application.pageHandler.getPopUps() and instead properly represent these overlay layers.
    const popUps = application.pageHandler.getPopUps();
    return (popUps.length === 0) || this.elements.some((element) => popUps[popUps.length - 1].contains(element));
  }

  remove() {
    const htmlElement = document.getElementsByTagName("html")[0];
    htmlElement.removeEventListener("click", this.listener, true);
  }
}

export class Labels {
  constructor(element) {
    this.element = element;

    const labels = element.querySelectorAll('[data--identifier]');

    labels.forEach(label => {
      const key = label.getAttribute('data--identifier');
      this[key] = label;
    });
  }
}

export class ComponentValidatedEvent {
  constructor(component) {
    this.component = component;
  }
}


// ---------- File: Browser.ts ----------
function isInternetExplorer() {
    return (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) || navigator.userAgent.toLowerCase().indexOf("trident") !== -1;
}

function isEdge() {
    return navigator.userAgent.toLowerCase().indexOf("edge") !== -1;
}

function isInternetExplorer6() {
    return navigator.userAgent.toLowerCase().indexOf("msie 6") !== -1;
}

function isInternetExplorer7() {
    return navigator.userAgent.toLowerCase().indexOf("msie 7") !== -1;
}

function isInternetExplorer8() {
    return navigator.userAgent.toLowerCase().indexOf("msie 8") !== -1;
}

function isFireFox() {
    return navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
}

function isChrome() {
    return navigator.userAgent.toLowerCase().indexOf("chrome") !== -1;
}

function isMobile() {
    return navigator.userAgent.toLowerCase().indexOf("mobi") !== -1;
}

function isSmallScreen() {
    return window.matchMedia('(max-width: 1024px)').matches;
}

const mediumScreenQuery = window.matchMedia('(max-width: 1024px)');


// ---------- File: Charta.ts ----------
// @ts-nocheck
function newXmlRequest() {
  var result = null;

  if (typeof XMLHttpRequest != "undefined") {
    result = new XMLHttpRequest();
  }
  else if (typeof window.ActiveXObject != "undefined") {
    try {
      result = new ActiveXObject("Msxml2.XMLHTTP.4.0");
    }
    catch (e) {
      try {
        result = new ActiveXObject("Msxml2.XMLHTTP");
      }
      catch (e) {
        try {
          result = new ActiveXObject("Microsoft.XMLHTTP");
        }
        catch (e) {
          result = null;
        }
      }
    }
  }

  return result;
}

function escapeXMLCharacterData(xml) {
  var result = "";

  for (var i = 0; i < xml.length; i++) {
    var c = xml[i];

    if (c == ">")
      result += "&gt;";
    else if (c == "<")
      result += "&lt;";
    else if (c == "&")
      result += "&amp;";
    else
      result += c;
  }

  return result;
}

function escapeXMLAttributeValue(xml) {
  var result = "";

  for (var i = 0; i < xml.length; i++) {
    var c = xml[i];

    if (c == ">")
      result += "&gt;";
    else if (c == "<")
      result += "&lt;";
    else if (c == "&")
      result += "&amp;";
    else if (c == "\"")
      result += "&quot;";
    else if (c == "'")
      result += "&apos;";
    else
      result += c;
  }

  return result;
}

function getCurrentScript() {
  var scriptElements = document.getElementsByTagName("script");
  return scriptElements[scriptElements.length - 1];
}

function openUrl(event, url) {
  event = getEvent(event);

  if (!nodeIsInteractive(event.getSource())) {
    if (event.ctrlKey)
      window.open(url);
    else
      application.pageHandler.navigate(url);
  }
}

function nodeHasClass(node, className) {
  var result = false;

  if (typeof node.className == "string") {
    var nodeClasses = node.className.split(" ");
    var i = 0;

    while (!result && i < nodeClasses.length)
      if (nodeClasses[i] == className)
        result = true;
      else
        i++;
  }

  return result;
}

function addNodeClass(node, className) {
  setNodeClassEnabled(node, className, true);
}

function removeNodeClass(node, className) {
  setNodeClassEnabled(node, className, false);
}

function setNodeClassEnabled(node, className, enabled) {
  new HtmlClassSwitch(node, className).setStatus(enabled);
}

function nodeIsInteractive(node) {
  return node.nodeName.toLowerCase() == "input";
}

function setHot(node, event, hot) {
  var source = getEvent(event).getSource();

  if (!nodeIsInteractive(source))
    setNodeClassEnabled(node, "hot", hot);
}

function isLink(source) {
  return source.nodeName.toLowerCase() == "a";
}

function isFormElement(source) {
  var name = source.nodeName.toLowerCase();

  return name == "select" || name == "option" || name == "input" || name == "textarea" || name == "button" || name == "label";
}

function changeNodeDisplay(node, display) {
  node.style.display = display;
}

function hideNode(node) {
  changeNodeDisplay(node, "none");
}

function showNode(node) {
  changeNodeDisplay(node, "block");
}

function showImageAttributes(node, altText) {
  var child = node.childNodes[1];

  node.title = altText;

  if (child) {
    showNode(child);
  }
}

function hideImageAttributes(node) {
  var child = node.childNodes[1];

  if (child)
    hideNode(child);
}

function booleanToXML(value) {
  if (value)
    return "true";
  else
    return "false";
}

function expand(node) {
  var itemNode = node.parentNode;
  var result = nodeHasClass(itemNode, "collapsed");

  if (result) {
    removeNodeClass(itemNode, "collapsed");
    addNodeClass(itemNode, "expanded");
  }

  return result;
}

function collapse(node) {
  var itemNode = node.parentNode;
  var result = nodeHasClass(itemNode, "expanded");

  if (result) {
    removeNodeClass(itemNode, "expanded");
    addNodeClass(itemNode, "collapsed");
  }

  return result;
}

function expandOrCollapse(node) {
  return expand(node) || collapse(node);
}

function shouldHandleMouseClick(parent, source) {
  var result = true;

  while (result && source != parent) {
    result = !isLink(source) && !isFormElement(source);
    source = source.parentNode;
  }

  return result;
}

function expandOrCollapseOnClick(node, event) {
  var source = getEvent(event).getSource();

  return shouldHandleMouseClick(node, source) && expandOrCollapse(node);
}

export class InteractivityRegistrationEntry {
  constructor(class_, constructor) {
    this._class = class_;
    this._constructor = constructor;
  }

  get class_() {
    return this._class;
  }

  get constructor_() {
    return this._constructor;
  }
}

export class InteractivityRegistration {
  constructor() {
    this.entries = [];
  }

  attach(element) {
    const query = new DomQuery(element);
    const entries = this.entries;
    const components = new Array();

    query.traversePostOrder(
      function (element) {
        if (element.component === undefined) {
          for (const entry of entries) {
            if (nodeHasClass(element, entry.class_)) {
              const component = entry.constructor_(element);

              if (component !== null) {
                element.component = component;
                components.push(element.component);
              }
            }
          }
        }
      }
    );

    this.updateHierarchy(components);

    for (const component of components)
      component.bind();
  }

  detach(element) {
    const parent = this.getParentComponent(element);

    if (parent !== null) {
      const components = parent.childComponents.filter(child => element.contains(child.element));

      for (const component of components)
        this.detachComponent(component);

      parent.childComponents = parent.childComponents.filter(child => !element.contains(child.element));
    }
    else if (element.component !== undefined)
      this.detachComponent(element.component);
  }

  detachComponent(component) {
    for (const child of component.childComponents)
      this.detachComponent(child);

    component.release();
  }

  getParentComponent(element) {
    let parent = element.parentNode;
    let result = null;

    while (result == null && parent !== null) {
      if (parent.component !== undefined)
        result = parent.component;
      else
        parent = parent.parentNode;
    }

    return result;
  }

  getComponents(element) {
    const parent = this.getParentComponent(element);
    return parent.childComponents.filter(child => element.contains(child.element));
  }

  register(class_, constructor_) {
    this.entries.push(new InteractivityRegistrationEntry(class_, constructor_));
  }

  updateHierarchy(components) {
    for (const component of components) {
      const parent = this.getParentComponent(component.element);

      if (parent !== null) {
        parent.childComponents.push(component);
        component.parentComponent = parent;
      }
    }
  }
}

export var interactivityRegistration = new InteractivityRegistration();


// ---------- File: Control.ts ----------
// @ts-nocheck
function MouseMove () {
    this.control = null;
    this.position = new Point(0, 0);
    this.metaKeys = null;
    this.timeStamp = 0;
}

function Control() {
    this.determineElements = function () {
        this.element = getCurrentScript().parentNode;
        this.element.control = this;

        this.menuElement = this.element.getElementsByClassName("menu Horizontal")[0];
        this.menuList = this.menuElement.getElementsByTagName("li")[0];
        this.menu = this.element.getElementsByTagName("ol")[1];
        this.image = this.element.getElementsByTagName("img")[0];

        var divisions = this.element.getElementsByTagName("div");

        this.element.tabIndex = 0;
        this.element.oncontextmenu = function () { return false; };

        this.focusedObject = divisions[0];
        this.hint = divisions[1];
    }

    this.sendEvents = function () {
        this.isDigesting = true;

        var object = this;
        var xmlRequest = newXmlRequest();

        var events = "<events isEditing=";

        if (this.isEditing) {
            events += "\"true\">";
        }
        else {
            events += "\"false\">";
        }

        for (var i = 0; i < this.events.length; i++)
            events += this.events[i];

        events = events + "</events>";
        this.events = new Array();

        xmlRequest.open("POST", this.url, true);
        xmlRequest.setRequestHeader("Content-Type", "application/xml");
        xmlRequest.onreadystatechange = function () { object.handleEventResponse(xmlRequest); };
        xmlRequest.send(events);
    }

    this.handleEventResponse = function (xmlRequest) {
        if (xmlRequest.readyState == 4) {
            var response = xmlRequest.responseXML;

            var focusedObject = response.getElementsByTagName("focusedObject")[0].getAttribute("value");
            this.focusedObject.innerHTML = focusedObject;
            setNodeClassEnabled(this.focusedObject, "visible", focusedObject != "");

            var hintElement = response.getElementsByTagName("hint")[0];
            var hint = hintElement.getAttribute("value");
            var hintHtmlElement = this.hint;

            hintHtmlElement.innerHTML = hint;
            setNodeClassEnabled(hintHtmlElement, "visible", hint != "");
            hintHtmlElement.style.left = hintElement.getAttribute("x") + "px";
            hintHtmlElement.style.top = hintElement.getAttribute("y") + "px";

            var imageElements = response.getElementsByTagName("image");

            if (imageElements.length > 0) {
                var image = this.image;
                var object = this;

                image.onload = function () {
                    object.handleDigestedEvents();

                    if (object.isEditing)
                        object.fireOnChange();
                };

                image.src = imageElements[0].getAttribute("uri");
            }
            else
                this.handleDigestedEvents();
        }
    }

    this.handleDigestedEvents = function () {
        if (this.events.length > 0)
            this.sendEvents();
        else
            this.isDigesting = false;
    }

    this.addEvent = function (event, parameters) {
        this.events.push("<" + event + " " + parameters + "/>");

        if (!this.isDigesting)
            this.sendEvents();
    }

    this.mouseDown = function (event) {
        var position = event.getPosition();
        var metaKeys = event.getMetaKeys();

        this.element.focus();
        this.image.style.cursor = "default";
        this.addEvent(
            "mouseDown",
            "x=\"" + position.x + "\" " +
            "y=\"" + position.y + "\" " +
            "button=\"" + event.getButton() + "\" " +
            metaKeys.asXMLAttributes()
        );

        event.stopHandling();
    }

    this.mouseUp = function (event) {
        var position = event.getPosition();
        var metaKeys = event.getMetaKeys();

        this.addEvent(
            "mouseUp",
            "x=\"" + position.x + "\" " +
            "y=\"" + position.y + "\" " +
            "button=\"" + event.getButton() + "\" " +
            metaKeys.asXMLAttributes()
        );

        event.stopHandling();
    }

    this.mouseMove = function (event) {
        var position = event.getPosition();
        var metaKeys = event.getMetaKeys();

        // TODO: By tracking mouse position we know whether the mouse position has actually changed, we might want to
        //       move this functionality somewhere else.
        if (position.x != this.previousMousePosition.x || position.y != this.previousMousePosition.y) {
            this.addEvent(
                "mouseMove",
                "x=\"" + position.x + "\" " +
                "y=\"" + position.y + "\" " +
                metaKeys.asXMLAttributes()
            );
        }

        this.previousMousePosition = position;
        event.stopHandling();
    }

    this.mouseOut = function (event) {
        this.addEvent("mouseLeave", "");

        event.stopHandling();
    }

    this.mouseWheel = function (event) {
        var position = event.getPosition();
        var metaKeys = event.getMetaKeys();

        this.addEvent(
            "mouseWheel",
            "x=\"" + position.x + "\" " +
            "y=\"" + position.y + "\" " +
            "delta=\"" + event.wheelDelta + "\" " +
            metaKeys.asXMLAttributes()
        );

        event.stopHandling();
    }

    this.mouseWheelFireFox = function (event) {
        var position = event.getPosition();
        var metaKeys = event.getMetaKeys();

        this.addEvent(
            "mouseWheel",
            "x=\"" + position.x + "\" " +
            "y=\"" + position.y + "\" " +
            "delta=\"" + event.detail*(-120) + "\" " +
            metaKeys.asXMLAttributes()
        );

        event.stopHandling();
    }

    this.handleKey = function (event, keyEventName) {
        var keyCode = event.getKey();

        if (keyCode < 16 || keyCode > 18) {
            var metaKeys = event.getMetaKeys();

            this.addEvent(
                keyEventName,
                "keyCode=\"" + keyCode + "\" " +
                metaKeys.asXMLAttributes()
            );
        }

        event.stopHandling();
    }

    this.keyDown = function (event) {
        this.handleKey(event, "keyDown");
    }

    this.keyUp = function (event) {
        this.handleKey(event, "keyUp");
    }

    this.keyPress = function (event) {
        this.handleKey(event, "keyPress");
    }

    this.attachEventHandlers = function () {
        var image = this.image;
        var element = this.element;
        var object = this;

        if (!isInternetExplorer6()) {
            image.onmousedown = function (event) { object.mouseDown(getEvent(event)); };
            image.onmouseup = function (event) { object.mouseUp(getEvent(event)); };
            image.onmousemove = function (event) { object.mouseMove(getEvent(event)); };
            image.onmouseout = function (event) { object.mouseOut(getEvent(event)); };

            if (!isInternetExplorer7()) {
                image.onmousewheel = function (event) { object.mouseWheel(getEvent(event)); };
            }

            if (isChrome())
                image.addEventListener("mousewheel", function (event) { object.mouseWheel(getEvent(event)); }, true);

            if (isFireFox())
                image.addEventListener("DOMMouseScroll", function (event) { object.mouseWheelFireFox(getEvent(event)); }, false);

            element.onkeydown = function (event) { object.keyDown(getEvent(event)); };
            element.onkeyup = function (event) { object.keyUp(getEvent(event)); };
            element.onkeypress = function (event) { object.keyPress(getEvent(event)); };
        }
    }

    this.toggleEditing = function (event) {
        this.isEditing = !this.isEditing;
        this.updateEditingIndicators();

        var object = this;
        var xmlRequest = newXmlRequest();
        var command = "<setEditing enabled=\"" + booleanToXML(this.isEditing) + "\"/>";

        xmlRequest.open("POST", this.url, true);
        xmlRequest.setRequestHeader("Content-Type", "application/xml");
        xmlRequest.send(command);
    }

    this.addEditMenuOption = function(caption, isEditing) {
        this.isEditing = isEditing;

        var option = document.createElement("li");
        var span = document.createElement("span");
        var link = document.createElement("a");
        var object = this;

        link.href = "javascript:void(0);";
        link.innerHTML = caption;

        link.onclick = function (event) {
            object.toggleEditing(getEvent(event));
            object.menuElement.component.collapse(object.menuList, getEvent(event));
        };

        span.appendChild(link);
        option.appendChild(span);

        this.menu.insertBefore(option, this.menu.childNodes[0]);
        this.editMenuOption = option;
        this.updateEditingIndicators();
    }

    this.updateEditingIndicators = function () {
        setNodeClassEnabled(this.editMenuOption, "current", this.isEditing);
        setNodeClassEnabled(this.element, "editing", this.isEditing);
    }

    this.registerOnChangeListener = function (listener) {
        this.onChangeListeners.push(listener);
    }

    this.fireOnChange = function () {
        for (var i = 0; i < this.onChangeListeners.length; i++)
            this.onChangeListeners[i]();
    }

    this.events = new Array();
    this.isDigesting = false;
    this.previousMousePosition = new Point(0, 0);
    this.onChangeListeners = new Array();

    this.determineElements();
    this.url = this.image.src.split("?")[0];

    this.attachEventHandlers();
}


// ---------- File: CookieBar.ts ----------
// @ts-nocheck
export class CookieBar extends WebPageComponent {
  constructor(element) {
    super(element);

    this.cookieName = element.dataset.Name;
    this.cookiePath = element.dataset.Path;

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.button = query.getDescendant(WithClass("Button"));

    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.expanded.setStatus(true);
  }

  buttonClicked(event) {
    document.cookie = this.cookieName + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=" + this.cookiePath;
    this.expanded.setStatus(false);
    getEvent(event).stopHandling();
  }

  attachEventHandlers() {
    this.button.onclick = (event) => { this.buttonClicked(getEvent(event)); };
  }
}

interactivityRegistration.register("CookieBar", function (element) { return new CookieBar(element); });


// ---------- File: Dom.ts ----------
// @ts-nocheck
function HtmlClasses(element) {
  this.element = element;
  this.classes = element.className.split(" ");

  this.updateElement = function () {
    this.element.className = this.classes.join(" ");
  }

  this.indexOf = function (class_) {
    var result = -1;
    var i = 0;

    while (result === -1 && i < this.classes.length) {
      if (this.classes[i] === class_)
        result = i;
      else
        i++;
    }

    return result;
  }

  this.add = function (class_) {
    var index = this.indexOf(class_);

    if (index === -1) {
      this.classes.push(class_);
      this.updateElement();
    }
  }

  this.remove = function (class_) {
    var index = this.indexOf(class_);

    if (index !== -1) {
      this.classes.splice(index, 1);
      this.updateElement();
    }
  }

  this.toggle = function (class_) {
    var index = this.indexOf(class_);

    if (index !== -1)
      this.classes.splice(index, 1);
    else
      this.classes.push(class_);

    this.updateElement();
  }

  this.contains = function (class_) {
    return this.indexOf(class_) !== -1;
  }

  this.setPresent = function (class_, value) {
    if (value)
      this.add(class_);
    else
      this.remove(class_);
  }
}

export function HtmlClassSwitch(element, class_) {
  this.element = element;
  this.class_ = class_;

  this.getStatus = function () {
    return new HtmlClasses(this.element).contains(this.class_);
  }

  this.setStatus = function (value) {
    new HtmlClasses(this.element).setPresent(this.class_, value);
  }

  this.toggle = function () {
    new HtmlClasses(this.element).toggle(this.class_);
  }
}

function HtmlClassCounter(element, class_) {
  this.switch_ = new HtmlClassSwitch(element, class_);
  this.count = 0;

  this.increase = function () {
    this.count++;
    this.switch_.setStatus(this.count > 0);
  }

  this.decrease = function () {
    this.count--;
    this.switch_.setStatus(this.count > 0);
  }
}

export function WithClass(class_) {
  return function (node) { return nodeHasClass(node, class_); }
}

export function WithId(id) {
  return function (node) { return node.id === id; }
}

export function WithTagName(tagName) {
  return function (node) { return node.tagName === tagName; }
}

function DomTraversalFrame(element) {
  this.element = element;
  this.childIndex = 0;

  this.isAtEnd = function () {
    return this.childIndex === this.element.childNodes.length;
  }

  this.getNext = function () {
    var result = this.element.childNodes[this.childIndex];
    this.childIndex++;

    return result;
  }
}

export function DomQuery(element) {
  this.element = element;

  this.getNthChild = function (condition, index) {
    var result = null;
    var i = 0;

    while (result === null && i < this.element.childNodes.length) {
      var node = this.element.childNodes[i];

      if (node.nodeType == "1" && condition(node)) {
        if (index === 0)
          result = node;
        else
          index--;
      }

      i++;
    }

    return result;
  }

  this.getChild = function (condition) {
    return this.getNthChild(condition, 0);
  }

  this.getChildren = function (condition) {
    var result = new Array();

    for (var i = 0; i < this.element.childNodes.length; i++) {
      var childNode = this.element.childNodes[i];

      if (childNode.nodeType == "1" && condition(childNode))
        result.push(childNode);
    }

    return result;
  }

  this.getDescendant = function (condition) {
    var result = null;
    var stack = new Array();

    for (var i = this.element.childNodes.length - 1; i >= 0; i--)
      stack.unshift(this.element.childNodes[i]);

    while (result === null && stack.length > 0) {
      var node = stack.shift();

      if (node.nodeType == "1") {
        if (condition(node))
          result = node;
        else {
          for (var i = node.childNodes.length - 1; i >= 0; i--)
            stack.unshift(node.childNodes[i]);
        }
      }
    }

    return result;
  }

  this.getDescendants = function (condition) {
    var result = new Array();
    var stack = new Array();

    for (var i = 0; i < this.element.childNodes.length; i++)
      stack.unshift(this.element.childNodes[i]);

    while (stack.length > 0) {
      var node = stack.shift();

      if (node.nodeType == "1") {
        if (condition(node))
          result.unshift(node);

        for (var i = 0; i < node.childNodes.length; i++)
          stack.unshift(node.childNodes[i]);
      }
    }

    return result;
  }

  this.hasAncestor = function (node) {
    var result = false;
    var current = this.element;

    while (!result && current !== null) {
      result = current === node;
      current = current.parentNode;
    }

    return result;
  }

  this.getAncestor = function (condition) {
    var result = null;
    var current = this.element;

    while (result === null && current !== null) {
      if (condition(current))
        result = current;
      else
        current = current.parentNode;
    }

    return result;
  }

  this.traversePostOrder = function (visit) {
    var stack = new Array();
    stack.push(new DomTraversalFrame(this.element));

    while (stack.length > 0) {
      var frame = stack[stack.length - 1];

      if (frame.isAtEnd()) {
        stack.pop();
        visit(frame.element);
      }
      else {
        var node = frame.getNext();

        if (node.nodeType == "1")
          stack.push(new DomTraversalFrame(node));
      }
    }
  }
}

function DomPathQuery(element) {
  this.element = element;

  this.getChild = function (condition) {
    return new DomPathQuery(new DomQuery(this.element).getChild(condition));
  }

  this.getDescendant = function (condition) {
    return new DomPathQuery(new DomQuery(this.element).getDescendant(condition));
  }

  this.getElement = function () {
    return this.element;
  }
}


// ---------- File: Email.Viewer.ts ----------
// @ts-nocheck
export class EmailViewer extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.addEventListeners();
    this.setInlineSources();
    this.resizeIframe();
  }

  setInlineSources() {
    if ((this.document != null) & (this.attachments != null)) {
      const tags = this.document.getElementsByTagName("img");

      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        const split = tag.src.split(":");

        if ((split.length == 2) && (split[0] == "cid"))
          tag.src = this.attachments.dataset.Uri + split[1];
      }
    }
  }

  resizeIframe() {
    if (this.iframe != null) {
      this.iframe.style.height = null;
      this.iframe.style.height = this.document.body.scrollHeight + "px";
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.iframe = query.getChild(WithTagName("IFRAME"));
    this.attachments = query.getChild(WithClass("Attachments"));

    if (this.iframe != null)
      this.document = this.iframe.contentWindow.document;
  }

  addEventListeners() {
    if (this.iframe != null)
      window.addEventListener("resize", () => { this.resizeIframe(); }, false);
  }
}

interactivityRegistration.register("EmailViewer", function (element) { return new EmailViewer(element); });


// ---------- File: Event.ts ----------
// @ts-nocheck
function MetaKeys() {
  this.alt = false;
  this.shift = false;
  this.control = false;

  this.asURLParameters = function () {
    var result = "";

    if (this.alt)
      result += "&alt=1";

    if (this.control)
      result += "&control=1";

    if (this.shift)
      result += "&shift=1";

    return result;
  }

  this.asXMLAttributes = function () {
    var result = "";

    if (this.alt)
      result += " alt=\"1\"";

    if (this.control)
      result += " control=\"1\"";

    if (this.shift)
      result += " shift=\"1\"";

    return result;
  }
}

if (typeof (Event) != "undefined") {
  Event.prototype.getKey = function () {
    var result = this.keyCode;

    if (result == null || result == 0)
      result = this.which;

    return result;
  }

  Event.prototype.getMetaKeys = function () {
    var result = new MetaKeys();

    result.alt = this.altKey;
    result.control = this.ctrlKey;
    result.shift = this.shiftKey;

    return result;
  }

  Event.prototype.getPosition = function () {
    var result = new Point(0, 0);
    var source = this.getSource();

    result.x = this.offsetX;
    result.y = this.offsetY;

    if (result.x == null)
      result.x = this.layerX - source.offsetLeft - 1;

    if (result.y == null)
      result.y = this.layerY - source.offsetTop - 1;

    return result;
  }

  Event.prototype.getSource = function () {
    var result = this.target;

    if (!result)
      result = this.srcElement;

    return result;
  }

  Event.prototype.stopHandling = function () {
    this.cancelBubble = true;
    this.cancel = true;

    if (this.stopPropagation)
      this.stopPropagation();

    if (this.preventDefault)
      this.preventDefault();
    else
      this.returnValue = false;

    return false;
  }

  Event.prototype.getButton = function () {
    if (isInternetExplorer6() || isInternetExplorer7() || isInternetExplorer8()) {
      if (this.button & 1)
        return 0;
      else if (this.button & 4)
        return 2;
      else if (this.button & 2)
        return 1;
    }
    else
      return this.button;
  }
}
else {
  function WindowEventAdapter(windowEvent) {
    this.windowEvent = windowEvent;

    this.getSource = function () {
      return this.windowEvent.srcElement;
    }

    this.getMetaKeys = function () {
      var result = new MetaKeys();

      result.alt = this.windowEvent.altKey;
      result.control = this.windowEvent.ctrlKey;
      result.shift = this.windowEvent.shiftKey;

      return result;
    }

    this.getPosition = function () {
      var result = new Point(0, 0);
      var source = this.getSource();

      result.x = this.windowEvent.offsetX;
      result.y = this.windowEvent.offsetY;

      if (result.x == null)
        result.x = this.windowEvent.layerX - source.offsetLeft - 1;

      if (result.y == null)
        result.y = this.windowEvent.layerY - source.offsetTop - 1;

      return result;
    }

    this.stopHandling = function () {
      this.cancelBubble = true;

      if (this.windowEvent.stopPropagation)
        this.windowEvent.stopPropagation();

      if (this.windowEvent.preventDefault)
        this.windowEvent.preventDefault();
      else
        this.windowEvent.returnValue = false;
    }

    this.getButton = function () {
      if (isInternetExplorer()) {
        if (this.windowEvent.button & 1)
          return 0;
        else if (this.windowEvent.button & 4)
          return 2;
        else if (this.windowEvent.button & 2)
          return 1;
      }
      else
        return this.windowEvent.button;
    }
  }
}

function getEvent(event) {
  if (typeof (Event) != "undefined") {
    if (!event)
      return window.event;
    else
      return event;
  }
  else {
    return new WindowEventAdapter(window.event);
  }
}

function DataChangedEvent(field) {
  this.field = field;
}

function VisibilityChangedEvent(field) {
  this.field = field;
}

function AvailableSizeChangedEvent() {
}

function distributeEvent(event) {
  var query = new DomQuery(document.body);
  var object = event.field;

  query.traversePostOrder(
    function (element) {
      if (element.component !== undefined && element.component !== object && element.component.handleEvent !== undefined)
        element.component.handleEvent(event);
    }
  );
}

function distributeEventUpHierarchy(event, component) {
  event.handled = false;
  component = component.parentComponent;

  while (component !== null && !event.handled) {
    component.handleEvent(event);
    component = component.parentComponent;
  }
}

function distributeEventDownHierarchy(event, component) {
  let index = 0;
  const children = component.childComponents;

  while (!event.handled && index < children.length) {
    const child = children[index];
    child.handleEvent(event);

    distributeEventDownHierarchy(event, child);
    index++;
  }
}

function clickElement(element) {
  var event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true
  });

  element.dispatchEvent(event);
}


// ---------- File: Geometry.ts ----------
function Point(x, y) {
  this.x = x;
  this.y = y;

  this.equals = function (otherPoint) {
    return this.x == otherPoint.x && this.y == otherPoint.y;
  }
}


// ---------- File: Http.Client.ts ----------
// @ts-nocheck
function HttpClient() {
  this.handleResponse = function (xmlRequest, handler) {
    if (xmlRequest.readyState === 4)
      handler(xmlRequest);
  };

  this.get = function (uri, handler, progress) {
    var client = this;
    var xmlRequest = newXmlRequest();

    xmlRequest.open("GET", uri, true);
    xmlRequest.onreadystatechange = function () { client.handleResponse(xmlRequest, handler) };

    this.updateProgress(xmlRequest, progress);

    xmlRequest.send();
  }

  this.postFormRequest = function (uri, form, handler, progress) {
    var client = this;
    var xmlRequest = newXmlRequest();

    xmlRequest.open("POST", uri, true);
    xmlRequest.onreadystatechange = function () { client.handleResponse(xmlRequest, handler) };

    this.updateProgress(xmlRequest, progress);

    xmlRequest.send(form);
  }

  this.sendJsonRequest = function (uri, object, handler, progress) {
    var client = this;
    var xmlRequest = newXmlRequest();

    xmlRequest.open("POST", uri, true);
    xmlRequest.setRequestHeader("Content-Type", "application/json");
    xmlRequest.onreadystatechange = function () { client.handleResponse(xmlRequest, handler) };

    this.updateProgress(xmlRequest, progress);

    xmlRequest.send(JSON.stringify(object));
  }

  this.sendXmlRequest = function (uri, content, handler, progress) {
    var client = this;
    var xmlRequest = newXmlRequest();

    xmlRequest.open("POST", uri, true);
    xmlRequest.setRequestHeader("Content-Type", "application/xml");
    xmlRequest.onreadystatechange = function () { client.handleResponse(xmlRequest, handler) };

    this.updateProgress(xmlRequest, progress);

    xmlRequest.send(content);
  };

  this.updateProgress = function (xmlRequest, progress) {
    if (progress !== undefined) {
      xmlRequest.onloadstart = function (event) { progress.setProgress(1) };
      xmlRequest.onloadend = function (event) { progress.setProgress(100) };
      xmlRequest.onload = function (event) { progress.setProgress(100) };
      xmlRequest.onabort = function (event) { progress.setProgress(0) };
      xmlRequest.onerror = function (event) { progress.setProgress(0) };
      xmlRequest.ontimeout = function (event) { progress.setProgress(0) };
    }
  }
}


// ---------- File: Image.ts ----------
// @ts-nocheck
function ImageViewer (imageIdentifiers, URI, embellished, maximumWidth) {
    this.viewer = getCurrentScript().parentNode;
    this.imageIdentifiers = imageIdentifiers;
    this.URI = URI;
    this.embellished = embellished;
    this.maximumWidth = maximumWidth;
    this.currentImageIdentifier;
    this.currentImage;
    this.viewPort;
    this.previousSelector;
    this.nextSelector;
    this.autoPlay;
    this.timer;
    this.overview;

    this.previous = function () {
        if (this.currentImageIdentifier > 0)
            this.currentImageIdentifier = this.currentImageIdentifier - 1;
        else
            this.currentImageIdentifier = this.imageIdentifiers.length - 1;

        this.render();
    }

    this.next = function () {
        if (this.currentImageIdentifier < this.imageIdentifiers.length - 1)
            this.currentImageIdentifier = this.currentImageIdentifier + 1;
        else
            this.currentImageIdentifier = 0;

        this.render();
    }

    this.select = function (imageIndex) {
        this.currentImageIdentifier = imageIndex;

        this.render();
    }

    this.handlePreviousClick = function() {
        var viewer = this;

        return function () {
            viewer.previous();
        }
    }

    this.handleNextClick = function() {
        var viewer = this;

        return function () {
            viewer.next();
        }
    }

    this.handleSelectClick = function(imageIndex) {
        var viewer = this;

        return function () {
            viewer.select(imageIndex);
        }
    }

    this.render = function () {
        this.currentImage.src = this.URI + this.imageIdentifiers[this.currentImageIdentifier] + "?Scaled=true&backgroundColor=FFFFFF&maximumWidth=" + this.maximumWidth;

        if (this.embellished == "True") {
            this.currentImage.src = this.currentImage.src + "&shadow=" + this.embellished;
        }

        if (this.autoPlay) {
            this.timer.kill();
            this.timer.schedule(this.handleNextClick());
        }
    }

    this.renderOverview = function () {
        var image;

        for (var i = 0; i < this.imageIdentifiers.length; i++) {
            image = new Image();
            image.src = this.URI + this.imageIdentifiers[i] + "?Scaled=true&backgroundColor=FFFFFF&maximumHeight=50&shadow=" + this.embellished;
            image.className = "miniature";
            image.onclick = this.handleSelectClick(i);

            this.overview.appendChild(image);
        }
    }

    this.startAutoPlay = function () {
        this.autoPlay = true;
        this.timer = new Timer(7000);
        this.timer.schedule(this.handleNextClick());
    }

    this.create = function () {
        this.currentImageIdentifier = 0;
        this.currentImage = new Image();
        this.autoPlay = false;
        this.overview = document.createElement('div');
        this.overview.className = "overview";

        var table = document.createElement('table');
        var tableBody = document.createElement('tbody');
        var row = document.createElement('tr');

        tableBody.appendChild(row);
        table.appendChild(tableBody);

        this.viewPort = document.createElement('td');
        this.viewPort.className = "viewPort";
        this.viewPort.appendChild(this.currentImage);

        this.previousSelector = document.createElement('td');
        this.previousSelector.className = "previous";
        this.previousSelector.innerHTML = "&nbsp;";
        this.previousSelector.onclick = this.handlePreviousClick();

        this.nextSelector = document.createElement('td');
        this.nextSelector.className = "next";
        this.nextSelector.innerHTML = "&nbsp;";
        this.nextSelector.onclick = this.handleNextClick();

        row.appendChild(this.previousSelector);
        row.appendChild(this.viewPort);
        row.appendChild(this.nextSelector);

        this.viewer.appendChild(table);
        this.viewer.appendChild(this.overview);
    }

    this.create();
}


// ---------- File: StructuredDocument.Template.Renderer.ts ----------
// @ts-nocheck
export class TemplateRenderer {
  renderTemplate(template, value) {
    const parser = new DOMParser();
    const templateDocument = parser.parseFromString(template, "application/xml");

    const result = document.createElement("main");

    for (const node of templateDocument.childNodes) {
      const component = this.renderElement(node, value);

      if (component !== null)
        result.appendChild(component);
    }

    return result;
  }

  renderDivision(node, value) {
    const result = document.createElement("div");

    for (const child of node.childNodes) {
      const component = this.renderElement(child, value);

      if (component !== null)
        result.appendChild(component);
    }

    for (const attribute of node.attributes) {
      if (attribute.name === "Classes")
        result.setAttribute("class", this.evaluate(attribute.value, value));
      else
        result.dataset[attribute.name] = this.evaluate(attribute.value, value);
    }

    return result;
  }

  renderElement(node, value) {
    if (node.tagName === "Division") {
      return this.renderDivision(node, value);
    }
    else if (node.tagName === "H1") {
      return this.renderHeader(node, value);
    }
    else if (node.nodeType === 3) {
      return this.renderText(node, value);
    }
    else
      return null;
  }

  renderHeader(node, value) {
    const result = document.createElement("h1");

    for (const child of node.childNodes) {
      const component = this.renderElement(child, value);

      if (component !== null)
        result.appendChild(component);
    }

    for (const attribute of node.attributes) {
      if (attribute.name === "Classes")
        result.setAttribute("class", this.evaluate(attribute.value, value));
      else
        result.dataset[attribute.name] = this.evaluate(attribute.value, value);
    }

    return result;
  }

  renderText(node, value) {
    return document.createTextNode(this.evaluate(node.textContent, value));
  }

  evaluate(text, value) {
    if (text.startsWith("Eval(") && text.endsWith(")")) {
      const expression = text.substring(5, text.length - 1);
      const result = value[expression];

      if (result !== undefined)
        return result;
      else
        return null;
    }
    else
      return text;
  }
}


// ---------- File: Timer.ts ----------
function Timer(delay) {
  this.delay = delay;
  this.isScheduled = false;
  this.timerID = 0;

  this.schedule = function (eventHandler) {
    this.isScheduled = true;
    this.timerID = window.setTimeout(eventHandler, this.delay);
  }

  this.kill = function () {
    if (this.isScheduled)
      window.clearTimeout(this.timerID);
  }
}


// ---------- File: Tristate.ts ----------
// @ts-nocheck
function Tristate(element) {
    this.attachHandlers = function() {
        var object = this;

        this.disabled.onclick = function(event) {object.toggle("Disabled")};
        this.neutral.onclick = function(event) {object.toggle("Neutral")};
        this.enabled.onclick = function(event) {object.toggle("Enabled")};
    }

    this.initialize = function() {
        this.disabled = document.createElement("div");
        this.disabled.classList.add("Disabled");

        this.neutral = document.createElement("div");
        this.neutral.classList.add("Neutral");

        this.enabled = document.createElement("div");
        this.enabled.classList.add("Enabled");

        this.element.appendChild(this.disabled);
        this.element.appendChild(this.neutral);
        this.element.appendChild(this.enabled);

        this.effect = true;
        this.effectClass = new HtmlClassSwitch(this.element, "Visible");
        this.effectClass.setStatus(true);
    }

    this.setEffect = function(effect) {
        this.effect = effect;
        this.effectClass.setStatus(effect);
    }

    this.toggle = function(state) {
        this.element.classList.remove("Disabled");
        this.element.classList.remove("Neutral");
        this.element.classList.remove("Enabled");

        this.element.classList.add(state);
        this.state = state;

        if (this.element.onchange !== null)
            this.element.onchange();
    }

    this.element = element;

    this.initialize();
    this.attachHandlers();
    this.toggle(this.element.dataset.Value);
}


// ---------- File: Uri.ts ----------
function Uri(uri) {
    this.addQueryParameter = function(name, value) {
        if (this.uri.indexOf("?") == -1)
            this.uri = this.uri + "?" + encodeURI(name) + "=" + encodeURI(value);
        else
            this.uri = this.uri + "&" + encodeURI(name) + "=" + encodeURI(value);

        return this.uri;
    }

    this.uri = uri;
}


// ---------- File: Value.TextFormat.Parser.ts ----------
function ValueTextParser() {
  this.parseText = function (value) {
    const escapedCharacters = "(),\\";

    let result = "";
    let escaped = false;

    for (const character of value) {
      if (escaped) {
        if (escapedCharacters.includes(character))
          result += character;
        else
          throw new Error("Unexpected escaped character: " + character);

        escaped = false;
      }
      else if (character === "\\")
        escaped = true;
      else
        result += character;
    }

    if (escaped)
      throw new Error("Unexpected escape character at end");

    return result;
  }
}


// ---------- File: Value.TextFormat.Renderer.ts ----------
function ValueTextRenderer() {
  this.escape = function (value) {
    let result = "";
    const escapedCharacters = "()\\,";

    for (const character of value) {
      if (escapedCharacters.includes(character))
        result += "\\";

      result += character;
    }

    return result;
  }

  this.render = function (value) {
    if (value === undefined)
      throw new Error("Undefined value cannot be rendered to text");
    else if (value === null)
      return "";
    else {
      const type = typeof value;

      // TODO: We currently only support null, boolean, number and string. We should support other types as well.
      if (type === "boolean")
        return this.renderBoolean(value);
      else if (type === "number")
        return value.toString();
      else if (type === "string")
        return this.escape(value);
      else if (type === "object")
        return value.toString();
      else
        return String(value);
    }
  }

  this.renderBoolean = function (value) {
    if (value)
      return "True";
    else
      return "False";
  }
}


// ---------- File: WebApp.ts ----------
// @ts-nocheck
export class Application {
  constructor() {
    this.rootUri = new URL("..", document.scripts[0].src);
    this.online = true;
    this.reloadOnControllerChange = false;
    this.updatePromptShown = false;

    this.store = new WebSiteStore();
    this.entityStore = new EntityStore();
    this.fileStore = new FileStore();
  }

  async prepare() {
    this.mode = await this.getMode();

    if ("serviceWorker" in navigator) {
      this.uploadCenter = new UploadCenter();
      this.synchronizationCenter = new SynchronizationCenter();

      this.startServiceWorker();

      setInterval(
        () => {
          this.assureServiceWorkerRunning();
        },
        5000
      );
    }

    this.toastBox = new ToastBox();
    this.pageHandler = new PageHandler(this.rootUri);
  }

  initialize() {
    if (this.uploadCenter) {
      this.uploadCenter.build();
      this.synchronizationCenter.initialize();
    }

    this.pageHandler.initialize();
    this.toastBox.initialize();
  }

  async getMode() {
    let mode = ApplicationMode.App;

    try {
      const value = await this.store.get("WebApp.Mode");

      if (value)
        mode = value;
    } catch (error) {
      console.error('Failed to load application mode from the database', error)
    }

    return mode;
  }

  setMode(value) {
    this.store.set("WebApp.Mode", value);
    this.mode = value;
  }

  async assureServiceWorkerRunning() {
    const serviceWorker = await navigator.serviceWorker.getRegistration();

    if (serviceWorker === undefined || serviceWorker.active === null)
      this.startServiceWorker();
    else
      serviceWorker.active.postMessage([]);
  }

  startServiceWorker() {
    const scope = this.resolve("ServiceWorker.js");

    navigator.serviceWorker.addEventListener("controllerchange", (event) => this.uploadCenter.connect(navigator.serviceWorker));
    navigator.serviceWorker.addEventListener("controllerchange", (event) => this.synchronizationCenter.connect(navigator.serviceWorker));
    navigator.serviceWorker.addEventListener("controllerchange", () => this.handleControllerChange());
    navigator.serviceWorker.register(scope, { updateViaCache: "none" })
      .then((registration) => {
        this.uploadCenter.connect(navigator.serviceWorker);
        this.synchronizationCenter.connect(navigator.serviceWorker);
        this.watchForUpdate(registration);
      });
  }

  handleControllerChange() {
    if (this.reloadOnControllerChange)
      window.location.reload();
  }

  watchForUpdate(registration) {
    if (registration.waiting && navigator.serviceWorker.controller)
      this.promptForUpdate(registration.waiting);

    registration.addEventListener(
      "updatefound",
      () => {
        const newWorker = registration.installing;

        if (newWorker) {
          newWorker.addEventListener(
            "statechange",
            () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller)
                this.promptForUpdate(newWorker);
            }
          );
        }
      }
    );
  }

  promptForUpdate(worker) {
    if (!this.updatePromptShown) {
      this.updatePromptShown = true;

      this.toastBox.addMessage(new ToastMessage(this.pageHandler.labels.UpdateAvailable, "Hint"));

      this.reloadOnControllerChange = true;
      worker.postMessage({ Action: "SkipWaiting" });
    }
  }

  resolve(path) {
    return new URL(path, this.rootUri);
  }
}

export let application;

window.onload = () => {
  application = new Application();

  document.documentElement.component = new WebPageComponent(document.documentElement);
  interactivityRegistration.attach(document.body);

  application.prepare();
}


// ---------- File: WebApp.ConfirmationWindow.ts ----------
// @ts-nocheck
export const ConfirmationClass = new Enumeration(["Confirm", "Delete"]);

export class ConfirmationWindowComponent {
  constructor(message, confirmLabel, cancelLabel, handler, class_ = ConfirmationClass.Confirm, target = null) {
    this.message = message;
    this.confirmLabel = confirmLabel;
    this.cancelLabel = cancelLabel;
    this.handler = handler;
    this.class = class_;
    this.target = target;
  }

  show() {
    if (!this.element) {
      this.element = document.createElement("div");
      this.element.classList.add(ConfirmationClass.toText(this.class));
      this.element.classList.add("ConfirmationWindowComponent");
      this.element.tabIndex = "-1";

      const window = document.createElement("div");
      window.classList.add("ConfirmationWindow");

      const message = document.createElement("span");
      message.classList.add("Message");
      message.append(this.message);

      const confirm = document.createElement("button");
      confirm.type = "button";
      confirm.classList.add("Confirm");
      confirm.append(this.confirmLabel);

      const cancel = document.createElement("button");
      cancel.type = "button";
      cancel.classList.add("Cancel");
      cancel.append(this.cancelLabel);

      window.appendChild(message);
      window.appendChild(confirm);
      window.appendChild(cancel);

      this.element.appendChild(window);

      confirm.addEventListener(
        "click",
        (event) => {
          this.confirm();

          event.stopPropagation();
          event.preventDefault();
        }
      );

      cancel.addEventListener(
        "click",
        (event) => {
          this.cancel();

          event.stopPropagation();
          event.preventDefault();
        }
      );

      this.element.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Enter") {
            this.confirm();

            event.stopPropagation();
            event.preventDefault();
          }
          else if (event.key === "Escape") {
            this.cancel();

            event.stopPropagation();
            event.preventDefault();
          }
        }
      );

      if (this.target !== null)
        this.target.appendChild(this.element);
      else
        application.pageHandler.contents.element.appendChild(this.element);

      this.element.focus();
    }
  }

  cancel() {
    this.hide();
  }

  confirm() {
    this.handler();
    this.hide();
  }

  hide() {
    if (this.element) {
      this.element.remove();
      this.element = undefined;
    }
  }
}


// ---------- File: WebApp.Entity.Store.ts ----------
// @ts-nocheck
const SynchronizationState = new Enumeration(["Synchronized", "Modified", "Conflict", "Stale", "Failed"]);

export class EntityStore {
  constructor() {
    this.databaseName = "EntityStore";
    this.entityStoreName = "entities";
    this.thumbnailStoreName = "thumbnails";
    this.contentsStoreName = "contents";
    this.database = null;

    this.databaseReady = this.openDatabase();
  }

  openDatabase() {
    return new Promise(
      (resolve, reject) => {
        const version = 5;
        const request = indexedDB.open(this.databaseName, version);

        request.onsuccess = (event) => {
          this.database = event.target.result;
          resolve();
        };

        request.onupgradeneeded = (event) => {
          const database = event.target.result;

          if (!database.objectStoreNames.contains(this.entityStoreName)) {
            const entityStore = database.createObjectStore(this.entityStoreName, { keyPath: "Uri" });
            entityStore.createIndex("Title", "Title", { unique: false });
            entityStore.createIndex("OrderTitle", ["Order", "Title"], { unique: false });
          }
          else {
            const entityStore = event.target.transaction.objectStore(this.entityStoreName);

            if (!entityStore.indexNames.contains("Title"))
              entityStore.createIndex("Title", "Title", { unique: false });

            if (!entityStore.indexNames.contains("OrderTitle"))
              entityStore.createIndex("OrderTitle", ["Order", "Title"], { unique: false });
          }

          if (!database.objectStoreNames.contains(this.thumbnailStoreName)) {
            const thumbnailStore = database.createObjectStore(this.thumbnailStoreName, { keyPath: ["Entity", "Id"] });
            thumbnailStore.createIndex("Entity", "Entity", { unique: false });
            thumbnailStore.createIndex("Id", "Id", { unique: false });
          }

          if (!database.objectStoreNames.contains(this.contentsStoreName))
            database.createObjectStore(this.contentsStoreName, { keyPath: "Entity" });
        };

        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  performTransaction(storeNames, mode, callback) {
    return this.databaseReady.then(
      () => new Promise(
        (resolve, reject) => {
          const transaction = this.database.transaction(storeNames, mode);
          const stores = storeNames.map(name => transaction.objectStore(name));

          callback(...stores, transaction, resolve, reject);
        }
      )
    );
  }

  add(entity) {
    return this.performTransaction(
      [this.entityStoreName],
      "readwrite",
      (store, transaction, resolve, reject) => {
        transaction.oncomplete = () => resolve(entity);
        transaction.onerror = (event) => reject(event.target.error);
        store.put(entity);
      }
    );
  }

  delete(entity) {
    return this.performTransaction(
      [this.entityStoreName, this.thumbnailStoreName, this.contentsStoreName],
      "readwrite",
      (entityStore, thumbnailStore, contentsStore, transaction, resolve, reject) => {
        const index = thumbnailStore.index("Entity");
        const range = IDBKeyRange.only(entity);
        const request = index.openCursor(range);

        request.onsuccess = () => {
          const cursor = request.result;
          if (cursor) {
            cursor.delete();
            cursor.continue();
          }
        };

        contentsStore.delete(entity);
        entityStore.delete(entity);

        transaction.oncomplete = resolve;
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  get(entity) {
    return this.performTransaction(
      [this.entityStoreName],
      "readonly",
      (store, transaction, resolve, reject) => {
        const request = store.get(entity);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getAll() {
    return this.performTransaction(
      [this.entityStoreName],
      "readonly",
      (store, transaction, resolve, reject) => {
        const index = store.index("OrderTitle");
        const request = index.getAll();

        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  update(entity) {
    return this.performTransaction(
      [this.entityStoreName],
      "readwrite",
      (store, transaction, resolve, reject) => {
        transaction.oncomplete = resolve;
        transaction.onerror = (event) => reject(event.target.error);
        store.put(entity);
      }
    );
  }

  addThumbnail(thumbnail) {
    return this.performTransaction(
      [this.thumbnailStoreName],
      "readwrite",
      (store, transaction, resolve, reject) => {
        transaction.oncomplete = () => resolve(thumbnail);
        transaction.onerror = (event) => reject(event.target.error);
        store.put(thumbnail);
      }
    );
  }

  getThumbnail(entity, id) {
    return this.performTransaction(
      [this.thumbnailStoreName],
      "readonly",
      (store, transaction, resolve, reject) => {
        const request = store.get([entity, id]);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  addContents(contents) {
    return this.performTransaction(
      [this.contentsStoreName],
      "readwrite",
      (store, transaction, resolve, reject) => {
        transaction.oncomplete = () => resolve(contents);
        transaction.onerror = (event) => reject(event.target.error);
        store.put(contents);
      }
    );
  }

  getContents(entity) {
    return this.performTransaction(
      [this.contentsStoreName],
      "readonly",
      (store, transaction, resolve, reject) => {
        const request = store.get(entity);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getThumbnailsByEntity(entity) {
    return this.performTransaction(
      [this.thumbnailStoreName],
      "readonly",
      (store, transaction, resolve, reject) => {
        const index = store.index("Entity");
        const range = IDBKeyRange.only(entity);
        const request = index.getAll(range);

        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getAllThumbnails() {
    return this.performTransaction(
      [this.thumbnailStoreName],
      "readonly",
      (store, transaction, resolve, reject) => {
        const index = store.index("Id");
        const request = index.getAll();

        request.onsuccess = () => {
          const fileIds = request.result.map(record => record.Id);
          resolve(fileIds);
        };
        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  deleteThumbnail(entity, id) {
    return this.performTransaction(
      [this.thumbnailStoreName],
      "readwrite",
      (store, transaction, resolve, reject) => {
        transaction.oncomplete = resolve;
        transaction.onerror = (event) => reject(event.target.error);
        store.delete([entity, id]);
      }
    );
  }
}


// ---------- File: WebApp.File_.Store.ts ----------
// @ts-nocheck
export const FileUploadState = new Enumeration(["Initial", "Preparing", "Prepared", "Uploading", "Error", "Successful", "Aborted", "Forbidden", "Submitting", "Submitted"]);

FileUploadState.uploadingStates = new Set([
  FileUploadState.Initial,
  FileUploadState.Preparing,
  FileUploadState.Prepared,
  FileUploadState.Uploading,
  FileUploadState.Successful,
  FileUploadState.Submitting
]);

export class FileStore {
  constructor() {
    this.databaseName = "FileStore";
    this.fileStoreName = "files";
    this.fileContentsStoreName = "file_contents";
    this.fileThumbnailStoreName = "file_thumbnail";
    this.database = null;

    this.databaseReady = this.openDatabase();
  }

  openDatabase() {
    return new Promise(
      (resolve, reject) => {
        const version = 3;
        const request = indexedDB.open(this.databaseName, version);

        request.onsuccess = (event) => {
          this.database = event.target.result;
          resolve();
        };

        request.onupgradeneeded = (event) => {
          const database = event.target.result;

          if (event.oldVersion < 1) {
            const fileStore = database.createObjectStore(this.fileStoreName, { keyPath: "id", autoIncrement: true });
            fileStore.createIndex("name", "name", { unique: false });
            fileStore.createIndex("state", "state", { unique: false });
            fileStore.createIndex("target", "target", { unique: false });
          }

          if (event.oldVersion < 2)
            database.createObjectStore(this.fileContentsStoreName, { keyPath: "id" });

          if (event.oldVersion < 3) {
            database.createObjectStore(this.fileThumbnailStoreName, { keyPath: "id" });

            const fileStore = event.target.transaction.objectStore(this.fileStoreName);
            fileStore.createIndex("processed", "processed", { unique: false });
            fileStore.createIndex("uuid", "uuid", { unique: false });
          }
        };

        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  performTransaction(storeNames, mode, callback) {
    return this.databaseReady.then(
      () => new Promise(
        (resolve, reject) => {
          const transaction = this.database.transaction(storeNames, mode);
          const stores = storeNames.map(name => transaction.objectStore(name));
          callback(...stores, transaction, resolve, reject);
        }
      )
    );
  }

  add(file) {
    return this.performTransaction(
      [this.fileStoreName, this.fileContentsStoreName],
      "readwrite",
      (files, contents, transaction, resolve, reject) => {
        const request = files.add({
          target: file.target,
          name: file.name,
          size: file.size,
          state: file.state,
          attempts: file.attempts,
          progress: file.progress,
          problems: file.problems,
          location: file.location,
          processed: 0,
          uuid: file.uuid
        });
        request.onsuccess = () => {
          file.id = request.result;
          contents.add({
            id: file.id,
            contents: file.contents
          });
        };

        transaction.oncomplete = () => resolve(file);
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  addThumbnail(file, contents) {
    return this.performTransaction(
      [this.fileThumbnailStoreName],
      "readwrite",
      (thumbnails, transaction, resolve, reject) => {
        const result = file;
        result.thumbnail = contents;

        const thumbnail = {
          id: file.id,
          contents: contents
        };
        thumbnails.add(thumbnail);

        transaction.oncomplete = () => resolve(result);
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  delete(key) {
    return this.performTransaction(
      [this.fileStoreName, this.fileContentsStoreName, this.fileThumbnailStoreName],
      "readwrite",
      (files, contents, thumbnails, transaction, resolve, reject) => {
        files.delete(key);
        contents.delete(key);
        thumbnails.delete(key);

        transaction.oncomplete = () => resolve();
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  deleteContents(file) {
    return this.performTransaction(
      [this.fileStoreName, this.fileContentsStoreName],
      "readwrite",
      (files, contents, transaction, resolve, reject) => {
        file.processed = 1;
        const request = files.put({
          id: file.id,
          target: file.target,
          name: file.name,
          size: file.size,
          state: file.state,
          attempts: file.attempts,
          progress: file.progress,
          problems: file.problems,
          location: file.location,
          processed: file.processed,
          type: file.type,
          uuid: file.uuid
        });

        request.onsuccess = () => {
          contents.delete(file.id);
        };

        transaction.oncomplete = () => resolve();
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  queueDeletion(file, target) {
    file.state = FileUploadState.Aborted;
    file.target = target;
    file.processed = 0;

    return this.update(file);
  }

  deleteMatches(indexName, value) {
    return this.performTransaction(
      [this.fileStoreName, this.fileContentsStoreName, this.fileThumbnailStoreName],
      "readwrite",
      (files, contents, thumbnails, transaction, resolve, reject) => {
        const index = files.index(indexName);
        const range = IDBKeyRange.only(value);
        const request = index.openCursor(range);

        request.onsuccess = () => {
          const cursor = request.result;

          if (cursor) {
            contents.delete(cursor.value.id);
            thumbnails.delete(cursor.value.id);

            cursor.delete();
            cursor.continue();
          }
          else
            transaction.oncomplete = () => resolve();
        };

        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getThumbnail(key) {
    return this.performTransaction(
      [this.fileStoreName, this.fileThumbnailStoreName],
      "readonly",
      (files, thumbnails, transaction, resolve, reject) => {
        const fileRequest = files.get(key);
        const thumbnailRequest = thumbnails.get(key);

        transaction.oncomplete = () => {
          const file = fileRequest.result;

          if (file) {
            const thumbnail = thumbnailRequest.result ? thumbnailRequest.result.contents : null;
            file.thumbnail = thumbnail;

            resolve(file);
          }
          else
            resolve(null);
        };

        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getThumbnailByUuid(uuid) {
    return this.performTransaction(
      [this.fileStoreName, this.fileThumbnailStoreName],
      "readonly",
      (files, thumbnails, transaction, resolve, reject) => {
        const index = files.index("uuid");
        const request = index.get(uuid);

        request.onsuccess = () => {
          const file = request.result;

          if (file) {
            const thumbnailRequest = thumbnails.get(file.id);
            thumbnailRequest.onsuccess = () => {
              const thumbnail = thumbnailRequest.result ? thumbnailRequest.result.contents : null;
              file.thumbnail = thumbnail;
              resolve(file);
            };
            thumbnailRequest.onerror = (event) => reject(event.target.error);
          }
          else
            resolve(null);
        };

        request.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getFileContents(key) {
    return this.performTransaction(
      [this.fileContentsStoreName],
      "readonly",
      (contents, transaction, resolve, reject) => {
        let result;

        const request = contents.get(key);
        request.onsuccess = () => {
          result = request.result ? request.result.contents : null;
        };

        transaction.oncomplete = () => resolve(result);
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  get(key) {
    return this.performTransaction(
      [this.fileStoreName],
      "readonly",
      (files, transaction, resolve, reject) => {
        let result;

        const request = files.get(key);
        request.onsuccess = () => {
          result = request.result;
        };

        transaction.oncomplete = () => resolve(result);
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getAll() {
    return this.performTransaction(
      [this.fileStoreName],
      "readonly",
      (files, transaction, resolve, reject) => {
        let result;

        const request = files.getAll();
        request.onsuccess = () => {
          result = request.result;
        };

        transaction.oncomplete = () => resolve(result);
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  getMatches(indexName, value) {
    return this.performTransaction(
      [this.fileStoreName],
      "readonly",
      (files, transaction, resolve, reject) => {
        const index = files.index(indexName);
        const range = IDBKeyRange.only(value);

        const request = index.getAll(range);
        request.onsuccess = () => {
          resolve(request.result);
        };

        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }

  update(file) {
    return this.performTransaction(
      [this.fileStoreName],
      "readwrite",
      (files, transaction, resolve, reject) => {
        const request = files.put({
          id: file.id,
          target: file.target,
          name: file.name,
          size: file.size,
          state: file.state,
          attempts: file.attempts,
          progress: file.progress,
          problems: file.problems,
          location: file.location,
          processed: file.processed,
          type: file.type,
          uuid: file.uuid
        });

        transaction.oncomplete = () => resolve();
        transaction.onerror = (event) => reject(event.target.error);
      }
    );
  }
}


// ---------- File: WebApp.File_.Thumbnail.Renderer.ts ----------
// @ts-nocheck
export class ThumbnailRenderer {
  constructor(maximumSize = 100) {
    this.maximumSize = maximumSize;
  }

  async renderThumbnail(file) {
    if (this.isImage(file.name))
      return await this.generateImageThumbnail(file);
    else
      return await this.generatePlaceholderThumbnail(file);
  }

  isImage(fileName) {
    return /\.(png|jpeg|jpg|gif|webp|bmp)$/i.test(fileName);
  }

  async generateImageThumbnail(file) {
    const fileBlob = new Blob([file.contents]);
    const imageBitmap = await createImageBitmap(fileBlob);

    const scaleFactor = Math.min(
      this.maximumSize / imageBitmap.width,
      this.maximumSize / imageBitmap.height
    );
    const thumbnailWidth = imageBitmap.width * scaleFactor;
    const thumbnailHeight = imageBitmap.height * scaleFactor;

    const offscreenCanvas = new OffscreenCanvas(thumbnailWidth, thumbnailHeight);
    const canvasContext = offscreenCanvas.getContext("2d");

    canvasContext.drawImage(imageBitmap, 0, 0, thumbnailWidth, thumbnailHeight);
    return await offscreenCanvas.convertToBlob({ type: "image/png" });
  }

  async generatePlaceholderThumbnail(file) {
    const offscreenCanvas = new OffscreenCanvas(this.maximumSize, this.maximumSize);
    const canvasContext = offscreenCanvas.getContext("2d");

    canvasContext.fillStyle = "#e0e0e0";
    canvasContext.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

    const fileExtension = file.name.split(".").pop().toUpperCase() || "FILE";

    canvasContext.fillStyle = "#404040";
    canvasContext.font = "bold 20px Arial";
    canvasContext.textAlign = "center";
    canvasContext.textBaseline = "middle";
    canvasContext.fillText(fileExtension, offscreenCanvas.width / 2, offscreenCanvas.height / 2);

    return await offscreenCanvas.convertToBlob({ type: "image/png" });
  }
}


// ---------- File: WebApp.LoadingIndicator.ts ----------
// @ts-nocheck
export class LoadingIndicator {
  constructor() {
    this.element = document.createElement("div");
    this.element.classList.add("LoadingIndicator");
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));
    this.element.appendChild(document.createElement("div"));

    this.active = new HtmlClassSwitch(this.element, "Active");
  }

  getStatus() {
    return this.active.getStatus();
  }

  setStatus(active) {
    this.active.setStatus(active);
  }
}


// ---------- File: WebApp.Page.ts ----------
// @ts-nocheck
export class NavigationEvent {
  constructor(uri) {
    this.uri = uri;
  }
}

const PageMode = new Enumeration(["Online", "Offline"]);

export class PageComponent {
  constructor(query) {
    this.query = query;
  }

  initialize(query) {
    this.element = this.load(query);
  }

  load(query) {
    return this.query(query);
  }

  reload(parent, query) {
    this.replace(parent, this.load(query));
  }

  replace(parent, element) {
    interactivityRegistration.detach(this.element);
    parent.replaceChild(element, this.element);
    this.element = element;
    interactivityRegistration.attach(element);
  }
}

export class PageHandler {
  constructor(rootUri) {
    this.rootUri = rootUri;
    this.mode = PageMode.Online;
    this.guards = new Set();

    this.contents = new PageComponent((query) => { return query.getChild(WithTagName("MAIN")); });
    this.breadcrumbs = new PageComponent((query) => { return query.getChild(WithClass("Breadcrumbs")); });

    this.components = new Array();
    this.components.push(new PageComponent((query) => { return query.getChild(WithClass("Menu")); }));
    this.components.push(this.breadcrumbs);
    this.components.push(this.contents);
    this.components.push(new PageComponent((query) => { return query.getChild(WithClass("WebSiteToolbar")); }));
    this.components.push(new PageComponent((query) => { return query.getChild(WithClass("Bookmarks")); }));

    this.uri = window.location.href;
    this.initialize();
    this.initializePage();
    this.addListeners();

    window.history.replaceState(
      { url: window.location.href },
      null,
      window.location.href
    );
  }

  addListeners() {
    addEventListener(
      "popstate",
      (event) => {
        if (event.state) {
          this.reload(window.location.href);
          event.preventDefault();
        }
      }
    );

    window.addEventListener(
      "click",
      (event) => {
        const link = event.target.closest("a");

        if (link && !event.ctrlKey && link.target !== "_blank" && link.getAttribute("href").startsWith(this.rootUri)) {
          event.preventDefault();
          this.navigate(link.getAttribute("href"));
        }
      }
    );
  }

  build() {
    this.loadingIndicator = new LoadingIndicator();
    this.loading = new HtmlClassSwitch(this.element, "Loading");

    this.loadingPage = document.createElement("div");
    this.loadingPage.classList.add("LoadingPage");
    this.loadingPage.appendChild(this.loadingIndicator.element);

    this.element.appendChild(this.loadingPage);
  }

  initialize() {
    this.labels = new Labels(new DomQuery(document.body).getChild(WithClass("Labels")));
    this.element = document.getElementById("main");

    const query = new DomQuery(this.element);

    for (const component of this.components)
      component.initialize(query);

    this.build();
  }

  async initializePage() {
    this.setStatus(true);

    try {
      await this.loadOfflinePage(window.location.href, true);
    }
    finally {
      this.setStatus(false);
    }
  }

  handleDocument(uri, text) {
    this.guards.clear();
    const newDocument = new DOMParser().parseFromString(text, "text/html");

    if (this.loadSupported() && !this.reloadRequired(newDocument)) {
      const main = new DomQuery(newDocument).getDescendant(WithId("main"));
      const query = new DomQuery(main);

      if (!this.components.some((component) => component.load(query) === null)) {
        document.title = newDocument.title;
        document.body.dataset.Source = newDocument.body.dataset.Source;

        for (const component of this.components)
          component.reload(this.element, query);

        application.synchronizationCenter.initialize();
        distributeEvent(new NavigationEvent(uri));
      }
      else
        this.reloadDocument(newDocument);
    }
    else
      this.reloadDocument(newDocument);

    this.uri = uri;
  }

  reloadDocument(newDocument) {
    interactivityRegistration.detach(document.documentElement);
    document.documentElement.innerHTML = newDocument.documentElement.innerHTML;
    interactivityRegistration.attach(document.documentElement);

    application.initialize();
  }

  async loadTemplate() {
    const response = await fetch(application.resolve("Template"));

    if (!response.ok) {
      console.error("Failed to fetch offline template.");
      return false;
    }

    const templateText = await response.text();
    const templateDocument = new DOMParser().parseFromString(templateText, "text/html");

    this.reloadDocument(templateDocument);
  }

  async loadOnlinePage(uri, pushState) {
    const response = await this.fetch(uri);

    if (pushState) {
      const pushUri = new URL(response.url);
      pushUri.hash = new URL(uri).hash;

      window.history.pushState(
        { url: pushUri.href },
        null,
        pushUri.href
      );
    }

    const text = await response.text();
    this.mode = PageMode.Online;
    this.handleDocument(uri, text);
  }

  async loadOfflinePage(uri, pushState) {
    let result = false;

    if (application.mode === ApplicationMode.App) {
      const entity = await application.entityStore.get(uri);
      const template = await application.entityStore.getContents(uri);

      if (entity && template && entity.Current !== null) {
        if (document.body.dataset.Source !== "Template")
          await this.loadTemplate();

        const parser = new DOMParser();
        const contents = parser.parseFromString(template.Contents, "text/html");

        const title = document.createElement("h1");
        title.append(entity.Title);

        const container = document.createElement("div");
        container.appendChild(title);
        container.appendChild(contents.body.firstChild);

        const main = document.createElement("main");
        main.appendChild(container);

        const breadcrumbs = this.breadcrumbs.element.cloneNode(true);
        breadcrumbs.firstChild.innerHTML = "";

        const prefix = document.createElement("li");
        prefix.appendChild(document.createElement("span"));
        prefix.firstChild.appendChild(document.createElement("span"));

        const category = document.createElement("li");
        category.appendChild(document.createElement("span"));
        category.firstChild.innerText = entity.Category;

        const link = document.createElement("a");
        link.href = entity.Uri;
        link.innerText = entity.Title + " - " + entity.Details;

        const item = document.createElement("li");
        item.appendChild(document.createElement("span"));
        item.firstChild.appendChild(link);

        const list = document.createElement("ol");
        list.appendChild(prefix);
        list.appendChild(category);
        list.appendChild(item);

        breadcrumbs.firstChild.appendChild(list);

        this.contents.replace(this.element, main);
        this.breadcrumbs.replace(this.element, breadcrumbs);

        this.uri = uri;
        this.mode = PageMode.Offline;
        this.load(entity.Current);
        this.version = entity.Version;
        this.persisted = entity.Persisted;
        this.current = entity.Current;

        document.title = entity.Title;

        if (pushState)
          window.history.pushState(
            { url: uri },
            null,
            uri
          );

        result = true;
      }
    }

    return result;
  }

  async persistThumbnail(file, thumbnail) {
    const result = await application.fileStore.addThumbnail(file, thumbnail);

    if (this.uri) {
      const entity = await application.entityStore.get(this.uri);

      if (entity) {
        await application.entityStore.addThumbnail({
          Entity: entity.Uri,
          Id: file.id
        });
      }
    }

    return result;
  }

  async retrieveThumbnail(id) {
    const entity = await application.entityStore.get(this.uri);

    if (entity) {
      let file = await application.fileStore.getThumbnailByUuid(id);

      if (!file && /^[0-9]+$/.test(id))
        file = await application.fileStore.getThumbnail(parseInt(id));

      return file;
    }
    else
      return null;
  }

  async persistOfflinePage() {
    if (this.mode === PageMode.Offline) {
      console.info("Persisting offline page: " + this.uri);
      const entity = await application.entityStore.get(this.uri);
      const contents = await application.entityStore.getContents(this.uri);

      if (entity !== undefined && contents && entity.Current !== null) {
        const newValue = this.save();

        const saved = JSON.stringify(entity.Current);
        const server = JSON.stringify(entity.Persisted);
        const current = JSON.stringify(newValue);
        const loaded = JSON.stringify(this.persisted);

        if (current === saved) {
          console.info("No changes for: " + this.uri);
        }
        else {
          if (server === loaded || server === saved) {
            entity.Current = newValue;
            entity.State = SynchronizationState.Modified;

            this.current = newValue;
            this.persisted = entity.Persisted;
            this.version = entity.Version;

            console.info("Offline page modified:", this.uri);
          }
          else {
            entity.Current = newValue;
            entity.Persisted = this.persisted;
            entity.Version = this.version;
            entity.State = SynchronizationState.Conflict;

            this.current = newValue;

            console.warn("Conflict found: " + this.uri);
          }
        }

        await application.entityStore.update(entity);
        application.synchronizationCenter.reload();
      }
      else
        console.info("Entity not found: " + this.uri);
    }
  }

  load(value) {
    const components = interactivityRegistration.getComponents(this.contents.element);

    for (const component of components) {
      if (component.name && value[component.name])
        component.load(value[component.name]);
    }
  }

  save() {
    const components = interactivityRegistration.getComponents(this.contents.element);
    const result = {};

    for (const component of components) {
      if (component.mode === ControlMode.edit && component.name)
        result[component.name] = component.save();
    }

    return result;
  }

  fetch(uri) {
    if (application.online)
      return fetch(
        uri,
        {
          method: "GET",
          headers: {
            "Accept": "text/html"
          }
        }
      );
    else
      return Promise.reject(new Error("The application is offline"));
  }

  async canNavigate(uri) {
    for (const guard of this.guards) {
      const result = await guard.canNavigate(uri);

      if (!result)
        return false;
    }

    return true;
  }

  async navigate(uri) {
    let result = false;
    const currentUri = new URL(window.location.href);
    const navigationUri = new URL(uri);

    if (!this.loadingIndicator.getStatus()) {
      if (await this.canNavigate(uri)) {
        if ((navigationUri.pathname === currentUri.pathname) && (navigationUri.hash.length > 0 || navigationUri.search.length > 0))
          window.location = navigationUri;
        else {
          await this.loadPage(uri, true);
          result = true;
        }
      }
    }

    return result;
  }

  setStatus(loading) {
    this.loading.setStatus(loading);
    this.loadingIndicator.setStatus(loading);
  }

  async reload(uri) {
    await this.loadPage(uri, false);
  }

  async loadPage(uri, pushState) {
    this.setStatus(true);

    try {
      if (!(await this.loadOfflinePage(uri, pushState)))
        await this.loadOnlinePage(uri, pushState);

      const navigationUri = new URL(uri);

      if (navigationUri.hash.length > 0)
        window.location.hash = navigationUri.hash;
    }
    catch (error) {
      application.toastBox.addMessage(new ToastMessage(this.labels.FailedToLoadPage, "Warning"));
      console.error(error);
    }
    finally {
      this.setStatus(false);
    }
  }

  reloadRequired(newDocument) {
    if (newDocument.head.childNodes.length === document.head.childNodes.length) {
      for (let index = 0; index < newDocument.head.childNodes.length; index++) {
        const left = newDocument.head.childNodes[index];
        const right = document.head.childNodes[index];

        if (left.tagName !== "TITLE" && !left.isEqualNode(right)) {
          return true;
        }
      }

      return false;
    }
    else
      return true;
  }

  loadSupported() {
    return !this.components.some((component) => component.element === null);
  }

  getPopUps() {
    return new DomQuery(this.contents.element).getChildren(WithClass("PopUp"));
  }
}


// ---------- File: WebApp.PopUp.ts ----------
// @ts-nocheck
export class PopUp {
  constructor(element, parent, restore, trigger = null, delay = 0) {
    this.element = element;
    this.parent = parent;
    this.popup = null;
    this.restore = restore;
    this.trigger = trigger;
    this.delay = delay;
    this.openTimer = new Timer(delay);
    this.closeTimer = new Timer(delay);
  }

  open(anchorLeft = null) {
    this.closeTimer.kill();

    if (this.delay > 0) {
      this.openTimer.kill();
      this.openTimer.schedule(() => { this.show(anchorLeft); });
    }
    else
      this.show(anchorLeft);
  }

  close() {
    this.openTimer.kill();

    if (this.delay > 0) {
      this.closeTimer.kill();
      this.closeTimer.schedule(() => { this.hide(); });
    }
    else
      this.hide();
  }

  show(anchorLeft = null) {
    if (!this.isOpen()) {
      const target = application.pageHandler.contents.element;
      const viewPort = target.getBoundingClientRect();
      const bounds = this.parent.getBoundingClientRect();

      this.popup = document.createElement("div");
      this.popup.classList.add("PopUp");
      this.popup.instance = this;
      this.popup.appendChild(this.element);
      this.popup.style.position = "absolute";
      this.popup.style.top = (target.scrollTop + bounds.bottom - viewPort.top) + "px";
      this.popup.style.left = (target.scrollLeft + bounds.left - viewPort.left) + "px";
      this.popup.style.zIndex = "var(--z-index-pop-up)";

      target.appendChild(this.popup);

      if (bounds.bottom + this.popup.offsetHeight > window.innerHeight && bounds.top - this.popup.offsetHeight >= viewPort.top)
        this.popup.style.top = (target.scrollTop + bounds.top - viewPort.top - this.popup.offsetHeight) + "px";

      if (anchorLeft !== null) {
        let left = Math.min(anchorLeft, bounds.right - this.popup.offsetWidth, window.innerWidth - this.popup.offsetWidth);
        left = Math.max(left, bounds.left);

        this.popup.style.left = (target.scrollLeft + left - viewPort.left) + "px";
      }

      if (this.delay > 0) {
        this.popup.addEventListener("mouseenter", (event) => { this.closeTimer.kill(); });
        this.popup.addEventListener("mouseleave", (event) => { this.close(); });
      }

      this.popup.addEventListener(
        "keydown",
        (event) => {
          if (event.code === "Escape")
            this.close();
        }
      );

      this.outsideListener = new ClickOutsideListener(
        this.trigger ? [this.popup, this.trigger] : [this.popup],
        (event) => {
          this.close();
        }
      );
    }
  }

  hide() {
    if (this.isOpen()) {
      this.closePopUpsOnTop();

      if (this.restore)
        this.parent.appendChild(this.element);

      application.pageHandler.contents.element.removeChild(this.popup);
      removeClickOutsideListener(this.outsideListener);

      this.popup = null;
    }
  }

  closePopUpsOnTop() {
    const popUps = application.pageHandler.getPopUps();

    for (let index = popUps.length - 1; popUps[index] !== this.popup; index--)
      popUps[index].instance.close();
  }

  isOpen() {
    return this.popup !== null;
  }
}


// ---------- File: WebApp.Request.Queue.ts ----------
// @ts-nocheck
export class XmlMessage {
  constructor() {
  }

  toXml() {
    return "";
  }
}

export class QueueSizeChangedEvent {
  constructor(size) {
    this.size = size;
  }
}

export class RequestQueue {
  constructor(source) {
    this.requests = new Array();
    this.listeners = new Array();

    this.source = source;
  }

  queue(uri, method, message, body, handler, blocking = true) {
    this.requests.push(
      {
        uri: uri,
        method: method,
        message: message,
        body: body,
        handler: handler,
        blocking: blocking
      }
    );

    this.fireQueueSizeChangedEvent();

    if (this.requests.length === 1)
      this.sendNextRequest();
  }

  fireQueueSizeChangedEvent() {
    for (const listener of this.listeners)
      listener(new QueueSizeChangedEvent(this.requests.length));
  }

  sendNextRequest() {
    this.send(this.requests[0]);
  }

  async send(request) {
    const headers = {
      "Accept": "text/html,application/xhtml+xml,application/xml"
    };

    if (request.message !== null)
      headers["Content-Type"] = "application/xml; charset=\"utf-8\"";

    try {
      try {
        const response = await fetch(
          request.uri,
          {
            method: request.method,
            headers: headers,
            body: request.body ?? request.message.toXml()
          }
        );

        if (response.ok || response.status === 400)
          await request.handler(response);
        else
          this.handleErrorResponse(response);
      } catch (error) {
        this.handleError(error);
      }
    } finally {
      this.requestFinished();
    }
  }

  handleError(error) {
    this.source.handleError(error);
    console.error(error);
  }

  async handleErrorResponse(response) {
    const contentType = response.headers.get("Content-Type");

    if (contentType.slice(0, 9) === "text/html") {
      const division = document.createElement("div");
      division.innerHTML = await response.text();

      const error = new DomQuery(division).getDescendant(WithClass("Error"));
      application.toastBox.addMessage(new ToastMessage(error.firstChild, "Error"));
    }
    else if (contentType === "text/plain")
      application.toastBox.addMessage(new ToastMessage(await response.text(), "Error"));
  }

  requestFinished() {
    this.requests.shift();
    this.fireQueueSizeChangedEvent();

    if (this.requests.length >= 1)
      this.sendNextRequest();
  }

  getLast() {
    return this.requests[this.requests.length - 1];
  }

  getSize() {
    return this.requests.length;
  }
}


// ---------- File: WebApp.Store.ts ----------
// @ts-nocheck
export const ApplicationMode = new Enumeration(["App", "Web"]);

export class WebSiteStore {
  constructor() {
    this.databaseName = "WebSiteStore";
    this.storeName = "Settings";
    this.database = this.initialize();
  }

  initialize() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.databaseName, 1);

      request.onupgradeneeded = (event) => {
        const database = event.target.result;

        if (!database.objectStoreNames.contains(this.storeName)) {
          database.createObjectStore(this.storeName, { keyPath: "key" });
        }
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  }

  async set(key, value) {
    const database = await this.database;

    return new Promise((resolve, reject) => {
      const transaction = database.transaction([this.storeName], "readwrite");
      const store = transaction.objectStore(this.storeName);
      const request = store.put({ key: key, value: value });

      request.onsuccess = () => resolve(true);
      request.onerror = (event) => reject(event.target.error);
    });
  }

  async get(key) {
    const database = await this.database;

    return new Promise((resolve, reject) => {
      const transaction = database.transaction([this.storeName], "readonly");
      const store = transaction.objectStore(this.storeName);
      const request = store.get(key);

      request.onsuccess = (event) => {
        const result = event.target.result;
        resolve(result ? result.value : undefined);
      };

      request.onerror = (event) => reject(event.target.error);
    });
  }

  async delete(key) {
    const database = await this.database;

    return new Promise((resolve, reject) => {
      const transaction = database.transaction([this.storeName], "readwrite");
      const store = transaction.objectStore(this.storeName);
      const request = store.delete(key);

      request.onsuccess = () => resolve(true);
      request.onerror = (event) => reject(event.target.error);
    });
  }
}


// ---------- File: WebApp.Synchronization.Center.ts ----------
// @ts-nocheck
export class SynchronizationCenter {
  constructor() {
    this.interactive = false;

    this.initialize();
  }

  connect(serviceWorker) {
    if (this.listener !== undefined)
      this.serviceWorker.removeEventListener("message", this.listener);

    this.listener = (event) => {
      const data = event.data;

      if (event.data.class === "Entities")
        this.reloadAll(data.value);
    }

    this.serviceWorker = serviceWorker;
    this.serviceWorker.addEventListener("message", this.listener);
  }

  initialize() {
    const elements = document.getElementsByClassName("Synchronization");

    if (elements.length === 1) {
      this.interactive = true;

      this.element = elements[0];
      this.element.addEventListener("click", (event) => { this.openMenu() });

      this.menuOpen = new HtmlClassSwitch(this.element, "Open");

      this.menu = document.createElement("div");
      this.menu.classList.add("SynchronizationMenu");

      this.element.appendChild(this.menu);

      this.button = document.createElement("button");
      this.button.addEventListener(
        "click",
        (event) => {
          this.setApplicationStatus(true);

          if (this.serviceWorker)
            this.serviceWorker.controller.postMessage({ Action: "StartSynchronization" });
        }
      );

      this.menu.appendChild(this.button);
      this.menu.appendChild(this.buildWebAppToggle());

      this.offline = new HtmlClassSwitch(this.element, "Offline");
      this.synchronizing = new HtmlClassSwitch(this.element, "Synchronizing");

      this.progress = document.createElement("progress");
      this.progress.max = 1;

      this.element.appendChild(this.progress);

      this.count = document.createElement("span");
      this.count.className = "Count";
      this.count.textContent = "";

      this.element.appendChild(this.count);
      this.reload();
    }
  }

  openMenu() {
    this.menuOpen.setStatus(true);
    this.clickOutsideListener = new ClickOutsideListener([this.menu], () => { this.closeMenu(); });
  }

  closeMenu() {
    this.menuOpen.setStatus(false);
    this.clickOutsideListener.remove();
  }

  buildWebAppToggle() {
    const toggle = document.createElement("div");

    this.webAppClassSwitch = new HtmlClassSwitch(toggle, "App");
    this.webAppClassSwitch.setStatus(application.mode === ApplicationMode.App);

    const icon = document.createElement("span");
    icon.classList.add("Icon");

    toggle.appendChild(icon);
    toggle.addEventListener("click", (event) => this.toggleApp());
    toggle.classList.add("Toggle");

    return toggle;
  }

  toggleApp() {
    if (application.mode === ApplicationMode.App)
      application.setMode(ApplicationMode.Web)
    else
      application.setMode(ApplicationMode.App);

    this.webAppClassSwitch.setStatus(application.mode === ApplicationMode.App);
  }

  async reload() {
    if (this.interactive) {
      const entities = await application.entityStore.getAll();
      this.updateCount(entities);
    }
  }

  updateCount(entities) {
    const pendingCount = entities
      ? entities.filter(entity => entity.State === SynchronizationState.Modified || entity.State === SynchronizationState.Conflict).length
      : 0;

    this.count.textContent = pendingCount > 0 ? pendingCount : "";
  }

  reloadAll(entities) {
    if (this.interactive) {
      this.progress.value = entities.progress;
      this.updateCount(entities.values);
    }

    this.setApplicationStatus(entities.status, entities.synchronizing);
  }

  setApplicationStatus(online, synchronizing) {
    application.online = online;

    if (this.interactive) {
      this.offline.setStatus(!online);
      this.synchronizing.setStatus(synchronizing);
    }
  }
}


// ---------- File: WebApp.ToastBox.ts ----------
// @ts-nocheck
export class ToastBox {
  constructor() {
    this.messages = new Array();

    this.initialize();
  }

  initialize() {
    this.element = document.createElement("div");
    this.element.classList.add("ToastBox");

    const target = document.getElementById("main");
    target.appendChild(this.element);
  }

  addMessage(message) {
    this.element.appendChild(message.render(this));
    this.messages.push(message);

    message.element.style.transition = 'opacity 1s ease';
    message.element.style.opacity = "0";

    setTimeout(() => { message.element.style.opacity = "1"; }, 50);

    if (message.type !== "Error")
      setTimeout(() => { this.removeMessage(message) }, 5000);
  }

  removeMessage(message) {
    const index = this.messages.indexOf(message);

    if (index !== -1) {
      this.messages.splice(index, 1);
      message.element.style.opacity = 0;

      setTimeout(() => { this.element.removeChild(message.element) }, 1000);
    }
  }
}

export class ToastMessage {
  constructor(message, type) {
    this.type = type;
    this.id = crypto.randomUUID();

    if (typeof message === "string")
      this.message = document.createTextNode(message);
    else if (message instanceof Node)
      this.message = message.cloneNode(true);
    else
      this.message = message;
  }

  render(target) {
    const icon = document.createElement("span");
    icon.classList.add("Icon");

    const close = document.createElement("BUTTON");
    close.addEventListener("click", (event) => { target.removeMessage(this); })

    const message = document.createElement("SPAN");
    message.append(this.message);
    message.classList.add("Content");

    this.element = document.createElement("SPAN");
    this.element.dataset.Id = this.id;
    this.element.appendChild(icon);
    this.element.appendChild(close);
    this.element.appendChild(message);
    this.element.classList.add("Message");
    this.element.classList.add(this.type);

    return this.element;
  }
}


// ---------- File: WebApp.Upload.Center.ts ----------
// @ts-nocheck
export class FileUploadStatusChangedEvent {
  constructor(upload) {
    this.upload = upload;
  }
}

export class UploadCenter {
  constructor() {
    this.uploads = new Map();

    this.filters = {
      successful: false,
      pending: true,
      error: true,
    };

    this.build();
    this.updateElement();

    const query = window.matchMedia('(max-width: 50em)');
    query.addEventListener(
      'change',
      (event) => {
        if (event.matches)
          this.collapsed.setStatus(true);
      }
    );

    if (query.matches)
      this.collapsed.setStatus(true);
  }

  build() {
    this.element = document.createElement("div");
    this.element.classList.add("UploadCenter");
    this.element.appendChild(this.buildToolbar());
    this.element.appendChild(this.buildTable());

    const main = document.getElementById("main");
    main.appendChild(this.element);

    this.collapsed = new HtmlClassSwitch(this.element, "Collapsed");

    // TODO: Add a proper label.
    this.confirmationWindow = new ConfirmationWindowComponent("Some uploads have failed. Are you sure you want to close all?", "Yes", "No", () => this.closeAll(), ConfirmationClass.Delete);
  }

  buildToolbar() {
    this.toolbar = document.createElement("span");
    this.toolbar.className = "Toolbar";
    this.toolbar.appendChild(this.buildTitle());
    this.toolbar.appendChild(this.buildFilterGroup());
    this.toolbar.appendChild(this.buildToggleButton());
    this.toolbar.appendChild(this.buildCloseAllButton());
    this.toolbar.appendChild(this.buildRestartAllButton());

    return this.toolbar;
  }

  buildTable() {
    this.table = document.createElement("table");
    return this.table;
  }

  buildTitle() {
    this.title = document.createElement("span");
    this.title.className = "Title";
    this.title.innerText = "Uploads";

    return this.title;
  }

  buildFilterGroup() {
    this.filterGroup = document.createElement("span");
    this.filterGroup.className = "FilterGroup";

    this.successFilter = document.createElement("button");
    this.successFilter.className = "Filter Successful";
    this.successFilter.addEventListener(
      "click",
      () => {
        this.filters.successful = !this.filters.successful;
        this.updateElement();
      }
    );

    this.pendingFilter = document.createElement("button");
    this.pendingFilter.className = "Filter Pending";
    this.pendingFilter.addEventListener(
      "click", () => {
        this.filters.pending = !this.filters.pending;
        this.updateElement();
      }
    );

    this.errorFilter = document.createElement("button");
    this.errorFilter.className = "Filter Error";
    this.errorFilter.addEventListener(
      "click", () => {
        this.filters.error = !this.filters.error;
        this.updateElement();
      }
    );

    this.filterGroup.appendChild(this.successFilter);
    this.filterGroup.appendChild(this.pendingFilter);
    this.filterGroup.appendChild(this.errorFilter);

    return this.filterGroup;
  }

  buildToggleButton() {
    this.toggleButton = document.createElement("button");
    this.toggleButton.classList = "Toggle";
    this.toggleButton.addEventListener("click", () => this.toggle());

    return this.toggleButton;
  }

  buildCloseAllButton() {
    this.closeAllButton = document.createElement("button");
    this.closeAllButton.classList = "Close";
    this.closeAllButton.addEventListener(
      "click",
      () => {
        if (this.shouldConfirmClose())
          this.confirmationWindow.show();
        else
          this.closeAll();
      }
    );

    return this.closeAllButton;
  }

  buildRestartAllButton() {
    this.restartAllButton = document.createElement("button");
    this.restartAllButton.classList = "Restart";
    this.restartAllButton.addEventListener("click", () => this.restartAll());

    return this.restartAllButton;
  }

  updateElement() {
    this.updateFilters();
    this.updateTitle();
    this.updateState();
  }

  updateFilters() {
    this.element.classList.toggle("HideSuccessful", !this.filters.successful);
    this.element.classList.toggle("HidePending", !this.filters.pending);
    this.element.classList.toggle("HideError", !this.filters.error);

    this.successFilter.classList.toggle("Off", !this.filters.successful);
    this.pendingFilter.classList.toggle("Off", !this.filters.pending);
    this.errorFilter.classList.toggle("Off", !this.filters.error);

    const uploads = Array.from(this.uploads.values());
    const counts = {
      successful: uploads.filter(upload => upload.state === FileUploadState.Submitted).length,
      pending: uploads.filter(upload => upload.state === FileUploadState.Initial || upload.state === FileUploadState.Preparing || upload.state === FileUploadState.Prepared || upload.state === FileUploadState.Uploading || upload.state === FileUploadState.Successful || upload.state === FileUploadState.Submitting).length,
      error: uploads.filter(upload => upload.state === FileUploadState.Error || upload.state === FileUploadState.Forbidden).length,
    };

    this.successFilter.textContent = `Successful ${counts.successful}`;
    this.pendingFilter.textContent = `Pending ${counts.pending}`;
    this.errorFilter.textContent = `Error ${counts.error}`;
  }

  updateTitle() {
    const query = new DomQuery(this.table);

    const total = this.table.rows.length - query.getDescendants(WithClass("Aborted")).length - query.getDescendants(WithClass("Forbidden")).length;
    const count = query.getDescendants(WithClass("Submitted")).length;

    // TODO: Use proper translated caption.
    if (total === 0)
      this.title.innerText = "Uploads";
    else
      this.title.innerText = "Uploads: " + count + " / " + total;
  }

  createRow(upload) {
    const row = this.table.insertRow();
    row.className = FileUploadState.toText(upload.state);
    row.dataset.Id = upload.id;

    let cell = row.insertCell();
    cell.classList.add("Name");
    cell.appendChild(document.createTextNode(upload.name));

    cell = row.insertCell();
    cell.classList.add("Target");
    cell.appendChild(document.createTextNode(upload.target));

    cell = row.insertCell();
    cell.classList.add("Size")
    cell.appendChild(document.createTextNode((upload.size / 1000000).toFixed(2) + "MB"));

    const imageCell = row.insertCell();
    imageCell.classList.add("Thumbnail");

    this.renderThumbnail(upload, imageCell);

    const progress = document.createElement("span");
    progress.style.width = 100 * upload.progress + "%";

    const container = document.createElement("span");
    container.appendChild(progress);

    cell = row.insertCell();
    cell.classList.add("Progress");
    cell.appendChild(container);

    cell = row.insertCell();
    cell.classList.add("Actions");

    let action = document.createElement("button");
    action.className = "Abort";
    action.addEventListener("click", () => this.abortUpload(upload.id));

    cell.appendChild(action);

    action = document.createElement("button");
    action.className = "Restart";
    action.addEventListener("click", () => this.restartUpload(upload.id));

    cell.appendChild(action);

    cell = row.insertCell();
    cell.classList.add("Problems");

    this.renderProblems(upload, cell);
  }

  getRow(id) {
    return new DomQuery(this.table).getDescendant((element) => element.dataset.Id == id);
  }

  deleteRow(id) {
    this.uploads.delete(id);
    const row = this.getRow(id);

    if (row) {
      const index = Array.from(this.table.rows).indexOf(row);

      if (index !== -1)
        this.table.deleteRow(index);
    }
  }

  renderProblems(upload, target) {
    if (!Array.isArray(upload.problems))
      upload.problems = [upload.problems]

    target.innerHTML = "";

    upload.problems.forEach(
      (problemJson) => {
        let problem = document.createElement("span");
        problem.innerText = problemJson.Message;
        problem.classList.add("Problem");

        if ("Severity" in problemJson)
          problem.classList.add(problemJson.Severity.replace(/\s/g, ""));

        target.appendChild(problem);
      }
    );
  }

  renderThumbnail(upload, target) {
    application.fileStore.getThumbnail(upload.id)
      .then(
        (file) => {
          if (file.thumbnail) {
            const image = document.createElement("img");
            image.src = URL.createObjectURL(new Blob([file.thumbnail]));
            image.title = file.name;

            target.innerHTML = "";
            target.appendChild(image);
          }
        }
      );
  }

  updateRow(upload) {
    let row = this.getRow(upload.id);
    const query = new DomQuery(row);

    const target = query.getChild(WithClass("Target"));
    target.innerText = upload.target;

    const progress = query.getChild(WithClass("Progress"));
    progress.childNodes[0].childNodes[0].style.width = 100 * upload.progress + "%";

    const thumbnail = query.getChild(WithClass("Thumbnail"));

    if (thumbnail.childNodes.length === 0)
      this.renderThumbnail(upload, thumbnail);

    const problems = query.getChild(WithClass("Problems"));
    this.renderProblems(upload, problems);

    row.className = FileUploadState.toText(upload.state);
  }

  async abortUpload(id) {
    // TODO: This operation should happen in a single transaction.
    const file = await application.fileStore.get(parseInt(id));
    file.state = FileUploadState.Aborted;

    await application.fileStore.update(file);
    this.serviceWorker.controller.postMessage(file);
  }

  async restartUpload(id) {
    // TODO: This operation should happen in a single transaction.
    const file = await application.fileStore.get(parseInt(id));

    if (file.location !== null) {
      file.state = FileUploadState.Prepared;
      file.progress = 0.05;
      file.problems = [];
    }
    else {
      file.state = FileUploadState.Initial;
      file.progress = 0;
      file.problems = [];
    }

    await application.fileStore.update(file);
    this.serviceWorker.controller.postMessage(file);
  }

  updateState() {
    if (this.table.rows.length == 0)
      this.element.classList.remove("Expanded");
    else {
      if (this.isActive()) {
        this.element.classList.add("Active");
        this.element.classList.add("Expanded");
      }
      else
        this.element.classList.remove("Active");

      const query = new DomQuery(this.element);
      const closeButton = query.getDescendant(WithClass("Close"));

      if (closeButton) {
        if (this.isClosable())
          closeButton.removeAttribute("disabled");
        else
          closeButton.setAttribute("disabled", "true");
      }

      const restartButton = query.getDescendant(WithClass("Restart"));

      if (restartButton) {
        if (this.isRestartable())
          restartButton.removeAttribute("disabled");
        else
          restartButton.setAttribute("disabled", "true");
      }
    }
  }

  isActive() {
    const completedUploads = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Submitted || upload.state === FileUploadState.Aborted), 0);
    return this.uploads.size > completedUploads;
  }

  isClosable() {
    const finishedUploads = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Submitted || upload.state === FileUploadState.Error || upload.state === FileUploadState.Aborted), 0);
    return this.uploads.size === finishedUploads;
  }

  isRestartable() {
    const errors = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Error), 0);
    return errors > 0;
  }

  shouldConfirmClose() {
    const errors = this.uploads.values().reduce((sum, upload) => sum + (upload.state === FileUploadState.Error), 0);
    return errors > 0;
  }

  restartAll() {
    this.uploads.values().forEach(
      (upload) => {
        if (upload.state === FileUploadState.Error)
          this.restartUpload(upload.id);
      }
    );
  }

  closeAll() {
    this.uploads.values().forEach(
      (upload) => {
        if (upload.state === FileUploadState.Error)
          this.abortUpload(upload.id);

        this.deleteRow(upload.id);
      }
    );

    this.updateState();
  }

  toggle() {
    this.collapsed.toggle();
  }

  reload(upload) {
    if (this.uploads.has(upload.id)) {
      this.uploads.set(upload.id, upload);

      let row = this.getRow(upload.id);
      row.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });

      this.updateRow(upload);
      this.updateElement();

      distributeEvent(new FileUploadStatusChangedEvent(upload));
    }
  }

  reloadAll(uploads) {
    for (const upload of uploads) {
      if (this.uploads.has(upload.id))
        this.updateRow(upload);
      else
        this.createRow(upload)

      this.uploads.set(upload.id, upload);
    }

    this.updateElement();
  }

  connect(serviceWorker) {
    if (this.listener !== undefined)
      this.serviceWorker.removeEventListener("message", this.listener);

    this.listener = (event) => {
      const data = event.data;

      if (event.data.class === "Files") {
        if (Array.isArray(data.value))
          this.reloadAll(data.value);
        else
          this.reload(data.value);
      }

      this.updateState();
    }

    this.serviceWorker = serviceWorker;
    this.serviceWorker.addEventListener("message", this.listener);
  }
}


// ---------- File: WebSite.Breadcrumbs.ts ----------
// @ts-nocheck
export class BreadcrumbsComponent extends WebPageComponent {
  constructor(element) {
    super(element);
  }

  bind() {
    this.menu = this.element.childNodes[0].component;
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent)
      this.invalidate();
    else
      super.handleEvent(event);
  }

  async validate() {
    this.reload();
  }

  reload() {
    if (application.pageHandler.mode !== PageMode.Offline) {
      const uri = window.location.href;

      fetch(
        this.uri,
        {
          method: "POST",
          headers: {
            "Accept": "text/html",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            Uri: uri
          })
        }
      )
        .then((response) => this.reloadFromResponse(response));
    }
  }

  async reloadFromResponse(response) {
    const dummyElement = document.createElement("div");
    dummyElement.innerHTML = await response.text();

    interactivityRegistration.detach(this.menu.element);
    this.element.replaceChild(dummyElement.childNodes[0].childNodes[0], this.menu.element);

    const newMenu = this.element.childNodes[0];
    interactivityRegistration.attach(newMenu);
    this.menu = newMenu.component;
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

interactivityRegistration.register("Breadcrumbs", function (element) { return new BreadcrumbsComponent(element); });


// ---------- File: WebSite.Form.Feedback.ts ----------
// @ts-nocheck
export class FormFeedback extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.collapsed = new HtmlClassSwitch(this.element, "collapsed");
    this.closeButton = query.getDescendant(WithClass("close"));
  }

  close() {
    this.collapsed.setStatus(true);
  }

  attachEventHandlers() {
    this.closeButton.onclick = (event) => { this.close(getEvent(event)); };
  }
}

export class FeedbackForm extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.expanded.setStatus(false);

    this.label = query.getDescendant(WithClass("Label"));
  }

  toggleForm() {
    this.expanded.toggle();
  }

  attachEventHandlers() {
    this.label.onclick = (event) => { this.toggleForm(getEvent(event)); };
  }
}

interactivityRegistration.register("feedback", function (element) { return new FormFeedback(element); });
interactivityRegistration.register("FeedbackForm", function (element) { return new FeedbackForm(element); });


// ---------- File: WebSite.Form.Field.ts ----------
// @ts-nocheck
export class FormField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.touched = false;
  }

  addValueChangedHandler(source) {
    source.addEventListener(
      "change",
      (event) => {
        this.touched = true;
        this.validate();
      }
    );
  }

  addBlurHandler(source) {
    source.addEventListener(
      "blur",
      (event) => {
        if (event.relatedTarget === null || !this.element.contains(event.relatedTarget)) {
          this.touched = true;
          this.validate();
        }
      }
    );
  }

  checkInput(problemTarget) {
    const value = this.getValue();

    if (value === null && !this.optional)
      problemTarget.addProblem(this, this.element.dataset.EmptyValueMessage);
  }

  validate(problemTarget = null) {
    if (this.mode === ControlMode.edit) {
      if (problemTarget === null)
        problemTarget = this.parentComponent;

      if (typeof problemTarget.addProblem === "function") {
        problemTarget.clearProblems(this);
        this.checkInput(problemTarget);
      }
    }
  }

  load(value) {
    this.setValue(value);
    this.validate();
  }

  save() {
    return this.getValue();
  }

  setInputDisabled(disabled) {
    console.warn("Missing `setInputDisabled` implementation for: " + constructor.name);
  }

  setInputName(name) {
    console.warn("Missing `setInputName` implementation for: " + constructor.name);
  }

  setName(name) {
    this.updateUri(name);

    this.element.dataset.HierarchicalName = this.element.dataset.HierarchicalName.replace(/[^/]*$/, name);
    this.element.dataset.Name = name;

    this.setInputName(this.element.dataset.HierarchicalName);
  }

  updateUri(name) {
  }

  get name() {
    return this.element.dataset.Name;
  }

  get optional() {
    return this.element.dataset.Optional === "true";
  }

  get value() {
    return this.getValue();
  }

  set value(value) {
    this.setValue(value);
  }
}

export class DefaultFormField extends FormField {
  constructor(element) {
    super(element);

    this.input = null;
    this.focused = new HtmlClassSwitch(this.element, "Focus");
  }

  bind() {
    if (this.input !== null) {
      this.input.addEventListener("focus", (event) => { this.focused.setStatus(true); });
      this.input.addEventListener("blur", (event) => { this.focused.setStatus(false); });
    }
  }

  addEventListener(event, handler) {
    if (this.input !== null)
      this.input.addEventListener(event, handler);
  }

  focus() {
    if (this.input !== null)
      this.input.focus();
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  getValue() {
    return this.input.value !== "" ? this.input.value : null;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      this.input.value = fieldValue;
      this.input.dispatchEvent(new Event("change"));
    }
  }
}


// ---------- File: WebSite.Form.Field.BiState.ts ----------
// @ts-nocheck
export class BiStateField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.valueField = query.getChild(WithTagName("INPUT"));
    this.trueSelector = query.getChild(WithClass("TrueSelector"));
    this.falseSelector = query.getChild(WithClass("FalseSelector"));

    this.falseState = new HtmlClassSwitch(this.element, "False");
    this.falseState.setStatus(this.valueField.value == "False");

    this.trueState = new HtmlClassSwitch(this.element, "True");
    this.trueState.setStatus(this.valueField.value == "True");
  }

  biStateClicked(event, biState) {
    this.trueState.setStatus(biState);
    this.falseState.setStatus(!biState);

    if (biState)
      this.valueField.value = "True";
    else
      this.valueField.value = "False";
  }

  attachEventHandlers() {
    if (this.mode === ControlMode.edit) {
      this.trueSelector.onclick = (event) => { this.biStateClicked(getEvent(event), true); };
      this.falseSelector.onclick = (event) => { this.biStateClicked(getEvent(event), false); };
    }
  }
}

interactivityRegistration.register("BiState", function (element) { return new BiStateField(element); });


// ---------- File: WebSite.Form.Field.Boolean.CheckBox.ts ----------
// @ts-nocheck
export class CheckBoxField extends FormField {
  constructor(element) {
    super(element);

    this.input = new DomQuery(this.element).getDescendant(WithTagName("INPUT"));

    if (this.input !== null && !this.input.disabled) {
      this.element.tabIndex = 0;
      this.element.addEventListener("keydown", this.createKeyListener());

      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  addEventListener(event, handler) {
    this.input.addEventListener(event, handler);
  }

  createKeyListener() {
    var object = this;

    return function (event) {
      if (event.code === "Enter" || event.code === "Space") {
        object.setValue(!object.getValue());
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  getValue() {
    if (this.input.indeterminate)
      return null
    else
      return this.input.checked;
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  setValue(value) {
    this.input.indeterminate = value === null;

    if (!this.input.indeterminate)
      this.input.checked = value;

    this.input.dispatchEvent(new Event("change"));
  }
}

interactivityRegistration.register("CheckBoxField", function (element) { return new CheckBoxField(element); });


// ---------- File: WebSite.Form.Field.Date.ts ----------
// @ts-nocheck
function daysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

function HTMLTable() {
  this.table = document.createElement("table");
  this.tableHeader = document.createElement("thead");
  this.table.appendChild(this.tableHeader);
  this.tableBody = document.createElement("tbody");
  this.table.appendChild(this.tableBody);

  this.addHeaderRow = function (row) {
    this.tableHeader.appendChild(row);
  }

  this.addRow = function (row) {
    this.tableBody.appendChild(row);
  }

  this.render = function () {
    return this.table;
  }
}

function HTMLTableRow() {
  this.row = document.createElement("tr");

  this.addArrayAsCells = function (array) {
    for (var index = 0; index < array.length; index++) {
      var tableData = new HTMLTableData();
      tableData.setHTML(array[index]);

      this.addTableData(tableData.render());
    }
  }

  this.addArrayAsHeaderCells = function (array) {
    for (var index = 0; index < array.length; index++) {
      var tableHeader = new HTMLTableHeader();
      tableHeader.setHTML(array[index]);

      this.addTableData(tableHeader.render());
    }
  }

  this.addTableData = function (tableData) {
    this.row.appendChild(tableData);
  }

  this.render = function () {
    return this.row;
  }
}

function HTMLTableHeader() {
  this.tableHeader = document.createElement("th");

  this.render = function () {
    return this.tableHeader;
  }

  this.setHTML = function (html) {
    this.tableHeader.innerHTML = html;
  }
}

function HTMLTableData() {
  this.tableData = document.createElement("td");

  this.appendChild = function (child) {
    this.tableData.appendChild(child);
  }

  this.render = function () {
    return this.tableData;
  }

  this.setColSpan = function (colSpan) {
    this.tableData.colSpan = colSpan;
  }

  this.setHTML = function (html) {
    this.tableData.innerHTML = html;
  }
}

function DateSelectorPage(input, dayLabels, year, month, showTime) {
  this.determineStartDay = function () {
    let day = (new Date(year, month, 1).getDay() + 6 % 7);

    if (day < 3)
      day = day + 7;

    if (day > 10)
      day = day - 7;

    return day;
  }

  this.determineEndDay = function () {
    return this.startDay + this.daysInMonth - 1;
  }

  this.dateToText = function (date) {
    var monthText = date.getMonth() + 1;
    var hourText = this.currentDate.getHours();
    var minutesText = this.currentDate.getMinutes();
    var dayText = date.getDate();

    if (monthText < 10)
      monthText = "0" + monthText;

    if (dayText < 10)
      dayText = "0" + dayText;

    if (hourText < 10)
      hourText = "0" + hourText;

    if (minutesText < 10)
      minutesText = "0" + minutesText;

    var result = date.getFullYear() + "-" + monthText + "-" + dayText

    if (this.showTime)
      result = result + " " + hourText + ":" + minutesText;

    return result;
  }

  this.daysArray = function () {
    var array = new Array(42);
    var start = this.startDay;

    var date = new Date(year, month, 1);
    date.setDate(date.getDate() - start);

    for (let index = 0; index < array.length; index++) {
      array[index] = new Date(date.valueOf());
      date.setDate(date.getDate() + 1);
    }

    return array;
  }

  this.changeFocus = function (delta) {
    let previousIndex = this.focusedIndex;

    this.focusedIndex += delta;
    this.focus(previousIndex);
  }

  this.focus = function (previousIndex) {
    this.buttons[previousIndex].tabIndex = -1;

    let button = this.buttons[this.focusedIndex];
    button.tabIndex = 0;
    button.focus();
  }

  this.focusLast = function () {
    let previousIndex = this.focusedIndex;

    this.focusedIndex = this.startDay + this.daysInMonth - 1;
    this.focus(previousIndex);
  }

  this.focusFirst = function () {
    let previousIndex = this.focusedIndex;

    this.focusedIndex = this.startDay;
    this.focus(previousIndex);
  }

  this.handleDateClick = function (date) {
    return () => this.setDate(date);
  }

  this.headerRow = function () {
    let row = new HTMLTableRow();
    row.addArrayAsHeaderCells(this.dayLabels);

    return row.render();
  }

  this.isSelected = function (date) {
    let value = this.dateToText(date);
    return value.substring(0, 11) == this.input.value.substring(0, 11);
  }

  this.isToday = function (date) {
    return this.currentDate.getFullYear() == date.getFullYear() && this.currentDate.getMonth() == date.getMonth() && this.currentDate.getDate() == date.getDate();
  }

  this.render = function (table) {
    this.buttons = new Array();

    table.addHeaderRow(this.headerRow());

    let index = 0;
    let daysArray = this.daysArray();

    while (index < daysArray.length) {
      let row = new HTMLTableRow();

      for (let weekDay = 0; weekDay < 7; weekDay++) {
        let label = document.createElement("span");
        label.innerText = daysArray[index].getDate();

        let button = document.createElement("button");
        button.appendChild(label);
        button.onclick = this.handleDateClick(daysArray[index]);
        button.tabIndex = -1;

        this.buttons.push(button);

        let cell = document.createElement("td");
        cell.appendChild(button);

        if (this.isToday(daysArray[index]))
          cell.classList.add("Today");

        if (this.isSelected(daysArray[index]))
          cell.classList.add("Selected");

        if (daysArray[index].getMonth() != this.month)
          cell.classList.add("OtherMonth");

        row.addTableData(cell);
        index++;
      }

      table.addRow(row.render());
    }

    return table.render();
  }

  this.setDate = function (date) {
    this.input.value = this.dateToText(date);

    this.input.dispatchEvent(new Event("input"));
    this.input.dispatchEvent(new Event("change"));
  }

  this.input = input;
  this.dayLabels = dayLabels;
  this.month = month;
  this.showTime = showTime;
  this.daysInMonth = daysInMonth(year, month);
  this.startDay = this.determineStartDay();
  this.endDay = this.determineEndDay();
  this.currentDate = new Date();
  this.focusedIndex = this.startDay;
}

function DateSelector(input, button, monthLabels, dayLabels, todayLabel, showTime) {
  this.changeMonth = function (index) {
    let date = this.currentDate.getDate();

    this.currentDate.setMonth(this.currentDate.getMonth() + index);

    if (this.currentDate.getDate() < date) {
      this.currentDate.setDate(0);
    }
  }

  this.create = function () {
    this.element.className = "DateSelector";
    this.element.tabIndex = "0";

    this.currentNode = this.refreshPage();
    this.element.appendChild(this.currentNode);

    this.input.oninput = (event) => {
      this.refresh();

      if (this.expanded.getStatus())
        this.setStatus(false);
    };
  }

  this.createKeyHandler = function () {
    return (event) => this.handleKey(event);
  }

  this.handleClickChangeMonthEvent = function (link, index) {
    return (event) => {
      this.changeMonth(index);
      this.refresh();

      getEvent(event).stopHandling();
    }
  }

  this.handleKey = function (event) {
    if (event.code === "ArrowLeft") {
      if (this.page.focusedIndex > this.page.startDay)
        this.page.changeFocus(-1);
      else {
        this.changeMonth(-1);
        this.refresh();
        this.page.focusLast();
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowRight") {
      if (this.page.focusedIndex < this.page.endDay)
        this.page.changeFocus(1);
      else {
        this.changeMonth(1);
        this.refresh();
        this.page.focusFirst();
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowUp") {
      if (this.page.focusedIndex >= this.page.startDay + 7)
        this.page.changeFocus(-7);
      else {
        let delta = this.page.startDay - (this.page.focusedIndex - 7);

        this.changeMonth(-1);
        this.refresh();
        this.page.changeFocus(this.page.daysInMonth - delta);
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowDown") {
      if (this.page.focusedIndex <= this.page.endDay - 7)
        this.page.changeFocus(7);
      else {
        let delta = this.page.focusedIndex - this.page.endDay + 7;

        this.changeMonth(1);
        this.refresh();
        this.page.changeFocus(delta - 1);
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "Home") {
      this.page.focusFirst();

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "End") {
      this.page.focusLast();

      event.preventDefault();
      event.stopPropagation();
    }
  }

  this.toolbar = function () {
    let today = document.createElement("button");

    today.classList.add("Today");
    today.innerText = this.todayLabel;

    today.onclick = (event) => {
      this.currentDate = new Date();
      this.refresh();

      getEvent(event).stopHandling();
    };

    let todayTableData = new HTMLTableData();
    todayTableData.appendChild(today);
    todayTableData.setColSpan(3);

    let result = new HTMLTableRow();
    result.addTableData(new HTMLTableData().render());
    result.addTableData(new HTMLTableData().render());
    result.addTableData(todayTableData.render());
    result.addTableData(new HTMLTableData().render());
    result.addTableData(new HTMLTableData().render());

    return result.render();
  }

  this.header = function () {
    let fastBackward = document.createElement("button");
    let backward = document.createElement("button");
    let caption = document.createElement("span");
    let forward = document.createElement("button");
    let fastForward = document.createElement("button");

    fastBackward.innerHTML = "&lt;&lt;";
    fastBackward.onclick = this.handleClickChangeMonthEvent(fastBackward, -12);

    backward.innerHTML = "&lt;";
    backward.onclick = this.handleClickChangeMonthEvent(backward, -1);

    forward.innerHTML = "&gt;";
    forward.onclick = this.handleClickChangeMonthEvent(forward, 1);

    fastForward.innerHTML = "&gt;&gt;";
    fastForward.onclick = this.handleClickChangeMonthEvent(fastForward, 12);

    caption.innerHTML = this.currentDate.getFullYear() + " " + this.monthLabels[this.currentDate.getMonth()];
    caption.className = "caption";

    let result = new HTMLTableRow();
    let fastBackwardTableData = new HTMLTableData();
    let backwardTableData = new HTMLTableData();
    let captionTableData = new HTMLTableData();
    let forwardTableData = new HTMLTableData();
    let fastForwardTableData = new HTMLTableData();

    captionTableData.setColSpan(3);

    fastBackwardTableData.appendChild(fastBackward);
    backwardTableData.appendChild(backward);
    captionTableData.appendChild(caption);
    forwardTableData.appendChild(forward);
    fastForwardTableData.appendChild(fastForward);

    result.addTableData(fastBackwardTableData.render());
    result.addTableData(backwardTableData.render());
    result.addTableData(captionTableData.render());
    result.addTableData(forwardTableData.render());
    result.addTableData(fastForwardTableData.render());

    return result.render();
  }

  this.parseDate = function (dateString) {
    let date = null;

    if (dateString.length === 10) {
      let parts = dateString.split("-");

      if (parts.length === 3)
        date = new Date(parts[0], parts[1] - 1, parts[2]);
    }

    return date;
  }

  this.parseDateTime = function (dateString) {
    let date = null;

    if (dateString.length === 16 || dateString.length === 19) {
      let dateTimeParts = dateString.split(" ");

      if (dateTimeParts.length === 2) {
        let dateParts = dateTimeParts[0].split("-");
        let timeParts = dateTimeParts[1].split(":");

        if (dateParts.length === 3 && timeParts.length === 2)
          date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1]);
        else if (dateParts.length === 3 && timeParts.length === 3)
          date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
      }
    }

    return date;
  }

  this.parseValue = function (dateString) {
    if (this.showTime)
      return this.parseDateTime(dateString);
    else
      return this.parseDate(dateString)
  }

  this.refresh = function () {
    let newNode = this.refreshPage();

    this.element.replaceChild(newNode, this.currentNode);
    this.currentNode = newNode;
    this.page.focus(0);
  }

  this.refreshPage = function () {
    let table = new HTMLTable();
    table.addHeaderRow(this.toolbar());
    table.addHeaderRow(this.header());
    table.tableBody.addEventListener("keydown", this.createKeyHandler());

    this.page = new DateSelectorPage(this.input, this.dayLabels, this.currentDate.getFullYear(), this.currentDate.getMonth(), this.showTime);
    this.page.render(table);

    let result = document.createElement("div");
    result.appendChild(table.render());

    return result;
  }

  this.setStatus = function (status) {
    this.expanded.setStatus(status);

    if (status) {
      this.page.focus(0);
      this.clickOutsideListener = new ClickOutsideListener(
        [this.element, this.button],
        () => this.setStatus(false)
      );
    }
    else {
      removeClickOutsideListener(this.clickOutsideListener);
      this.input.focus();
    }
  }

  this.toggle = function () {
    this.setStatus(!this.expanded.getStatus());
  }

  this.input = input;
  this.button = button;
  this.monthLabels = monthLabels;
  this.dayLabels = dayLabels;
  this.todayLabel = todayLabel;
  this.showTime = showTime;
  this.element = document.createElement("div");
  this.expanded = new HtmlClassSwitch(this.element, "Expanded");

  if (this.input.value.length > 0) {
    let value = this.parseValue(input.value);

    if (value !== null)
      this.currentDate = value;
    else
      this.currentDate = new Date();
  }
  else
    this.currentDate = new Date();

  this.create();
}

export class DateField extends DefaultFormField {
  constructor(element, showTime) {
    super(element);

    this.showTime = showTime;

    if (this.mode === ControlMode.edit) {
      this.determineElements();
      this.initializeLabels();
      this.createSelector();
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    this.button.addEventListener(
      "click",
      (event) => this.selector.toggle()
    );

    this.input.addEventListener("keyup", this.createKeyHandler());
    this.addValueChangedHandler(this.input);

    this.input.addEventListener(
      "blur",
      (event) => {
        if (!this.selector.expanded.getStatus() && event.relatedTarget !== this.button && event.relatedTarget !== null)
          this.validate();
      }
    );
  }

  checkInput(problemTarget) {
    super.checkInput(problemTarget);

    if (this.value !== null) {
      if (this.showTime && !(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(this.value) && this.isValidDateTime(this.value)))
        problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
      else if (!this.showTime && !(/^\d{4}-\d{2}-\d{2}$/.test(this.value) && this.isValidDate(this.value)))
        problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
    }
  }

  isValidDate(value) {
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    return (year >= 1 && month >= 1 && month <= 12 && day >= 1 && day <= 31)
      && (date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day);
  }

  isValidDateTime(value) {
    const [datePart, timePart] = value.split(" ");
    const [hour, minute] = timePart.split(":").map(Number);

    return this.isValidDate(datePart)
      && (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59)
  }

  createKeyHandler() {
    return (event) => { return this.handleKey(event) };
  }

  createSelector() {
    this.selector = new DateSelector(this.input, this.button, this.monthLabels, this.dayLabels, this.todayLabel, this.showTime);
    this.element.appendChild(this.selector.element);
  }

  determineElements() {
    let query = new DomQuery(this.element);

    this.button = query.getChild(WithTagName("BUTTON"));
    this.button.tabIndex = -1;

    let label = query.getChild(WithClass("Labels"));
    this.labels = new DomQuery(label).getChildren(WithClass("Label"));

    this.input = query.getChild(WithTagName("INPUT"));
  }

  handleKey(event) {
    if (event.ctrlKey && event.code === "Space")
      this.selector.toggle();
  }

  initializeLabels() {
    this.monthLabels = new Array();
    this.dayLabels = new Array();

    let labelIndex = 0;

    for (let index = 1; index <= 12; index++) {
      this.monthLabels.push(this.labels[labelIndex].innerHTML);
      labelIndex++;
    }

    for (let index = 1; index <= 7; index++) {
      this.dayLabels.push(this.labels[labelIndex].innerHTML);
      labelIndex++;
    }

    this.todayLabel = this.labels[labelIndex].innerHTML;
  }

  removeClickOutsideListener() {
    let htmlElement = document.getElementsByTagName("html")[0];
    htmlElement.removeEventListener("click", this.clickOutsideListener, true);
  }
}

interactivityRegistration.register("DateField", function (element) { return new DateField(element, false); });
interactivityRegistration.register("DateTimeField", function (element) { return new DateField(element, true); });


// ---------- File: WebSite.Form.Field.Period.ts ----------
// @ts-nocheck
const PeriodSelectionMode = new Enumeration(["Start", "End"]);

export class PeriodSelectorPage {
  constructor(periodStart, periodEnd, dayLabels, year, month, period) {
    this.periodStart = periodStart;
    this.periodEnd = periodEnd;
    this.period = period;

    this.dayLabels = dayLabels;
    this.year = year;
    this.month = month;

    this.daysInMonth = daysInMonth(year, month);
    this.startDay = this.determineStartDay();
    this.endDay = this.determineEndDay();
    this.referenceDate = new Date();
    this.focusedIndex = this.startDay;
  }

  determineStartDay() {
    let day = new Date(this.year, this.month, 1).getDay() + 6 % 7;

    if (day < 3)
      day = day + 7;

    if (day > 10)
      day = day - 7;

    return day;
  }

  determineEndDay() {
    return this.startDay + this.daysInMonth - 1;
  }

  daysArray() {
    const array = new Array(42);
    const start = this.startDay;

    const date = new Date(this.year, this.month, 1);
    date.setDate(date.getDate() - start);

    for (let index = 0; index < array.length; index++) {
      array[index] = new Date(date.valueOf());
      date.setDate(date.getDate() + 1);
    }

    return array;
  }

  changeFocus(delta) {
    this.focusIndex(this.focusedIndex + delta);
  }

  focus(previousIndex) {
    this.buttons[previousIndex].tabIndex = -1;

    const button = this.buttons[this.focusedIndex];
    button.tabIndex = 0;
    button.focus();
  }

  focusIndex(index) {
    const previousIndex = this.focusedIndex;

    this.focusedIndex = index;
    this.focus(previousIndex);
  }

  focusLast() {
    this.focusIndex(this.startDay + this.daysInMonth - 1);
  }

  focusFirst() {
    this.focusIndex(this.startDay);
  }

  handleDateClick(date) {
    return () => this.setDate(date);
  }

  headerRow() {
    const row = new HTMLTableRow();
    row.addArrayAsHeaderCells(this.dayLabels);

    return row.render();
  }

  isToday(date) {
    return this.equalDates(this.referenceDate, date);
  }

  equalDates(left, right) {
    return left.getFullYear() === right.getFullYear() && left.getMonth() === right.getMonth() && left.getDate() === right.getDate();
  }

  render(table) {
    this.buttons = new Array();
    table.addHeaderRow(this.headerRow());

    let index = 0;
    const daysArray = this.daysArray();

    while (index < daysArray.length) {
      const row = new HTMLTableRow();

      for (let weekDay = 0; weekDay < 7; weekDay++) {
        const date = daysArray[index];

        const label = document.createElement("span");
        label.innerText = date.getDate();

        const button = document.createElement("button");
        button.appendChild(label);
        button.onclick = this.handleDateClick(date);
        button.tabIndex = -1;

        this.buttons.push(button);

        const cell = document.createElement("td");
        cell.appendChild(button);

        if (date.getMonth() !== this.month)
          cell.classList.add("OtherMonth");
        else {
          if (this.period.start !== null && date.getTime() === this.period.start.getTime())
            cell.classList.add("PeriodStart");

          if (this.period.end !== null && date.getTime() === this.period.end.getTime())
            cell.classList.add("PeriodEnd");

          if (this.period.start !== null && this.period.end !== null && date.getTime() > this.period.start.getTime() && date.getTime() < this.period.end.getTime())
            cell.classList.add("InPeriod");
        }

        if (this.isToday(date))
          cell.classList.add("Today");

        row.addTableData(cell);
        index++;
      }

      table.addRow(row.render());
    }

    return table.render();
  }

  setDate(date) {
    if (this.period.mode === PeriodSelectionMode.Start) {
      this.setValue(this.periodStart, date);

      if (date > this.period.end)
        this.setValue(this.periodEnd, null);

      this.period.mode = PeriodSelectionMode.End;
    }
    else if (this.period.mode === PeriodSelectionMode.End) {
      if (date < this.period.start)
        this.setValue(this.periodStart, date);
      else {
        this.setValue(this.periodEnd, date);
        this.period.callback();
        this.period.mode = PeriodSelectionMode.Start;
      }
    }
  }

  setValue(field, date) {
    if (date !== null)
      field.value = this.valueToText(date);
    else
      field.value = '';

    field.dispatchEvent(new Event("input"));
    field.dispatchEvent(new Event("change"));
  }
}

export class PeriodSelector {
  constructor(periodStart, periodEnd, monthLabels, dayLabels, todayLabel, callback) {
    this.periodStart = periodStart;
    this.periodEnd = periodEnd;

    this.monthLabels = monthLabels;
    this.dayLabels = dayLabels;
    this.todayLabel = todayLabel;
    this.element = document.createElement("div");
    this.expanded = new HtmlClassSwitch(this.element, "Expanded");

    this.period = {
      start: this.parseValue(this.periodStart.value),
      end: this.parseValue(this.periodEnd.value),
      mode: PeriodSelectionMode.Start,
      callback: callback
    }

    if (this.period.start !== null)
      this.referenceDate = new Date(this.period.start.getTime());
    else if (this.period.end !== null)
      this.referenceDate = new Date(this.period.end.getTime());
    else
      this.referenceDate = new Date();

    this.create();
    this.setPeriodSelectionMode(this.period.mode);
  }

  changeMonth(index) {
    const date = this.referenceDate.getDate();
    this.referenceDate.setMonth(this.referenceDate.getMonth() + index);

    if (this.referenceDate.getDate() < date) {
      this.referenceDate.setDate(0);
    }
  }

  create() {
    this.element.className = "DateSelector";
    this.element.tabIndex = "0";

    this.currentNode = this.refreshPage();
    this.element.appendChild(this.currentNode);

    this.periodStart.addEventListener(
      "input",
      (event) => {
        const value = this.parseValue(this.periodStart.value);

        this.period.start = value;
        this.refresh();
      }
    );

    this.periodEnd.addEventListener(
      "input",
      (event) => {
        const value = this.parseValue(this.periodEnd.value);

        this.period.end = value;
        this.refresh();
      }
    );
  }

  createKeyHandler() {
    return (event) => this.handleKey(event);
  }

  handleClickChangeMonthEvent(link, index) {
    return (event) => {
      this.changeMonth(index);
      this.refresh();

      getEvent(event).stopHandling();
    }
  }

  handleKey(event) {
    if (event.code === "ArrowLeft") {
      if (this.page.focusedIndex > this.page.startDay)
        this.page.changeFocus(-1);
      else {
        this.changeMonth(-1);
        this.refresh();
        this.page.focusLast();
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowRight") {
      if (this.page.focusedIndex < this.page.endDay)
        this.page.changeFocus(1);
      else {
        this.changeMonth(1);
        this.refresh();
        this.page.focusFirst();
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowUp") {
      if (this.page.focusedIndex >= this.page.startDay + 7)
        this.page.changeFocus(-7);
      else {
        const delta = this.page.startDay - (this.page.focusedIndex - 7);

        this.changeMonth(-1);
        this.refresh();
        this.page.changeFocus(this.page.daysInMonth - delta);
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowDown") {
      if (this.page.focusedIndex <= this.page.endDay - 7)
        this.page.changeFocus(7);
      else {
        const delta = this.page.focusedIndex - this.page.endDay + 7;

        this.changeMonth(1);
        this.refresh();
        this.page.changeFocus(delta - 1);
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "Home") {
      this.page.focusFirst();

      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "End") {
      this.page.focusLast();

      event.preventDefault();
      event.stopPropagation();
    }
  }

  header() {
    const fastBackward = document.createElement("button");
    const backward = document.createElement("button");
    const caption = document.createElement("span");
    const forward = document.createElement("button");
    const fastForward = document.createElement("button");

    fastBackward.innerHTML = "&lt;&lt;";
    fastBackward.onclick = this.handleClickChangeMonthEvent(fastBackward, -12);

    backward.innerHTML = "&lt;";
    backward.onclick = this.handleClickChangeMonthEvent(backward, -1);

    forward.innerHTML = "&gt;";
    forward.onclick = this.handleClickChangeMonthEvent(forward, 1);

    fastForward.innerHTML = "&gt;&gt;";
    fastForward.onclick = this.handleClickChangeMonthEvent(fastForward, 12);

    caption.innerHTML = this.referenceDate.getFullYear() + " " + this.monthLabels[this.referenceDate.getMonth()];
    caption.className = "caption";

    const result = new HTMLTableRow();
    const fastBackwardTableData = new HTMLTableData();
    const backwardTableData = new HTMLTableData();
    const captionTableData = new HTMLTableData();
    const forwardTableData = new HTMLTableData();
    const fastForwardTableData = new HTMLTableData();

    captionTableData.setColSpan(3);
    fastBackwardTableData.appendChild(fastBackward);
    backwardTableData.appendChild(backward);
    captionTableData.appendChild(caption);
    forwardTableData.appendChild(forward);
    fastForwardTableData.appendChild(fastForward);

    result.addTableData(fastBackwardTableData.render());
    result.addTableData(backwardTableData.render());
    result.addTableData(captionTableData.render());
    result.addTableData(forwardTableData.render());
    result.addTableData(fastForwardTableData.render());

    return result.render();
  }

  refresh() {
    const newNode = this.refreshPage();

    this.element.replaceChild(newNode, this.currentNode);
    this.currentNode = newNode;
    this.page.focus(0);
  }

  refreshPage() {
    const table = new HTMLTable();
    table.addHeaderRow(this.header());
    table.tableBody.addEventListener("keydown", this.createKeyHandler());

    this.page = this.newPage();
    this.page.render(table);

    const result = document.createElement("div");
    result.appendChild(table.render());

    return result;
  }

  setPeriodSelectionMode(mode) {
    this.period.mode = mode;
    this.refresh();
  }
}

export class PeriodField extends FormField {
  constructor(element) {
    super(element);

    this.input = null;

    if (this.mode === ControlMode.edit) {
      this.determineElements();
      this.initializeLabels();
      this.createSelector();
      this.attachEventHandlers();
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.button = query.getChild(WithTagName("BUTTON"));
    this.selector = query.getChild(WithClass("PeriodSelector"));

    this.determineInputFields();

    this.input = document.createElement("input");
    this.input.setAttribute("type", "hidden");
    this.input.setAttribute("name", this.element.dataset.HierarchicalName);
    this.input.value = this.determineValue();

    this.element.appendChild(this.input);

    this.submitButton = query.getDescendant(WithClass("Submit"));
    this.defaultPeriods = query.getDescendants(WithClass("DefaultPeriod"));
  }

  attachEventHandlers() {
    this.button.addEventListener("click", (event) => this.toggleSelector());
    this.submitButton.addEventListener("click", (event) => this.submit());

    this.start.addEventListener("change", (event) => this.updateValue());
    this.end.addEventListener("change", (event) => this.updateValue());

    for (const defaultPeriod of this.defaultPeriods) {
      defaultPeriod.addEventListener(
        "click",
        (event) => {
          this.start.value = defaultPeriod.dataset.PeriodStart;
          this.start.dispatchEvent(new Event("input"));

          this.end.value = defaultPeriod.dataset.PeriodEnd;
          this.end.dispatchEvent(new Event("input"));

          this.updateValue();
          this.submit();
        }
      );
    }

    this.addValueChangedHandler(this.input);
    this.addBlurHandler(this.start);
    this.addBlurHandler(this.end);
  }

  checkInput(problemTarget) {
    if ((this.startRequired || this.endRequired) && this.value === "")
      problemTarget.addProblem(this, this.element.dataset.EmptyValueMessage);

    if (this.value.length > 0) {
      const [start, end] = this.value.split(",");

      if (start.length > 0 && !this.isValid(start))
        problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
      else if (start.length === 0 && this.startRequired)
        problemTarget.addProblem(this, this.element.dataset.StartRequiredMessage);

      if (end.length > 0 && !this.isValid(end))
        problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
      else if (end.length === 0 && this.endRequired)
        problemTarget.addProblem(this, this.element.dataset.EndRequiredMessage);

      if (this.isValid(start) && this.isValid(end)) {
        const startDate = new Date(start);
        const endDate = new Date(end);

        if (startDate > endDate)
          problemTarget.addProblem(this, this.element.dataset.StartAfterEndMessage);
      }
    }
  }

  determineValue() {
    const renderer = new ValueTextRenderer();

    const start = this.start.value;
    const end = this.end.value;

    if (start.length > 0 || end.length > 0)
      return renderer.render(start) + ',' + renderer.render(end);
    else
      return "";
  }

  updateValue() {
    this.input.value = this.determineValue();
    this.input.dispatchEvent(new Event("change"));
  }

  getValue() {
    return this.input.value;
  }

  initializeLabels() {
    this.labels = new DomQuery(this.element).getDescendants(WithClass("Label"));

    this.monthLabels = new Array();
    this.dayLabels = new Array();

    let labelIndex = 0;

    for (let index = 1; index <= 12; index++) {
      this.monthLabels.push(this.labels[labelIndex].innerHTML);
      labelIndex++;
    }

    for (let index = 1; index <= 7; index++) {
      this.dayLabels.push(this.labels[labelIndex].innerHTML);
      labelIndex++;
    }

    this.todayLabel = this.labels[labelIndex].innerHTML;
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  submit() {
    this.toggleSelector();
    this.element.dispatchEvent(new Event("change"));
  }

  toggleSelector() {
    if (this.selector.classList.contains("Expanded")) {
      this.selector.classList.remove("Expanded");
      removeClickOutsideListener(this.clickOutsideListener);
    }
    else {
      this.selector.classList.add("Expanded");
      this.clickOutsideListener = new ClickOutsideListener(
        [this.selector, this.button],
        () => this.toggleSelector()
      );
    }
  }

  get startRequired() {
    return this.element.dataset.StartRequired === "true";
  }

  get endRequired() {
    return this.element.dataset.EndRequired === "true";
  }
}


// ---------- File: WebSite.Form.Field.Date.Period.ts ----------
// @ts-nocheck
export class DatePeriodSelectorPage extends PeriodSelectorPage {
  valueToText(date) {
    const monthText = (date.getMonth() + 1).toString().padStart(2, "0");
    const dayText = date.getDate().toString().padStart(2, "0");

    return `${date.getFullYear()}-${monthText}-${dayText}`;
  }
}

export class DatePeriodSelector extends PeriodSelector {
  newPage() {
    return new DatePeriodSelectorPage(
      this.periodStart,
      this.periodEnd,
      this.dayLabels,
      this.referenceDate.getFullYear(),
      this.referenceDate.getMonth(),
      this.period
    );
  }

  parseValue(dateString) {
    let date = null;

    if (dateString.length === 10) {
      const parts = dateString.split("-");

      if (parts.length === 3)
        date = new Date(parts[0], parts[1] - 1, parts[2]);
    }

    return date;
  }
}

export class DatePeriodField extends PeriodField {
  constructor(element) {
    super(element);
  }

  createSelector() {
    this.periodSelector = new DatePeriodSelector(this.start, this.end, this.monthLabels, this.dayLabels, this.todayLabel, () => this.submit());
    this.selector.appendChild(this.periodSelector.element);
  }

  determineInputFields() {
    const query = new DomQuery(this.element);

    this.start = query.getChild(WithClass("Start"));
    this.end = query.getChild(WithClass("End"));
  }

  isValid(value) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return (year >= 1 && month >= 1 && month <= 12 && day >= 1 && day <= 31)
        && (date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day);
    }
    else
      return false;
  }
}

interactivityRegistration.register("DatePeriod", function (element) { return new DatePeriodField(element); });


// ---------- File: WebSite.Form.Field.DateTime.Period.ts ----------
// @ts-nocheck
export class DateTimePeriodSelectorPage extends PeriodSelectorPage {
  valueToText(date) {
    const monthText = (date.getMonth() + 1).toString().padStart(2, "0");
    const dayText = date.getDate().toString().padStart(2, "0");
    const hourText = date.getHours().toString().padStart(2, "0");
    const minuteText = date.getMinutes().toString().padStart(2, "0");
    const secondText = date.getSeconds().toString().padStart(2, "0");

    return `${date.getFullYear()}-${monthText}-${dayText} ${hourText}:${minuteText}:${secondText}`;
  }
}

export class DateTimePeriodSelector extends PeriodSelector {
  newPage() {
    return new DateTimePeriodSelectorPage(
      this.periodStart,
      this.periodEnd,
      this.dayLabels,
      this.referenceDate.getFullYear(),
      this.referenceDate.getMonth(),
      this.period
    );
  }

  parseValue(dateString) {
    let dateTime = null;

    if (dateString.length === 19) {
      const parts = dateString.split(" ");

      if (parts.length === 2) {
        const dateParts = parts[0].split("-");
        const timeParts = parts[1].split(":");

        if (dateParts.length === 3 && timeParts.length === 3)
          dateTime = new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
      }
    }

    return dateTime;
  }
}

export class DateTimePeriodField extends PeriodField {
  constructor(element) {
    super(element);
  }

  createSelector() {
    this.periodSelector = new DateTimePeriodSelector(this.start, this.end, this.monthLabels, this.dayLabels, this.todayLabel, () => this.submit());
    this.selector.appendChild(this.periodSelector.element);
  }

  determineInputFields() {
    const query = new DomQuery(this.element);

    this.start = query.getChild(WithClass("Low"));
    this.end = query.getChild(WithClass("High"));
  }

  isValid(value) {
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
      const [datePart, timePart] = value.split(" ");
      const [hour, minute, second] = timePart.split(":").map(Number);

      return this.isValidDate(datePart)
        && (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59 && second >=0 && second <= 59)
    }
    else
      return false;
  }

  isValidDate(value) {
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    return (year >= 1 && month >= 1 && month <= 12 && day >= 1 && day <= 31)
      && (date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day);
  }
}

interactivityRegistration.register("DateTimePeriod", function (element) { return new DateTimePeriodField(element); });


// ---------- File: WebSite.Form.Field.Decimal.ts ----------
// @ts-nocheck
export class DecimalField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.input !== null) {
      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  checkInput(problemTarget) {
    super.checkInput(problemTarget);

    const value = this.getValue();

    if (value !== null && !/^-?\d+(\.\d+)?$/.test(value))
      problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
  }

  determineElements() {
    this.input = this.element;
  }
}

interactivityRegistration.register("DecimalField", function (element) { return new DecimalField(element); });


// ---------- File: WebSite.Form.Field.Expression.ts ----------
// @ts-nocheck
export class ExpressionField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
    this.element.tabIndex = 0;
  }

  attachHandlers() {
    if (this.mode === ControlMode.edit) {
      this.element.addEventListener("click", (event) => { this.focus(); });
      this.element.addEventListener("focus", (event) => { this.focus(); });

      this.input.addEventListener("blur", (event) => { this.blur(); });
      this.input.addEventListener("change", (event) => { this.reload() });

      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  blur() {
    this.element.classList.remove("Focus");
    this.element.tabIndex = 0;
  }

  focus() {
    this.element.classList.add("Focus");
    this.input.focus();

    this.element.tabIndex = -1;
  }

  determineElements() {
    this.expression = this.element.childNodes[0];

    if (this.mode === ControlMode.edit) {
      this.input = new DomQuery(this.element).getChild(WithTagName("TEXTAREA"));
      this.input.spellcheck = false;
    }
  }

  reload() {
    this.client.sendJsonRequest(
      this.element.dataset.Uri, {
      "Command": "Parse",
      "Value": this.input.value
    },
      (response) => {
        if (response.status === 200) {
          var dummy = document.createElement("div");
          dummy.innerHTML = response.responseText;

          this.element.replaceChild(dummy.firstChild.firstChild, this.element.firstChild);

          this.expression = this.element.firstChild;
          this.expression.addEventListener("click", (event) => { this.focus() });
        }
      }
    );
  }

  updateUri(name) {
    const encodedName = encodeURIComponent(name);
    const newUri = this.element.dataset.Uri.replace(/\/[^\/]+$/, `/${encodedName}`);

    this.element.dataset.Uri = newUri;
  }
}

interactivityRegistration.register("Expression", function (element) { return new ExpressionField(element); });


// ---------- File: WebSite.Form.Field.FloatingPoint.ts ----------
// @ts-nocheck
export class FloatingPointField extends DefaultFormField {
    constructor(element) {
      super(element);

      this.determineElements();
      this.attachHandlers();
    }

    attachHandlers() {
      if (this.input !== null) {
        this.addValueChangedHandler(this.input);
        this.addBlurHandler(this.input);
      }
    }

    checkInput(problemTarget) {
      super.checkInput(problemTarget);

      const value = this.getValue();

      if (value !== null && !/^-?\d+(\.\d+)?$/.test(value))
        problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
    }

    determineElements() {
      this.input = this.element;
    }
  }

  interactivityRegistration.register("FloatingPointField", function (element) { return new FloatingPointField(element); });


// ---------- File: WebSite.Form.Field.Image.ts ----------
// @ts-nocheck
var CropHandle = new Enumeration(["TopLeft", "TopRight", "BottomLeft", "BottomRight", "Center"]);

function uniqueFileName(name, used) {
  if (!used.has(name)) {
    used.add(name);
    return name;
  }

  const dot = name.lastIndexOf(".");
  const base = dot > 0 ? name.slice(0, dot) : name;
  const extension = dot > 0 ? name.slice(dot) : "";

  let index = 2;
  let candidate = base + "." + index + extension;

  while (used.has(candidate)) {
    index++;
    candidate = base + "." + index + extension;
  }

  used.add(candidate);
  return candidate;
}

function triggerDownload(blob, name) {
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = name;

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
}

class CropRectangle {
  constructor(x, y, width, height) {
    this.set(x, y, width, height);
  }

  set(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  containsPoint(x, y) {
    return (
      x >= this.x &&
      x <= this.x + this.width &&
      y >= this.y &&
      y <= this.y + this.height
    );
  }

  getHandles() {
    return {
      [CropHandle.TopLeft]: { x: this.x, y: this.y },
      [CropHandle.TopRight]: { x: this.x + this.width, y: this.y },
      [CropHandle.BottomLeft]: { x: this.x, y: this.y + this.height },
      [CropHandle.BottomRight]: { x: this.x + this.width, y: this.y + this.height },
    };
  }

  getHandleAtPoint(x, y, size) {
    for (const [key, point] of Object.entries(this.getHandles())) {
      if (
        x >= point.x - size && x <= point.x + size &&
        y >= point.y - size && y <= point.y + size
      ) {
        return key;
      }
    }

    return null;
  }

  clamp(maxWidth, maxHeight) {
    this.x = Math.max(this.x, 0);
    this.y = Math.max(this.y, 0);
    this.width = Math.min(this.width, maxWidth - this.x);
    this.height = Math.min(this.height, maxHeight - this.y);
  }
}

class ImageField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
    this.updateBackdrop();

    this.handleSize = 10;
  }

  updateBackdrop() {
    if (this.image && this.image.src)
      this.element.style.setProperty("--image-url", `url("${this.image.src}")`);
    else
      this.element.style.removeProperty("--image-url");
  }

  attachHandlers() {
    this.image.addEventListener(
      "click",
      (event) => {
        this.openPreview();
        event.stopPropagation();
      }
    );

    if (application.pageHandler.mode !== PageMode.Offline) {
      if (this.canEdit)
        this.editButton.addEventListener(
          "click",
          (event) => {
            this.startEdit();
            event.stopPropagation();
          }
        );

      this.shareButton.addEventListener(
        "click",
        (event) => {
          this.share();
          event.stopPropagation();
        }
      );

      this.downloadButton.addEventListener(
        "click",
        (event) => {
          this.download();
          event.stopPropagation();
        }
      );
    }
  }

  detectImageType() {
    const match = (this.image.title || "").toLowerCase().match(/\.(\w+)$/);
    const extension = match ? match[1] : null;

    const typeByExtension = {
      "jpg": "image/jpeg",
      "jpeg": "image/jpeg",
      "png": "image/png",
      "webp": "image/webp",
      "gif": "image/gif"
    };

    return typeByExtension[extension] || "image/jpeg";
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.image = query.getChild(WithTagName("IMG"));
    this.preview = query.getChild(WithClass("ImagePreview"));
    this.labels = new Labels(query.getChild(WithClass("Labels")));

    if (application.pageHandler.mode !== PageMode.Offline) {
      this.downloadButton = document.createElement("button");
      this.downloadButton.classList.add("Download");
      this.downloadButton.type = "button";

      this.shareButton = document.createElement("button");
      this.shareButton.classList.add("Share");
      this.shareButton.disabled = typeof navigator.canShare !== "function";
      this.shareButton.type = "button";

      this.toolbar = document.createElement("span");
      this.toolbar.classList.add("Toolbar");

      if (this.canEdit) {
        this.editButton = document.createElement("button");
        this.editButton.classList.add("Edit");
        this.editButton.type = "button";

        this.toolbar.appendChild(this.editButton);
      }

      this.toolbar.appendChild(this.shareButton);
      this.toolbar.appendChild(this.downloadButton);

      this.element.appendChild(this.toolbar);
    }
  }

  download() {
    fetch(this.uri)
      .then(
        response => {
          if (!response.ok)
            throw new Error("Network response was not ok");

          return response.blob();
        }
      )
      .then(blob => {
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = this.image.title || "image.jpg";

        document.body.appendChild(link);

        link.click();
        link.remove();

        URL.revokeObjectURL(url);
      })
      .catch(error => {
        application.toastBox.addMessage(new ToastMessage(this.labels.FailedToDownloadImage, "Error"));
        console.error("Download failed: ", error);
      });
  }

  save(contents) {
    const loadingOverlay = document.createElement("div");
    loadingOverlay.classList.add("Loading");

    this.element.appendChild(loadingOverlay);

    return fetch(
      this.saveUri,
      {
        method: "POST",
        headers: {
          "Content-Type": contents.type || "image/jpeg",
        },
        body: contents,
      }
    )
      .finally(() => {
        this.element.removeChild(loadingOverlay);
      });
  }

  loadOriginal() {
    return new Promise(
      (resolve, reject) => {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error("Failed to load image: " + this.uri));
        image.src = this.uri;
      }
    );
  }

  buildRotatedCanvas(sourceImage, degrees) {
    const radians = (degrees * Math.PI) / 180;
    const isVertical = degrees % 180 !== 0;

    const sourceWidth = sourceImage.width;
    const sourceHeight = sourceImage.height;

    const rotatedWidth = isVertical ? sourceHeight : sourceWidth;
    const rotatedHeight = isVertical ? sourceWidth : sourceHeight;

    const canvas = document.createElement("canvas");
    canvas.width = rotatedWidth;
    canvas.height = rotatedHeight;

    const context = canvas.getContext("2d");
    context.translate(rotatedWidth / 2, rotatedHeight / 2);
    context.rotate(radians);
    context.drawImage(sourceImage, -sourceWidth / 2, -sourceHeight / 2);

    return canvas;
  }

  async writeBack(canvas) {
    const blob = await new Promise(
      (resolve) => {
        canvas.toBlob(resolve, "image/jpeg", 0.92);
      }
    );

    this.image.src = URL.createObjectURL(blob);
    this.updateBackdrop();

    return this.save(blob);
  }

  async rotateAndSave(degrees) {
    if (this.canEdit) {
      const source = await this.loadOriginal();
      await this.writeBack(this.buildRotatedCanvas(source, degrees));
    }
  }

  getPublishedActions() {
    const result = [];

    if (this.canEdit) {
      result.push({
        name: "Photo.Rotate.Left",
        caption: this.labels.RotateLeft.textContent,
        execute: (items) => Promise.all(items.map((item) => item.rotateAndSave(-90)))
      });

      result.push({
        name: "Photo.Rotate.Right",
        caption: this.labels.RotateRight.textContent,
        execute: (items) => Promise.all(items.map((item) => item.rotateAndSave(90)))
      });
    }

    if (typeof navigator.canShare === "function") {
      result.push({
        name: "Photo.Share",
        caption: this.labels.Share.textContent,
        execute: async (items) => {
          try {
            const files = await Promise.all(items.map((item) => item.fetchAsFile()));

            if (navigator.canShare({ files }))
              await navigator.share({ files });
            else
              application.toastBox.addMessage(new ToastMessage(items[0].labels.FailedToShareImage, "Error"));
          }
          catch (error) {
            application.toastBox.addMessage(new ToastMessage(items[0].labels.FailedToShareImage, "Error"));
            console.error("Failed to share images: ", error);
          }
        }
      });
    }

    result.push({
      name: "Photo.Download.Zip",
      caption: this.labels.Download.textContent,
      execute: async (items) => {
        try {
          const zip = new ZipBuilder();
          const used = new Set();

          for (const item of items) {
            const blob = await (await fetch(item.uri)).blob();
            await zip.addFile(uniqueFileName(item.image.title, used), blob);
          }

          triggerDownload(zip.build(), "Images.zip");
        }
        catch (error) {
          application.toastBox.addMessage(new ToastMessage(items[0].labels.FailedToDownloadImage, "Error"));
          console.error("Failed to download images: ", error);
        }
      }
    });

    return result;
  }

  async fetchAsFile() {
    const response = await fetch(this.uri);
    const blob = await response.blob();
    return new File([blob], this.image.title, { type: this.detectImageType() });
  }

  async share() {
    try {
      const file = await this.fetchAsFile();

      if (navigator.canShare({ files: [file] }))
        await navigator.share({ title: this.image.title, files: [file] });
      else
        application.toastBox.addMessage(new ToastMessage(this.labels.FailedToShareImage, "Error"));
    }
    catch (error) {
      application.toastBox.addMessage(new ToastMessage(this.labels.FailedToShareImage, "Error"));
      console.error("Failed to share image: ", error);
    }
  }

  startEdit() {
    const maxWidth = 0.9 * window.innerWidth;
    const maxHeight = 0.9 * window.innerHeight;

    this.maximumUserInterfaceSize = Math.min(800, Math.max(300, Math.floor(Math.min(maxWidth, maxHeight) * 0.9)));
    this.rotationAngle = 0;
    this.isCroppingModeActive = false;
    this.cropRectangle = null;
    this.renderingScale = 1;
    this.isDragging = false;
    this.draggingHandle = null;

    this.dragStartX = 0;
    this.dragStartY = 0;

    this.loadOriginal().then(
      (image) => {
        this.sourceImage = image;
        this.renderImage();
      }
    );

    this.overlayElement = this.createOverlayElement();
    application.pageHandler.contents.element.appendChild(this.overlayElement);
  }

  createOverlayElement() {
    const overlay = document.createElement("div");
    overlay.classList.add("ImageOverlay");

    this.toolbarElement = this.createToolbarElement();
    overlay.appendChild(this.toolbarElement);

    this.userInterfaceCanvas = document.createElement("canvas");
    this.userInterfaceContext = this.userInterfaceCanvas.getContext("2d");
    overlay.appendChild(this.userInterfaceCanvas);

    this.attachCanvasEventHandlers();

    overlay.addEventListener(
      "click",
      (event) => {
        if (event.target === overlay)
          application.pageHandler.contents.element.removeChild(overlay);
      }
    );

    return overlay;
  }

  createToolbarElement() {
    const toolbar = document.createElement("div");
    toolbar.classList.add("Toolbar");

    this.rotateLeftButton = document.createElement("button");
    this.rotateLeftButton.classList.add("RotateLeft");
    this.rotateLeftButton.addEventListener("click", () => this.rotateLeft());
    this.rotateLeftButton.type = "button";

    this.rotateRightButton = document.createElement("button");
    this.rotateRightButton.classList.add("RotateRight");
    this.rotateRightButton.addEventListener("click", () => this.rotateRight());
    this.rotateRightButton.type = "button";

    this.cropButton = document.createElement("button");
    this.cropButton.classList.add("Crop");
    this.cropButton.addEventListener("click", () => this.toggleCropMode());
    this.cropButton.type = "button";

    this.saveButton = document.createElement("button");
    this.saveButton.classList.add("Save");
    this.saveButton.addEventListener("click", () => this.saveImage());
    this.saveButton.type = "button";

    toolbar.appendChild(this.rotateLeftButton);
    toolbar.appendChild(this.rotateRightButton);
    toolbar.appendChild(this.cropButton);
    toolbar.appendChild(this.saveButton);

    return toolbar;
  }

  attachCanvasEventHandlers() {
    this.userInterfaceCanvas.addEventListener(
      "mousedown",
      (event) => {
        if (this.isCroppingModeActive) {
          const bounds = this.userInterfaceCanvas.getBoundingClientRect();
          const x = event.clientX - bounds.left;
          const y = event.clientY - bounds.top;

          if (this.cropRectangle) {
            const handle = this.cropRectangle.getHandleAtPoint(x, y, this.handleSize);

            if (handle) {
              this.draggingHandle = handle;
              this.isDragging = true;
            }
            else if (this.cropRectangle.containsPoint(x, y)) {
              this.draggingHandle = CropHandle.Center;
              this.isDragging = true;
              this.dragStartX = x;
              this.dragStartY = y;
              this.startCropRect = { ...this.cropRectangle };
            }
          }
          else {
            this.draggingHandle = null;
            this.dragStartX = x;
            this.dragStartY = y;
            this.isDragging = true;
            this.cropRectangle = new CropRectangle(x, y, 0, 0);
            this.renderImage();
          }
        }
      }
    );

    this.userInterfaceCanvas.addEventListener(
      "mousemove",
      (event) => {
        if (this.isCroppingModeActive && this.isDragging) {
          const bounds = this.userInterfaceCanvas.getBoundingClientRect();
          const x = event.clientX - bounds.left;
          const y = event.clientY - bounds.top;

          if (this.draggingHandle === CropHandle.Center) {
            const deltaX = x - this.dragStartX;
            const deltaY = y - this.dragStartY;
            this.cropRectangle.x = this.startCropRect.x + deltaX;
            this.cropRectangle.y = this.startCropRect.y + deltaY;

            this.cropRectangle.clamp(this.userInterfaceCanvas.width, this.userInterfaceCanvas.height);
          }
          else if (this.draggingHandle)
            this.resizeCropRect(this.draggingHandle, x, y);
          else {
            this.cropRectangle = new CropRectangle(
              Math.min(this.dragStartX, x),
              Math.min(this.dragStartY, y),
              Math.abs(x - this.dragStartX),
              Math.abs(y - this.dragStartY)
            );
          }
        }

        this.renderImage();
      }
    );

    this.userInterfaceCanvas.addEventListener(
      "mouseup",
      () => {
        if (this.isCroppingModeActive) {
          this.isDragging = false;
          this.draggingHandle = null;
        }
      }
    );
  }

  rotateLeft() {
    if (this.isCroppingModeActive)
      this.toggleCropMode();

    this.rotationAngle = (this.rotationAngle - 90 + 360) % 360;
    this.renderImage();
  }

  rotateRight() {
    if (this.isCroppingModeActive)
      this.toggleCropMode();

    this.rotationAngle = (this.rotationAngle + 90) % 360;
    this.renderImage();
  }

  toggleCropMode() {
    this.isCroppingModeActive = !this.isCroppingModeActive;

    if (this.isCroppingModeActive) {
      if (!this.cropRectangle) {
        const width = this.userInterfaceCanvas.width;
        const height = this.userInterfaceCanvas.height;

        const rectangleWidth = width * 0.8;
        const rectangleHeight = height * 0.8;

        this.cropRectangle = new CropRectangle(
          (width - rectangleWidth) / 2,
          (height - rectangleHeight) / 2,
          rectangleWidth,
          rectangleHeight
        )
      }
    }
    else
      this.cropRectangle = null;

    this.renderImage();
  }

  renderImage() {
    this.exportCanvas = this.buildRotatedCanvas(this.sourceImage, this.rotationAngle);

    const rotatedWidth = this.exportCanvas.width;
    const rotatedHeight = this.exportCanvas.height;

    this.renderingScale = Math.min(this.maximumUserInterfaceSize / rotatedWidth, this.maximumUserInterfaceSize / rotatedHeight, 1);

    const userInterfaceWidth = rotatedWidth * this.renderingScale;
    const userInterfaceHeight = rotatedHeight * this.renderingScale;

    this.userInterfaceCanvas.width = userInterfaceWidth;
    this.userInterfaceCanvas.height = userInterfaceHeight;

    this.userInterfaceContext.clearRect(0, 0, userInterfaceWidth, userInterfaceHeight);
    this.userInterfaceContext.drawImage(this.exportCanvas, 0, 0, userInterfaceWidth, userInterfaceHeight);

    if (this.cropRectangle) {
      this.userInterfaceContext.strokeStyle = "black";
      this.userInterfaceContext.lineWidth = 2;
      this.userInterfaceContext.strokeRect(
        this.cropRectangle.x,
        this.cropRectangle.y,
        this.cropRectangle.width,
        this.cropRectangle.height
      );
    }

    if (this.cropRectangle) {
      const size = this.handleSize;
      const rectangle = this.cropRectangle;

      const handlePoints = [
        { x: rectangle.x, y: rectangle.y },
        { x: rectangle.x + rectangle.width, y: rectangle.y },
        { x: rectangle.x, y: rectangle.y + rectangle.height },
        { x: rectangle.x + rectangle.width, y: rectangle.y + rectangle.height },
      ];

      this.userInterfaceContext.fillStyle = "black";
      this.userInterfaceContext.strokeStyle = "black";
      this.userInterfaceContext.lineWidth = 1;

      for (const point of handlePoints) {
        this.userInterfaceContext.fillRect(point.x - size / 2, point.y - size / 2, size, size);
        this.userInterfaceContext.strokeRect(point.x - size / 2, point.y - size / 2, size, size);
      }
    }
  }

  resizeCropRect(handle, x, y) {
    let rectangle = this.cropRectangle;

    switch (handle) {
      case CropHandle.TopLeft:
        rectangle.width += rectangle.x - x;
        rectangle.height += rectangle.y - y;
        rectangle.x = x;
        rectangle.y = y;
        break;
      case CropHandle.TopRight:
        rectangle.width = x - rectangle.x;
        rectangle.height += rectangle.y - y;
        rectangle.y = y;
        break;
      case CropHandle.BottomLeft:
        rectangle.width += rectangle.x - x;
        rectangle.x = x;
        rectangle.height = y - rectangle.y;
        break;
      case CropHandle.BottomRight:
        rectangle.width = x - rectangle.x;
        rectangle.height = y - rectangle.y;
        break;
    }

    if (rectangle.width < 0) {
      rectangle.width = Math.abs(rectangle.width);
      rectangle.x -= rectangle.width;

      if (handle === CropHandle.TopRight)
        this.draggingHandle = CropHandle.TopLeft;
      else if (handle === CropHandle.BottomRight)
        this.draggingHandle = CropHandle.BottomLeft;
    }
    if (rectangle.height < 0) {
      rectangle.height = Math.abs(rectangle.height);
      rectangle.y -= rectangle.height;

      if (handle === CropHandle.BottomLeft)
        this.draggingHandle = CropHandle.TopLeft;
      else if (handle === CropHandle.BottomRight)
        this.draggingHandle = CropHandle.TopRight;
    }

    this.cropRectangle = rectangle;
    this.cropRectangle.clamp(this.userInterfaceCanvas.width, this.userInterfaceCanvas.height);
  }

  async saveImage() {
    let canvasToSave = this.exportCanvas;

    if (this.cropRectangle) {
      const cropCanvas = document.createElement("canvas");
      const cropSourceX = this.cropRectangle.x / this.renderingScale;
      const cropSourceY = this.cropRectangle.y / this.renderingScale;
      const cropSourceWidth = this.cropRectangle.width / this.renderingScale;
      const cropSourceHeight = this.cropRectangle.height / this.renderingScale;

      cropCanvas.width = cropSourceWidth;
      cropCanvas.height = cropSourceHeight;

      const cropContext = cropCanvas.getContext("2d");
      cropContext.drawImage(
        this.exportCanvas,
        cropSourceX,
        cropSourceY,
        cropSourceWidth,
        cropSourceHeight,
        0,
        0,
        cropSourceWidth,
        cropSourceHeight
      );

      canvasToSave = cropCanvas;
    }

    await this.writeBack(canvasToSave);
    application.pageHandler.contents.element.removeChild(this.overlayElement);
  }

  focus() {
    this.image.focus();
  }

  closePreview() {
    this.preview.classList.remove("Active");
    removeClickOutsideListener(this.clickOutsideListener);
    this.element.appendChild(this.preview);
  }

  openPreview() {
    this.preview.classList.add("Active");

    if (this.preview.childNodes.length === 0) {
      const image = document.createElement("IMG");
      image.src = this.preview.dataset.Uri;

      this.preview.appendChild(image);
    }

    this.clickOutsideListener = connectClickOutsideListener(
      null,
      (event) => {
        this.closePreview();
        event.stopPropagation();
      }
    );

    application.pageHandler.contents.element.appendChild(this.preview);
  }

  get name() {
    return this.element.dataset.Name;
  }

  get uri() {
    return this.element.dataset.Uri;
  }

  get canEdit() {
    return this.saveUri !== undefined;
  }

  get saveUri() {
    return this.element.dataset.SaveUri;
  }
}

interactivityRegistration.register("ImageField", function (element) { return new ImageField(element); });


// ---------- File: WebSite.Form.Field.Integer.ts ----------
// @ts-nocheck
export class IntegerField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    this.addValueChangedHandler(this.input);
    this.addBlurHandler(this.input);
  }

  checkInput(problemTarget) {
    super.checkInput(problemTarget);

    const value = this.getValue();

    if (value !== null && !/^-?\d+$/.test(value))
      problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
  }

  determineElements() {
    this.input = this.element;
  }
}

interactivityRegistration.register("IntegerField", function (element) { return new IntegerField(element); });


// ---------- File: WebSite.Form.Field.Interval.ts ----------
// @ts-nocheck
export class FloatingPointIntervalField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
  }

  addEventListener(event, handler) {
    this.input.addEventListener(event, handler);
  };

  determineElements() {
    const query = new DomQuery(this.element);

    this.low = query.getChild(WithClass("Low"));
    this.low.addEventListener(
      "change",
      () => { this.input.value = this.determineValue(); }
    );

    this.high = query.getChild(WithClass("High"));
    this.high.addEventListener(
      "change",
      () => { this.input.value = this.determineValue(); }
    );

    this.input = query.getChild(WithClass("Interval"));
    this.input.value = this.determineValue();
  }

  determineValue() {
    return this.low.value + "," + this.high.value;
  }

  focus() {
    this.low.focus();
  }

  getValue() {
    return this.input.value;
  }

  setValue(value) {
    if (value !== this.input.value) {
      this.input.value = value;
      this.input.dispatchEvent(new Event("change"));
    }
  }

  get name() {
    if (this.input !== null)
      return this.input.name;
    else
      return null;
  }
}

interactivityRegistration.register("FloatingPointIntervalField", (element) => { return new FloatingPointIntervalField(element); });


// ---------- File: WebSite.Form.Field.Money.ts ----------
// @ts-nocheck
export class MoneyField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.inputField != null) {
      this.inputField.onfocus = (event) => { this.element.classList.add("Focus"); };
      this.inputField.onblur = (event) => { this.element.classList.remove("Focus"); };
    }
  }

  determineElements() {
    this.textField = new DomQuery(this.element).getChild(WithClass("SingleLineTextField"));

    if (this.textField !== null)
      this.inputField = new DomQuery(this.textField).getChild(WithTagName("INPUT"));
  }
}

interactivityRegistration.register("Money", function (element) { return new MoneyField(element); });


// ---------- File: WebSite.Form.Field.MultipleSelect.Buttons.ts ----------
// @ts-nocheck
export class MultipleSelectButtons extends FormField {
  constructor(element) {
    super(element);

    this.input = null;
    this.buttons = null;

    if (this.mode === ControlMode.edit) {
      this.buttons = new Array();
      this.initialize();
      this.attachHandlers();

      if (this.buttons.length > 0)
        this.buttons[0].element.tabIndex = 0;
    }
  }

  addEventListener(event, handler) {
    if (this.mode === ControlMode.edit)
      this.input.addEventListener(event, handler);
  }

  attachHandlers() {
    for (const button of this.buttons) {
      button.element.addEventListener("click", this.createToggleButtonHandler(button));
      button.element.addEventListener("keydown", this.createKeyHandler(button));
    }

    this.addValueChangedHandler(this.input);
  }

  createKeyHandler(button) {
    return (event) => {
      if (!this.disabled)
        this.handleKey(button, event);
      else {
        event.preventDefault();
        event.stopPropagation();
      }
    };
  }

  createToggleButtonHandler(button) {
    return (event) => {
      if (!this.disabled) {
        if (event.shiftKey) {
          for (const other of this.buttons)
            if (other.selected)
              other.toggle();

          if (!button.selected)
            button.toggle();

          this.recalculate();
        }
        else
          this.toggle(button);
      }
      else {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  focus() {
    this.buttons[0].element.focus();
  }

  focusNext(button) {
    var target = button.element.nextSibling;

    if (target !== null && target.tagName === "BUTTON")
      target.focus();
  }

  focusPrevious(button) {
    var target = button.element.previousSibling;

    if (target !== null && target.tagName === "BUTTON")
      target.focus();
  }

  getValue() {
    return this.input.value;
  }

  handleKey(button, event) {
    var result = false;

    if (event.code === "Space") {
      event.preventDefault();
    }
    else if (event.code === "ArrowLeft") {
      this.focusPrevious(button);
      event.preventDefault();
    }
    else if (event.code === "ArrowRight") {
      this.focusNext(button);
      event.preventDefault();
    }
    else if (event.code === "Home") {
      this.buttons[0].element.focus();
      event.preventDefault();
    }
    else if (event.code === "End") {
      this.buttons[this.buttons.length - 1].element.focus();
      event.preventDefault();
    }
    else if (event.ctrlKey && event.code === "KeyA") {
      this.selectAll();
      event.preventDefault();
    }

    return result;
  }

  initialize() {
    var query = new DomQuery(this.element);
    var buttons = query.getDescendants(WithTagName("BUTTON"));

    for (var button of buttons)
      this.buttons.push(new MultipleSelectButton(button));

    this.input = query.getDescendant(WithTagName("INPUT"));
  }

  recalculate() {
    var values = new Array();

    for (var button of this.buttons)
      if (button.selected)
        values.push(button.value);

    this.updateFieldValue(values.join(","));
  }

  selectAll() {
    for (var button of this.buttons)
      if (!button.selected)
        button.toggle();

    this.recalculate();
  }

  updateFieldValue(value) {
    this.input.value = value;

    this.input.dispatchEvent(new Event("input"));
    this.input.dispatchEvent(new Event("change"));
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;

    if (this.buttons !== null)
      for (const button of this.buttons)
        button.element.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      const values = new Set(fieldValue.split(","));

      this.buttons.forEach(
        button => {
          if (values.has(button.value) !== button.selected)
            button.toggle();
        }
      );

      this.updateFieldValue(fieldValue);
    }
  }

  toggle(button) {
    button.toggle();
    this.recalculate();
  }

  get disabled() {
    return (this.input === null || this.input.disabled);
  }
}

class MultipleSelectButton {
  constructor(element) {
    this.element = element;
    this.element.tabIndex = -1;

    this.value = this.element.dataset.Value;
    this.selected = element.classList.contains("Selected");

    this.classSwitch = new HtmlClassSwitch(this.element, "Selected");
    this.selected = this.classSwitch.getStatus();
  }

  toggle() {
    this.selected = !this.selected;

    this.classSwitch.setStatus(this.selected);
    this.element.setAttribute("aria-selected", this.selected);
  }
}

interactivityRegistration.register("MultipleSelectButtons", function (element) { return new MultipleSelectButtons(element); });


// ---------- File: WebSite.Form.Field.MultipleSelect.DropDown.ts ----------
// @ts-nocheck
export class MultipleSelectDropDown extends FormField {
  constructor(element) {
    super(element);

    this.element.tabIndex = 0;
    this.input = null;
    this.options = new Array();

    this.determineElements();
    this.recalculate();
    this.attachHandlers();
  }

  addEventListener(event, handler) {
    this.input.addEventListener(event, handler);
  }

  attachHandlers() {
    var object = this;
    this.button.addEventListener("click", function (event) { object.toggleForm(); });
    this.label.addEventListener("click", function (event) { object.toggleForm(); });

    for (var option of this.options) {
      option.element.addEventListener("click", this.createToggleOptionHandler(option));
      option.element.addEventListener("keydown", this.createOptionKeyHandler(option));
    }

    this.element.addEventListener("keydown", this.createKeyHandler());
    this.addValueChangedHandler(this.input);

    this.element.addEventListener(
      "blur",
      (event) => {
        if (!this.dropDownToggle.getStatus() && event.relatedTarget !== null)
          this.validate();
      }
    );
  }

  close() {
    this.dropDownToggle.setStatus(false);
    removeClickOutsideListener(this.clickOutsideListener);
  }

  createKeyHandler() {
    var object = this;

    return function (event) {
      return object.handleKey(event);
    }
  }

  createOptionKeyHandler(option) {
    var object = this;

    return function (event) {
      return object.handleOptionKey(option, event);
    }
  }

  createToggleOptionHandler(option) {
    var object = this;

    return function (event) {
      object.toggle(option);
      return true;
    }
  }

  determineElements() {
    var query = new DomQuery(this.element);

    this.dropDown = query.getChild(WithClass("Options"));
    this.dropDownToggle = new HtmlClassSwitch(this.dropDown, "Expanded");

    this.button = query.getChild(WithTagName("BUTTON"));
    this.button.tabIndex = -1;

    this.label = query.getChild(WithClass("Label"));
    this.input = query.getChild(WithTagName("INPUT"));

    var options = new DomQuery(this.dropDown).getChildren(WithClass("Option"));

    for (var option of options)
      this.options.push(new MultipleSelectOption(option));
  }

  focus() {
    this.options[0].element.focus();
  }

  focusNext(option) {
    var target = option.element.nextSibling;

    if (target !== null && target.classList.contains("Option"))
      target.focus();
  }

  focusPrevious(option) {
    var target = option.element.previousSibling;

    if (target !== null && target.classList.contains("Option"))
      target.focus();
  }

  getValue() {
    return this.input.value;
  }

  handleKey(event) {
    if (event.ctrlKey && event.code === "Space") {
      this.toggleForm();
      event.stopPropagation();
    }
  }

  handleOptionKey(option, event) {
    if (event.code === "Space") {
      this.toggle(option);
      event.stopPropagation();
    }
    else if (event.code === "Enter") {
      this.toggle(option);

      if (this.isOpen())
        this.close();
    }
    else if (this.isOpen() && event.code === "Escape") {
      this.close();
    }
    else if (event.code === "ArrowUp") {
      this.focusPrevious(option);
      event.preventDefault();
    }
    else if (event.code === "ArrowDown") {
      this.focusNext(option);
      event.preventDefault();
    }
    else if (event.code === "Home") {
      this.options[0].element.focus();
      event.preventDefault();
    }
    else if (event.code === "End") {
      this.options[this.options.length - 1].element.focus();
      event.preventDefault();
    }
    else if (event.ctrlKey && event.code === "KeyA") {
      this.selectAll();
      event.preventDefault();
    }
  }

  isOpen() {
    return this.dropDownToggle.getStatus();
  }

  open() {
    var object = this;

    this.dropDownToggle.setStatus(true);
    this.dropDown.scrollIntoView({ block: "nearest", inline: "nearest" });
    this.clickOutsideListener = connectClickOutsideListener(this.element, function (event) { object.toggleForm(); });

    this.focus();
  }

  recalculate() {
    const values = new Array();

    for (const option of this.options)
      if (option.selected)
        values.push(option.value);

    this.updateFieldValue(values.join(","));
    this.reloadCaption();
  }

  reloadCaption() {
    const captions = new Array();

    for (const option of this.options)
      if (option.selected)
        captions.push(option.element.innerHTML);

    this.label.innerHTML = captions.join(", ");
  }

  selectAll() {
    for (var option of this.options)
      option.setStatus(true);

    this.recalculate();
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      const values = fieldValue.split(",");

      for (const option of this.options)
        if (option.selected !== values.includes(option.value))
          option.toggle();

      this.reloadCaption();
      this.updateFieldValue(fieldValue);
    }
  }

  updateFieldValue(value) {
    this.input.value = value;
    this.input.dispatchEvent(new Event("input"));
    this.input.dispatchEvent(new Event("change"));
  }

  toggle(option) {
    option.toggle();
    this.recalculate();
  }

  toggleForm() {
    if (this.isOpen())
      this.close();
    else
      this.open();
  }
}

function MultipleSelectOption(element) {
  this.setStatus = function (status) {
    this.selected = status;

    this.classSwitch.setStatus(status);
    this.element.setAttribute("aria-selected", status);
  }

  this.toggle = function () {
    this.setStatus(!this.selected);
  }

  this.element = element;
  this.element.tabIndex = -1;

  this.value = this.element.dataset.Value;
  this.selected = element.classList.contains("Selected");

  this.classSwitch = new HtmlClassSwitch(this.element, "Selected");
  this.selected = this.classSwitch.getStatus();
}

interactivityRegistration.register("MultipleSelectDropDown", function (element) { return new MultipleSelectDropDown(element); });


// ---------- File: WebSite.Form.Field.Options.DropDown.ts ----------
// @ts-nocheck
export class DropDown extends FormField {
  constructor(element) {
    super(element);

    this.input = null;
    this.options = new Array();

    if (this.mode === ControlMode.edit) {
      this.determineElements();
      this.recalculate();
      this.attachHandlers();
    }

    this.visibleOptions = this.options;
    this.focused = new HtmlClassSwitch(this.element, "Focus");
  }

  addEventListener(event, handler) {
    if (this.mode === ControlMode.edit)
      this.input.addEventListener(event, handler);
  }

  attachHandlers() {
    this.button.addEventListener("click", (event) => { this.toggleForm(); });
    this.label.addEventListener("click", (event) => { this.toggleForm(); });

    this.search.addEventListener(
      "input",
      (event) => {
        this.filterOptions();

        if (!this.isOpen())
          this.open(false);
      }
    );

    this.search.addEventListener("keydown", (event) => { this.handleSearchKey(event); });
    this.search.addEventListener("focus", (event) => { this.focused.setStatus(true); });
    this.search.addEventListener("blur", (event) => { this.focused.setStatus(false); });

    for (const option of this.options) {
      option.element.addEventListener("click", this.createSelectOptionHandler(option));
      option.element.addEventListener("keydown", this.createOptionKeyHandler(option));
    }

    this.element.addEventListener("keydown", this.createKeyHandler());
    this.addValueChangedHandler(this.input);

    this.element.addEventListener(
      "blur",
      (event) => {
        if (!this.dropDownToggle.getStatus() && event.relatedTarget !== this.button && event.relatedTarget !== null)
          this.validate();
      }
    );
  }

  close() {
    this.search.value = "";
    this.filterOptions();
    this.dropDownToggle.setStatus(false);
    removeClickOutsideListener(this.clickOutsideListener);

    if (!this.element.contains(document.activeElement))
      this.validate();
  }

  createKeyHandler() {
    return (event) => {
      return this.handleKey(event);
    }
  }

  createOptionKeyHandler(option) {
    return (event) => {
      return this.handleOptionKey(option, event);
    }
  }

  createSelectOptionHandler(option) {
    return (event) => {
      this.select(option);
      this.close();
      this.focus();

      return true;
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.dropDown = query.getChild(WithClass("Options"));
    this.dropDownToggle = new HtmlClassSwitch(this.dropDown, "Expanded");

    this.button = query.getChild(WithTagName("BUTTON"));
    this.button.tabIndex = -1;

    this.label = query.getChild(WithClass("Label"));

    const inputs = query.getChildren(WithTagName("INPUT"));

    this.search = inputs[0];
    this.input = inputs[1];

    const options = new DomQuery(this.dropDown).getChildren(WithClass("Option"));

    for (const option of options)
      this.options.push(new DropDownOption(option));
  }

  filterOptions() {
    const query = this.search.value.toLowerCase();
    this.visibleOptions = new Array();

    for (const option of this.options) {
      const text = option.element.textContent.toLowerCase();

      if (text.includes(query)) {
        this.visibleOptions.push(option);
        option.show();
      }
      else
        option.hide();
    }
  }

  focus() {
    this.search.focus();
  }

  focusNext(option) {
    const index = this.visibleOptions.indexOf(option);

    if (index !== -1 && index < this.visibleOptions.length - 1)
      this.visibleOptions[index + 1].focus();
  }

  focusPrevious(option) {
    const index = this.visibleOptions.indexOf(option);

    if (index > 0)
      this.visibleOptions[index - 1].focus();
  }

  getValue() {
    if (this.mode === ControlMode.edit)
      return this.input.value !== "" ? this.input.value : null;
    else if (this.mode === ControlMode.display)
      return this.element.dataset.Value;
    else
      throw "Unknown control mode: " + this.mode;
  }

  handleKey(event) {
    if (event.ctrlKey && event.code === "Space") {
      this.toggleForm();
      event.stopPropagation();
    }
  }

  handleOptionKey(option, event) {
    if (event.code === "Space" || event.code === "Enter") {
      this.select(option);
      this.close();
      this.focus();

      event.preventDefault();
    }
    else if (event.code === "Escape") {
      this.close();
      this.focus();

      event.stopPropagation();
    }
    else if (event.code === "ArrowUp") {
      this.focusPrevious(option);
      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "ArrowDown") {
      this.focusNext(option);
      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "Home") {
      this.visibleOptions[0].focus();
      event.preventDefault();
      event.stopPropagation();
    }
    else if (event.code === "End") {
      this.visibleOptions[this.visibleOptions.length - 1].focus();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  handleSearchKey(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      event.stopPropagation();

      if (this.visibleOptions.length > 0)
        this.visibleOptions[0].element.focus();
    }
  }

  isOpen() {
    return this.dropDownToggle.getStatus();
  }

  open(focus) {
    this.dropDownToggle.setStatus(true);
    this.dropDown.scrollIntoView({ block: "nearest", inline: "nearest" });
    this.clickOutsideListener = connectClickOutsideListener(this.element, (event) => { this.toggleForm(); });

    const selected = this.visibleOptions.find(element => element.selected);

    if (focus) {
      if (selected !== undefined)
        selected.focus();
      else if (this.visibleOptions.length > 0)
        this.visibleOptions[0].focus();
    }
  }

  recalculate() {
    this.label.innerHTML = "";

    for (const option of this.options) {
      if (option.value === this.input.value) {
        option.selected = true;
        this.label.innerHTML = option.element.innerHTML;
      }
      else
        option.selected = false;
    }
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.input.value) {
      this.input.value = fieldValue;
      this.recalculate();

      this.input.dispatchEvent(new Event("change"));
    }
  }

  select(option) {
    if (!this.input.disabled && !option.selected)
      this.setValue(option.value);
  }

  toggleForm() {
    if (!this.input.disabled) {
      if (this.isOpen())
        this.close();
      else
        this.open(true);
    }
  }
}

class DropDownOption {
  constructor(element) {
    this.element = element;
    this.element.tabIndex = -1;

    this.classSwitch = new HtmlClassSwitch(this.element, "Selected");
    this.hiddenSwitch = new HtmlClassSwitch(this.element, "Hidden");
  }

  focus() {
    this.element.focus();
  }

  hide() {
    this.hiddenSwitch.setStatus(true);
  }

  show() {
    this.hiddenSwitch.setStatus(false);
  }

  get selected() {
    return this.classSwitch.getStatus();
  }

  set selected(selected) {
    this.classSwitch.setStatus(selected);
    this.element.setAttribute("aria-selected", selected);
  }

  get value() {
    return this.element.dataset.Value;
  }
}

interactivityRegistration.register("DropDown", function (element) { return new DropDown(element); });


// ---------- File: WebSite.Form.Field.Options.RadioButton.ts ----------
// @ts-nocheck
export class RadioButtonField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.name = this.element.dataset.HierarchicalName;
    this.options = this.determineOptions();
  }

  determineOptions() {
    const query = new DomQuery(this.element);
    return query.getDescendants((node) => { return node.tagName === "INPUT" && node.name === this.name; });
  }

  focus() {
    this.options[0].focus();
  }

  getValue() {
    let result = null;
    let index = 0;

    while (result == null && index < this.options.length) {
      if (this.options[index].checked)
        result = this.options[index].value;
      else
        index++;
    }

    return result;
  }

  addEventListener(event, handler) {
    for (const option of this.options)
      option.addEventListener(event, handler);
  }
}

interactivityRegistration.register("RadioButtonField", function (element) { return new RadioButtonField(element); });


// ---------- File: WebSite.Form.Field.Options.SegmentedButton.ts ----------
// @ts-nocheck
export class SegmentedButton extends FormField {
  constructor(element) {
    super(element);

    if (this.mode === ControlMode.edit) {
      this.options = this.determineOptions();
      this.options[0].element.tabIndex = 0;

      this.attachHandlers();
    }
  }

  addEventListener(event, handler) {
    if (this.mode === ControlMode.edit) {
      for (const option of this.options)
        option.input.addEventListener(event, handler);
    }
  }

  attachHandlers() {
    for (const option of this.options) {
      option.element.addEventListener(
        "click",
        (event) => {
          this.toggle(option);
          event.preventDefault();
        }
      );
      option.element.addEventListener("keydown", this.createKeyHandler(option));

      this.addValueChangedHandler(option.input);

      option.element.addEventListener(
        "blur",
        (event) => {
          if (!this.options.some(option => option.element === event.relatedTarget) && event.relatedTarget !== null)
            this.validate();
        }
      );
    }
  }

  createKeyHandler(option) {
    return (event) => {
      return this.handleKey(option, event);
    }
  }

  determineOptions() {
    const options = new Array();
    const query = new DomQuery(this.element);
    const elements = query.getDescendants(WithTagName("LABEL"));

    for (const element of elements)
      options.push(new SegmentedButtonElement(element));

    return options;
  }

  focus() {
    this.options[0].element.focus();
  }

  focusNext(option) {
    const target = option.element.nextSibling;

    if (target !== null && target.tagName === "LABEL")
      target.focus();
  }

  focusPrevious(option) {
    const target = option.element.previousSibling;

    if (target !== null && target.tagName === "LABEL")
      target.focus();
  }

  getValue() {
    let result = null;
    let index = 0;

    while (result === null && index < this.options.length) {
      const option = this.options[index];

      if (option.input.checked)
        result = option.value;
      else
        index++;
    }

    return result;
  }

  setInputDisabled(disabled) {
    if (this.options !== undefined)
      for (const option of this.options)
        option.setInputDisabled(disabled);
  }

  setInputName(name) {
    if (this.options !== undefined)
      for (const option of this.options)
        option.setInputName(name);
  }

  setValue(value) {
    for (const option of this.options) {
      if (value !== option.value)
        option.deselect();
      else if (!option.input.checked) {
        option.select();
        option.input.dispatchEvent(new Event("change"));
      }
    }
  }

  handleKey(option, event) {
    if (event.code === "Space" || event.code === "Enter")
      this.handleKeyStroke(this.handleToggleKey, option, event);
    else if (event.code === "ArrowLeft")
      this.handleKeyStroke(this.focusPrevious, option, event);
    else if (event.code === "ArrowRight")
      this.handleKeyStroke(this.focusNext, option, event);
    else if (event.code === "Home")
      this.handleKeyStroke(this.handleHomeKey, option, event);
    else if (event.code === "End")
      this.handleKeyStroke(this.handleEndKey, option, event);
  }

  handleHomeKey(option) {
    this.options[0].element.focus();
  }

  handleEndKey(option) {
    this.options[this.options.length - 1].element.focus();
  }

  handleToggleKey(option) {
    this.toggle(option);
  }

  handleKeyStroke(callback, option, event) {
    callback.call(this, option);
    event.preventDefault();
  }

  select(value) {
    for (const option of this.options)
      option.deselect();

    value.select();
  }

  toggle(option) {
    if (!option.input.disabled) {
      for (const other of this.options)
        if (other !== option && other.input.checked)
          other.deselect();

      if (this.optional || !option.input.checked) {
        option.toggle();
        option.input.dispatchEvent(new Event("change"));
      }
    }
  }
}

export class SegmentedButtonElement {
  constructor(element) {
    this.element = element;
    this.element.tabIndex = -1;

    this.initialize();
  }

  deselect() {
    if (this.input.checked)
      this.input.checked = false;

    this.element.classList.remove("Selected");
  }

  initialize() {
    this.input = new DomQuery(this.element).getChild(WithTagName("INPUT"));
    this.value = new ValueTextParser().parseText(this.input.value);

    this.element.classList.toggle("Selected", this.input.checked);
  }

  select() {
    if (!this.input.checked)
      this.input.checked = true;

    this.element.classList.add("Selected");
  }

  setInputDisabled(disabled) {
    if (this.input !== null)
      this.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.input !== null)
      this.input.name = name;
  }

  toggle() {
    if (this.input.checked)
      this.deselect();
    else
      this.select();
  }
}

interactivityRegistration.register("SegmentedButton", function (element) { return new SegmentedButton(element); });


// ---------- File: WebSite.Form.Field.Password.ts ----------
// @ts-nocheck
export class PasswordField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.input !== null) {
      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  determineElements() {
    this.input = new DomQuery(this.element).getChild(WithTagName("INPUT"));
  }
}

interactivityRegistration.register("PasswordField", function (element) { return new PasswordField(element); });


// ---------- File: WebSite.Form.Field.Percentage.ts ----------
// @ts-nocheck
export class PercentageField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.input !== null) {
      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  checkInput(problemTarget) {
    super.checkInput(problemTarget);

    const value = this.getValue();

    if (value !== null && !/^-?\d+(\.\d+)?%?$/.test(value))
      problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
  }

  determineElements() {
    this.input = this.element;
  }
}

interactivityRegistration.register("PercentageField", function (element) { return new PercentageField(element); });


// ---------- File: WebSite.Form.Field.RecordSet.ts ----------
// @ts-nocheck
export class RecordSetFieldRow extends WebPageComponent {
  constructor(element, parent, index, prototype = null) {
    super(element);

    this.parent = parent;
    this.index = index;
    this.fields = new Array();

    if (prototype !== null) {
      this.build(prototype);
      interactivityRegistration.attach(this.element);
    }

    this.determineElements();
    this.attachHandlers();

    if (prototype !== null)
      this.initialize();
  }

  attachHandlers() {
    for (const field of this.fields)
      field.addEventListener("change", () => this.valueChanged());
  }

  build(prototype) {
    if (prototype !== null)
      Array.from(prototype.children).forEach((child) => this.element.appendChild(child.cloneNode(true)));
  }

  createRemoveButton() {
    this.removeButton = document.createElement("button");
    this.removeButton.classList.add("RemoveRow");
    this.removeButton.type = "button";
    this.removeButton.addEventListener("click", (event) => { this.parent.removeRow(this); });

    const cell = document.createElement("td");
    cell.appendChild(this.removeButton);

    return cell;
  }

  determineElements() {
    const cells = new DomQuery(this.element).getChildren(WithTagName("TD"));

    for (const cell of cells) {
      const field = new DomQuery(cell).getChild(WithClass("Field"));

      if (field !== null)
        this.fields.push(field.component);
      else
        console.warn("Missing `Field` class on child of record set field row");
    }

    this.element.prepend(this.createRemoveButton());
  }

  focus() {
    const field = this.fields.find((field) => field.isFocusable());

    if (field)
      field.focus();
  }

  load(value) {
    for (const field of this.fields)
      field.load(value[field.name]);
  }

  save() {
    const value = {};

    for (const field of this.fields)
      value[field.name] = field.save();

    return value;
  }

  initialize() {
    if (this.mode === ControlMode.edit) {
      for (const field of this.fields) {
        field.setInputDisabled(false);
        this.updateFieldName(field);
      }
    }
  }

  updateFieldName(field) {
    const fieldName = this.parent.fields[this.fields.indexOf(field)].component.name;
    field.setName(`${this.parent.name}[${this.index}].${fieldName}`);
  }

  updateIndex(newIndex) {
    this.index = newIndex;

    if (this.mode === ControlMode.edit)
      for (const field of this.fields)
        this.updateFieldName(field);
  }

  valueChanged() {
    this.parent.valueChanged();
  }

  validate(problemTarget = null) {
    if (this.mode === ControlMode.edit) {
      if (problemTarget === null)
        problemTarget = this.parentComponent;

      if (typeof problemTarget.addProblem === "function") {
        problemTarget.clearProblems(this);

        for (const field of this.fields)
          field.validate(problemTarget)
      }
    }
  }

  setInputDisabled(disabled) {
    this.removeButton.disabled = disabled;

    for (const field of this.fields)
      field.setInputDisabled(disabled);
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

export class RecordSetField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.addButton = null;
    this.rows = new Array();
    this.fields = new Array();

    this.determineElements();
    this.initializeRows();

    this.build();
    this.attachHandlers();
  }

  bind() {
    const fields = new DomQuery(this.prototype).getDescendants(WithClass("Field"));

    for (const field of fields)
      field.component.setInputDisabled(true);
  }

  insertRow() {
    const rowElement = document.createElement("tr");
    this.table.tBodies[0].appendChild(rowElement);

    const row = new RecordSetFieldRow(rowElement, this, this.rows.length, this.prototype);
    this.rows.push(row);

    this.normalizeRowIndices();

    return row;
  }

  initializeRows() {
    this.rowIndices = this.determineRowIndices();

    if (this.rowIndices !== null)
      Array.from(this.table.tBodies[0].children).forEach(
        (row, index) => {
          this.rows.push(new RecordSetFieldRow(row, this, index));
        }
      );

    this.normalizeRowIndices();
  }

  setInputDisabled(disabled) {
    if (this.addButton !== null)
      this.addButton.disabled = disabled;

    for (const row of this.rows)
      row.setInputDisabled(disabled);
  }

  removeRow(row) {
    const rowIndex = this.rows.indexOf(row);

    if (rowIndex > -1)
      this.rows.splice(rowIndex, 1);

    row.element.remove();

    this.normalizeRowIndices();
    this.valueChanged();
  }

  normalizeRowIndices() {
    this.rowIndices = [];

    for (let index = 0; index < this.rows.length; index++) {
      this.rows[index].updateIndex(index);
      this.rowIndices.push(index);
    }

    this.updateRowIndicesField();
  }

  updateRowIndicesField() {
    if (this.rowIndicesField)
      this.rowIndicesField.value = this.rowIndices.join(", ");
  }

  valueChanged() {
    this.element.dispatchEvent(new Event("change"));
  }

  determineElements() {
    this.table = this.element.getElementsByTagName("table")[0];

    if (this.table.tBodies.length === 0)
      this.table.appendChild(document.createElement("tbody"));

    const prototype = new DomQuery(this.element).getDescendant(WithClass("Prototype"));
    this.prototype = new DomQuery(prototype).getDescendant(WithTagName("TR"));

    for (const cell of this.prototype.cells)
      this.fields.push(cell.childNodes[0]);

    if (this.mode === ControlMode.edit) {
      const form = new DomQuery(this.element).getAncestor(WithTagName("FORM"));
      this.rowIndicesField = form.elements[this.hierarchicalName + ".RowIndices"];
    }
  }

  createInsertButton() {
    this.addButton = document.createElement("button");
    this.addButton.classList.add("InsertRow");
    this.addButton.type = "button";
    this.addButton.addEventListener(
      "click",
      (event) => {
        const row = this.insertRow();
        row.focus();

        this.valueChanged();
      }
    );

    const cell = document.createElement("td");
    cell.appendChild(this.addButton);

    return cell;
  }

  build() {
    if (this.mode === ControlMode.edit)
      this.table.rows[0].prepend(this.createInsertButton());
  }

  determineRowIndices() {
    if (this.mode === ControlMode.edit) {
      const value = this.rowIndicesField.value;
      let rowIndices;

      if (value.length > 0)
        rowIndices = value.split(", ");
      else
        rowIndices = new Array();

      const result = new Array(rowIndices.length);

      for (let index = 0; index < rowIndices.length; index++) {
        const rowIndex = parseInt(rowIndices[index]);
        result[index] = rowIndex;
      }

      return result;
    }
    else
      return null;
  }

  attachHandlers() {
    for (const row of this.rows) {
      if (row.uri !== undefined) {
        row.addEventListener("click", (event) => { openUrl(event, row.uri); });
        row.addEventListener("mousemove", (event) => { setHot(row, event, true); });
        row.addEventListener("mouseout", (event) => { setHot(row, event, false); });
      }
    }
  }

  load(value) {
    this.clearTable();

    for (const element of value)
      this.insertRow().load(element);

    this.valueChanged();
  }

  save() {
    const result = new Array();

    for (const row of this.rows)
      result.push(row.save());

    return result;
  }

  validate(problemTarget = null) {
    if (this.mode === ControlMode.edit) {
      if (problemTarget === null)
        problemTarget = this.parentComponent;

      if (typeof problemTarget.addProblem === "function") {
        problemTarget.clearProblems(this);

        for (const row of this.rows)
          row.validate(problemTarget)
      }
    }
  }

  clearTable() {
    for (const row of this.rows)
      row.element.remove();

    this.rows = [];
    this.rowIndices = [];
    this.normalizeRowIndices();
  }

  getProblems(field) {
    const cell = field.element.parentNode;
    return new DomQuery(cell).getChild(WithClass("Problems"));
  }

  addProblem(field, message) {
    const cell = field.element.parentNode;

    if (field.touched) {
      const problems = this.getProblems(field);

      if (problems !== null) {
        const problem = document.createElement("span");
        problem.classList.add("Problem");
        problem.classList.add("Error");
        problem.innerText = message;

        problems.appendChild(problem);

        new HtmlClassSwitch(cell, "Error").setStatus(true);
      }
    }

    new HtmlClassSwitch(cell, "Ok").setStatus(false);
  }

  clearProblems(field) {
    const problems = this.getProblems(field);

    if (problems !== null)
      problems.innerHTML = "";

    new HtmlClassSwitch(field.element.parentNode, "Error").setStatus(false);
    new HtmlClassSwitch(field.element.parentNode, "Ok").setStatus(field.value !== null);
  }

  get name() {
    return this.element.dataset.Name;
  }

  get hierarchicalName() {
    return this.element.dataset.HierarchicalName;
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

interactivityRegistration.register("RecordSet", function (element) { return new RecordSetField(element); });


// ---------- File: WebSite.Form.Field.Signature.ts ----------
// @ts-nocheck
export class SignatureField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.build();
    this.initialize();

    if (this.mode === ControlMode.edit)
      this.attachHandlers();
  }

  attachHandlers() {
    this.canvas.addEventListener("mousedown", (event) => { this.startDraw(this.getMousePosition(event)); }, false);
    this.canvas.addEventListener("mouseup", (event) => { this.stopDraw(); }, false);
    this.canvas.addEventListener("mousemove", (event) => { this.draw(this.getMousePosition(event)); }, false);

    this.canvas.addEventListener("touchstart", (event) => { this.startDraw(this.getTouchPosition(event)); }, false);
    this.canvas.addEventListener("touchend", (event) => { this.stopDraw(); }, false);
    this.canvas.addEventListener("touchmove", (event) => { this.draw(this.getTouchPosition(event)); }, false);

    this.clearButton.addEventListener("click", (event) => { this.clear(); }, false);

    document.body.addEventListener("touchstart", (event) => { if (event.target === this.canvas) { event.preventDefault(); } }, false);
    document.body.addEventListener("touchmove", (event) => { if (event.target === this.canvas) { event.preventDefault(); } }, false);
    document.body.addEventListener("touchend", (event) => { if (event.target === this.canvas) { event.preventDefault(); } }, false);
  }

  build() {
    this.canvas = document.createElement("canvas");
    this.canvas.height = 200;
    this.canvas.width = 800;

    this.element.appendChild(this.canvas);

    if (this.mode === ControlMode.edit) {
      this.input = document.createElement("input");
      this.input.setAttribute("type", "hidden");
      this.input.setAttribute("name", this.element.dataset.Name);

      this.element.appendChild(this.input);

      this.clearButton = document.createElement("button");
      this.clearButton.setAttribute("type", "button");

      this.element.appendChild(this.clearButton);
    }
  }

  clear() {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.input.value = "";
  }

  draw(position) {
    if (this.isDrawing && this.previousPosition !== null) {
      this.context.beginPath();
      this.context.moveTo(this.previousPosition.x, this.previousPosition.y);
      this.context.lineTo(position.x, position.y);
      this.context.stroke();

      this.previousPosition = position;
      this.input.value = this.canvas.toDataURL().split(';base64,')[1];
    }
  }

  getPosition(x, y) {
    const rectangle = this.canvas.getBoundingClientRect();
    const scaleX = this.canvas.width / this.canvas.clientWidth;
    const scaleY = this.canvas.height / this.canvas.clientHeight;

    return {
      x: scaleX * (x - rectangle.left),
      y: scaleY * (y - rectangle.top)
    };
  }

  getMousePosition(event) {
    return this.getPosition(event.clientX, event.clientY);
  }

  getTouchPosition(event) {
    return this.getPosition(event.touches[0].clientX, event.touches[0].clientY);
  }

  initialize() {
    this.context = this.canvas.getContext("2d");
    this.context.strokeStyle = "#404040";
    this.context.lineWidth = 2;

    if (this.element.dataset.Value.length >= 0) {
      const image = new Image();
      image.addEventListener("load", () => { this.context.drawImage(image, 0, 0); }, false);
      image.src = "data:image/png;base64," + this.element.dataset.Value;
    }

    this.isDrawing = false;
    this.previousPosition = null;
  }

  stopDraw() {
    this.isDrawing = false;
  }

  startDraw(position) {
    this.isDrawing = true;
    this.previousPosition = position;
  }
}

interactivityRegistration.register("Signature", function (element) { return new SignatureField(element); });


// ---------- File: WebSite.Form.Field.Suggest.ts ----------
// @ts-nocheck
function SuggestFieldValue(identifier, element) {
  this.build = function (row) {
    if (this.element !== undefined)
      interactivityRegistration.detach(this.element);

    this.element = document.createElement("tr");

    for (var child of row.childNodes)
      this.element.appendChild(child.cloneNode(true));

    this.element.className = "Value";
    this.element.classList.add("Card");

    interactivityRegistration.attach(this.element);
  }

  this.identifier = identifier;
  this.element = element;
}

function SuggestFieldValueList(element, table, supportsMultipleValues) {
  this.determineElements = function () {
    var query = new DomQuery(this.element);

    this.input = query.getDescendant(WithClass("InputValue"));
    this.valuesElement = query.getDescendant(WithClass("Values"));

    query = new DomQuery(this.valuesElement.tBodies[0]);

    var values = query.getChildren(WithClass("Value"));

    for (var index = 0; index < values.length; index++)
      this.registerValueElement(values[index]);

    if (this.table !== null)
      this.synchronizeTableRowSelection();
  }

  this.clearClicked = function (event, value) {
    var index = this.values.indexOf(value);

    if (index !== -1)
      this.delete(index);

    this.updateValue();
    getEvent(event).stopHandling();
  }

  this.addClearButton = function (value) {
    var object = this;

    var clearButton = document.createElement("div");
    clearButton.className = "Clear";
    clearButton.onclick = function (event) { object.clearClicked(getEvent(event), value); };

    var cell = value.element.insertCell();
    cell.appendChild(clearButton);
  }

  this.registerValueElement = function (element) {
    var value = new SuggestFieldValue(element.dataset.Identifier, element);
    this.values.push(value);

    var button = new DomQuery(element).getDescendant(WithClass("Clear"));

    if (button !== null) {
      var object = this;
      button.onclick = function (event) { object.clearClicked(getEvent(event), value); };
    }
  }

  this.add = function (identifier, row) {
    var value = new SuggestFieldValue(identifier);
    value.build(row);

    this.addClearButton(value);

    if (!this.supportsMultipleValues && this.values.length > 0)
      this.delete(0);

    this.values.push(value);

    this.valuesElement.tBodies[0].appendChild(value.element);
    this.updateValue();
  }

  this.delete = function (index) {
    var body = this.valuesElement.tBodies[0];

    this.values.splice(index, 1);
    body.removeChild(body.childNodes[index]);
  }

  this.updateValue = function () {
    this.input.value = "";

    for (var index = 0; index < this.values.length; index++) {
      var value = this.values[index];

      if (index > 0)
        this.input.value += ",";

      this.input.value += value.identifier;
    }

    // TODO: We should use new Event() instead, however this is not supported in IE.

    this.synchronizeTableRowSelection();

    var event = new Event("change");
    this.input.dispatchEvent(event);

    var event = new Event("input");
    this.input.dispatchEvent(event);
  }

  this.getIdentifiers = function () {
    var result = new Array();

    for (var index = 0; index < this.values.length; index++)
      result.push(this.values[index].identifier);

    return result;
  }

  this.hasIdentifier = function (identifier) {
    return this.getIdentifiers().indexOf(identifier) > -1;
  }

  this.extractWithIdentifier = function (identifier) {
    var index = this.getIdentifiers().indexOf(identifier);

    if (index !== -1)
      this.delete(index);

    this.updateValue();
  }

  this.removeLast = function () {
    this.delete(this.values.length - 1);
    this.updateValue();
  }

  this.synchronizeTableRowSelection = function () {
    const rows = this.table.tableElement.rows;

    for (var index = 0; index < rows.length; index++) {
      const row = rows[index];

      setNodeClassEnabled(row, "Selected", this.hasIdentifier(row.dataset.Identifier));
    }
  }

  this.element = element;
  this.input = null;
  this.values = new Array();
  this.table = table;
  this.supportsMultipleValues = supportsMultipleValues;

  this.determineElements();
}

export class SuggestField extends FormField {
  constructor(element) {
    super(element);

    this.table = null;
    this.icon = null;
    this.input = null;
    this.division = null;
    this.values = null;

    this.supportsMultipleValues = this.element.dataset.SupportsMultipleValues === "true" && this.mode === ControlMode.edit;
    this.determineElements();
    this.attachEventHandlers();

    if (this.mode === ControlMode.edit)
      this.initialize();
  }

  addEventListener(event, handler) {
    if (this.mode === ControlMode.edit)
      this.values.input.addEventListener(event, handler);
  }

  determineElements() {
    this.element.field = this;
    var query = new DomQuery(this.element);

    this.icon = query.getDescendant(WithClass("Icon"));

    if (this.icon !== null)
      this.icon.tabIndex = -1;

    this.division = query.getDescendant(WithClass("InnerDropDown"));
    this.outerDropDown = query.getDescendant(WithClass("OuterDropDown"));

    this.input = query.getDescendant(WithClass("TextInput"))
    this.popup = new PopUp(this.division, this.outerDropDown, true, this.icon);
    this.table = this.determineTable();

    this.values = new SuggestFieldValueList(this.element, this.table, this.supportsMultipleValues);

    var classes = new HtmlClasses(this.element);
    classes.add(ControlMode.toText(this.mode));
  }

  determineTable() {
    var result = null;

    if (this.division !== null)
      result = this.division.getElementsByTagName("table")[0].parentNode.parentNode.component;

    return result;
  }

  focus() {
    this.input.focus();
  }

  getValue() {
    return this.values.input.value !== "" ? this.values.input.value : null;
  }

  setInputDisabled(disabled) {
    if (this.values.input !== null)
      this.values.input.disabled = disabled;
  }

  setInputName(name) {
    if (this.values.input !== null)
      this.values.input.name = name;
  }

  updateUri(name) {
    const encodedName = encodeURIComponent(name);
    const newUri = this.table.element.dataset.Uri.replace(/\/[^\/]+$/, `/${encodedName}`);

    this.table.uri = newUri;
  }

  setValue(value) {
    const fieldValue = value !== null ? value : "";

    if (fieldValue !== this.values.input.value) {
      this.values.input.value = fieldValue;
      this.values.input.dispatchEvent(new Event("change"));
    }
  }

  toggle() {
    if (this.popup.isOpen())
      this.close();
    else
      this.open();
  }

  open() {
    this.table.assureRendered();
    this.popup.open();
  }

  close() {
    this.popup.close();

    if (!this.element.contains(document.activeElement))
      this.validate();
  }

  iconClicked(event) {
    this.toggle();
  }

  onTextInputInput(event) {
    this.popup.open();
    getEvent(event).stopHandling();
    return this.table.searchTextChanged(this.input);
  }

  onTextInputKeyDown(event) {
    if (event.code === "ArrowDown" && this.popup.isOpen() && this.rows.length > 0) {
      this.rows[0].focus();
      event.stopHandling();
    }
  }

  makeRowsInteractive(table) {
    for (var i = 0; i < table.tBodies.length; i++) {
      var body = table.tBodies[i];

      for (const row of body.rows) {
        row.tabIndex = "0";
        row.onkeydown = this.createRowOnKeyDownHandler(row);
        row.onclick = this.createRowClickedHandler(row);
        row.onmouseover = this.createRowHotHandler(row, true);
        row.onmouseout = this.createRowHotHandler(row, false);

        addNodeClass(row, "SuggestRow");
      }
    }
  }

  createRowOnKeyDownHandler(row) {
    var field = this;

    return function (event) {
      if (event.code === "Space") {
        field.rowClicked(event, row);
        event.stopHandling();
      }
      else if (event.code === "Enter" || event.code === "Tab") {
        field.rowClicked(event, row);
        event.stopHandling();

        field.close();
        field.input.value = "";
        field.input.focus();
        field.table.searchTextChanged(field.input);
      }
    };
  }

  createRowClickedHandler(row) {
    return (event) => {
      this.rowClicked(event, row);
      this.close();
      this.input.value = "";
      this.input.focus();

      event.stopPropagation();
    }
  }

  createRowHotHandler(row, hot) {
    return function (event) {
      setHot(row, event, hot);
    };
  }

  rowClicked(event, row) {
    var event = getEvent(event);
    var eventSource = event.getSource();

    if (!isLink(eventSource)) {
      var identifier = row.dataset.Identifier;

      if (this.values.hasIdentifier(identifier)) {
        this.values.extractWithIdentifier(identifier);
      }
      else
        this.addValue(identifier, row);

      event.stopHandling();
    }
  }

  addValue(value, row) {
    this.values.add(value, row);
  }

  findRowWithKey(table, key) {
    var result = null;
    var i = 1;

    while (result === null && i < table.rows.length) {
      var row = table.rows[i];

      if (row.dataset.Identifier == key)
        result = row;
      else
        i++;
    }

    return result;
  }

  createOnTableChangedHandler() {
    var field = this;

    return function (newTable) {
      field.tableChanged(newTable);
    }
  }

  tableChanged(newTable) {
    this.makeRowsInteractive(newTable);
    this.values.synchronizeTableRowSelection();
  }

  handleHotKey(event) {
    if (this.popup.isOpen() && event.code === "Escape") {
      this.close();
      this.input.focus();
      event.stopHandling();
    }
    else if (event.code === "Space" && event.ctrlKey) {
      this.open();

      if (this.rows.length > 0)
        this.rows[0].focus();

      event.stopHandling();
    }
    else if (event.code === "Backspace" && this.input === document.activeElement && this.input.value.length == 0) {
      if (this.values.values.length > 0) {
        this.values.removeLast();
        this.input.focus();
      }

      event.stopHandling();
    }
  }

  attachEventHandlers() {
    if (this.mode === ControlMode.edit) {
      this.element.addEventListener("keydown", (event) => { this.handleHotKey(getEvent(event)); });
      this.icon.addEventListener("click", (event) => { this.iconClicked(getEvent(event)); });

      if (this.input !== null) {
        this.input.addEventListener("input", (event) => { this.onTextInputInput(getEvent(event)); });
        this.input.addEventListener("keydown", (event) => { this.onTextInputKeyDown(getEvent(event)); });

        this.input.addEventListener("focus", (event) => { this.element.classList.add("Focus") });
        this.input.addEventListener("blur", (event) => { this.element.classList.remove("Focus") });

        this.addValueChangedHandler(this.values.input);

        this.input.addEventListener(
          "blur",
          (event) => {
            if (!this.popup.isOpen() && event.relatedTarget !== this.icon && event.relatedTarget !== null)
              this.validate();
          }
        );
      }
    }
  }

  initialize() {
    this.table.onChanged = this.createOnTableChangedHandler();
    var table = this.table.getTableElement();

    this.makeRowsInteractive(table);
  }

  get rows() {
    return this.table.tableElement.tBodies[0].rows;
  }
}

interactivityRegistration.register("Suggest", function (element) { return new SuggestField(element); });


// ---------- File: WebSite.Form.Field.Text.ts ----------
// @ts-nocheck
export class TextField extends DefaultFormField {
  constructor(element) {
    super(element);
  }

  attachHandlers() {
    if (this.input !== null) {
      this.input.addEventListener("focus", (event) => { this.element.classList.add("Focus"); });
      this.input.addEventListener("blur", (event) => { this.element.classList.remove("Focus"); });

      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);

      if (this.checkBox !== null)
        this.checkBox.addEventListener("change", (event) => { this.valueChanged(); });
    }
  }

  determineElements() {
    this.checkBox = new DomQuery(this.element).getChild(WithClass("CheckBoxField"));

    if (this.checkBox !== null)
      this.checkBox = this.checkBox.childNodes[0];

    this.determineInputElement();
  }

  checkInput(problemTarget) {
    super.checkInput(problemTarget);

    if (this.value !== null && this.value.length < this.minimumLength)
      problemTarget.addProblem(this, this.element.dataset.OutOfRangeMessage);
    else if (this.value !== null && this.value.length > this.maximumLength)
      problemTarget.addProblem(this, this.element.dataset.OutOfRangeMessage);
  }

  getValue() {
    return (this.minimumLength > 0 && this.input.value === "") ? null : this.input.value;
  }

  disable() {
    this.element.classList.add("Disabled");
  }

  enable() {
    this.element.classList.remove("Disabled");
  }

  valueChanged() {
    this.input.readOnly = this.checkBox.checked;

    if (this.checkBox.checked)
      this.disable();
    else
      this.enable();
  }

  get minimumLength() {
    return this.element.dataset.MinimumLength ?? 0;
  }

  get maximumLength() {
    return this.element.dataset.MaximumLength ?? Infinity
  }
}

export class SingleLineTextField extends TextField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  determineInputElement() {
    this.input = new DomQuery(this.element).getChild(WithTagName("INPUT"));
  }
}

export class MultipleLineTextField extends TextField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  determineInputElement() {
    this.input = new DomQuery(this.element).getChild(WithTagName("TEXTAREA"));
  }
}

interactivityRegistration.register("SingleLineTextField", function (element) { return new SingleLineTextField(element); });
interactivityRegistration.register("MultipleLineTextField", function (element) { return new MultipleLineTextField(element); });


// ---------- File: WebSite.Form.Field.Type_.ts ----------
// @ts-nocheck
function TypeMode(element) {
  this.determineElements = function () {
    this.value = this.element.dataset.Value;

    this.selected = new HtmlClassSwitch(this.element, "Selected");
    this.selected.setStatus(false);
  }

  this.element = element;
  this.selected = null;

  this.determineElements();
}

function ChoiceRow(index) {
  this.determineElements = function () {
    this.element = document.createElement("div");
    this.element.className = "Row";
    this.element.setAttribute("data--index", this.index);

    this.removeButton = document.createElement("div");
    this.removeButton.className = "Remove";

    this.valueField = document.createElement("input");
    this.valueField.name = "Value";
    this.valueField.className = "Value";

    this.textField = document.createElement("input");
    this.textField.name = "Text";
    this.textField.className = "Text";

    this.element.appendChild(this.removeButton);
    this.element.appendChild(this.valueField);
    this.element.appendChild(this.textField);
  }

  this.index = index;
  this.element = null;
  this.removeButton = null;
  this.valueField = null;
  this.textField = null;

  this.determineElements();
}

function ChoiceFactory(field) {
  this.determineElements = function () {
    var query = new DomQuery(this.field.element);

    this.element = query.getChild(WithClass("Choices"));

    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.expanded.setStatus(false);

    query = new DomQuery(this.element);

    this.addButton = query.getDescendant(WithClass("Add"));

    var rows = query.getChildren(WithClass("Row"));

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var newRow = new ChoiceRow(row.dataset.Index);
      var object = this;

      this.count++;
      query = new DomQuery(row);

      newRow.removeButton = query.getChild(WithClass("Remove"));
      newRow.removeButton.onclick = this.createRemoveButtonClickedHandler(newRow);

      newRow.valueField = query.getChild(WithClass("Value"));
      newRow.valueField.oninput = function (event) { object.updateTextArea(); };

      newRow.textField = query.getChild(WithClass("Text"));
      newRow.textField.oninput = function (event) { object.updateTextArea(); };

      this.rows.push(newRow);
    }
  }

  this.updateTextArea = function () {
    this.textArea.value = "<Choice Optional=\"" + field.optionalCheckBox.checked + "\">";

    for (var i = 0; i < this.rows.length; i++) {
      var row = this.rows[i];

      this.textArea.value += "<Option Value=\"" + row.valueField.value + "\">" + row.textField.value + "</Option>";
    }

    this.textArea.value += "</Choice>";
  }

  this.addChoiceRow = function () {
    var object = this;
    var row = new ChoiceRow(this.count++);

    row.removeButton.onclick = function (event) { object.removeChoiceRow(row); };
    row.valueField.oninput = function (event) { object.updateTextArea(); };
    row.textField.oninput = function (event) { object.updateTextArea(); };

    this.element.appendChild(row.element);
    this.rows.push(row);
  }

  this.createRemoveButtonClickedHandler = function (row) {
    var object = this;

    return function () {
      object.removeChoiceRow(row);
    };
  }

  this.removeChoiceRow = function (row) {
    var query = new DomQuery(this.element);
    var rows = query.getChildren(WithClass("Row"));

    for (var i = 0; i < rows.length; i++) {
      var rowNode = rows[i];

      if (rowNode.dataset.Index == row.index) {
        this.element.removeChild(rowNode);
        this.rows.splice(i, 1);
      }
    }

    this.updateTextArea();
  }

  this.field = field;
  this.textArea = this.field.textArea;
  this.element = null;
  this.expanded = null;
  this.addButton = null;
  this.rows = [];
  this.count = 0;

  this.determineElements();
}

export class TypeField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.textArea = null;
    this.textLength = null;
    this.optional = null;
    this.readOnly = true;
    this.structuredText = null;
    this.choiceFactory = null;
    this.modes = [];
    this.mode = "Text";

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    let query = new DomQuery(this.element);

    const modes = query.getChild(WithClass("Modes"));

    for (let i = 0; i < modes.childNodes.length; i++) {
      this.modes.push(new TypeMode(modes.childNodes[i]));
    }

    this.textArea = query.getDescendant(WithTagName("TEXTAREA"));
    this.readOnly = this.textArea.readOnly;

    this.textLength = query.getDescendant(WithClass("TextLength"));
    this.optional = query.getDescendant(WithClass("Optional"));

    this.showTextLength = new HtmlClassSwitch(this.textLength, "Expanded");
    this.showTextLength.setStatus(false);

    query = new DomQuery(this.textLength);

    this.textLengthLow = query.getDescendant(WithClass("Low"));
    this.textLengthHigh = query.getDescendant(WithClass("High"));

    query = new DomQuery(this.optional);

    this.showOptional = new HtmlClassSwitch(this.optional, "Expanded");
    this.showOptional.setStatus(false);

    this.optionalCheckBox = query.getDescendant(WithTagName("INPUT"));

    this.choiceFactory = new ChoiceFactory(this);
    this.structuredText = this.textArea.value;

    if (this.structuredText !== "") {
      if (this.structuredText.slice(0, 23) == "<Text Type=\"SingleLine\"")
        this.mode = "Text";
      else if (this.structuredText.slice(0, 7) == "<Choice")
        this.mode = "Choice";
      else if (this.structuredText.slice(0, 9) == "<Document")
        this.mode = "Document";
      else
        this.mode = "TextArea";
    }

    this.updateMode();
  }

  updateMode() {
    if (this.mode == "Text")
      this.textArea.value = "<Text Type=\"SingleLine\" Interval=\"" + this.textLengthLow.value + "," + this.textLengthHigh.value + "\"/>";
    else if (this.mode == "TextArea")
      this.textArea.value = "<Text Interval=\"" + this.textLengthLow.value + "," + this.textLengthHigh.value + "\"/>";
    else if (this.mode == "Document") {
      this.textArea.value = "<Document Optional=\"" + this.optionalCheckBox.checked + "\"/>";
    }
    else
      this.choiceFactory.updateTextArea();

    this.showTextLength.setStatus(this.mode == "Text" || this.mode == "TextArea");
    this.showOptional.setStatus(this.mode == "Document" || this.mode == "Choice");
    this.choiceFactory.expanded.setStatus(this.mode == "Choice" && !this.readOnly);

    for (const mode of this.modes)
      mode.selected.setStatus(this.mode == mode.value);
  }

  toggleMode(value) {
    this.mode = value;
    this.updateMode();
  }

  createModeClickedHandler(mode) {
    return () => {
      this.toggleMode(mode.value);
    };
  }

  createTextLengthChangedHandler() {
    return () => {
      this.updateMode();
    };
  }

  createOptionalChangedHandler() {
    return () => {
      this.updateMode();
    };
  }

  createAddButtonClickedHandler() {
    return () => {
      this.choiceFactory.addChoiceRow();
    };
  }

  attachEventHandlers() {
    if (!this.readOnly) {
      for (const mode of this.modes)
        mode.element.onclick = this.createModeClickedHandler(mode);

      this.textLengthLow.oninput = this.createTextLengthChangedHandler();
      this.textLengthHigh.oninput = this.createTextLengthChangedHandler();
      this.optionalCheckBox.onclick = this.createOptionalChangedHandler();
      this.choiceFactory.addButton.onclick = this.createAddButtonClickedHandler();
    }
  }
}

export class TypeComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.type = null;
    this.labels = new Array();

    this.writer = new TypeWriter();
    this.parser = new TypeParser();

    this.determineElements();
    this.determineBaseType();

    this.updateForm();

    this.attachInteractivity();
    this.parseValue();
    this.readFields();
  }

  attachFieldInteraction() {
    const fields = new DomQuery(this.section).getDescendants(WithTagName("INPUT"));

    for (const field of fields)
      field.onchange = () => { this.writeFields(); };
  }

  attachInteractivity() {
    this.baseTypeSelector.input.onchange = (event) => {
      this.updateForm();

      if (this.type !== null)
        this.writeFields();
    };

    this.value.onchange = (event) => {
      this.type = null;

      this.determineBaseType();
      this.parseValue();
      this.readFields();
    };
  }

  createFormForType(type) {
    const element = new DomQuery(this.forms).getChild(WithClass(type + "Form"));
    return element.innerHTML;
  }

  determineBaseType() {
    let value;

    if (this.value.value.substring(0, 10) === "Set(Record")
      value = "RecordSet";
    else
      value = this.value.value.split("(")[0];

    this.baseTypeSelector.setValue(value);
  }

  determineElements() {
    this.baseTypeSelector = this.getDescendant(ComponentWithName("BaseType"));
    this.value = new DomQuery(this.element).getChild(WithTagName("INPUT"));
    this.forms = new DomQuery(this.element).getChild(WithClass("Forms"));
    this.form = new DomQuery(this.element).getChild(WithClass("Properties"));
  }

  getFormValue(name) {
    let value = this.section.component.getDescendant(new ComponentWithName(name)).getValue();

    if (value === "")
      value = null;

    return value;
  }

  getLabels() {
    return this.labels;
  }

  parseValue() {
    this.type = this.parser.parse(this.baseTypeSelector.getValue(), this.value.value);
  }

  readFields() {
    if (this.type.baseType === "Text") {
      if (this.type.maximumLength !== null)
        this.setFormValue("Properties/MaximumLength", this.type.maximumLength);

      if (this.type.lines !== null)
        this.setFormValue("Properties/Height", this.type.lines);
    }
    else if (this.type.baseType === "Decimal") {
      if (this.type.digits !== null)
        this.setFormValue("Properties/Digits", this.type.digits);

      if (this.type.decimalPlaces !== null)
        this.setFormValue("Properties/DecimalPlaces", this.type.decimalPlaces);
    }
    else if (this.type.baseType === "Enumeration") {
      const target = this.section.component.getDescendant(new ComponentWithClass(EnumerationTypeBuilder));
      target.setValue(this.type);
    }
    else if (this.type.baseType === "RecordSet") {
      const target = this.section.component.getDescendant(new ComponentWithClass(RecordTypeBuilder));
      target.setValue(this.type);
    }
    else if (this.type.baseType === "Data")
      this.setFormValue("Properties/DataSource", this.type.identifier);
  }

  setFormValue(name, value) {
    this.section.component.getDescendant(new ComponentWithName(name)).setValue(value);
  }

  setLabels(labels) {
    this.labels = labels;
  }

  setValue(value) {
    this.value.value = value;
  }

  updateForm() {
    interactivityRegistration.detach(this.form);
    this.form.innerHTML = "";
    this.form.innerHTML = this.createFormForType(this.baseTypeSelector.getValue());

    interactivityRegistration.attach(this.form);

    this.section = new DomQuery(this.form).getChild(WithClass("FormSection"));
    this.attachFieldInteraction();
  }

  writeFields() {
    this.type = new Type(this.baseTypeSelector.getValue());

    if (this.type.baseType === "Text") {
      this.type.maximumLength = this.getFormValue("Properties/MaximumLength");
      this.type.lines = this.getFormValue("Properties/Height");
    }
    else if (this.type.baseType === "Decimal") {
      this.type.digits = this.getFormValue("Properties/Digits");
      this.type.decimalPlaces = this.getFormValue("Properties/DecimalPlaces");
    }
    else if (this.type.baseType === "Enumeration") {
      const target = this.section.component.getDescendant(new ComponentWithClass(EnumerationTypeBuilder));
      target.updateValue();
      this.type = target.type;
    }
    else if (this.type.baseType === "RecordSet") {
      const target = this.section.component.getDescendant(new ComponentWithClass(RecordTypeBuilder));
      target.updateValue();
      this.type = target.type;
    }
    else if (this.type.baseType === "Data")
      this.type.identifier = this.getFormValue("Properties/DataSource");

    this.setValue(this.writer.write(this.type));
  }
}

function Type(baseType) {
  this.baseType = baseType;
}

function TypeParser() {
  this.parse = function (baseType, value) {
    var type = new Type(baseType);

    if (baseType === "Text")
      this.parseTextType(value, type);
    else if (baseType === "Decimal")
      this.parseDecimalType(value, type);
    else if (baseType === "Enumeration")
      this.parseEnumerationType(value, type);
    else if (baseType === "RecordSet")
      this.parseRecordSetType(value, type);
    else if (baseType === "Data")
      this.parseDataType(value, type);

    return type;
  }

  this.parseDataType = function (value, type) {
    var current = { "value": value, "remainder": "" };

    if (this.parseDelimiter(current, "Data(")) {
      this.readUntilAndParseDelimiter(current, ")");
      type.identifier = current.remainder;
    }
  }

  this.parseDelimiter = function (value, delimiter) {
    const parts = value.value.split(delimiter, 2);
    var result = (parts.length === 2 && parts[0].length === 0)

    if (result) {
      value.value = parts[1];
      value.remainder = parts[0];
    }

    return result;
  }

  this.parseDecimalType = function (value, type) {
    var current = { "value": value, "remainder": "" };

    type.digits = null;
    type.decimalPlaces = null;

    if (this.parseDelimiter(current, "Decimal(")) {
      this.readUntilAndParseDelimiter(current, ")");
      var values = current.remainder.split(",");

      if (values.length === 2) {
        type.digits = parseInt(values[0]);
        type.decimalPlaces = parseInt(values[1]);
      }
    }
  }

  this.parseEnumerationType = function (value, type) {
    if (value.substring(0, 11) == "Enumeration" && value.length > 11)
      type.options = value.substring(12, value.length - 1).split(",");
    else
      type.options = new Array();
  }

  this.parseRecordSetType = function (value, type) {
    type.members = new Array();

    if (value.substring(0, 10) == "Set(Record" && value.length > 10) {
      var members = value.substring(11, value.length - 2).match(/[A-z0-9_]*:[A-z]*(\([A-z0-9:,]*\))?/g);

      for (var member of members) {
        type.members.push({
          name: member.split(":", 2)[0],
          type: member.split(":", 2)[1]
        });
      }
    }
  }

  this.parseTextType = function (value, type) {
    var current = { "value": value, "remainder": "" };

    type.maximumLength = null;
    type.lines = null;

    if (this.parseDelimiter(current, "Text(")) {
      if (this.parseDelimiter(current, "[")) {
        this.readUntilAndParseDelimiter(current, "]");
        var interval = current.remainder.split(",");

        if (interval.length === 1)
          type.maximumLength = parseInt(interval[0]);
        else if (interval[1].length > 0)
          type.maximumLength = parseInt(interval[1]);

        this.readUntilAndParseDelimiter(current, ",");
      }

      if (this.parseDelimiter(current, "Lines:")) {
        this.readUntilAndParseDelimiter(current, ")");
        type.lines = parseInt(current.remainder);
      }
    }
  }

  this.readUntilAndParseDelimiter = function (value, delimiter) {
    const parts = value.value.split(delimiter, 2);
    var result = parts.length === 2;

    if (result) {
      value.value = parts[1];
      value.remainder = parts[0];
    }

    return result;
  }
}

function TypeWriter() {
  this.write = function (type) {
    var value = new String(type.baseType);

    if (type.baseType === "Text")
      value = this.writeTextType(type);
    else if (type.baseType === "Decimal")
      value = this.writeDecimalType(type);
    else if (type.baseType === "Enumeration")
      value = this.writeEnumerationType(type);
    else if (type.baseType === "RecordSet")
      value = this.writeRecordSetType(type);
    else if (type.baseType === "Data")
      value = this.writeDataType(type);

    return value;
  }

  this.writeDataType = function (type) {
    var result = "Data";

    result += "(";
    result += type.identifier;
    result += ")";

    return result;
  }

  this.writeDecimalType = function (type) {
    var result = "Decimal";

    if (type.digits !== null && type.decimalPlaces !== null) {
      result += "(";
      result += type.digits;
      result += ",";
      result += type.decimalPlaces;
      result += ")";
    }

    return result;
  }

  this.writeEnumerationType = function (type) {
    var result = "Enumeration(";

    for (var index = 0; index < type.options.length - 1; index++)
      result += type.options[index] + ",";

    if (type.options.length > 0)
      result += type.options[type.options.length - 1];

    result += ")";
    return result;
  }

  this.writeRecordSetType = function (type) {
    var result = "Set(Record(";

    if (type.members.length > 0) {
      result += this.writeRecordMember(type.members[0]);

      for (var index = 1; index < type.members.length; index++) {
        result += ",";
        result += this.writeRecordMember(type.members[index]);
      }
    }

    result += "))";
    return result;
  }

  this.writeRecordMember = function (member) {
    return member.name + ":" + member.type;
  }

  this.writeTextType = function (type) {
    var result = "Text([1,";

    if (type.maximumLength !== null)
      result += type.maximumLength;

    result += "]"

    if (type.lines !== null) {
      result += ",Lines:";
      result += type.lines;
    }

    result += ")";

    return result;
  }
}

export class StructuredTypeBuilder extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachInteractivity();
  }

  addRow() {
    this.table.tBodies[0].appendChild(this.createRow());
  }

  attachInteractivity() {
    this.add.onclick = (event) => { this.addRow(); };
  }

  createCell(contents) {
    const cell = document.createElement("td");
    cell.appendChild(contents);

    return cell;
  }

  createField(name) {
    const field = document.createElement("INPUT");
    field.type = "text";
    field.name = name;
    field.onchange = (event) => { this.valueChanged(); };

    return field;
  }

  createTextArea(name) {
    const field = document.createElement("textarea");
    field.rows = 1;
    field.name = name;
    field.onchange = (event) => { this.valueChanged(); };

    return field;
  }

  determineElements() {
    this.table = new DomQuery(this.element).getChild(WithTagName("TABLE"));
    this.add = new DomQuery(this.element).getDescendant(WithClass("Add"));
  }

  getLabel(name) {
    let index = 0;
    let result = null;
    const labels = this.getTypeComponent().getLabels();

    while (result === null && index < labels.length) {
      if (labels[index].Name === name)
        result = labels[index].Value;

      index++;
    }

    return result;
  }

  getTypeComponent() {
    return this.getAncestor(ComponentWithClass(TypeComponent));
  }

  removeRow(row) {
    this.table.tBodies[0].removeChild(row);
    this.valueChanged();
  }

  valueChanged() {
    this.updateValue();
    this.getTypeComponent().writeFields();
  }
}

export class EnumerationTypeBuilder extends StructuredTypeBuilder {
  constructor(element) {
    super(element);
  }

  createRow() {
    const close = document.createElement("div");
    close.classList.add("Close");

    const row = document.createElement("tr");
    close.onclick = (event) => { this.removeRow(row); };

    row.appendChild(this.createCell(close));
    row.appendChild(this.createCell(this.createField("Value")));
    row.appendChild(this.createCell(this.createTextArea("Caption")));

    return row;
  }

  setValue(value) {
    this.type = value;
    this.table.tBodies[0].innerHTML = "";

    for (let index = 0; index < this.type.options.length; index++) {
      this.addRow();
      this.table.tBodies[0].rows[index].cells[1].childNodes[0].value = value.options[index];
      this.table.tBodies[0].rows[index].cells[2].childNodes[0].value = this.getLabel(value.options[index]);
    }
  }

  updateValue() {
    this.type = new Type("Enumeration");
    this.type.options = new Array();

    const labels = new Array();
    const rows = this.table.tBodies[0].rows;

    for (const row of rows) {
      const identifier = row.cells[1].childNodes[0].value;
      const label = row.cells[2].childNodes[0].value;

      this.type.options.push(identifier);

      labels.push({
        "Name": identifier,
        "Value": label
      });
    }

    this.getTypeComponent().setLabels(labels);
  }
}

export class RecordTypeBuilder extends StructuredTypeBuilder {
  constructor(element) {
    super(element);
  }

  createRow() {
    const close = document.createElement("div");
    close.classList.add("Close");

    const row = document.createElement("tr");
    close.onclick = (event) => { this.removeRow(row); };

    row.appendChild(this.createCell(close));
    row.appendChild(this.createCell(this.createField("Member.Name")));
    row.appendChild(this.createCell(this.createTextArea("Member.Caption")));
    row.appendChild(this.createCell(this.createField("Member.Type")));

    return row;
  }

  setValue(value) {
    this.type = value;
    this.table.tBodies[0].innerHTML = "";

    for (let index = 0; index < this.type.members.length; index++) {
      this.addRow();
      this.table.tBodies[0].rows[index].cells[1].childNodes[0].value = value.members[index].name;
      this.table.tBodies[0].rows[index].cells[2].childNodes[0].value = this.getLabel(value.members[index].name);
      this.table.tBodies[0].rows[index].cells[3].childNodes[0].value = value.members[index].type;
    }
  }

  updateValue() {
    this.type = new Type("RecordSet");
    this.type.members = new Array();

    const labels = new Array();
    const rows = this.table.tBodies[0].rows;

    for (const row of rows) {
      const name = row.cells[1].childNodes[0].value;
      const label = row.cells[2].childNodes[0].value;
      const value = row.cells[3].childNodes[0].value;

      this.type.members.push({
        "name": name,
        "type": value
      });

      labels.push({
        "Name": name,
        "Value": label
      });
    }

    this.getTypeComponent().setLabels(labels);
  }
}

interactivityRegistration.register("TypeComponent", function (element) { return new TypeComponent(element); });
interactivityRegistration.register("TypeField", function (element) { return new TypeField(element); });
interactivityRegistration.register("EnumerationBuilder", function (element) { return new EnumerationTypeBuilder(element); });
interactivityRegistration.register("RecordBuilder", function (element) { return new RecordTypeBuilder(element); });


// ---------- File: WebSite.Form.Field.Uri.ts ----------
// @ts-nocheck
export class UriField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.input !== null) {
      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  determineElements() {
    this.input = new DomQuery(this.element).getChild(WithTagName("INPUT"));
  }
}

interactivityRegistration.register("UriField", function (element) { return new UriField(element); });


// ---------- File: WebSite.Form.Field.Uuid.ts ----------
// @ts-nocheck
export class UuidField extends DefaultFormField {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.input !== null) {
      this.addValueChangedHandler(this.input);
      this.addBlurHandler(this.input);
    }
  }

  checkInput(problemTarget) {
    super.checkInput(problemTarget);

    const value = this.getValue();

    if (value !== null && !/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value))
      problemTarget.addProblem(this, this.element.dataset.InvalidValueMessage);
  }

  determineElements() {
    this.input = this.element;
  }
}

interactivityRegistration.register("UuidField", function (element) { return new UuidField(element); });


// ---------- File: WebSite.Form.ts ----------
// @ts-nocheck
export class UploadForm extends WebPageComponent {
  constructor(element) {
    super(element);

    this.element.component = this;

    this.fields = null;
    this.fileField = null;

    this.uri = this.element.dataset.Uri;
    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    for (const field of this.fields) {
      if (field.name.slice(0, 7) == "Upload-") {
        if (field.type == "file") {
          this.fileField = field;
          field.onchange = (event) => { this.fileChanged(); };
        }
        else
          field.onchange = (event) => { this.inputChanged(); };
      }
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.fields = query.getDescendants(WithTagName("INPUT"));
  }

  inputChanged(event) {
    const xmlRequest = new newXmlRequest();
    const formData = new FormData(this.element);

    xmlRequest.open("POST", this.uri, true);
    xmlRequest.onreadystatechange = () => { this.render(xmlRequest); };
    xmlRequest.send(formData);
  }

  fileChanged(event) {
    const uploadArea = this.element.parentNode;
    const files = this.fileField.files;

    uploadArea.component.processFiles(files);
  }

  refresh() {
    const xmlRequest = new newXmlRequest();

    xmlRequest.open("GET", this.uri, true);
    xmlRequest.onreadystatechange = () => { this.render(xmlRequest); };
    xmlRequest.send();
  }

  render(xmlRequest) {
    if (xmlRequest.readyState == 4) {
      const newFormDivision = document.createElement("div");
      newFormDivision.innerHTML = xmlRequest.responseText;

      interactivityRegistration.detach(this.element);
      const newForm = newFormDivision.firstChild;

      this.element.parentElement.replaceChild(newForm, this.element);
      this.element = newForm;

      interactivityRegistration.attach(newForm);
    }
  }
}

export class Form extends WebPageComponent {
  constructor(element) {
    super(element);

    this.initialize();
  }

  initialize() {
    this.loadingSwitch = new HtmlClassSwitch(this.element, "Loading");
    this.labels = new Labels(new DomQuery(this.element).getChild(WithClass("Labels")));

    if (this.asynchronous)
      this.initializeAsynchronous();
    else
      this.initializeSynchronous();
  }

  initializeAsynchronous() {
    this.element.addEventListener(
      "submit",
      (event) => {
        event.preventDefault();
        this.submitAsynchronous();
      }
    )
  }

  submitAsynchronous() {
    if (!this.loading) {
      this.loading = true;
      const formData = new FormData(this.element);

      fetch(
        this.uri,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: new URLSearchParams(formData).toString(),
          redirect: "manual"
        }
      )
        .then((response) => this.reloadAsynchronous(response));
    }
  }

  async reloadAsynchronous(response) {
    if (response.ok) {
      application.toastBox.addMessage(new ToastMessage(this.labels.SuccessfulSubmission, "Success"));
      await this.reloadForm(response);
    }
    else if (response.status === 400) {
      application.toastBox.addMessage(new ToastMessage(this.labels.WarningsInForm, "Warning"));
      await this.reloadForm(response);
    }
    else if (response.status >= 300 && response.status < 400)
      application.pageHandler.navigate(response.headers.get("Location"));
    else
      application.toastBox.addMessage(new ToastMessage(this.labels.ErrorsDuringSubmission, "Error"));

    this.loading = false;
  }

  async reloadForm(response) {
    const dummyElement = document.createElement("div");
    dummyElement.innerHTML = await response.text();

    const form = dummyElement.firstChild;

    interactivityRegistration.detach(this.element);
    this.element.parentElement.replaceChild(form, this.element);

    form.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });

    interactivityRegistration.attach(form);
  }

  initializeSynchronous() {
    this.alreadySubmitted = false;
    this.element.addEventListener(
      "submit",
      (event) => {
        if (this.alreadySubmitted) {
          event.preventDefault();
          alert("Form already submitted");

          return false;
        }
        else {
          this.alreadySubmitted = true;
          return true;
        }
      }
    );
  }

  handleEvent(event) {
    if (event instanceof VisibilityChangedEvent) {
      const element = this.getElementWithComponent(event.field);

      if (element !== null)
        this.updateVisibility(event.field, element);
    }
    else
      super.handleEvent(event);
  }

  getElementWithComponent(component) {
    let result = null;
    let index = 0;

    while (result === null && index < this.element.childNodes.length) {
      const node = this.element.childNodes[index];

      if (node.contains(component.element))
        result = node;
      else
        index++;
    }

    return result;
  }

  updateVisibility(field, element) {
    const visibility = new HtmlClassSwitch(element, "Hidden");
    visibility.setStatus(!field.visible);
  }

  focus() {
    const target = this.childComponents.find(child => child.isFocusable());

    if (target !== undefined)
      target.focus();
  }

  get asynchronous() {
    return this.element.dataset.Asynchronous === "true";
  }

  get name() {
    return this.element.dataset.Name;
  }

  get uri() {
    return this.element.dataset.Uri;
  }

  get loading() {
    return this.loadingSwitch.getStatus();
  }

  set loading(value) {
    this.loadingSwitch.setStatus(value);
  }
}

interactivityRegistration.register(
  "Form",
  function (element) {
    if (element.classList.contains("Wizard"))
      return new WizardForm(element);
    else
      return new Form(element);
  }
);
interactivityRegistration.register("UploadForm", function (element) { return new UploadForm(element); });


// ---------- File: WebSite.Form.Section.ts ----------
// @ts-nocheck
export class FormSection extends WebPageComponent {
  constructor(element) {
    super(element);

    this.setUp();
  }

  focus() {
    var target = this.childComponents.find(child => child.isFocusable());

    if (target !== undefined)
      target.focus();
  }

  setUp() {
    for (var index = 0; index < this.element.tBodies[0].rows.length; index++) {
      var row = this.element.tBodies[0].rows[index];
      var cell = row.cells[1];
      var element = cell.firstChild;

      if (element !== null && element.component !== undefined)
        this.updateRowVisibility(row, element.component);
    }
  }

  getRowWithComponent(component) {
    var result = null;
    var index = 0;

    while (result === null && index < this.element.tBodies[0].rows.length) {
      var row = this.element.tBodies[0].rows[index];

      if (row.contains(component.element))
        result = row;
      else
        index++;
    }

    return result;
  }

  updateRowVisibility(row, component) {
    var visibility = new HtmlClassSwitch(row, "Hidden");
    visibility.setStatus(!component.visible);
  }

  handleEvent(event) {
    if (event instanceof VisibilityChangedEvent) {
      var row = this.getRowWithComponent(event.field);

      if (row !== null)
        this.updateRowVisibility(row, event.field);
    }
    else
      super.handleEvent(event);
  }

  getProblems(field) {
    const cell = field.element.parentNode;
    return new DomQuery(cell).getChild(WithClass("Problems"));
  }

  addProblem(field, message) {
    const cell = field.element.parentNode;
    const row = cell.parentNode;

    if (field.touched) {
      const problems = this.getProblems(field);

      if (problems !== null) {
        const problem = document.createElement("span");
        problem.classList.add("Problem");
        problem.classList.add("Error");
        problem.innerText = message;

        problems.appendChild(problem);

        new HtmlClassSwitch(row, "Error").setStatus(true);
      }
    }

    new HtmlClassSwitch(row, "Ok").setStatus(false);
  }

  clearProblems(field) {
    const problems = this.getProblems(field);

    if (problems !== null)
      problems.innerHTML = "";

    new HtmlClassSwitch(field.element.parentNode.parentNode, "Error").setStatus(false);
    new HtmlClassSwitch(field.element.parentNode.parentNode, "Ok").setStatus(field.value !== null);
  }
}

interactivityRegistration.register("FormSection", function (element) { return new FormSection(element); });


// ---------- File: WebSite.Form.Wizard.ts ----------
// @ts-nocheck
export class ProblemTarget {
  constructor() {
    this.problems = new Map();
  }

  clearProblems(field) {
    this.problems.set(field, new Array());
  }

  addProblem(field, problem) {
    this.problems.get(field).push(problem);
  }

  isValid() {
    return this.someValid() && Array.from(this.problems.values()).every(problems => problems.length === 0);
  }

  someValid() {
    return Array.from(this.problems.entries()).some(
      ([field, problems]) => {
        const value = field.getValue();
        return (!field.optional || (value !== null && value !== "")) && problems.length === 0;
      }
    )
  }
}

export class WizardFormSection {
  constructor(wizard, selector, section) {
    this.wizard = wizard;
    this.selector = selector;
    this.section = section;

    const formSection = new DomQuery(this.section).getDescendant(WithClass("FormSection")).component;

    if (formSection !== null)
      this.fields = formSection.childComponents;
    else
      this.fields = new Array();

    this.inProgress = new HtmlClassSwitch(this.selector, "InProgress");
    this.completed = new HtmlClassSwitch(this.selector, "Completed");

    this.attachHandlers();
    this.validate(false);
  }

  attachHandlers() {
    for (const field of this.fields)
      field.addEventListener("change", (event) => this.validate(true));
  }

  validate(recalculate) {
    if (this.wizard.mode === ControlMode.edit) {
      const problems = new ProblemTarget();

      for (const field of this.fields)
        field.validate(problems);

      this.completed.setStatus(problems.isValid());
      this.inProgress.setStatus(!this.completed.getStatus() && problems.someValid());

      if (recalculate)
        this.wizard.recalculate();
    }
  }

  isInProgress() {
    return this.fields.some(element => element.inputOk);
  }

  isCompleted() {
    return this.fields.every(element => element.inputOk);
  }

  load(value) {
    for (const property in value) {
      const field = this.fields.find(element => element.name === property);

      if (field && field.mode === ControlMode.edit)
        field.load(value[property]);
    }
  }

  save() {
    const result = {};

    for (const field of this.fields)
      if (field.mode === ControlMode.edit)
        result[field.name] = field.save();

    return result;
  }

  select() {
    this.selector.classList.add("Active");
    this.section.classList.add("Active");

    this.validate(false);
  }

  deselect() {
    this.selector.classList.remove("Active");
    this.section.classList.remove("Active");

    this.validate(false);
  }

  get name() {
    return this.section.dataset.Name;
  }
}

export class WizardForm extends Form {
  constructor(element) {
    super(element);

    this.sections = new Array();
    this.pristine = null;
    this.modified = new HtmlClassSwitch(this.element, "Modified");
    this.saving = new HtmlClassSwitch(this.element, "Saving");
  }

  bind() {
    this.initializeSections();
    this.initializeToolbar();

    this.sections[0].select();
    this.active = this.sections[0];
  }

  load(value) {
    for (const property in value) {
      const section = this.sections.find(element => element.name === property);

      if (section)
        section.load(value[property]);
    }

    this.pristine = this.save();
  }

  save() {
    const result = {};

    for (const section of this.sections)
      result[section.name] = section.save();

    return result;
  }

  async recalculate() {
    if (this.mode === ControlMode.edit && this.pristine !== null) {
      const pristine = JSON.stringify(this.pristine);
      const current = JSON.stringify(this.save());

      if (pristine !== current) {
        if (application.pageHandler.mode === PageMode.Offline)
          await this.persist();
        else
          this.modified.setStatus(pristine !== current);
      }
    }
  }

  async persist() {
    this.saving.setStatus(true);

    try {
      await application.pageHandler.persistOfflinePage();

      this.pristine = this.save();
      this.modified.setStatus(false);
    } finally {
      setTimeout(
        () => {
          this.saving.setStatus(false);
        },
        250
      );
    }
  }

  async submit() {
    if (application.pageHandler.mode === PageMode.Online)
      this.submitAsynchronous();
    else {
      await this.persist();
      application.toastBox.addMessage(new ToastMessage(this.labels.SuccessfulSubmission, "Success"));
    }
  }

  initializeSections() {
    const selectorsElement = new DomQuery(this.element).getChild(WithClass("Sections"));
    const selectorElements = new DomQuery(selectorsElement).getChildren(WithClass("Section"));

    for (let index = 0; index < selectorElements.length; index++) {
      const selectorElement = selectorElements[index];

      const section = new WizardFormSection(this, selectorElement, new DomQuery(this.element).getChild((element) => { return selectorElement.dataset.Name === element.dataset.Name }));
      section.selector.addEventListener(
        "click",
        (event) => {
          this.select(section);
        }
      );

      this.sections.push(section);
    }
  }

  initializeToolbar() {
    this.toolbar = document.createElement("div");
    this.toolbar.classList.add("Toolbar");

    this.previousButton = this.addButton("Previous", (event) => this.previous());

    if (this.mode === ControlMode.edit)
      this.submitButton = this.addButton("Submit", (event) => this.submit());

    this.nextButton = this.addButton("Next", (event) => this.next());

    this.element.appendChild(this.toolbar);
  }

  next() {
    const index = this.sections.indexOf(this.active);

    if (index < this.sections.length - 1)
      this.select(this.sections[index + 1]);
  }

  previous() {
    const index = this.sections.indexOf(this.active);

    if (index > 0)
      this.select(this.sections[index - 1]);
  }

  addButton(className, action) {
    const button = document.createElement("button");
    button.classList.add(className);
    button.type = "button";

    if (action)
      button.addEventListener("click", action);

    this.toolbar.appendChild(button);
    return button;
  }

  select(target) {
    this.active.validate(false);

    this.sections.forEach(
      (section) => {
        if (section !== target)
          section.deselect();
      }
    );

    target.select();

    this.active = target;
    this.active.section.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

    this.previousButton.disabled = this.active === this.sections[0];
    this.nextButton.disabled = this.active === this.sections[this.sections.length - 1];
  }

  get name() {
    return this.element.dataset.Name;
  }
}


// ---------- File: WebSite.Menu.Bookmarks.ts ----------
// @ts-nocheck
export class Bookmarks extends WebPageComponent {
  constructor(element) {
    super(element);

    this.toggle = new HtmlClassSwitch(element, "Expanded");

    const query = new DomQuery(element);

    this.icon = query.getDescendant(WithClass("Icon"));
    this.contents = query.getDescendant(WithClass("Contents"));

    this.icon.addEventListener(
      'click',
      (event) => {
        this.toggleBookmarks();
      }
    );
  }

  toggleBookmarks() {
    this.toggle.toggle();

    if (this.toggle.getStatus()) {
      this.clickOutsideListener = connectClickOutsideListener(
        this.contents,
        (event) => {
          this.toggleBookmarks();
          event.stopPropagation();
        }
      );
    }
    else
      removeClickOutsideListener(this.clickOutsideListener);
  }
}

interactivityRegistration.register("Bookmarks", function (element) { return new Bookmarks(element); });


// ---------- File: WebSite.Menu.ts ----------
// @ts-nocheck
const Orientation = new Enumeration(["Horizontal", "Vertical"]);

function MenuActionEvent(action) {
    this.action = action;
}

export class Menu extends WebPageComponent {
  constructor(element) {
    super(element);

    this.uri = this.element.dataset.Uri;
    this.type = this.element.dataset.Type;
    this.itemHasToolbar = new HtmlClassSwitch(element, "ItemHasToolbar");
    this.determineElements();
    this.attachActionHandlers();

    this.initialize();
    this.attachKeyboardInteractivity();
  }

  bind() {
    if (this.type === "SlideOut") {
      this.screenWidthListener = (event) => {
        if (event.matches && this.element.classList.contains("Expanded"))
          this.toggleIconizedState(true);
      };

      mediumScreenQuery.addEventListener('change', this.screenWidthListener);
    }
  }

  release() {
    if (this.screenWidthListener !== undefined)
      mediumScreenQuery.removeEventListener('change', this.screenWidthListener);
  }

  updateMenuItem(menuItem, command) {
    if (this.uri !== undefined) {
      const itemId = menuItem.getElementsByTagName("span")[0].dataset.Id;
      const commands = "<Commands><" + command + " Item=\"" + escapeXMLAttributeValue(itemId) + "\"/></Commands>";

      fetch(
        this.uri,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/xml'
          },
          body: commands
        }
      )
        .then(response => { menuItem.classList.remove("Updating"); })
        .catch(error => { console.error('Error:', error); });
    }
  }

  expand(element, event) {
    const classes = new HtmlClasses(element);

    if (!classes.contains("expanded")) {
      classes.add("expanded");
      classes.remove("collapsed");

      if (this.uri !== undefined)
        classes.add("Updating");

      this.updateMenuItem(element, "Expand");

      if (this.isTopLevelMenu(element))
        element.outsideListener = connectClickOutsideListener(
          element,
          (event) => {
            this.collapse(element, getEvent(event));
          }
        );
    }
  }

  collapse(element, event) {
    const classes = new HtmlClasses(element);

    if (!classes.contains("collapsed")) {
      classes.add("collapsed");
      classes.remove("expanded");

      if (this.uri !== undefined)
        classes.add("Updating");

      this.updateMenuItem(element, "Collapse");

      if (this.isTopLevelMenu(element) && element.outsideListener != null)
        removeClickOutsideListener(element.outsideListener);
    }
  }

  attachItemHandlers(element, collapsed) {
    const span = new DomQuery(element).getChild(WithTagName("SPAN"));
    const button = new DomQuery(span).getChild(WithTagName("BUTTON"));
    const classes = new HtmlClasses(span);

    classes.add("Collapsible");

    if (span.firstChild.tagName !== "A") {
      span.firstChild.addEventListener(
        'click',
        (event) => {
          if (element.classList.contains("collapsed"))
            this.expand(element, getEvent(event));
          else if (element.classList.contains("expanded"))
            this.collapse(element, getEvent(event));
        }
      );
    }

    button.addEventListener(
      'click',
      (event) => {
        if (element.classList.contains("collapsed"))
          this.expand(element, getEvent(event));
        else if (element.classList.contains("expanded"))
          this.collapse(element, getEvent(event));
      }
    );
  }

  attachActionHandlers() {
    const actions = new DomQuery(this.element).getDescendants(WithClass('Action'));

    for (const action of actions) {
      action.addEventListener(
        'click',
        (event) => {
          distributeEventUpHierarchy(new MenuActionEvent(action.dataset.Action), this);
        }
      );
    }
  }

  isTopLevelMenu(element) {
    const classes = new HtmlClasses(element.parentNode.parentNode);
    return (classes.contains("Menu") && classes.contains("Horizontal"));
  }

  attachItemsHandlers(elements, collapsed) {
    for (const element of elements)
      this.attachItemHandlers(element, collapsed);
  }

  attachSlideOutHandler(toolbar, handler) {
    const toggle = new DomQuery(toolbar).getChild(WithClass("Toggle"));
    const classes = new HtmlClasses(toggle);

    classes.add("Collapsible");
    toggle.addEventListener('click', handler);
  }

  booleanToAttribute(value) {
    if (value)
      return "True";
    else
      return "False";
  }

  sendIconizeCommand(value) {
    if (this.uri !== undefined) {
      const xmlRequest = newXmlRequest();
      const commands = "<Commands><Iconize" + " Value=\"" + this.booleanToAttribute(value) + "\"/></Commands>";

      xmlRequest.open("POST", this.uri, true);
      xmlRequest.setRequestHeader("Content-Type", "application/xml");
      xmlRequest.send(commands);
    }
  }

  sendSlideOutCommand(value) {
    if (this.uri !== undefined) {
      const xmlRequest = newXmlRequest();
      const commands = "<Commands><SlideOutLevel" + " Value=\"" + value + "\"/></Commands>";

      xmlRequest.open("POST", this.uri, true);
      xmlRequest.setRequestHeader("Content-Type", "application/xml");
      xmlRequest.send(commands);
    }
  }

  toggleIconizedState(persist) {
    const classes = new HtmlClasses(this.element);

    if (classes.contains("Expanded")) {
      classes.remove("Expanded");
      classes.add("Collapsed");

      if (persist)
        this.sendIconizeCommand(true);
    }
    else {
      classes.remove("Collapsed");
      classes.add("Expanded");

      if (persist)
        this.sendIconizeCommand(false);
    }

    setTimeout(
      function () {
        distributeEvent(new AvailableSizeChangedEvent());
      },
      500
    );
  }

  attachSlideOutHandlers() {
    const firstLevelToolbar = new DomQuery(this.element).getChild(WithClass("Toolbar"));

    this.attachSlideOutHandler(
      firstLevelToolbar,
      (event) => {
        this.toggleIconizedState(!isSmallScreen());
      }
    );

    if (mediumScreenQuery.matches && this.element.classList.contains("Expanded"))
      this.toggleIconizedState(true);

    const secondLevelMenu = new DomQuery(this.element).getChild(WithTagName("OL"));
    const menuItems = new DomQuery(secondLevelMenu).getChildren(WithTagName("LI"));

    for (const menuItem of menuItems) {
      const toolbar = new DomQuery(menuItem).getDescendant(WithClass("Toolbar"));

      if (toolbar !== null) {
        if (new HtmlClasses(menuItem).contains("pathCurrent"))
          this.itemHasToolbar.setStatus(true);

        this.attachSlideOutHandler(
          toolbar,
          (event) => {
            if (this.getSlideOutLevel() === "2")
              this.setSlideOutLevel("1");
            else
              this.setSlideOutLevel("2");

            this.sendSlideOutCommand(this.getSlideOutLevel());

            setTimeout(
              function () {
                distributeEvent(new AvailableSizeChangedEvent());
              },
              500
            );
          }
        );
      };
    }

    const plusLevelMenus = new DomQuery(secondLevelMenu).getDescendants(WithTagName("OL"));

    for (const plusLevelMenu of plusLevelMenus) {
      this.attachItemsHandlers(new DomQuery(plusLevelMenu).getChildren(WithClass("collapsed")), true);
      this.attachItemsHandlers(new DomQuery(plusLevelMenu).getChildren(WithClass("expanded")), false);
    }
  }

  getSlideOutLevel() {
    return this.element.getAttribute("data-slide-out-level");
  }

  setSlideOutLevel(level) {
    this.element.setAttribute("data-slide-out-level", level);
  }

  determineElements() {
    const query = new DomQuery(this.element);

    if (this.type === "SlideOut")
      this.attachSlideOutHandlers();
    else if (this.type !== "SlideOut") {
      this.attachItemsHandlers(query.getDescendants(WithClass("collapsed")), true);
      this.attachItemsHandlers(query.getDescendants(WithClass("expanded")), false);
    }
  }

  attachKeyboardInteractivity() {
    this.element.addEventListener(
      "keydown",
      (event) => {
        switch (event.code) {
          case "ArrowLeft":
            if (this.orientation === Orientation.Horizontal && this.focusedItem.parent === this.item)
              this.focusPreviousItem();
            else
              this.focusParentItem();

            event.preventDefault();
            break;
          case "ArrowRight":
            if (this.orientation === Orientation.Horizontal && this.focusedItem.parent === this.item)
              this.focusNextItem();
            else
              this.focusChildItem();

            event.preventDefault();
            break;
          case "ArrowUp":
            if (this.orientation === Orientation.Horizontal && this.focusedItem.parent === this.item)
              this.focusParentItem();
            else
              this.focusPreviousItem();

            event.preventDefault();
            break;
          case "ArrowDown":
            if (this.orientation === Orientation.Horizontal && this.focusedItem.parent === this.item)
              this.focusChildItem();
            else
              this.focusNextItem();

            event.preventDefault();
            break;
          case "Space":
            this.focusChildItem();
            event.preventDefault();
            break;
          case "Escape":
            this.focusParentItem();
            event.preventDefault();
            break;
        }
      }
    );
  }

  focus(item) {
    if (item !== null) {
      this.focusedItem = item;

      if (this.focusedItem.link !== null)
        this.focusedItem.link.focus();
    }
  }

  focusChildItem() {
    if (this.focusedItem.items.length > 0) {
      if (this.focusedItem.isExpanded())
        this.focus(this.focusedItem.getChild());
      else if (this.focusedItem.expandable)
        this.expand(this.focusedItem.element);
    }
    else if (this.focusedItem.parent !== this.item)
      this.focus(this.focusedItem.parent.getNextSibling());
  }

  focusNextItem() {
    this.focus(this.focusedItem.getNextSibling());
  }

  focusParentItem() {
    if (this.focusedItem.expandable && this.focusedItem.isExpanded())
      this.collapse(this.focusedItem.element);
    else if (this.focusedItem.parent !== this.item)
      this.focus(this.focusedItem.parent);
  }

  focusPreviousItem() {
    this.focus(this.focusedItem.getPreviousSibling());
  }

  initialize() {
    if (this.element.classList.contains("Horizontal"))
      this.orientation = Orientation.Horizontal;
    else if (this.element.classList.contains("Vertical"))
      this.orientation = Orientation.Vertical;
    else
      throw new Error("Unspecified menu orientation");

    this.item = new MenuItem(this.element, null);

    if (this.item.items.length > 0) {
      this.item.items[0].setFocusable(this);
      this.focusedItem = this.item.items[0];
    }
  }
}

function MenuItem(element, parent) {
    this.getChild = function() {
        if (this.items.length > 0)
            return this.items[0];
    }

    this.getNextSibling = function() {
        if (this.parent !== null) {
            const index = this.parent.items.indexOf(this);
            const nextIndex = (index + 1) % this.parent.items.length;

            return this.parent.items[nextIndex];
        }
        else
            return null;
    }

    this.getPreviousSibling = function() {
        if (this.parent !== null) {
            const index = this.parent.items.indexOf(this);
            let previousIndex = (index - 1) % this.parent.items.length;

            if (previousIndex < 0)
                previousIndex = previousIndex + this.parent.items.length;

            return this.parent.items[previousIndex];
        }
        else
            return null;
    }

    this.initialize = function() {
        this.label = new DomQuery(this.element).getChild(WithTagName("SPAN"));

        if (this.label !== null) {
            this.link = this.label.childNodes[0];
            this.link.tabIndex = -1;

            this.expandable = this.label.classList.contains("Collapsible");
        }
        else
            this.expandable = false;

        const list = new DomQuery(this.element).getChild(WithTagName("OL"));

        if (list !== null) {
            const elements = new DomQuery(list).getChildren(WithTagName("LI"));

            for (const element of elements)
                this.items.push(new MenuItem(element, this));
        }
    }

    this.isExpanded = function() {
        return this.element.classList.contains("expanded");
    }

    this.setFocusable = function(component) {
        if (this.link !== null) {
            this.link.tabIndex = 0;
            this.link.addEventListener(
                "focus",
                (event) => {
                    component.focusedItem = this;
                }
            );
        }
    }

    this.element = element;
    this.parent = parent;
    this.items = new Array();
    this.initialize();
}

interactivityRegistration.register(
    "Menu",
    function(element) {
        if (element.tagName === "DIV")
            return new Menu(element);
        else
            return null;
    }
);


// ---------- File: WebSite.Notification.Center.ts ----------
// @ts-nocheck
export class Task extends WebPageComponent {
  constructor(element) {
    super(element);

    this.parent = null;
    this.count = null;
    this.children = null;
    this.expanded = null;

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.parent = query.getDescendant(WithClass("Parent"));
    this.count = query.getDescendant(WithClass("Count"));
    this.children = query.getDescendant(WithClass("Children"));

    if (this.children !== null) {
      this.expanded = new HtmlClassSwitch(this.element, "Expanded");
      this.expanded.setStatus(false);
    }
  }

  attachEventHandlers() {
    if (this.count !== null && this.children !== null) {
      this.count.onclick = (event) => {
        this.iconClicked(getEvent(event));
      };
    }
  }

  iconClicked(event) {
    this.expanded.toggle();
    getEvent(event).stopHandling();
  }
}

export class NotificationCenterComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.updatingSwitch = new HtmlClassSwitch(element, "Updating");
    this.uri = element.dataset.Uri;
    this.renderTime = element.dataset.RenderTime;
    this.toggleSwitch = new HtmlClassSwitch(element, "Collapsed");

    this.determineElements();
    this.attachToolbarEventHandlers();
    this.initialize();

    mediumScreenQuery.addEventListener(
      "change",
      (event) => {
        if (event.matches && !this.toggleSwitch.getStatus())
          this.toggle();
      }
    );

    if (mediumScreenQuery.matches && !this.toggleSwitch.getStatus())
      this.toggle();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.contents = query.getChild(WithClass("Contents"));
    this.widgets = new DomQuery(this.contents).getChildren(WithClass("widget"));

    this.toggleButton = query.getDescendant(WithClass("Toggle"));
    this.refreshButton = query.getDescendant(WithClass("Refresh"));

    if (this.element.dataset.Count > 0)
      this.toggleButton.childNodes[0].innerHTML = this.element.dataset.Count;
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent || event instanceof NavigationEvent)
      this.invalidate();
    else
      super.handleEvent(event);
  }

  async validate() {
    this.refresh();
  }

  initialize() {
    if (this.renderTime === "Deferred")
      this.refresh();
  }

  async toggle() {
    if (!this.updatingSwitch.getStatus()) {
      this.updatingSwitch.setStatus(true);

      try {
        this.toggleSwitch.toggle();
        const state = { Collapsed: this.toggleSwitch.getStatus() };

        setTimeout(
          () => distributeEvent(new AvailableSizeChangedEvent()),
          500
        );

        await fetch(
          this.uri,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(state)
          }
        )
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.updatingSwitch.setStatus(false);
      }
    }
  }

  reload(html) {
    const container = document.createElement("div");
    container.innerHTML = html;

    const notificationCenter = container.firstChild;

    if (notificationCenter.classList.contains("NotificationCenter")) {
      interactivityRegistration.detach(this.element);
      this.element.parentNode.replaceChild(notificationCenter, this.element);
      interactivityRegistration.attach(notificationCenter);
    }
  }

  refresh() {
    if (!this.updatingSwitch.getStatus())
      this.refreshNotificationCenter();
  }

  async refreshNotificationCenter() {
    this.updatingSwitch.setStatus(true);

    try {
      const response = await fetch(
        this.uri,
        {
          method: "GET",
          headers: {
            "Accept": "text/html"
          }
        }
      );

      if (response.ok) {
        const text = await response.text();
        this.reload(text);
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.updatingSwitch.setStatus(false)
    }
  }

  attachToolbarEventHandlers() {
    this.toggleButton.addEventListener("click", (event) => this.toggle());
    this.refreshButton.addEventListener("click", (event) => this.refresh());
  }
}

interactivityRegistration.register("Task", function (element) { return new Task(element); });
interactivityRegistration.register("NotificationCenter", function (element) { return new NotificationCenterComponent(element); });


// ---------- File: WebSite.Object_.Action.ts ----------
// @ts-nocheck
export class ObjectAction extends WebPageComponent {
  constructor(element) {
    super(element);

    this.canSubmit = true; // TODO: We should properly disable any other action while any operation is still in progress

    this.name = element.dataset.Name;
    this.uri = element.dataset.Uri;
    this.requiresConfirmation = element.dataset.RequiresConfirmation === "true";
    this.requiresConfirmationWindow = element.dataset.ConfirmationWindow === "true";
    this.useSiblingComponent = element.dataset.UseSiblingComponent === "true";

    this.keyListener = (event) => { this.handleHotKey(getEvent(event)); };
    this.determineElements();

    if (!this.element.classList.contains("Disabled"))
      this.attachEventHandlers();
  }

  attachEventHandlers() {
    if (this.caption !== null)
      this.caption.addEventListener("click", (event) => { this.open(); });

    if (this.submit !== null)
      this.submit.addEventListener("click", (event) => { this.submitForm(); });

    if (this.cancel !== null)
      this.cancel.addEventListener("click", (event) => { this.cancelForm(); });
  }

  bind() {
    const form = this.getForm();

    if (form !== null) {
      form.addEventListener(
        "keydown",
        this.keyListener,
        true
      );

      if (form.component !== undefined)
        form.component.focus();
    }
  }

  release() {
    const form = this.getForm();

    if (form !== null) {
      form.removeEventListener(
        "keydown",
        this.keyListener
      );
    }
  }

  cancelForm() {
    const parent = this.parentComponent.parentComponent;
    parent.sendCommandRequest("<Action Name=\"\"/>");
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.caption = query.getChild(WithClass("Caption"));
    this.submit = query.getChild(WithClass("Submit"));
    this.cancel = query.getChild(WithClass("Cancel"));

    if (this.requiresConfirmationWindow) {
      this.labels = new Labels(query.getChild(WithClass("Labels")));
      this.confirmationWindow = new ConfirmationWindowComponent(this.labels.Confirmation, this.labels.Confirm, this.labels.Cancel, () => { this.execute(); }, this.getConfirmationClass());
    }
  }

  getConfirmationClass() {
    if (this.name === "Delete")
      return ConfirmationClass.Delete;
    else
      return ConfirmationClass.Confirm;
  }

  async execute() {
    if (await application.pageHandler.canNavigate()) {
      const parent = this.parentComponent.parentComponent;
      const form = this.getForm();

      parent.sendActionRequest(this.name, form, () => this.canSubmit = true);
    }
    else
      this.canSubmit = true;
  }

  getForm() {
    if (this.useSiblingComponent)
      return this.parentComponent.parentComponent.getForm();
    else if (this.parentComponent.actionForm !== null)
      return new DomQuery(this.parentComponent.actionForm).getDescendant(WithTagName("FORM"));
  }

  handleHotKey(event) {
    if (event.ctrlKey && event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();

      this.submitForm();
    }
    else if (event.key === "Escape") {
      this.cancelForm();
    }
  }

  open() {
    if (!this.requiresConfirmation) {
      if (this.requiresConfirmationWindow)
        this.confirmationWindow.show();
      else
        this.execute();
    }
    else
      this.showForm();
  }

  submitForm() {
    if (this.canSubmit) {
      this.canSubmit = false;

      if (this.requiresConfirmationWindow) {
        this.confirmationWindow.show();
        this.canSubmit = true;
      }
      else
        this.execute();
    }
  }

  showForm() {
    const parent = this.parentComponent.parentComponent;
    parent.toggleAction(this.name);
  }
}

function ActionGroup(element) {
  this.initialize = function () {
    this.collapsed = this.element.dataset.Collapsed === "true";
    this.icon = new DomQuery(this.element).getChild(WithClass("Icon"));
    this.caption = new DomQuery(this.element).getChild(WithClass("Caption"));

    if (this.collapsed) {
      this.collapsed = new HtmlClassSwitch(this.element, "Collapsed");

      var object = this;
      this.icon.onclick = function (event) {
        object.collapsed.toggle();
        var listener = connectClickOutsideListener(object.element, function (event) { object.collapsed.toggle(); removeClickOutsideListener(listener); });
      };

      this.caption.onclick = function (event) {
        object.collapsed.toggle();
        var listener = connectClickOutsideListener(object.element, function (event) { object.collapsed.toggle(); removeClickOutsideListener(listener); });
      };
    }
  }

  this.element = element;
  this.initialize();
}

class ActionMenu extends WebPageComponent {
  constructor(element) {
    super(element);

    this.element = element;
    this.expanded = new HtmlClassSwitch(this.element, "Expanded");

    this.determineElements();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.button = query.getChild(WithTagName("BUTTON"));
    this.button.addEventListener("click", (event) => { this.toggle(); });

    this.menu = query.getChild(WithClass("ActionMenuDropDown"));

    const actions = query.getDescendants(WithClass("Action"));

    for (const action of actions)
      action.addEventListener(
        "click",
        (event) => {
          distributeEventUpHierarchy(new MenuActionEvent(action.dataset.Action), this);
        }
      );
  }

  toggle() {
    if (this.expanded.getStatus())
      this.close();
    else
      this.open();
  }

  open() {
    this.expanded.setStatus(true);
    this.clickOutsideListener = new ClickOutsideListener(
      [this.menu],
      (event) => {
        this.close();
      }
    );
  }

  close() {
    this.clickOutsideListener.remove();
    this.expanded.setStatus(false);
  }
}

interactivityRegistration.register("ObjectAction", function (element) { return new ObjectAction(element); });
interactivityRegistration.register("ActionMenu", function (element) { return new ActionMenu(element); });


// ---------- File: WebSite.Object_.Filter.ts ----------
// @ts-nocheck
export class WebSiteObjectFilters extends WebPageComponent {
  constructor(element) {
    super(element);

    this.fields = new Array();
    this.defaultFilters = new Array();

    this.uri = this.element.dataset.Uri;
    this.filterForm = null;

    // TODO: provide base uri server side.
    this.baseUri = this.uri.split(";", 1);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.add !== null)
      this.attachHiddenFilters();
  }

  attachFilterHandler(field) {
    field.component.addEventListener("change", (event) => { this.filter(); });
  }

  bind() {
    this.registerHiddenFilters();
    this.registerDefaultFilters();

    this.filtersChanged();
  }

  determineElements() {
    let query = new DomQuery(this.element);

    this.toolbar = query.getChild(WithClass("Toolbar"));
    this.header = new DomQuery(this.toolbar).getChild(WithClass("Header"));
    this.progress = new Progress(query.getChild(WithClass("Progress")));
    this.contents = query.getChild(WithClass("Contents"));
    this.feedback = new DomQuery(this.toolbar).getChild(WithClass("Feedback"));

    query = new DomQuery(this.header);

    this.toggle = query.getChild(WithClass("ToggleFilters"));
    this.toggle.addEventListener(
      "click",
      (event) => {
        new HtmlClassSwitch(this.element, "Active").toggle();
      }
    )

    this.clear = query.getChild(WithClass("ClearFilters"));

    if (this.clear !== null) {
      this.clear.addEventListener(
        "click",
        () => {
          this.clearFilters();
        }
      )
    }

    query = new DomQuery(this.toolbar);
    this.add = query.getChild(WithClass("Add"));
    this.values = query.getDescendants(WithClass("FilterValue"));

    const defaultFilters = query.getDescendants(WithClass("DefaultFilter"));

    for (const defaultFilter of defaultFilters)
      this.defaultFilters.push(new Filter(defaultFilter));
  }

  registerDefaultFilters() {
    for (const defaultFilter of this.defaultFilters)
      this.registerFilter(defaultFilter.field, true);
  }

  registerHiddenFilters() {
    if (this.filterForm !== null) {
      const form = this.filterForm.component;
      const section = form.childComponents[0];

      for (const child of section.childComponents)
        this.registerFilter(child.element, false);
    }
  }

  createClearFilterHandler(value) {
    const name = value.childNodes[1].dataset.Name;

    return (event) => {
      this.toolbar.removeChild(value);

      for (const field of this.fields) {
        if (field.name.indexOf(name, field.name.length - name.length) !== -1) {
          field.setValue("");
          this.filter();
        }
      }
    };
  }

  clearFilters() {
    this.reload(this.baseUri, true);
  }

  attachHiddenFilters() {
    this.button = new DomQuery(this.add).getChild(WithTagName("BUTTON"));
    this.button.addEventListener(
      "click",
      (event) => {
        this.toggleAddForm()
      }
    );

    this.addExpanded = new HtmlClassSwitch(this.add, "Expanded");

    this.filterForm = new DomQuery(this.add).getChild(WithTagName("FORM"));
    this.filterForm.childNodes[1].childNodes[0].addEventListener(
      "click",
      () => {
        this.toggleAddForm();
        this.filter();
      }
    );

    for (const value of this.values) {
      const close = new DomQuery(value).getChild(WithClass("Close"));
      close.onclick = this.createClearFilterHandler(value);
    }
  }

  filter() {
    this.reload(this.getUri(), false);
    this.filtersChanged();
  }

  reloadContents(contents) {
    interactivityRegistration.detach(this.contents);
    this.contents.replaceWith(contents);
    this.contents = contents;
    interactivityRegistration.attach(this.contents);
  }

  reloadToolbar(newToolbar, reset) {
    this.fields = new Array();

    const query = new DomQuery(newToolbar);
    const newFilters = query.getChild(WithClass("Add"));

    if (this.add !== null && newFilters !== null) {
      interactivityRegistration.detach(this.add);
      this.add.replaceWith(newFilters);
      this.add = newFilters;
      interactivityRegistration.attach(this.add);

      this.values.forEach(value => value.remove());
      this.values = query.getChildren(WithClass("FilterValue"));

      this.toolbar.append(...this.values);

      this.attachHiddenFilters();
      this.registerHiddenFilters();
    }

    const newFeedback = query.getChild(WithClass("Feedback"));

    this.feedback.remove();
    this.toolbar.append(newFeedback);
    this.feedback = newFeedback;

    const defaultFilters = query.getChildren(WithClass("DefaultFilter"));

    for (const defaultFilter of defaultFilters) {
      const newFilter = new Filter(defaultFilter);
      const filter = this.defaultFilters.find(element => element.name === newFilter.name);

      if (filter !== null) {
        if (filter.reload(newFilter, reset))
          this.attachFilterHandler(filter.field);

        this.fields.push(filter.field.component);
      }
    }
  }

  reload(uri, reset) {
    const client = new HttpClient();

    client.get(
      uri + ";$Filter",
      (response) => {
        const dummy = document.createElement("div");
        dummy.innerHTML = response.responseText;

        const newFilter = dummy.childNodes[0];
        const newToolbar = newFilter.childNodes[0];

        this.reloadContents(newFilter.childNodes[2]);
        this.reloadToolbar(newToolbar, reset);

        window.history.pushState(
          { url: uri },
          null,
          uri
        );
      },
      this.progress
    );
  }

  getQuery() {
    let query = "";

    for (const field of this.fields) {
      const value = field.getValue();

      if (value !== null && value.length > 0)
        query = query + encodeURIComponent(field.name) + "=" + encodeURIComponent(value) + ";";
    }

    if (query.length > 0)
      query = query.substring(0, query.length - 1);

    return query;
  }

  getUri() {
    let uri = this.baseUri;
    const query = this.getQuery();

    if (query.length > 0)
      uri = uri + ";" + query;

    return uri;
  }

  registerFilter(field, defaultFilter) {
    this.fields.push(field.component);

    if (defaultFilter)
      this.attachFilterHandler(field);
  }

  toggleAddForm() {
    this.addExpanded.toggle();

    const listener = connectClickOutsideListener(
      this.add,
      (event) => {
        this.addExpanded.toggle();
        removeClickOutsideListener(listener);
      }
    );
  }

  filtersChanged() {
    this.clear.classList.toggle("Hidden", this.baseUri === this.getUri());
  }
}

export class Filter extends WebPageComponent {
  constructor(element) {
    super(element);

    const query = new DomQuery(this.element);

    this.field = query.getChild(WithClass("Field"));
    this.problems = query.getChild(WithClass("Problems"));
  }

  reload(filter, reset) {
    this.problems.replaceWith(filter.problems);
    this.problems = filter.problems;

    this.element.className = filter.element.className;

    // TODO: Suggest fields need to be updated to ensure they communicate with the correct URI.
    //       We should only update the URI of the underlying table instead.
    if (reset || this.field.component instanceof SuggestField) {
      interactivityRegistration.detach(this.field);
      this.field.replaceWith(filter.field);
      this.field = filter.field;
      interactivityRegistration.attach(this.field);

      return true;
    }
    else
      return false;
  }

  get name() {
    return this.element.dataset.Name;
  }
}

interactivityRegistration.register("Filtering", function (element) { return new WebSiteObjectFilters(element); });


// ---------- File: WebSite.Page.Component.Canvas.ts ----------
// @ts-nocheck
export class WebPageCanvasComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.rotation = mat4.create();
    mat4.identity(this.rotation);

    this.element.focus();
    this.attachInteractivity();
    this.initialize();
    this.paint();
  }

  initialize() {
    this.objectString = this.element.dataset.Objects;
    this.objects = JSON.parse(this.objectString);

    this.geometries = new Array();

    for (let index = 0; index < this.objects.length; index++) {
      const geometryObject = this.objects[index];
      const geometry = new Geometry(GeometryType.fromText(geometryObject.Type));
      const points = geometryObject.Points;

      geometry.color = [geometryObject.Color[0] / 255, geometryObject.Color[1] / 255, geometryObject.Color[2] / 255, geometryObject.Color[3] / 255];

      for (let pointIndex = 0; pointIndex < points.length; pointIndex++) {
        const point = points[pointIndex];

        if (pointIndex == 0)
          geometry.dimension.initialize(point.X, point.Y, point.Z);
        else
          geometry.dimension.update(point.X, point.Y, point.Z);

        geometry.points.push(point.X);
        geometry.points.push(point.Y);
        geometry.points.push(point.Z);

        geometry.indices.push(pointIndex);
      }

      this.geometries.push(geometry);
    }

    this.element.setAttribute("width", this.element.clientWidth + "px");
    this.element.setAttribute("height", this.element.clientHeight + "px");
  }

  paint() {
    paint3d(this.element, this.geometries, this.rotation);
  }

  degreesToRadians(value) {
    return value / 180 * Math.PI;
  }

  rotate(x, y, z) {
    const newRotationMatrix = mat4.create();
    mat4.identity(newRotationMatrix);

    mat4.rotate(newRotationMatrix, newRotationMatrix, this.degreesToRadians(x), [1, 0, 0]);
    mat4.rotate(newRotationMatrix, newRotationMatrix, this.degreesToRadians(y), [0, 1, 0]);
    mat4.rotate(newRotationMatrix, newRotationMatrix, this.degreesToRadians(z), [0, 0, 1]);
    mat4.multiply(this.rotation, this.rotation, newRotationMatrix);
  }

  attachInteractivity() {
    this.lastMouseX = null;
    this.lastMouseY = null;

    this.element.onmousedown = (event) => {
      this.mouseDown = true;
      this.lastMouseX = event.clientX;
      this.lastMouseY = event.clientY;
    };

    this.element.onmouseup = (event) => {
      this.mouseDown = false;
    };

    document.addEventListener('keydown', (event) => {
      if (event.ctrlKey && event.keyCode == 37) {
        this.rotate(0, 0, -10);
      }
      else if (event.ctrlKey && event.keyCode == 39) {
        this.rotate(0, 0, 10);
      }
      else if (event.keyCode == 37) {
        this.rotate(0, -10, 0);
      }
      else if (event.keyCode == 38) {
        this.rotate(-10, 0, 0);
      }
      else if (event.keyCode == 39) {
        this.rotate(0, 10, 0);
      }
      else if (event.keyCode == 40) {
        this.rotate(10, 0, 0);
      }
    });

    this.element.onmousemove = (event) => {
      if (this.mouseDown) {
        const newX = event.clientX;
        const newY = event.clientY;

        const deltaX = newX - this.lastMouseX;
        const deltaY = newY - this.lastMouseY;

        this.rotate(deltaX, deltaY, 0);
        this.lastMouseX = newX;
        this.lastMouseY = newY;
      }
    };
  }
}

var GeometryType = new Enumeration(["Point", "Line", "Triangle"]);

function Geometry(type) {
  this.points = new Array();
  this.indices = new Array();
  this.dimension = new Dimension();

  this.type = type;
}

function Dimension() {
  this.initialize = function (x, y, z) {
    this.minX = x;
    this.maxX = x;
    this.minY = y;
    this.maxY = y;
    this.minZ = z;
    this.maxZ = z;
  }

  this.getMaximum = function () {
    return Math.max(this.size(0), this.size(1), this.size(2));
  }

  this.size = function (index) {
    if (index == 0)
      return this.maxX - this.minX;
    else if (index == 1)
      return this.maxY - this.minY;
    else if (index == 2)
      return this.maxZ - this.minZ;
  }

  this.union = function (dimension) {
    var result = new Dimension();
    result.initialize(this.minX, this.minY, this.minZ);
    result.update(this.maxX, this.maxY, this.maxZ);
    result.update(dimension.minX, dimension.minY, dimension.minZ);
    result.update(dimension.maxX, dimension.maxY, dimension.maxZ);

    return result;
  }

  this.update = function (x, y, z) {
    if (x < this.minX)
      this.minX = x;
    else if (x > this.maxX)
      this.maxX = x;

    if (y < this.minY)
      this.minY = y;
    else if (y > this.maxY)
      this.maxY = y;

    if (z < this.minZ)
      this.minZ = z;
    else if (z > this.maxZ)
      this.maxZ = z;
  }
}

function paint3d(element, geometries, rotation) {
  const canvas = document.querySelector('#glcanvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

  if (!gl) {
    return;
  }

  const vsSource = `
        attribute vec4 aVertexPosition;
        attribute vec4 aVertexColor;
        uniform mat4 uModelViewMatrix;
        uniform mat4 uProjectionMatrix;
        varying lowp vec4 vColor;
        void main(void) {
            gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;
            vColor = aVertexColor;
            gl_PointSize = 2.0;
        }
    `;

  const fsSource = `
        varying lowp vec4 vColor;
        void main(void) {
            gl_FragColor = vColor;
        }
    `;

  const shaderProgram = initShaderProgram(gl, vsSource, fsSource);

  const programInfo = {
    program: shaderProgram,
    attribLocations: {
      vertexPosition: gl.getAttribLocation(shaderProgram, 'aVertexPosition'),
      vertexColor: gl.getAttribLocation(shaderProgram, 'aVertexColor'),
    },
    uniformLocations: {
      projectionMatrix: gl.getUniformLocation(shaderProgram, 'uProjectionMatrix'),
      modelViewMatrix: gl.getUniformLocation(shaderProgram, 'uModelViewMatrix'),
    },
  };

  const buffers = new Array();

  for (var index = 0; index < geometries.length; index++)
    buffers.push(initBuffers(gl, geometries[index]));

  function render(now) {
    drawScene(gl, programInfo, geometries, buffers, rotation);

    requestAnimationFrame(render);
  }

  requestAnimationFrame(render);
}

function initBuffers(gl, geometry) {
  const positionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry.points), gl.STATIC_DRAW);

  const indexBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
  gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(geometry.indices), gl.STATIC_DRAW);

  // Initialize color buffer.
  const colorBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);

  var colors = [];

  for (var index2 = 0; index2 < geometry.points.length; index2++)
    colors = colors.concat(geometry.color);

  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);

  return {
    position: positionBuffer,
    colors: colorBuffer,
    indices: indexBuffer,
  };
}

function drawScene(gl, programInfo, geometries, buffers, rotation) {
  gl.clearColor(0.9, 0.9, 0.9, 1.0);
  gl.clearDepth(1.0);
  gl.disable(gl.DEPTH_TEST);
  gl.depthFunc(gl.LEQUAL);
  gl.depthMask(false);
  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

  const projectionMatrix = mat4.create();
  const modelViewMatrix = mat4.create();

  mat4.perspective(projectionMatrix, 45 * Math.PI / 180, gl.canvas.clientWidth / gl.canvas.clientHeight, 0.1, 100);
  var dimension = geometries[0].dimension;

  for (var index = 1; index < geometries.length; index++)
    dimension = dimension.union(geometries[index].dimension);

  var size = [
    dimension.size(0),
    dimension.size(1),
    dimension.size(2)
  ];

  var translations = [-dimension.minX - size[0] / 2, -dimension.minY - size[1] / 2, -dimension.minZ - size[2] / 2];
  var scale = 2 / dimension.getMaximum();

  mat4.translate(modelViewMatrix, modelViewMatrix, [0, 0, -1.5]);
  mat4.multiply(modelViewMatrix, modelViewMatrix, rotation);
  mat4.scale(modelViewMatrix, modelViewMatrix, [scale, scale, scale]);
  mat4.translate(modelViewMatrix, modelViewMatrix, translations);

  for (var index = 0; index < geometries.length; index++) {
    var geometry = geometries[index];
    const buffer = buffers[index];

    {
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer.position);
      gl.vertexAttribPointer(programInfo.attribLocations.vertexPosition, 3, gl.FLOAT, false, 0, 0);
      gl.enableVertexAttribArray(programInfo.attribLocations.vertexPosition);
    }

    {
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer.colors);
      gl.vertexAttribPointer(programInfo.attribLocations.vertexColor, 4, gl.FLOAT, false, 0, 0);
      gl.enableVertexAttribArray(programInfo.attribLocations.vertexColor);
    }

    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer.indices);
    gl.useProgram(programInfo.program);

    gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
    gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, modelViewMatrix);

    var offset = 0;
    var vertexCount = geometry.points.length / 3;

    {
      const type = gl.UNSIGNED_SHORT;

      if (geometry.type == GeometryType.Point)
        gl.drawElements(gl.POINTS, vertexCount, type, offset);
      else if (geometry.type == GeometryType.Line)
        gl.drawElements(gl.LINES, vertexCount, type, offset);
      else if (geometry.type == GeometryType.Triangle)
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    }
  }
}

function initShaderProgram(gl, vsSource, fsSource) {
  const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSource);
  const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSource);

  const shaderProgram = gl.createProgram();
  gl.attachShader(shaderProgram, vertexShader);
  gl.attachShader(shaderProgram, fragmentShader);
  gl.linkProgram(shaderProgram);

  if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
    return null;
  }

  return shaderProgram;
}

function loadShader(gl, type, source) {
  const shader = gl.createShader(type);

  gl.shaderSource(shader, source);
  gl.compileShader(shader);

  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    gl.deleteShader(shader);
    return null;
  }

  return shader;
}

interactivityRegistration.register("Canvas", function (element) { return new WebPageCanvasComponent(element); });


// ---------- File: WebSite.Page.Component.Collapsible.ts ----------
// @ts-nocheck
export class Collapsible extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    this.toggleElement.onclick = (event) => { this.toggle(event); };
  }

  determineElements() {
    this.collapsed = new HtmlClassSwitch(this.element, "Collapsed");

    const query = new DomQuery(this.element);
    const toggle = query.getDescendant(WithClass("Toggle"));

    this.toggleElement = toggle !== null ? toggle : this.element;
    this.toggleElement.tabIndex = 0;
  }

  toggle(event) {
    if (event.target.href === undefined) {
      this.collapsed.toggle();
      this.toggleElement.setAttribute('aria-expanded', !this.collapsed.getStatus());
    }
  }
}

interactivityRegistration.register("Collapsible", function (element) { return new Collapsible(element); });


// ---------- File: WebSite.Page.Component.Conditional.ts ----------
// @ts-nocheck
function FieldCondition(field, value) {
  this.isMet = function () {
    var renderer = new ValueTextRenderer();
    return renderer.render(this.field.getValue()) === this.value;
  }

  this.field = field;
  this.value = value;
}

export class ConditionalComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.value = "";
    this.hideSelf = this.element.dataset.HideSelf === "true";
  }

  determineElements() {
    const form = this.getAncestor(new ComponentWithClass(Form));
    const conditionElements = new DomQuery(this.element).getChildren(WithClass("FieldCondition"));

    this.conditions = new Array();

    for (const condition of conditionElements) {
      const fieldName = condition.dataset.Name;
      const component = form.getDescendant(new ComponentWithName(fieldName));

      if (component !== null)
        this.conditions.push(new FieldCondition(component, condition.dataset.Value));
      else
        console.log("Cannot find field for element: " + fieldName);
    }
  }

  bind() {
    this.determineElements();
    this.attachEventHandlers();
    this.updateVisibility();
  }

  valueChanged() {
    this.updateVisibility();
  }

  updateVisibility() {
    let visible = false;
    let index = 0;

    while (!visible && index < this.conditions.length) {
      visible = this.conditions[index].isMet();
      index++;
    }

    this.visible = visible;
    this.element.classList.toggle("Hidden", !this.visible);

    if (!this.hideSelf) {
      const parent = this.parentComponent;

      if (parent !== null)
        parent.handleEvent(new VisibilityChangedEvent(this));
    }
  }

  attachEventHandlers() {
    const fields = new Array(this.conditions.length);

    for (let index = 0; index < this.conditions.length; index++) {
      const condition = this.conditions[index];

      if (fields.indexOf(condition.field) == -1)
        condition.field.addEventListener("change", (event) => { this.valueChanged(); });

      fields[index] = condition.field;
    }
  }
}

interactivityRegistration.register("ConditionalComponent", function (element) { return new ConditionalComponent(element); });


// ---------- File: WebSite.Page.Component.Consent.ts ----------
// @ts-nocheck
export class ConsentWindow extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    this.button.onclick = (event) => { this.consent(); };
  }

  consent() {
    const request = new XMLHttpRequest();

    const formData = new FormData();
    formData.append("Consent", true);

    request.open("POST", this.element.dataset.Uri, true);
    request.onload = () => {
      window.location = this.element.dataset.Uri;
    };
    request.send(formData);
  }

  determineElements() {
    this.button = new DomQuery(this.element).getChild(WithClass("Consent"));
  }
}

interactivityRegistration.register("ConsentWindow", function (element) { return new ConsentWindow(element); });


// ---------- File: WebSite.Page.Component.Diagram.ts ----------
// @ts-nocheck
export class Diagram extends WebPageComponent {
  toolbar: HTMLElement;
  contents: HTMLElement;
  labels: Labels;
  updating: HtmlClassSwitch;
  loadingIndicator: LoadingIndicator;
  diagramRenderer: DiagramToImageRenderer;
  interaction: DiagramInteraction | null;
  copyButton: HTMLButtonElement;
  downloadButton: HTMLButtonElement;
  shareButton: HTMLButtonElement;
  diagram: SVGSVGElement;
  legend: HTMLElement;

  constructor(element) {
    super(element);

    const query = new DomQuery(this.element);

    this.toolbar = query.getChild(WithClass("Toolbar"));
    this.contents = query.getChild(WithClass("Contents"));
    this.labels = new Labels(query.getChild(WithClass("Labels")));

    this.updating = new HtmlClassSwitch(this.element, "Updating");
    this.loadingIndicator = new LoadingIndicator();
    this.element.appendChild(this.loadingIndicator.element);

    this.diagramRenderer = new DiagramToImageRenderer(this);
    this.interaction = null;

    this.attachButtonHandlers();
  }

  get renderTime(): string {
    return this.element.dataset.RenderTime;
  }

  get interactionMode(): string {
    return this.element.dataset.Interaction;
  }

  get uri(): string {
    return this.element.dataset.Uri;
  }

  determineComponents() {
    if (this.contents.childNodes.length === 2) {
      this.diagram = this.contents.childNodes[0].childNodes[0];
      this.legend = this.contents.childNodes[1];

      this.copyButton.disabled = !this.diagramRenderer.canCopy();
      this.downloadButton.disabled = false;
      this.shareButton.disabled = !this.diagramRenderer.canShare();

      this.interaction?.destroy();

      this.interaction = this.interactionMode === "Disabled"
        ? null
        : new DiagramInteraction(this.diagram, this.legend, this.labels, this.interactionMode);
    }
  }

  attachButtonHandlers() {
    this.copyButton = new DomQuery(this.toolbar).getChild(WithClass("Copy"));
    this.copyButton.addEventListener("click", (event) => this.copy());
    this.copyButton.disabled = true;

    this.downloadButton = new DomQuery(this.toolbar).getChild(WithClass("Download"));
    this.downloadButton.addEventListener("click", (event) => this.download());
    this.downloadButton.disabled = true;

    this.shareButton = new DomQuery(this.toolbar).getChild(WithClass("Share"));
    this.shareButton.addEventListener("click", (event) => this.share());
    this.shareButton.disabled = true;
  }

  bind() {
    if (this.renderTime === "Deferred")
      this.refresh();
    else
      this.determineComponents();
  }

  copy() {
    this.diagramRenderer.copy();
  }

  download() {
    this.diagramRenderer.download("Diagram");
  }

  share() {
    this.diagramRenderer.share("Diagram");
  }

  reload(text) {
    const dummyElement = document.createElement("div");
    dummyElement.innerHTML = text;

    const contents = new DomQuery(dummyElement).getDescendant(WithClass("Contents"));

    this.element.replaceChild(contents, this.contents);
    this.contents = contents;

    this.determineComponents();
  }

  refresh() {
    this.updating.setStatus(true);
    this.loadingIndicator.setStatus(true);

    fetch(
      this.uri,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "Command": "Refresh" })
      })
      .then((response) => response.text())
      .then(text => this.reload(text))
      .finally(() => {
        this.updating.setStatus(false);
        this.loadingIndicator.setStatus(false);
      });
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent && this.refreshMode === RefreshMode.ForSiblings)
      this.invalidate();
    else
      super.handleEvent(event);
  }

  async validate() {
    this.refresh();
  }
}

export class DiagramToImageRenderer {
  constructor(diagram) {
    this.component = diagram;
  }

  copy() {
    this.createImage(
      (canvas) => {
        canvas.toBlob(
          blob => {
            navigator.clipboard.write([new ClipboardItem({ "image/png": blob })])
              .then(() => { application.toastBox.addMessage(new ToastMessage(this.component.labels.DiagramCopiedSuccessfully, "Success")); })
              .catch((error) => { application.toastBox.addMessage(new ToastMessage(this.component.labels.FailedToCopyDiagram, "Error")); });
          },
          "image/png"
        );
      }
    );
  }

  canCopy() {
    return 'ClipboardItem' in window;
  }

  canShare() {
    return typeof navigator.canShare === "function";
  }

  download(name) {
    this.createImage(
      (canvas) => {
        const pngData = canvas.toDataURL("image/png");

        const downloadLink = document.createElement("a");
        downloadLink.href = pngData;
        downloadLink.download = name + ".png";
        downloadLink.click();
      }
    );
  }

  share(name) {
    this.createImage(
      (canvas) => {
        canvas.toBlob(
          (blob) => {
            const file = new File([blob], name + ".png", { type: "image/png" });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              navigator.share({
                title: name,
                files: [file]
              });
            }
          },
          "image/png"
        );
      }
    );
  }

  applyComputedStyles(original, clone) {
    const computedStyle = window.getComputedStyle(original);

    for (let index = 0; index < computedStyle.length; index++) {
      const name = computedStyle[index];
      const value = computedStyle.getPropertyValue(name);

      clone.style[name] = value;
    }

    for (let index = 0; index < original.children.length; index++)
      this.applyComputedStyles(original.children[index], clone.children[index]);
  }

  createImage(onload) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const diagram = this.component.diagram.cloneNode(true);
    this.applyComputedStyles(this.component.diagram, diagram);

    const diagramWidth = this.component.diagram.getBoundingClientRect().width;
    const diagramHeight = this.component.diagram.getBoundingClientRect().height;
    const legendWidth = 350;

    const legend = this.component.legend.cloneNode(true);
    this.applyComputedStyles(this.component.legend, legend);
    legend.style.width = legendWidth + "px";
    legend.style.height = diagramHeight;

    canvas.width = diagramWidth + legendWidth;
    canvas.height = diagramHeight;

    const legendContainer = document.createElement("div");
    legendContainer.appendChild(legend);

    const container = document.createElement("div");
    container.style.background = "white";
    container.style.display = "flex";
    container.style.alignItems = "center";
    container.style.width = canvas.width + "px";
    container.appendChild(diagram);
    container.appendChild(legendContainer);

    const foreignObject = document.createElementNS("http://www.w3.org/2000/svg", "foreignObject");
    foreignObject.setAttribute("width", "100%");
    foreignObject.setAttribute("height", "100%");
    foreignObject.appendChild(container);

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.appendChild(foreignObject);

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    const image = new Image();
    image.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgString)));

    image.onload = function () {
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      onload(canvas);
    };
  }
}

const svgNamespace = "http://www.w3.org/2000/svg";

interface DiagramVertex {
  x: number;
  y: number;
  xLabel: string;
  yLabel: string;
  segment: string;
}

interface DiagramSeries {
  group: SVGGElement;
  scatter: boolean;
  vertices: DiagramVertex[];
  color: string;
  name: string;
}

interface DiagramShape {
  element: SVGElement;
  label: string;
  color: string;
}

interface OverlayPoint {
  x: number;
  y: number;
}

interface NearestHit {
  vertex: DiagramVertex;
  series: DiagramSeries;
  seriesIndex: number;
}

interface ListenerBinding {
  target: EventTarget;
  type: string;
  handler: EventListener;
}

class DiagramAnimator {
  svg: SVGSVGElement;

  constructor(svg: SVGSVGElement) {
    this.svg = svg;
  }

  animateStrokes(): void {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      const duration = 600;

      this.svg.querySelectorAll("g.DataSeries").forEach(
        (group) => {
          const strokes = group.querySelectorAll("polyline, path");

          strokes.forEach(
            (stroke) => {
              const length = stroke.getTotalLength();

              stroke.style.strokeDasharray = length;
              stroke.animate(
                [
                  { strokeDashoffset: length },
                  { strokeDashoffset: 0 }
                ],
                { duration: duration, easing: "ease-in-out", fill: "backwards" }
              );
            }
          );

          if (strokes.length > 0)
            this.animateMarkers(group, duration);
        }
      );
    }
  }

  animateMarkers(group: Element, delay: number): void {
    group.querySelectorAll("circle:not(.DataPoint), ellipse:not(.DataPoint), polygon").forEach(
      (marker) => {
        marker.animate(
          [
            { opacity: 0 },
            { opacity: 1 }
          ],
          { duration: 300, delay: delay, easing: "ease", fill: "backwards" }
        );
      }
    );
  }
}

class DiagramModel {
  svg: SVGSVGElement;
  series: DiagramSeries[];
  elements: DiagramShape[];

  constructor(svg: SVGSVGElement, legend: Element | null) {
    this.svg = svg;
    this.series = this.collectSeries(legend);
    this.elements = this.collectElements();
  }

  collectSeries(legend: Element | null): DiagramSeries[] {
    const legendItems = legend?.querySelectorAll(".LegendItem") ?? [];
    const groups = this.svg.querySelectorAll("g.DataSeries");
    const named = legendItems.length === groups.length;
    const result: DiagramSeries[] = [];

    groups.forEach(
      (group, index) => {
        const anchors = group.querySelectorAll(".DataPoint");

        if (anchors.length > 0) {
          const vertices = Array.from(anchors).map(
            (anchor) => ({
              x: Number(anchor.getAttribute("cx")),
              y: Number(anchor.getAttribute("cy")),
              xLabel: anchor.getAttribute("data-x") || "",
              yLabel: anchor.getAttribute("data-y") || "",
              segment: anchor.getAttribute("data-segment") || ""
            })
          );

          const seriesName = group.getAttribute("data-series-name");
          const description = named ? legendItems[index].querySelector("span") : null;

          let name = "";

          if (seriesName !== null)
            name = seriesName;
          else if (description !== null)
            name = description.textContent.trim();

          result.push({
            group: group,
            scatter: group.querySelector(".Scatter") !== null,
            vertices: vertices,
            color: group.getAttribute("data-series-color") || "currentColor",
            name: name
          });
        }
      }
    );

    return result;
  }

  collectElements(): DiagramShape[] {
    const result: DiagramShape[] = [];

    this.svg.querySelectorAll(".PieSlice, .Column").forEach(
      (element) => {
        const title = element.querySelector("title");

        if (title !== null) {
          result.push({
            element: element,
            label: title.textContent.trim(),
            color: element.getAttribute("fill") || "currentColor"
          });
        }
      }
    );

    return result;
  }
}

class DiagramTooltip {
  overlay: SVGSVGElement;
  element: HTMLElement;

  constructor(container: Element, overlay: SVGSVGElement) {
    this.overlay = overlay;

    this.element = document.createElement("div");
    this.element.setAttribute("class", "DiagramTooltip");
    this.element.style.opacity = "0";

    container.appendChild(this.element);
  }

  clear(): void {
    this.element.replaceChildren();
  }

  addHeader(text: string): void {
    const header = document.createElement("div");
    header.className = "Header";
    header.textContent = text;

    this.element.appendChild(header);
  }

  addRow(color: string, name: string, value: string): void {
    const swatch = document.createElement("span");
    swatch.className = "Swatch";
    swatch.style.background = color;

    const label = document.createElement("span");
    label.className = "Name";
    label.textContent = name;

    const amount = document.createElement("span");
    amount.className = "Value";
    amount.textContent = value;

    const row = document.createElement("div");
    row.className = "Row";
    row.appendChild(swatch);
    row.appendChild(label);
    row.appendChild(amount);

    this.element.appendChild(row);
  }

  addLabelRow(color: string, label: string): void {
    const swatch = document.createElement("span");
    swatch.className = "Swatch";
    swatch.style.background = color;

    const text = document.createElement("span");
    text.className = "Name";
    text.textContent = label;

    const row = document.createElement("div");
    row.className = "Row";
    row.appendChild(swatch);
    row.appendChild(text);

    this.element.appendChild(row);
  }

  addSegment(segment: string): void {
    const row = document.createElement("div");
    row.className = "Segment";
    row.textContent = segment;

    this.element.appendChild(row);
  }

  positionAtAnchor(anchorX: number): void {
    const overlayWidth = this.overlay.getBoundingClientRect().width;
    let left = anchorX + 14;

    if (left + this.element.offsetWidth > overlayWidth)
      left = anchorX - this.element.offsetWidth - 14;

    this.element.style.left = Math.max(0, left) + "px";
    this.element.style.top = "8px";
    this.element.style.opacity = "1";
  }

  positionNearPoint(anchorX: number, anchorY: number): void {
    const box = this.overlay.getBoundingClientRect();
    let left = anchorX + 14;

    if (left + this.element.offsetWidth > box.width)
      left = anchorX - this.element.offsetWidth - 14;

    let top = anchorY + 14;

    if (top + this.element.offsetHeight > box.height)
      top = anchorY - this.element.offsetHeight - 14;

    this.element.style.left = Math.max(0, left) + "px";
    this.element.style.top = Math.max(0, top) + "px";
    this.element.style.opacity = "1";
  }

  positionAtCursor(event: MouseEvent): void {
    const box = this.overlay.getBoundingClientRect();
    let left = event.clientX - box.left + 14;

    if (left + this.element.offsetWidth > box.width)
      left = event.clientX - box.left - this.element.offsetWidth - 14;

    this.element.style.left = Math.max(0, left) + "px";
    this.element.style.top = (event.clientY - box.top + 14) + "px";
    this.element.style.opacity = "1";
  }

  hide(): void {
    this.element.style.opacity = "0";
    this.element.style.left = "0";
    this.element.style.top = "0";
  }

  remove(): void {
    this.element.remove();
  }
}

class DiagramOverlay {
  svg: SVGSVGElement;
  element: SVGSVGElement;
  crosshairVertical: SVGLineElement;
  crosshairHorizontal: SVGLineElement;
  markers: SVGCircleElement[];
  tooltip: DiagramTooltip;
  segmentHighlights: SVGElement[];

  constructor(svg: SVGSVGElement, container: Element, series: DiagramSeries[]) {
    this.svg = svg;
    this.segmentHighlights = [];

    this.element = document.createElementNS(svgNamespace, "svg");
    this.element.setAttribute("class", "InteractionOverlay");

    this.crosshairVertical = this.createCrosshair();
    this.crosshairHorizontal = this.createCrosshair();

    this.markers = series.map(
      (entry) => {
        const marker = document.createElementNS(svgNamespace, "circle");
        marker.setAttribute("class", "HighlightMarker");
        marker.setAttribute("r", "5");
        marker.setAttribute("fill", entry.color);
        marker.style.opacity = "0";

        this.element.appendChild(marker);
        return marker;
      }
    );

    container.appendChild(this.element);

    this.tooltip = new DiagramTooltip(container, this.element);
  }

  createCrosshair(): SVGLineElement {
    const line = document.createElementNS(svgNamespace, "line");
    line.setAttribute("class", "Crosshair");
    line.style.opacity = "0";

    this.element.appendChild(line);
    return line;
  }

  toOverlay(userX: number, userY: number): OverlayPoint {
    const point = this.svg.createSVGPoint();
    point.x = userX;
    point.y = userY;

    const screen = point.matrixTransform(this.svg.getScreenCTM());
    const box = this.element.getBoundingClientRect();

    return { x: screen.x - box.left, y: screen.y - box.top };
  }

  getBox(): DOMRect {
    return this.element.getBoundingClientRect();
  }

  addSegmentHighlight(highlight: SVGElement): void {
    highlight.setAttribute("class", "SegmentHighlight");

    this.element.appendChild(highlight);
    this.segmentHighlights.push(highlight);
  }

  clearSegmentHighlights(): void {
    this.segmentHighlights.forEach((highlight) => highlight.remove());
    this.segmentHighlights = [];
  }

  hide(): void {
    this.crosshairVertical.style.opacity = "0";
    this.crosshairHorizontal.style.opacity = "0";
    this.markers.forEach((marker) => marker.style.opacity = "0");
    this.tooltip.hide();
  }

  remove(): void {
    this.element.remove();
    this.tooltip.remove();
  }
}

class SeriesHover {
  svg: SVGSVGElement;
  model: DiagramModel;
  overlay: DiagramOverlay;
  mode: string;
  listeners: ListenerBinding[];

  constructor(svg: SVGSVGElement, model: DiagramModel, overlay: DiagramOverlay, mode: string) {
    this.svg = svg;
    this.model = model;
    this.overlay = overlay;
    this.mode = mode;
    this.listeners = [];

    this.listen(svg, "mousemove", (event) => this.move(event));
    this.listen(svg, "mouseleave", (event) => this.overlay.hide());
  }

  listen(target: EventTarget, type: string, handler: EventListener): void {
    target.addEventListener(type, handler);
    this.listeners.push({ target: target, type: type, handler: handler });
  }

  move(event: MouseEvent): void {
    if (this.mode === "NearestPoint")
      this.moveNearest(event);
    else
      this.moveUnified(event);
  }

  toUserX(event: MouseEvent): number {
    const point = this.svg.createSVGPoint();
    point.x = event.clientX;
    point.y = event.clientY;

    return point.matrixTransform(this.svg.getScreenCTM().inverse()).x;
  }

  nearest(distance: (vertex: DiagramVertex) => number): NearestHit | null {
    let best: NearestHit | null = null;
    let bestDistance = Infinity;

    this.model.series.forEach(
      (entry, seriesIndex) => {
        if (!entry.group.classList.contains("Hidden"))
          entry.vertices.forEach(
            (vertex) => {
              const value = distance(vertex);

              if (value < bestDistance) {
                bestDistance = value;
                best = { vertex: vertex, series: entry, seriesIndex: seriesIndex };
              }
            }
          );
      }
    );

    return best;
  }

  moveNearest(event: MouseEvent): void {
    const overlayBox = this.overlay.getBox();
    const cursorX = event.clientX - overlayBox.left;
    const cursorY = event.clientY - overlayBox.top;

    const nearest = this.nearest(
      (vertex) => {
        const point = this.overlay.toOverlay(vertex.x, vertex.y);
        const dx = point.x - cursorX;
        const dy = point.y - cursorY;

        return dx * dx + dy * dy;
      }
    );

    if (nearest === null)
      this.overlay.hide();
    else {
      const bounds = this.plotBounds();
      const position = this.overlay.toOverlay(nearest.vertex.x, nearest.vertex.y);

      this.showVerticalCrosshair(position.x, bounds.top - overlayBox.top, bounds.bottom - overlayBox.top);
      this.showHorizontalCrosshair(bounds.left - overlayBox.left, bounds.right - overlayBox.left, position.y);

      this.overlay.markers.forEach(
        (marker, index) => {
          if (index !== nearest.seriesIndex)
            marker.style.opacity = "0";
          else {
            marker.setAttribute("cx", position.x);
            marker.setAttribute("cy", position.y);
            marker.style.opacity = "1";
          }
        }
      );

      const tooltip = this.overlay.tooltip;
      tooltip.clear();
      tooltip.addHeader(nearest.series.name);
      tooltip.addLabelRow(nearest.series.color, nearest.vertex.xLabel + ", " + nearest.vertex.yLabel);

      if (nearest.vertex.segment !== "")
        tooltip.addSegment(nearest.vertex.segment);

      tooltip.positionNearPoint(position.x, position.y);
    }
  }

  moveUnified(event: MouseEvent): void {
    const userX = this.toUserX(event);
    const target = this.nearest((vertex) => Math.abs(vertex.x - userX));

    if (target === null)
      this.overlay.hide();
    else {
      const overlayBox = this.overlay.getBox();
      const bounds = this.plotBounds();
      const crosshairX = this.overlay.toOverlay(target.vertex.x, 0).x;

      this.showVerticalCrosshair(crosshairX, bounds.top - overlayBox.top, bounds.bottom - overlayBox.top);

      const tooltip = this.overlay.tooltip;
      tooltip.clear();
      tooltip.addHeader(target.vertex.xLabel);

      this.model.series.forEach(
        (entry, seriesIndex) => {
          const marker = this.overlay.markers[seriesIndex];

          if (entry.group.classList.contains("Hidden"))
            marker.style.opacity = "0";
          else {
            const vertex = entry.vertices.find((candidate) => candidate.x === target.vertex.x);

            if (vertex === undefined)
              marker.style.opacity = "0";
            else {
              const position = this.overlay.toOverlay(vertex.x, vertex.y);

              marker.setAttribute("cx", position.x);
              marker.setAttribute("cy", position.y);
              marker.style.opacity = "1";

              tooltip.addRow(entry.color, entry.name, vertex.yLabel);

              if (vertex.segment !== "")
                tooltip.addSegment(vertex.segment);
            }
          }
        }
      );

      tooltip.positionAtAnchor(crosshairX);
    }
  }

  plotBounds(): DOMRect {
    const plotArea = this.svg.querySelector(".PlotArea");

    return (plotArea !== null ? plotArea : this.svg).getBoundingClientRect();
  }

  showVerticalCrosshair(x: number, top: number, bottom: number): void {
    const crosshair = this.overlay.crosshairVertical;
    crosshair.setAttribute("x1", x);
    crosshair.setAttribute("x2", x);
    crosshair.setAttribute("y1", top);
    crosshair.setAttribute("y2", bottom);
    crosshair.style.opacity = "1";
  }

  showHorizontalCrosshair(left: number, right: number, y: number): void {
    const crosshair = this.overlay.crosshairHorizontal;
    crosshair.setAttribute("x1", left);
    crosshair.setAttribute("x2", right);
    crosshair.setAttribute("y1", y);
    crosshair.setAttribute("y2", y);
    crosshair.style.opacity = "1";
  }

  destroy(): void {
    this.listeners.forEach((binding) => binding.target.removeEventListener(binding.type, binding.handler));
  }
}

class SegmentHighlighter {
  model: DiagramModel;
  overlay: DiagramOverlay;

  constructor(model: DiagramModel, overlay: DiagramOverlay) {
    this.model = model;
    this.overlay = overlay;
  }

  highlight(segment: string): void {
    this.clear();

    this.model.series.forEach(
      (entry) => {
        const vertices = entry.vertices.filter((vertex) => vertex.segment === segment);

        if (vertices.length > 0 && !entry.group.classList.contains("Hidden")) {
          entry.group.classList.add("Faded");

          if (entry.scatter)
            vertices.forEach((vertex) => this.highlightPoint(entry, vertex));
          else
            this.segmentRuns(entry, segment).forEach(
              (run) => {
                if (run.length > 1)
                  this.highlightRun(entry, run);
                else
                  this.highlightPoint(entry, run[0]);
              }
            );
        }
      }
    );
  }

  highlightRun(entry: DiagramSeries, run: DiagramVertex[]): void {
    const points = run.map(
      (vertex) => {
        const point = this.overlay.toOverlay(vertex.x, vertex.y);
        return point.x + "," + point.y;
      }
    ).join(" ");

    const highlight = document.createElementNS(svgNamespace, "polyline");
    highlight.setAttribute("fill", "none");
    highlight.setAttribute("stroke", entry.color);
    highlight.setAttribute("points", points);

    this.overlay.addSegmentHighlight(highlight);
  }

  highlightPoint(entry: DiagramSeries, vertex: DiagramVertex): void {
    const point = this.overlay.toOverlay(vertex.x, vertex.y);

    const highlight = document.createElementNS(svgNamespace, "circle");
    highlight.setAttribute("fill", entry.color);
    highlight.setAttribute("cx", point.x);
    highlight.setAttribute("cy", point.y);
    highlight.setAttribute("r", "5");

    this.overlay.addSegmentHighlight(highlight);
  }

  segmentRuns(entry: DiagramSeries, segment: string): DiagramVertex[][] {
    const runs: DiagramVertex[][] = [];
    const vertices = entry.vertices;
    let index = 0;

    while (index < vertices.length) {
      if (vertices[index].segment === segment) {
        const run: DiagramVertex[] = [];

        while (index < vertices.length && vertices[index].segment === segment) {
          run.push(vertices[index]);
          index += 1;
        }

        runs.push(run);
      }
      else
        index += 1;
    }

    return runs;
  }

  clear(): void {
    this.model.series.forEach((entry) => entry.group.classList.remove("Faded"));
    this.overlay.clearSegmentHighlights();
  }

  destroy(): void {
    this.clear();
  }
}

class LegendController {
  svg: SVGSVGElement;
  model: DiagramModel;
  labels: any;
  highlighter: SegmentHighlighter;
  legendItems: Element[];
  legendTargets: Element[];
  listeners: ListenerBinding[];

  constructor(svg: SVGSVGElement, model: DiagramModel, legend: Element | null, labels: any, highlighter: SegmentHighlighter) {
    this.svg = svg;
    this.model = model;
    this.labels = labels;
    this.highlighter = highlighter;
    this.legendItems = [];
    this.legendTargets = [];
    this.listeners = [];

    if (legend !== null) {
      this.attachSeries(legend);
      this.attachSegments(legend);
    }
  }

  listen(target: EventTarget, type: string, handler: EventListener): void {
    target.addEventListener(type, handler);
    this.listeners.push({ target: target, type: type, handler: handler });
  }

  attachSeries(legend: Element): void {
    const items = legend.querySelectorAll(".LegendItem");
    const targets = this.svg.querySelectorAll("g.DataSeries, g.Columns g.Series, .PieSlice");

    if (items.length > 0 && items.length === targets.length) {
      this.legendItems = Array.from(items);
      this.legendTargets = Array.from(targets);

      this.legendItems.forEach(
        (item, index) => {
          const target = this.legendTargets[index];
          const control = item.querySelector(".LegendHeader") || item;

          control.classList.add("Interactive");

          this.listen(control, "mouseenter", (event) => this.highlightSeries(index));
          this.listen(control, "mouseleave", (event) => this.clearHighlight());

          if (item.querySelector("table") === null && !target.classList.contains("PieSlice")) {
            control.classList.add("Toggleable");

            if (this.labels !== null && this.labels.ShowOrHideSeries !== undefined)
              control.title = this.labels.ShowOrHideSeries.textContent;

            this.listen(control, "click", (event) => this.toggleSeries(index));
          }
        }
      );
    }
  }

  highlightSeries(index: number): void {
    this.legendTargets.forEach(
      (target, targetIndex) => {
        if (targetIndex !== index)
          target.classList.add("Faded");
      }
    );
  }

  clearHighlight(): void {
    this.legendTargets.forEach((target) => target.classList.remove("Faded"));
  }

  toggleSeries(index: number): void {
    const hidden = this.legendTargets[index].classList.toggle("Hidden");
    this.legendItems[index].classList.toggle("Disabled", hidden);
  }

  attachSegments(legend: Element): void {
    legend.querySelectorAll(".LegendSegment").forEach(
      (item) => {
        const segment = item.dataset.Segment;

        item.classList.add("Interactive");

        this.listen(item, "mouseenter", (event) => this.highlighter.highlight(segment));
        this.listen(item, "mouseleave", (event) => this.highlighter.clear());
      }
    );
  }

  destroy(): void {
    this.listeners.forEach((binding) => binding.target.removeEventListener(binding.type, binding.handler));
  }
} 

class ElementHover {
  model: DiagramModel;
  overlay: DiagramOverlay;
  listeners: ListenerBinding[];

  constructor(model: DiagramModel, overlay: DiagramOverlay) {
    this.model = model;
    this.overlay = overlay;
    this.listeners = [];

    this.model.elements.forEach(
      (entry) => {
        this.listen(entry.element, "mouseenter", (event) => this.show(entry, event));
        this.listen(entry.element, "mousemove", (event) => this.overlay.tooltip.positionAtCursor(event));
        this.listen(entry.element, "mouseleave", (event) => this.overlay.hide());
      }
    );
  }

  listen(target: EventTarget, type: string, handler: EventListener): void {
    target.addEventListener(type, handler);
    this.listeners.push({ target: target, type: type, handler: handler });
  }

  show(entry: DiagramShape, event: MouseEvent): void {
    const tooltip = this.overlay.tooltip;
    tooltip.clear();
    tooltip.addLabelRow(entry.color, entry.label);
    tooltip.positionAtCursor(event);
  }

  destroy(): void {
    this.listeners.forEach((binding) => binding.target.removeEventListener(binding.type, binding.handler));
  }
}

export class DiagramInteraction {
  model: DiagramModel;
  overlay: DiagramOverlay | null;
  seriesHover: SeriesHover | null;
  segmentHighlighter: SegmentHighlighter | null;
  legendController: LegendController | null;
  elementHover: ElementHover | null;

  constructor(svg: SVGSVGElement, legend: Element | null, labels: any, mode: string) {
    this.overlay = null;
    this.seriesHover = null;
    this.segmentHighlighter = null;
    this.legendController = null;
    this.elementHover = null;

    this.model = new DiagramModel(svg, legend);

    if (this.model.series.length > 0 || this.model.elements.length > 0) {
      this.overlay = new DiagramOverlay(svg, svg.parentNode, this.model.series);

      if (this.model.series.length > 0) {
        new DiagramAnimator(svg).animateStrokes();
        this.seriesHover = new SeriesHover(svg, this.model, this.overlay, mode);
      }

      if (this.model.elements.length > 0)
        this.elementHover = new ElementHover(this.model, this.overlay);

      this.segmentHighlighter = new SegmentHighlighter(this.model, this.overlay);
      this.legendController = new LegendController(svg, this.model, legend, labels, this.segmentHighlighter);
    }
  }

  destroy(): void {
    this.seriesHover?.destroy();
    this.elementHover?.destroy();
    this.legendController?.destroy();
    this.segmentHighlighter?.destroy();
    this.overlay?.remove();
  }
}

interactivityRegistration.register("Diagram", function (element) { return new Diagram(element); });


// ---------- File: WebSite.Page.Component.DropZone.ts ----------
// @ts-nocheck
export class DropZone extends WebPageComponent {
  constructor(element) {
    super(element);
  }

  createDragEndOutsideListener() {
    return (event) => {
      this.draggingOutside.setStatus(false);
      this.draggingInside.setStatus(false);
    };
  }

  createDragEnterOutsideListener() {
    return (event) => {
      const query = new DomQuery(getEvent(event).getSource());

      if (!query.hasAncestor(this.element))
        this.draggingInside.setStatus(false);
    };
  }

  createDragLeaveOutsideListener() {
    return (event) => {
      if (event.fromElement == null)
        this.draggingOutside.setStatus(false);
    };
  }

  createDragOverOutsideListener() {
    return (event) => {
      event = getEvent(event);
      const query = new DomQuery(getEvent(event).getSource());

      if (!query.hasAncestor(this.element)) {
        event.preventDefault();

        if (event.dataTransfer.dropEffect != "move")
          event.dataTransfer.dropEffect = "none";

        this.draggingOutside.setStatus(true);
      }
      else
        event.dataTransfer.dropEffect = "move";
    };
  }

  dragEnter(event) {
    this.draggingInside.setStatus(true);
    this.draggingOutside.setStatus(false);
  }

  dragOver(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();

    const element = document.getElementsByTagName("html")[0];
    const dragEndEvent = document.createEvent("DragEvent");
    dragEndEvent.initEvent("dragend", false, false);

    element.dispatchEvent(dragEndEvent);

    if (this.canDrop(event))
      this.handleDrop(event);
  }

  initializeDropZone() {
    if (this.isEnabled()) {
      this.draggingInside = new HtmlClassSwitch(this.element, "DraggingInside");
      this.draggingInside.setStatus(false);

      this.draggingOutside = new HtmlClassSwitch(this.element, "DraggingOutside");
      this.draggingOutside.setStatus(false);

      this.dragEnterOutsideListener = this.createDragEnterOutsideListener();
      this.dragOverOutsideListener = this.createDragOverOutsideListener();
      this.dragLeaveOutsideListener = this.createDragLeaveOutsideListener();
      this.dragEndOutsideListener = this.createDragEndOutsideListener();

      this.element.ondragenter = (event) => { this.dragEnter(getEvent(event)); };
      this.element.ondragover = (event) => { this.dragOver(getEvent(event)); };
      this.element.ondrop = (event) => { this.drop(getEvent(event)); };

      const htmlElement = document.getElementsByTagName("html")[0];
      htmlElement.addEventListener("dragenter", this.dragEnterOutsideListener, true);
      htmlElement.addEventListener("dragover", this.dragOverOutsideListener, true);
      htmlElement.addEventListener("dragleave", this.dragLeaveOutsideListener, true);
      htmlElement.addEventListener("dragend", this.dragEndOutsideListener, true);
    }
  }

  isEnabled() {
    return true;
  }
}


// ---------- File: WebSite.Page.Component.DropZone.File_.ts ----------
// @ts-nocheck
export class FileDropZone extends DropZone {
  constructor(element) {
    super(element);
  }

  canDrop(event) {
    if (event.dataTransfer.types) {
      for (const type of event.dataTransfer.types) {
        if (type === "Files" || type === "file")
          return true;
      }
    }

    return false;
  }

  handleDrop(event) {
    if (event.dataTransfer.files.length > 0)
      this.handleFiles(event.dataTransfer.files);
    else
      retrieveFile(event.dataTransfer.getData("file"), event.dataTransfer.getData("filename"), (file) => { this.handleFiles([file]); });
  }

  validateFile(file, accept) {
    let valid;

    if (accept.length > 0) {
      const allowedTypes = accept.split(",");
      let index = 0;

      valid = false;

      while (!valid && index < allowedTypes.length) {
        const allowedType = allowedTypes[index];

        if (allowedType.startsWith("."))
          valid = file.name.endsWith(allowedType);
        else if (allowedType === "audio/*")
          valid = file.type.startsWith("audio/");
        else if (allowedType === "video/*")
          valid = file.type.startsWith("video/");
        else if (allowedType === "image/*")
          valid = file.type.startsWith("image/");
        else
          valid = file.type === allowedType;

        index++;
      }
    }
    else
      valid = true;

    return valid;
  }
}


// ---------- File: WebSite.Form.Field.File_.ts ----------
// @ts-nocheck
function retrieveFile(uri, name, callback) {
    var blob = null;
    var request = new XMLHttpRequest();
    request.responseType = "blob";

    request.open("GET", uri, true);
    request.onload = function() {
        blob = request.response;
        callback(new File([blob], name, {type: "application/octet-stream", lastModified: Date.now()}));
    }
    request.send();
}

function ProgressBar(phases) {
    this.createElement = function () {
        const result = document.createElement("div");
        result.className = "ProgressBar"

        for (let index = 0; index < this.phases; index++) {
            const indicator = result.appendChild(document.createElement("div"));
            indicator.className = "Indicator";
            indicator.style.opacity = Math.pow(0.5, this.phases - index);

            this.indicators.push(indicator);
        }

        this.indicator = result.appendChild(document.createElement("div"));
        this.indicator.className = "Indicator";
        this.indicator.innerHTML = "0%";

        return result;
    }

    this.setProgress = function (progress, phase) {
        for (let index = 0; index < progress.length; index++) {
            this.indicators[index].style.width = progress[index] + "%";

            if (index === phase) {
                this.progress = progress[index];
                this.indicator.innerHTML = (progress[index].toFixed(2)) + "%";
            }
        }
    }

    this.phases = phases;
    this.progress = 0;
    this.indicators = new Array();
    this.element = this.createElement();
}

export class FileField extends FileDropZone {
  constructor(element) {
    super(element);

    this.initialize();
    this.build();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.mode === "edit") {
      this.icon.onclick = (event) => { clickElement(this.input); };
      this.clear.onclick = (event) => { this.setValue(null); };
      this.input.onchange = (event) => { this.valueChanged(); };

      this.fileName.onclick = (event) => {
        if (this.value != null) {
          this.openPreview();
          event.stopPropagation();
        }
      };
    }
    else {
      if (this.value !== null) {
        this.fileName.onclick = (event) => {
          this.openPreview();
          event.stopPropagation();
        };

        this.fileName.draggable = true;
        this.fileName.addEventListener(
          "dragstart",
          (event) => {
            event.dataTransfer.setData("DownloadURL", "application/octet-stream:" + this.getFileName() + ":" + this.getUri());
            event.dataTransfer.setData("File", this.getUri());
            event.dataTransfer.setData("FileName", this.getFileName());
          },
          false
        );
      }
    }

    this.preview.onscroll = (event) => { event.stopPropagation(); };
  }

  createButton(caption) {
    const result = document.createElement("input");
    result.type = "button";
    result.value = caption;

    return result;
  }

  createDownloadButton() {
    const result = document.createElement("a");
    result.classList.add("button");
    result.classList.add("Action");
    result.href = this.uri;
    result.download = this.getFileName();
    result.innerHTML = "Download";

    return result;
  }

  enableDownloadButton(enabled) {
    new HtmlClassSwitch(this.downloadButton, "Disabled").setStatus(!enabled);

    if (enabled)
      this.downloadButton.href = this.uri;
    else
      this.downloadButton.href = "javascript:void(0);";
  }

  createToolBar() {
    this.downloadButton = this.createDownloadButton();

    const fileNameLabel = document.createElement("span");
    fileNameLabel.classList.add("FileName");
    fileNameLabel.innerHTML = this.getFileName();

    const result = document.createElement("div");
    result.classList.add("ToolBar");
    result.appendChild(this.downloadButton);
    result.appendChild(fileNameLabel);

    return result;
  }

  build() {
    this.element.innerHTML = "";

    this.fileName = document.createElement("div");
    this.fileName.classList.add("FileName");

    if (this.value !== null)
      this.fileName.innerHTML = this.value;

    if (this.mode === "edit") {
      this.valueField = document.createElement("input");
      this.valueField.type = "hidden";
      this.valueField.value = this.element.dataset.State;
      this.valueField.name = this.element.dataset.HierarchicalName;

      this.input = document.createElement("input");
      this.input.type = "file";
      this.input.style.display = "none";
      this.input.accept = this.element.dataset.Accept;

      this.icon = document.createElement("div");
      this.icon.classList.add("Icon");

      this.clear = document.createElement("div");
      this.clear.classList.add("Clear");

      this.progressBar = document.createElement("div");
      this.progressBar.classList.add("ProgressBar");

      if (this.value === null)
        this.fileName.innerHTML = this.hint;

      this.element.appendChild(this.valueField);
      this.element.appendChild(this.input);
      this.element.appendChild(this.icon);
      this.element.appendChild(this.fileName);
      this.element.appendChild(this.clear);
      this.element.appendChild(this.progressBar);
    }
    else
      this.element.appendChild(this.fileName);

    this.toolBar = this.createToolBar();

    this.previewContent = document.createElement("div");
    this.previewContent.classList.add("Contents");

    this.previewWindow = document.createElement("div");
    this.previewWindow.classList.add("Window");
    this.previewWindow.appendChild(this.toolBar);
    this.previewWindow.appendChild(this.previewContent);

    this.preview = document.createElement("div");
    this.preview.classList.add("Preview");
    this.preview.appendChild(this.previewWindow);
    this.preview.onclick = (event) => { event.stopPropagation(); };

    this.element.appendChild(this.preview);
  }

  getFileName() {
    return this.fileName.innerHTML;
  }

  getUri() {
    return this.uri + "/" + this.fileName.innerHTML;
  }

  handleFiles(files) {
    this.setValue(files[0]);
  }

  initialize() {
    this.mode = this.element.dataset.Mode;
    this.uri = this.element.dataset.Uri;
    this.hint = this.element.dataset.Hint;
    this.confirmationRequired = this.element.dataset.ConfirmationRequired === "true";

    if (this.element.dataset.Value !== undefined)
      this.value = this.element.dataset.Value;
    else
      this.value = null;

    if (this.mode === "edit" && this.value !== null)
      this.element.classList.add("Selected");

    this.initializeDropZone();
  }

  isEnabled() {
    return this.mode === "edit";
  }

  showPreview(content) {
    this.previewContent.innerHTML = content;
  }

  retrievePreview() {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("GET", this.uri + "/Preview");

    xmlHttpRequest.onreadystatechange = (event) => {
      if (xmlHttpRequest.readyState === 4)
        this.showPreview(xmlHttpRequest.responseText);
    };

    xmlHttpRequest.send();
  }

  acceptConfirmation() {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("POST", this.uri + "/Confirmation");

    xmlHttpRequest.onreadystatechange = (event) => {
      if (xmlHttpRequest.readyState === 4) {
        this.enableDownloadButton(true);
        this.confirmationRequired = false;
        this.retrievePreview();
      }
    };

    xmlHttpRequest.send();
  }

  showConfirmation(content) {
    const confirmationContentsPanel = document.createElement("div");
    confirmationContentsPanel.classList.add("ConfirmationContentsPanel");
    confirmationContentsPanel.innerHTML = content;

    const confirmationMessage = new DomQuery(confirmationContentsPanel).getChild(WithClass("ConfirmationMessage"));
    const unconfirmableMessage = new DomQuery(confirmationMessage).getChild(WithClass("Unconfirmable"));

    const confirmable = confirmationMessage.dataset.Confirmable === "true";

    const acceptButton = this.createButton("Accept");
    acceptButton.disabled = !confirmable;
    acceptButton.onclick = (event) => {
      this.acceptConfirmation();
      event.stopPropagation();
    };

    const toolBar = document.createElement("div");
    toolBar.classList.add("ToolBar");
    toolBar.appendChild(acceptButton);

    if (unconfirmableMessage !== null)
      toolBar.appendChild(unconfirmableMessage);

    const confirmationPanel = document.createElement("div");
    confirmationPanel.classList.add("ConfirmationPanel");
    confirmationPanel.appendChild(confirmationContentsPanel);
    confirmationPanel.appendChild(toolBar);

    this.previewContent.innerHTML = "";
    this.previewContent.appendChild(confirmationPanel);
  }

  retrieveConfirmation() {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("GET", this.uri + "/Confirmation");

    xmlHttpRequest.onreadystatechange = (event) => {
      if (xmlHttpRequest.readyState === 4)
        this.showConfirmation(xmlHttpRequest.responseText);
    };

    xmlHttpRequest.send();
  }

  openPreview() {
    this.enableDownloadButton(!this.confirmationRequired);
    this.preview.classList.add("Expanded");

    const listener = connectClickOutsideListener(
      this.previewWindow,
      (event) => {
        this.preview.classList.remove("Expanded");
        this.previewContent.innerHTML = "";
        event.stopPropagation();
        removeClickOutsideListener(listener);
      }
    );

    if (this.confirmationRequired)
      this.retrieveConfirmation();
    else
      this.retrievePreview();
  }

  setProgress(progress) {
    this.progressBar.style.width = progress + "%";
  }

  setValue(file) {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("POST", this.uri);

    const formData = new FormData();
    formData.append("form", "Form");

    if (file == null) {
      formData.append("Name", "");
      formData.append("Contents", "");

      xmlHttpRequest.onreadystatechange = (event) => {
        if (xmlHttpRequest.readyState === 4) {
          this.element.classList.remove("Selected");
          this.fileName.innerHTML = this.hint;
          this.input.value = "";
          this.valueField.value = "Empty";

          if (this.valueField.onchange !== null)
            this.valueField.onchange();
        }
      };
    }
    else {
      this.element.classList.add("Uploading");
      this.fileName.innerHTML = file.name;

      formData.append("Name", file.name);
      formData.append("Contents", file);

      xmlHttpRequest.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const complete = (event.loaded / event.total * 100 | 0);
          this.setProgress(complete);
        }
      };

      xmlHttpRequest.onreadystatechange = (event) => {
        if (xmlHttpRequest.readyState === 4) {
          if (xmlHttpRequest.status === 200) {
            this.element.classList.add("Selected");
            this.value = file.name;
            this.valueField.value = "Input";

            if (this.valueField.onchange !== null)
              this.valueField.onchange();
          }
          else {
            this.value = null;
            this.fileName.innerHTML = this.hint;
          }

          this.element.classList.remove("Uploading");
          this.setProgress(0);
        }
      };
    }

    xmlHttpRequest.send(formData);
  }

  valueChanged() {
    if (this.input.files.length === 1)
      this.setValue(this.input.files[0]);
  }
}

interactivityRegistration.register("FileField", function (element) { return new FileField(element); });


// ---------- File: WebSite.Page.Component.FormBuilder.ts ----------
// @ts-nocheck
export class FormBuilder extends WebPageComponent {
  constructor(element) {
    super(element);

    this.components = new Array();
    this.history = new Array();
    this.future = new Array();

    this.determineElements();
    this.initialize();
  }

  add(element) {
    if (this.target.target.container)
      this.target.target.appendChild(element);
    else
      this.target.target.after(element);

    this.setTarget(element);
  }

  closeInspector(component) {
    if (this.inspector.childNodes.length > 1 && this.target.header != undefined)
      this.target.header.parentNode.insertBefore(this.inspector.childNodes[1], this.target.header.nextSibling);
  }

  createAddComponentHandler(component) {
    return (event) => {
      this.add(component.createInstance(this, this.xmlDocument.createElement(component.name)));
      this.editorComponent.writeToElement();
      this.componentList.toggle();
    };
  }

  determineElements() {
    const query = new DomQuery(this.element);

    // Main components
    this.toolbar = query.getChild(WithClass("Toolbar"));
    this.progress = new Progress(query.getChild(WithClass("Progress")));
    this.problems = query.getChild(WithClass("Problems"));
    this.editor = query.getChild(WithClass("Editor"));
    this.inspector = query.getChild(WithClass("Inspector"));
    this.previewElement = query.getChild(WithClass("Preview"));
    this.tools = query.getChild(WithClass("Components"));
    this.valueField = query.getChild(WithTagName("INPUT"));

    this.componentElements = query.getDescendants(WithClass("Component"));

    this.pristine = this.valueField.value;
  }

  getComponent(name, type) {
    for (const component of this.components) {
      if (component.name == name) {
        if (type == undefined)
          return component;
        else if (component.element.dataset.FieldType == type)
          return component;
      }
    }
  }

  initialize() {
    this.initializeToolbar();
    this.initializeComponents();

    this.xmlDocument = document.implementation.createDocument("", "", null);

    this.initializeEditor();
    this.loadForm();

    this.observer = new MutationObserver((mutations) => { this.updateValue(); });
    this.observer.observe(this.editorComponent.object, { attributes: true, childList: true, subtree: true });

    this.editor.scrollTop = 0;
    this.updateToolbar();
  }

  initializeComponents() {
    this.preview = new HtmlClassSwitch(this.element, "Preview");
    this.componentList = new HtmlClassSwitch(this.tools, "Expanded");

    for (const componentElement of this.componentElements) {
      const component = createFormBuilderComponent(componentElement, this.isEditable());

      component.element.onclick = this.createAddComponentHandler(component);
      this.components.push(component);
    }
  }

  initializeEditor() {
    this.editorComponent = new Editor(this.editor, this.xmlDocument.createElement("Form"), "Form");
    this.editor.onclick = (event) => {
      this.setTarget(this.editorComponent);

      if (event != null)
        event.stopPropagation();
    };
  }

  initializeToolbar() {
    const query = new DomQuery(this.toolbar);

    // Toolbar actions
    this.saveButton = query.getChild(WithClass("Save"));
    this.previousButton = query.getChild(WithClass("Previous"));
    this.nextButton = query.getChild(WithClass("Next"));
    this.addButton = query.getChild(WithClass("Add"));
    this.previewButton = query.getChild(WithClass("Preview"));
    this.submitButton = query.getChild(WithClass("Submit"));

    this.previewButton.onclick = (event) => { this.togglePreview(); };
  }

  isEditable() {
    return this.mode === ControlMode.edit;
  }

  loadChildren(element, parent) {
    const query = new DomQuery(parent.element);

    for (const child of element.childNodes) {
      const component = this.getComponent(child.tagName, child.getAttribute("FieldType"));

      if (component != undefined) {
        const instance = component.createInstance(this, child);
        this.add(instance);

        if (instance.container)
          this.loadChildren(child, instance);

        this.setTarget(parent);
      }
      else {
        const value = query.getChild(WithClass(child.tagName));

        if (value != undefined && value.component != undefined && value.component.container)
          this.loadChildren(child, value.component);
      }
    }
  }

  loadForm() {
    const value = this.valueField.value;
    this.setTarget(this.editorComponent);

    if (value.length > 0) {
      const parser = new DOMParser();
      const element = parser.parseFromString(value, "application/xml");

      if (element != undefined) {
        this.editor.component.object = element.childNodes[0];
        this.loadChildren(element.childNodes[0], this.target);
      }
    }
  }

  next() {
    this.history.push(this.valueField.value);
    this.valueField.value = this.future.shift();
    this.reload();
    this.valueChanged();
  }

  openInspector() {
    if (this.target.form != undefined)
      this.inspector.appendChild(this.target.form);
  }

  openPreview() {
    this.previewElement.innerHTML = "";
    this.toggleButton(false, this.saveButton, null);
    this.toggleButton(false, this.previousButton, null);
    this.toggleButton(false, this.nextButton, null);
    this.toggleButton(false, this.addButton, null);
    this.toggleButton(true, this.submitButton, (event) => { this.submit(); });

    this.client.sendJsonRequest(
      this.element.dataset.Uri,
      {
        "Command": "Preview"
      },
      (response) => {
        if (response.status === 200) {
          interactivityRegistration.detach(this.previewElement);
          this.previewElement.innerHTML = response.responseText;
          interactivityRegistration.attach(this.previewElement);
        }
      },
      this.progress
    );
  }

  previous() {
    this.future.unshift(this.valueField.value);
    this.valueField.value = this.history.pop();
    this.reload();
    this.valueChanged();
  }

  reload() {
    this.observer.disconnect();
    this.editorComponent.object = this.xmlDocument.createElement("Form");
    this.editorComponent.clear();
    this.loadForm();
    this.editor.scrollTop = 0;
    this.observer.observe(this.editorComponent.object, { attributes: true, childList: true, subtree: true });
  }

  remove(element) {
    element.remove();
    this.setTarget(element.parent);
  }

  save() {
    if (this.pristine !== this.valueField.value) {
      this.client.sendJsonRequest(
        this.element.dataset.Uri,
        {
          "Command": "Save",
          "Value": this.valueField.value
        },
        (response) => {
          if (response.status === 200) {
            this.setSuccessful();
            this.pristine = this.valueField.value;
            this.valueChanged();
          }
          else if (response.status === 400) {
            this.toolbar.classList.add("Error");
            const listener = connectClickOutsideListener(this.toolbar, (event) => {
              this.toolbar.classList.remove("Error");
              this.problems.innerHTML = "";
              removeClickOutsideListener(listener);
            });

            this.problems.innerHTML = response.responseText;
          }
        },
        this.progress
      );
    }
  }

  setSuccessful() {
    this.toolbar.classList.add("Successful");
    const listener = connectClickOutsideListener(this.toolbar, (event) => { this.toolbar.classList.remove("Successful"); removeClickOutsideListener(listener); });
  }

  setTarget(element) {
    if (element.canFocus()) {
      if (this.target != undefined) {
        this.target.blur();

        this.closeInspector();
      }

      this.target = element;
      this.target.focus();

      this.openInspector();
    }
    else if (element.parent.canFocus())
      this.setTarget(element.parent);
  }

  submit(element) {
    const formData = new FormData(this.previewElement.childNodes[0]);

    formData.append("Action", "Submit");

    this.client.postFormRequest(
      this.element.dataset.Uri,
      formData,
      (xmlRequest) => {
        if (xmlRequest.status === 200) {
          this.setSuccessful();
          this.previewElement.innerHTML = xmlRequest.responseText;
          interactivityRegistration.attach(this.previewElement);
        }
      },
      this.progress
    );
  }

  toggleButton(status, button, function_) {
    if (status) {
      button.onclick = function_;
      button.classList.add("Enabled");
    }
    else {
      button.onclick = null;
      button.classList.remove("Enabled");
    }
  }

  togglePreview() {
    if (!this.preview.getStatus())
      this.openPreview();
    else
      this.updateToolbar();

    this.preview.toggle();
  }

  updateToolbar() {
    this.toggleButton(this.isEditable() && this.valueField.value !== this.pristine, this.saveButton, (event) => { this.save(); });
    this.toggleButton(this.isEditable() && this.history.length > 0, this.previousButton, (event) => { this.previous(); });
    this.toggleButton(this.isEditable() && this.future.length > 0, this.nextButton, (event) => { this.next(); });
    this.toggleButton(this.isEditable(), this.addButton, (event) => { this.componentList.toggle(); });
    this.toggleButton(false, this.submitButton, null);
  }

  updateValue() {
    const serializer = new XMLSerializer();
    const previous = this.valueField.value;

    this.valueField.value = serializer.serializeToString(this.editorComponent.object);

    if (this.valueField.value !== previous) {
      this.history.push(previous);
      this.future = new Array();
      this.valueChanged();
    }
  }

  valueChanged() {
    this.updateToolbar();
  }
}

function createFormBuilderComponent(element, editable) {
  var name = element.dataset.Name;

  if (name === "Section")
    return new FormSectionComponent(element, editable);
  else if (name === "Division")
    return new FormEmbedComponent(element, editable);
  else if (name === "Field")
    return new FormFieldComponent(element, editable);
  else
    return new FormBuilderComponent(element, editable);
}

export class FormBuilderComponent extends WebPageComponent {
  constructor(element, editable) {
    super(element);

    this.name = this.element.dataset.Name;
    this.container = this.element.dataset.Container == "true";
    this.canFocus = true;
    this.closable = true;
    this.editable = editable;

    this.determineElements();
  }

  createElement() {
    const instance = this.element.cloneNode();

    const close = document.createElement("div");
    close.classList.add("Close");
    close.tabIndex = 0;

    const up = document.createElement("div");
    up.classList.add("Up");
    up.tabIndex = 0;

    const down = document.createElement("div");
    down.classList.add("Down");
    down.tabIndex = 0;

    const icon = document.createElement("div");
    icon.classList.add("Icon");

    const title = document.createElement("div");
    title.classList.add("Title");

    const header = document.createElement("div");
    header.classList.add("Header");
    header.appendChild(icon);
    header.appendChild(title);

    if (this.captionElement !== null)
      title.innerHTML = this.captionElement.innerHTML;

    const form = document.createElement("div");
    form.classList.add("Properties");

    if (this.form !== null) {
      form.innerHTML = this.form.outerHTML;
      interactivityRegistration.attach(form);
    }

    if (this.canFocus)
      instance.tabIndex = 0;

    if (this.closable && this.editable) {
      instance.appendChild(close);
      instance.appendChild(up);
      instance.appendChild(down);
    }

    instance.appendChild(header);
    instance.appendChild(form);

    return instance;
  }

  createFormBuilderElement(editor, value) {
    const element = this.createElement();
    const instance = new DefaultFormBuilderElement(element, value, this);

    return instance;
  }

  createInstance(editor, value) {
    const instance = this.createFormBuilderElement(editor, value);

    if (instance.canFocus()) {
      instance.element.onclick = (event) => {
        editor.setTarget(instance);

        if (event != null)
          event.stopPropagation();
      };
    }
    else
      instance.element.onclick = (event) => {
        if (event != null)
          event.stopPropagation();
      };

    return instance;
  }

  createNewElement(name, container) {
    const element = document.createElement("div");
    element.classList.add(name);
    element.classList.add("Component");
    element.dataset.Name = name;
    element.dataset.Container = container;

    return element;
  }

  determineElements() {
    this.properties = new DomQuery(this.element).getChild(WithClass("Properties"));

    if (this.properties !== null)
      this.form = new DomQuery(this.properties).getChild(WithTagName("FORM"));
    else
      this.form = null;

    this.captionElement = new DomQuery(this.element).getChild(WithClass("Caption"));

    if (!this.editable && this.form !== null) {
      for (let index = 0; index < this.form.elements.length; index++) {
        this.form.elements[index].readOnly = true;
        this.form.elements[index].disabled = true;
      }

      const fields = new DomQuery(this.form).getDescendants(WithClass("edit"));

      for (const field of fields) {
        field.classList.remove("edit");
        field.classList.add("display");
      }
    }
  }
}

export class FormDocumentComponent extends FormBuilderComponent {
  constructor(element) {
    super(element);
  }

  createElement() {
    return this.element.cloneNode();
  }

  createFormBuilderElement(editor, value) {
    const element = this.createElement();
    const instance = new InlineFormBuilderElement(element, value, this);

    return instance;
  }
}

export class FormFieldComponent extends FormBuilderComponent {
  constructor(element, editable) {
    super(element, editable);

    this.caption = new FormDocumentComponent(this.createNewElement("Caption", false), false);
    this.caption.canFocus = false;
    this.caption.closable = false;

    this.labels = new FormDocumentComponent(this.createNewElement("Labels", false), false);
    this.labels.canFocus = false;
    this.labels.closable = false;
  }

  createFormBuilderElement(editor, value) {
    const element = new DefaultFormBuilderElement(this.createElement(), value, this);
    let caption = new DomQuery(value).getChild(WithTagName("Caption"));

    if (caption === null)
      caption = editor.xmlDocument.createElement("Caption");

    const caption_ = this.caption.createInstance(editor, caption);

    let labels = new DomQuery(value).getChild(WithTagName("Labels"));

    if (labels === null)
      labels = editor.xmlDocument.createElement("Labels");

    const labels_ = this.labels.createInstance(editor, labels);

    element.appendChild(caption_);
    element.appendChild(labels_);
    return element;
  }
}

export class FormEmbedComponent extends FormBuilderComponent {
  constructor(element, editable) {
    super(element, editable);

    this.canFocus = true;
  }

  createFormBuilderElement(editor, value) {
    const element = this.createElement();
    const instance = new EmbedFormBuilderElement(element, value, this);

    return instance;
  }
}

export class FormSectionComponent extends FormBuilderComponent {
  constructor(element, editable) {
    super(element, editable);

    this.title = new FormDocumentComponent(this.createNewElement("Title", false), false);
    this.title.canFocus = false;
    this.title.closable = false;

    this.contents = new FormBuilderComponent(this.createNewElement("Contents", true), false);
    this.contents.closable = false;
    this.contents.canFocus = false;

    this.canFocus = true;
  }

  createFormBuilderElement(editor, value) {
    const element = new DefaultFormBuilderElement(this.createElement(), value, this);

    let title = new DomQuery(value).getChild(WithTagName("Title"));
    let contents = new DomQuery(value).getChild(WithTagName("Contents"));

    if (title == undefined) {
      title = editor.xmlDocument.createElement("Title");
      contents = editor.xmlDocument.createElement("Contents");
    }

    const target = this.contents.createInstance(editor, contents);
    const title_ = this.title.createInstance(editor, title);

    element.appendChild(title_);
    element.appendChild(target);
    element.target = target;

    return element;
  }
}

function EditorType() {
  this.canFocus = true;
  this.container = true;
}

export class Editor extends WebPageComponent {
  constructor(element, object, name) {
    super(element);

    this.object = object;
    this.target = this;
    this.type = new EditorType();
    this.name = name;
    this.container = true;
    this.element.component = this;
  }

  _contains(object, element) {
    let result = false;

    for (const child of this.object.childNodes)
      result = result || (child === element);

    return result;
  }

  appendChild(element) {
    this.element.appendChild(element.element);

    if (!this._contains(this.object, element.object))
      this.object.appendChild(element.object);

    element.parent = this;
    element.readFromElement();
  }

  blur() {
    this.element.classList.remove("Target");
  }

  canFocus() {
    return true;
  }

  clear() {
    const components = new DomQuery(this.element).getChildren(WithClass("Component"));

    for (const component of components)
      this.element.removeChild(component);
  }

  focus() {
    this.element.focus();
    this.element.classList.add("Target");
  }

  writeToElement() {
    for (const child of this.element.childNodes) {
      if (child.component != undefined)
        child.component.writeToElement();
    }
  }
}

export class FormBuilderElement extends WebPageComponent {
  constructor(element, object, type) {
    super(element);

    this.object = object;
    this.type = type;
    this.container = this.type.container;
    this.target = this;
    this.element.component = this;

    this.determineElements();
    this.attachHandlers();
  }

  _contains(object, element) {
    let result = false;

    for (const child of this.object.childNodes)
      result = result || (child === element);

    return result;
  }

  after(element) {
    this.element.after(element.element);

    if (!this._contains(this.object.parentNode, element.object))
      this.object.after(element.object);

    element.parent = this.parent;
    element.readFromElement();
  }

  appendChild(element) {
    this.element.appendChild(element.element);

    if (!this._contains(this.object, element.object))
      this.object.appendChild(element.object);

    element.parent = this;
    element.readFromElement();
  }

  attachHandlers() {
    if (this.closeButton != undefined) {
      this.closeButton.onclick = (event) => { this.close(); event.stopPropagation(); };
      this.moveDownButton.onclick = (event) => { this.moveDown(); event.stopPropagation(); };
      this.moveUpButton.onclick = (event) => { this.moveUp(); event.stopPropagation(); };
    }
  }

  attributeToBoolean(value) {
    return value === "True";
  }

  before(element) {
    this.element.before(element.element);

    if (!this._contains(this.object.parentNode, element.object))
      this.object.before(element.object);

    element.parent = this.parent;
    element.readFromElement();
  }

  booleanToAttribute(value) {
    if (value)
      return "True";
    else
      return "False";
  }

  blur() {
    this.element.classList.remove("Target");
    this.writeToElement();
    this.updateHeader();
  }

  canFocus() {
    return this.type.canFocus;
  }

  close() {
    this.remove();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.header = query.getChild(WithClass("Header"));

    if (this.header != undefined)
      this.title = this.header.childNodes[1];

    this.closeButton = query.getChild(WithClass("Close"));
    this.moveDownButton = query.getChild(WithClass("Down"));
    this.moveUpButton = query.getChild(WithClass("Up"));

    this.form = query.getChild(WithClass("Properties"));

    this.fields = new Array();

    if (this.form != undefined) {
      const formQuery = new DomQuery(this.form);

      Array.prototype.push.apply(this.fields, formQuery.getDescendants(WithTagName("INPUT")));
      Array.prototype.push.apply(this.fields, formQuery.getDescendants(WithTagName("TEXTAREA")));

      this.fields = this.fields.filter((field, index) => {
        const formId = this.form.childNodes[0].id;
        return (field.name !== "form") && (field.name.startsWith(formId) || field.name === "Type");
      });
    }

    for (const field of this.fields) {
      const fieldName = field.name.split("/").pop();

      if (fieldName === "FieldType")
        field.readOnly = true;
    }
  }

  focus() {
    this.element.focus();
    this.element.classList.add("Target");
  }

  getName() {
    const field = this.getNameField();

    if (field != null)
      return field.value;
    else
      return "";
  }

  getNameField() {
    let result = null;

    for (const field of this.fields) {
      const fieldName = field.name.split("/").pop();

      if (fieldName == "Name")
        result = field;
    }

    return result;
  }

  moveDown() {
    if (this.element.nextSibling !== null && this.element.nextSibling.component !== undefined) {
      const next = this.element.nextSibling.component;

      this.remove();
      next.after(this);
      this.element.onclick();
    }
  }

  moveUp() {
    if (this.element.previousSibling.component !== undefined) {
      const previous = this.element.previousSibling.component;

      this.remove();
      previous.before(this);
      this.element.onclick();
    }
  }

  readField(fieldName) {
    return this.object.getAttribute(fieldName);
  }

  remove() {
    this.parent.element.removeChild(this.element);
    this.parent.object.removeChild(this.object);

    if (this.parent.type.canFocus) {
      this.parent.element.focus();
      this.parent.element.onclick(null);
    }
    else {
      this.parent.parent.element.focus();
      this.parent.parent.element.onclick(null);
    }
  }

  updateHeader() {
    if (this.header != undefined) {
      const name = this.getName();

      if (name.length > 0)
        this.header.childNodes[1].innerHTML = name;
      else
        this.header.childNodes[1].innerHTML = this.title.innerHTML;
    }
  }

  writeField(fieldName, value) {
    this.object.setAttribute(fieldName, value);
  }
}

export class DefaultFormBuilderElement extends FormBuilderElement {
  constructor(element, object, type) {
    super(element, object, type);
  }

  readFromElement() {
    for (const field of this.fields) {
      const fieldName = field.name.split("/").pop();

      if (fieldName === "Optional")
        field.checked = this.attributeToBoolean(this.readField(fieldName));
      else {
        if (this.object.hasAttribute(fieldName)) {

          if (field.type === "checkbox")
            field.checked = this.attributeToBoolean(this.readField(fieldName));
          else
            field.value = this.readField(fieldName);
        }
      }

      if (field.onchange != undefined)
        field.onchange();
    }

    this.updateHeader();
  }

  writeToElement() {
    for (const field of this.fields) {
      const fieldName = field.name.split("/").pop();

      if (fieldName === "Optional")
        this.writeField(fieldName, this.booleanToAttribute(field.checked));
      else if (fieldName !== "Label" && fieldName !== "Contents") {
        if (field.type == "checkbox")
          this.writeField(fieldName, this.booleanToAttribute(field.checked));
        else if (field.value !== "")
          this.writeField(fieldName, field.value);
        else
          this.object.removeAttribute(fieldName);
      }
    }

    for (const child of this.element.childNodes) {
      if (child.component != undefined)
        child.component.writeToElement();
    }
  }
}

export class EmbedFormBuilderElement extends FormBuilderElement {
  constructor(element, object, type) {
    super(element, object, type);
  }

  readFromElement() {
    const field = this.fields[0];

    field.value = this.object.innerHTML;
  }

  writeToElement() {
    const field = this.fields[0];

    this.object.innerHTML = field.value;
  }
}

export class InlineFormBuilderElement extends FormBuilderElement {
  constructor(element, object, type, target) {
    super(element, object, type);
  }

  getCaptionElement() {
    const fields = new DomQuery(this.parent.form).getDescendants(WithTagName("TEXTAREA"));
    let result = null;

    for (const field of fields) {
      const fieldName = field.name.split("/").pop();

      if (fieldName === "Label")
        result = field;
    }

    return result;
  }

  getTypeElement() {
    let result = null;

    if (this.parent.form !== null)
      result = new DomQuery(this.parent.form).getDescendant(WithClass("TypeComponent"));

    return result;
  }

  readFromElement() {
    if (this.object.tagName === "Labels") {
      const typeField = this.getTypeElement();

      if (typeField.component !== undefined) {
        const labels = new Array();

        for (const child of this.object.childNodes) {
          labels.push({
            "Name": child.getAttribute("Name"),
            "Value": child.innerHTML
          });
        }

        typeField.component.setLabels(labels);
      }
    }
    else if (this.object.childNodes.length > 0)
      this.getCaptionElement().value = new XMLSerializer().serializeToString(this.object.childNodes[0]);
  }

  writeToElement() {
    if (this.object.tagName === "Labels") {
      const typeField = this.getTypeElement();

      if (typeField.component !== undefined) {
        const xmlDocument = document.implementation.createDocument("", "", null);
        const labelsElement = xmlDocument.createElement("Labels");
        const labels = typeField.component.getLabels();

        for (const label of labels) {
          const labelElement = xmlDocument.createElement("Label");
          labelElement.setAttribute("Name", label.Name);
          labelElement.innerHTML = label.Value;

          labelsElement.appendChild(labelElement);
        }

        this.object.innerHTML = labelsElement.innerHTML;
      }
    }
    else
      this.object.innerHTML = this.getCaptionElement().value;
  }
}

function Progress(element) {
  this.build = function () {
    this.progress = document.createElement("div");
    this.progress.classList.add("Value");
    this.progress.style.width = "0%";

    this.element.appendChild(this.progress);
  }

  this.setProgress = function (value) {
    if (this.timeOutId !== 0)
      window.clearTimeout(this.timeOutId);

    this.progress.style.width = value + "%";
    this.progress.style.visibility = "visible";

    var object = this;

    if (value < 100 && value > 0) {
      var remainder = 100 - value;
      var timeOut = 1000 / remainder;

      this.timeOutId = window.setTimeout(function () { object.timeOutId = 0; object.setProgress(value + remainder / 25); }, timeOut);
    }
    else if (value === 100) {
      window.setTimeout(function () { object.setProgress(0); object.progress.style.visibility = "hidden"; }, 100);
    }
  }

  this.timeOutId = 0;
  this.element = element;
  this.build();
}

interactivityRegistration.register("FormBuilder", function (element) { return new FormBuilder(element); });


// ---------- File: WebSite.Page.Component.Grid.ts ----------
// @ts-nocheck
export class GridPanel extends WebPageComponent {
  constructor(element) {
    super(element);

    this.uri = this.element.dataset.Uri;
    this.contents = new DomQuery(this.element).getChild(WithClass("Contents"));
    this.resizable = this.element.dataset.Resizable === "true";
    this.edit = new HtmlClassSwitch(this.element, "Edit");

    this.gridItems = new Array();
    this.initialize();
  }

  initialize() {
    if (this.resizable) {
      this.settings = new DomQuery(this.element).getChild(WithClass("Settings"));

      this.resetButton = new DomQuery(this.settings).getChild(WithClass("Reset"));
      this.resetButton.addEventListener("click", (event) => { this.reset(); });

      this.configurationButton = new DomQuery(this.settings).getChild(WithClass("Configuration"));
      this.configurationButton.addEventListener("click", (event) => { this.edit.toggle(); });

      this.overlay = document.createElement("div");
      this.overlay.classList.add("GridOverlay");

      this.contents.appendChild(this.overlay);
    }
  }

  bind() {
    const gridItems = new DomQuery(this.contents).getChildren(WithClass("GridItem"));

    for (const gridItem of gridItems)
      this.gridItems.push(gridItem.component);

    this.recalculate();
  }

  disableOverlay(action) {
    this.element.classList.remove(action);
    this.overlay.classList.remove("Visible");
  }

  enableOverlay(action) {
    this.element.classList.add(action);
    this.overlay.classList.add("Visible");
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent)
      this.invalidate();
    else
      super.handleEvent(event);
  }

  async validate() {
    await this.reload();
  }

  persist() {
    const items = new Array();

    for (const gridItem of this.gridItems) {
      gridItem.preferredBounds = gridItem.bounds.copy();

      items.push({
        Identifier: gridItem.element.dataset.Identifier,
        Enabled: gridItem.enabled,
        Bounds: {
          Left: gridItem.bounds.left - 1,
          Top: gridItem.bounds.top - 1,
          Right: gridItem.bounds.right - 2,
          Bottom: gridItem.bounds.bottom - 2
        }
      });
    }

    fetch(
      this.uri,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(items)
      }
    );
  }

  async reload() {
    await fetch(
      this.uri,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((data) => this.reloadFromResponse(data));
  }

  reloadFromResponse(data) {
    for (const item of data) {
      const gridItem = this.gridItems.find((element) => { return element.element.dataset.Identifier === item.Identifier });
      gridItem.enabled = item.Enabled;

      if (gridItem !== null)
        gridItem.setBounds(new Rectangle(item.Bounds.Left + 1, item.Bounds.Top + 1, item.Bounds.Right + 2, item.Bounds.Bottom + 2));
    }

    this.recalculate();
  }

  reset() {
    fetch(
      this.uri,
      {
        method: "DELETE",
      }
    )
      .then(() => this.reload());
  }

  recalculate() {
    this.bounds = new Rectangle(1, 1, 2, 2);

    for (const gridItem of this.gridItems) {
      if (gridItem.enabled) {
        this.bounds.left = Math.min(gridItem.bounds.left, this.bounds.left);
        this.bounds.right = Math.max(gridItem.bounds.right, this.bounds.right);
        this.bounds.top = Math.min(gridItem.bounds.top, this.bounds.top);
        this.bounds.bottom = Math.max(gridItem.bounds.bottom, this.bounds.bottom);
      }
    }

    this.updateGrid();

    if (this.resizable)
      this.updateOverlay();
  }

  updateGrid() {
    if (this.resizable) {
      this.contents.style.gridTemplateRows = `repeat(${this.bounds.height()}, 100px)`;
      this.contents.style.gridTemplateColumns = `repeat(${this.bounds.width()}, 100px)`;
    }
    else {
      this.contents.style.gridTemplateRows = `repeat(${this.bounds.height()}, auto)`;
      this.contents.style.gridTemplateColumns = `repeat(${this.bounds.width()}, minmax(0, 1fr))`;
    }
  }

  toggleAddForm(event, x, y) {
    const form = document.createElement("div");
    form.classList.add("GridForm");

    const title = document.createElement("span");
    title.innerHTML = this.settings.dataset.AddWidgetLabel;
    title.classList.add("Title");

    form.appendChild(title);

    for (const item of this.gridItems.filter((element) => { return !element.enabled; })) {
      const element = document.createElement("span");
      element.innerHTML = item.element.dataset.Title;
      element.classList.add("Item");
      element.addEventListener("click", (event) => {
        item.enabled = true;
        item.setBounds(
          new Rectangle(
            x,
            y,
            x + item.bounds.width(),
            y + item.bounds.height()
          )
        );

        this.resolveConflicts(item);
        this.persist();

        this.popUp.close();
        this.popUp = null;
      });

      form.appendChild(element);
    }

    this.popUp = new PopUp(form, event.target, false);
    this.popUp.open();
  }

  updateOverlay() {
    this.overlay.innerHTML = "";
    this.overlay.style.gridTemplateRows = `repeat(${this.bounds.height() + 1}, 100px)`;
    this.overlay.style.gridTemplateColumns = `repeat(${this.bounds.width() + 1}, 100px)`;

    const hasDisabledItems = this.gridItems.some((element) => { return !element.enabled });

    for (let x = this.bounds.left; x <= this.bounds.right; x++) {
      for (let y = this.bounds.top; y <= this.bounds.bottom; y++) {
        const item = document.createElement("div");
        item.style.gridColumnStart = x;
        item.style.gridColumnEnd = x + 1;
        item.style.gridRowStart = y;
        item.style.gridRowEnd = y + 1;

        if (this.isValid(new Rectangle(x, y, x + 1, y + 1))) {
          item.classList.add("Empty");

          if (hasDisabledItems) {
            const button = document.createElement("button");
            button.addEventListener("click", (event) => { this.toggleAddForm(event, x, y) });
            button.title = this.settings.dataset.AddWidgetLabel;

            item.appendChild(button);
          }
        }

        this.overlay.appendChild(item);
      }
    }
  }

  isValid(bounds) {
    let result = true;
    let index = 0;

    while (index < this.gridItems.length && result) {
      const gridItem = this.gridItems[index];
      result = !gridItem.enabled || !gridItem.bounds.overlaps(bounds);
      index++;
    }

    return result;
  }

  resolveConflicts(modified) {
    let sorted = this.gridItems.toSorted((a, b) => { return a.bounds.left - b.bounds.left });
    sorted.splice(sorted.indexOf(modified), 1);
    sorted.unshift(modified);

    for (const item of sorted) {
      item.bounds = item.preferredBounds.copy();
      item.boundsChanged();
    }

    for (let index = 1; index < sorted.length; index++) {
      const item = sorted[index];

      if (item.enabled) {
        for (let otherIndex = 0; otherIndex < index; otherIndex++) {
          const other = sorted[otherIndex];

          if (other.enabled) {
            while (item.bounds.overlaps(other.bounds)) {
              const width = item.bounds.width();
              const height = item.bounds.height();

              if (modified.movementDirection === "horizontal") {
                item.bounds.left += 1;
                item.bounds.right = item.bounds.left + width;
              }
              else {
                item.bounds.top += 1;
                item.bounds.bottom = item.bounds.top + height;
              }

              item.boundsChanged();
            }
          }
        }
      }
    }

    this.recalculate();
  }
}

export class GridItem extends WebPageComponent {
  constructor(element) {
    super(element);

    this.setBounds(
      new Rectangle(
        parseInt(element.dataset.Left) + 1,
        parseInt(element.dataset.Top) + 1,
        parseInt(element.dataset.Right) + 2,
        parseInt(element.dataset.Bottom) + 2
      )
    );
    this.enabledClassSwitch = new HtmlClassSwitch(this.element, "Enabled");
    this.enabledClassSwitch.setStatus(this.element.dataset.Enabled === "true");

    if (this.element.childNodes.length === 2) {
      this.content = this.element.childNodes[1];

      if (this.content.component !== undefined) {
        this.content.component.handleEvent(new VisibilityChangedEvent(this));
      }
    }

    this.header = new DomQuery(element).getChild(WithClass("Header"));

    this.count = document.createElement("span");
    this.count.classList.add("Count");

    this.header.appendChild(this.count);

    this.expand = document.createElement("button");
    this.expand.classList.add("Expand");
    this.expand.addEventListener(
      "click",
      (event) => {
        if (this.expanded.getStatus())
          this.minimize();
        else
          this.maximize();
      }
    )

    this.header.appendChild(this.expand);
    this.expanded = new HtmlClassSwitch(this.element, "Expand");
  }

  maximize() {
    this.clickOutsideListener = new ClickOutsideListener(
      [this.element],
      (event) => {
        this.minimize();
        event.stopPropagation();
      }
    )
    this.expanded.setStatus(true);
  }

  minimize() {
    this.clickOutsideListener.remove();
    this.expanded.setStatus(false);
  }

  async validate() {
    await this.reload();
  }

  async reload() {
    await fetch(
      this.uri,
      {
        method: "GET"
      }
    )
      .then((response) => this.reloadFromResponse(response));
  }

  async reloadFromResponse(response) {
    const dummyElement = document.createElement("div");
    dummyElement.innerHTML = await response.text();

    interactivityRegistration.detach(this.content);
    this.element.replaceChild(dummyElement.firstChild, this.content);
    this.content = this.element.childNodes[1];
    interactivityRegistration.attach(this.content);
  }

  setBounds(bounds) {
    this.bounds = bounds;
    this.preferredBounds = this.bounds.copy();
    this.boundsChanged();
  }

  boundsChanged() {
    this.element.style.gridColumn = this.bounds.left;
    this.element.style.gridColumnEnd = this.bounds.right;
    this.element.style.gridRow = this.bounds.top;
    this.element.style.gridRowEnd = this.bounds.bottom;
  }

  attachMoveHandlers() {
    let startX, startY, startBounds;

    this.moveStartHandler = (event) => {
      if (event.button === 0 && this.parentComponent.edit.getStatus()) {
        startBounds = this.bounds.copy();
        startX = event.clientX;
        startY = event.clientY;

        this.startEdit("Moving");

        document.addEventListener("mousemove", this.moveHandler);
        document.addEventListener("mouseup", this.moveEndHandler);

        event.preventDefault();
      }
    };

    this.moveHandler = (event) => {
      const bounds = this.element.getBoundingClientRect();
      const width = bounds.width;
      const height = bounds.height;

      const columnWidth = width / startBounds.width();
      const rowHeight = height / startBounds.height();

      const offsetX = Math.max(Math.round((event.clientX - startX) / columnWidth), -startBounds.left + 1)
      const offsetY = Math.max(Math.round((event.clientY - startY) / rowHeight), -startBounds.top + 1);

      this.setBounds(
        new Rectangle(
          startBounds.left + offsetX,
          startBounds.top + offsetY,
          startBounds.right + offsetX,
          startBounds.bottom + offsetY
        )
      );

      const deltaX = this.bounds.left - startBounds.left;
      const deltaY = this.bounds.top - startBounds.top;

      this.movementDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "horizontal" : "vertical";
      this.parentComponent.resolveConflicts(this);

      event.preventDefault();
    };

    this.moveEndHandler = () => {
      this.stopEdit("Moving");

      document.removeEventListener("mousemove", this.moveHandler);
      document.removeEventListener("mouseup", this.moveEndHandler);

      this.parentComponent.persist();
    };

    this.header.addEventListener("mousedown", this.moveStartHandler);
  }

  attachResizeHandlers() {
    this.resizeStartHandler = (event) => {
      if (event.button === 0) {
        this.startEdit("Resizing");

        document.addEventListener("mousemove", this.resizeHandler);
        document.addEventListener("mouseup", this.resizeEndHandler);

        event.preventDefault();
      }
    }

    this.resizeHandler = (event) => {
      const bounds = this.element.getBoundingClientRect();
      const width = bounds.width;
      const height = bounds.height;

      const newWidth = event.clientX - bounds.left;
      const newHeight = event.clientY - bounds.top;

      const columnWidth = width / this.bounds.width();
      const rowHeight = height / this.bounds.height();

      this.setBounds(
        new Rectangle(
          this.bounds.left,
          this.bounds.top,
          Math.max(
            this.bounds.left + Math.round(newWidth / columnWidth),
            this.bounds.left + 1
          ),
          Math.max(
            this.bounds.top + Math.round(newHeight / rowHeight),
            this.bounds.top + 1
          )
        )
      );
      this.parentComponent.resolveConflicts(this);

      event.preventDefault();
    }

    this.resizeEndHandler = (event) => {
      this.stopEdit("Resizing");

      document.removeEventListener("mousemove", this.resizeHandler);
      document.removeEventListener("mouseup", this.resizeEndHandler);

      this.parentComponent.persist();
    }

    this.resizer.addEventListener("mousedown", this.resizeStartHandler);
  }

  disable(event) {
    this.enabled = false;

    this.parentComponent.recalculate();
    this.parentComponent.persist();
  }

  bind() {
    this.resizable = this.parentComponent.resizable;

    if (this.resizable) {
      this.delete = new DomQuery(this.header).getChild(WithClass("Delete"));
      this.delete.addEventListener("mousedown", (event) => { event.stopPropagation() });
      this.delete.addEventListener("click", (event) => { this.disable(event); });

      this.resizer = document.createElement("span");
      this.resizer.classList.add("Resizer");

      this.element.appendChild(this.resizer);

      this.attachResizeHandlers();
      this.attachMoveHandlers();
    }
  }

  startEdit(action) {
    this.element.classList.add("Target");
    this.parentComponent.enableOverlay(action);
  }

  stopEdit(action) {
    this.element.classList.remove("Target");
    this.parentComponent.disableOverlay(action);
  }

  handleEvent(event) {
    if (event instanceof CountChangedEvent) {
      this.count.textContent = event.count > 0 ? `(${event.count})` : "";
      event.handled = true;
    }
    else
      super.handleEvent(event);
  }

  get enabled() {
    return this.element.dataset.Enabled === "true";
  }

  set enabled(value) {
    if (this.enabled !== value) {
      this.invalidate();

      this.element.dataset.Enabled = JSON.stringify(value);
      this.enabledClassSwitch.setStatus(this.enabled);
    }
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

export class Rectangle {
  constructor(left, top, right, bottom) {
    this.left = left;
    this.top = top;
    this.right = right;
    this.bottom = bottom;

    this.height = function () {
      return this.bottom - this.top;
    };

    this.width = function () {
      return this.right - this.left;
    };

    this.copy = function () {
      return new Rectangle(this.left, this.top, this.right, this.bottom);
    };

    this.overlaps = function (other) {
      return (
        this.left < other.right &&
        this.right > other.left &&
        this.top < other.bottom &&
        this.bottom > other.top
      );

    };
  }
}

interactivityRegistration.register("Grid", function (element) { return new GridPanel(element); });
interactivityRegistration.register("GridItem", function (element) { return new GridItem(element); });


// ---------- File: WebSite.Page.Component.ImageGrid.ts ----------
// @ts-nocheck
export class ImageGrid extends WebPageComponent {
  constructor(element) {
    super(element);

    this.images = new DomQuery(this.element).getChild(WithClass("Images"));
    this.uploadArea = null;
  }

  bind() {
    this.uploadArea = this.getAncestor((component) => component instanceof UploadArea);

    if (this.isEditable()) {
      this.labels = new Labels(new DomQuery(this.element).getChild(WithClass("Labels")));

      for (const container of this.images.querySelectorAll(".Image"))
        this.addDeleteControl(container);
    }
  }

  isEditable() {
    return this.uploadArea !== null;
  }

  async addFile(file) {
    this.addImage(file);
  }

  async downloadThumbnail(uuid) {
    let result = null;
    const uri = `${this.uri}/${uuid}/Thumbnail`;

    try {
      const response = await fetch(uri);

      if (response.ok) {
        const blob = await response.blob();
        const file = {
          target: uri,
          name: uuid,
          uuid: uuid,
          state: FileUploadState.Submitted,
          attempts: 0,
          progress: 0,
          problems: [],
          location: uri
        };

        await application.fileStore.add(file);
        await application.pageHandler.persistThumbnail(file, blob);

        result = file;
      }
    } catch (error) {
      console.warn(`Failed to fetch thumbnail for file ${uuid}:`, error);
    }

    return result;
  }

  addImage(file) {
    const image = document.createElement("img");
    image.src = URL.createObjectURL(new Blob([file.thumbnail]));
    image.title = file.name;
    image.dataset.Name = file.uuid ? file.uuid : file.id;

    const container = document.createElement("div");
    container.classList.add("Image");
    container.appendChild(image);

    this.updateImageState(container, file.state);
    this.images.appendChild(container);

    if (this.isEditable())
      this.addDeleteControl(container);
  }

  addDeleteControl(container) {
    const button = document.createElement("button");
    button.type = "button";
    button.classList.add("Delete");
    button.addEventListener(
      "click",
      (event) => {
        this.confirmDelete(container);

        event.stopPropagation();
        event.preventDefault();
      }
    );

    container.appendChild(button);
  }

  confirmDelete(container) {
    const name = container.querySelector("[data--name]")?.dataset.Name;

    if (name) {
      const confirmation = new ConfirmationWindowComponent(
        this.labels.DeleteConfirmation,
        this.labels.Confirm,
        this.labels.Cancel,
        () => this.deleteImage(name),
        ConfirmationClass.Delete
      );

      confirmation.show();
    }
  }

  async deleteImage(id) {
    const file = await this.findFile(id);

    if (file) {
      if (file.location === null)
        await application.fileStore.delete(file.id);
      else
        await application.fileStore.queueDeletion(file, this.uploadArea.URI);
    }
    else if (!this.isNumericIdentifier(id))
      await this.queueServerImageDeletion(id);

    this.removeImage(id);
    this.fireDataChanged();
  }

  findFile(id) {
    return this.isNumericIdentifier(id) ? application.fileStore.get(parseInt(id)) : application.fileStore.getThumbnailByUuid(id);
  }

  isNumericIdentifier(identifier) {
    return /^\d+$/.test(identifier);
  }

  async queueServerImageDeletion(uuid) {
    await application.fileStore.add({
      target: this.uploadArea.URI,
      uuid: uuid,
      name: uuid,
      state: FileUploadState.Aborted,
      location: `${this.uri}/${uuid}/Thumbnail`,
      processed: 0,
      attempts: 0,
      progress: 0,
      problems: []
    });
  }

  removeImage(id) {
    const element = this.images.querySelector(`.Image > [data--name="${id}"]`);

    if (element)
      element.parentElement.remove();
  }

  updateImageState(image, state) {
    image.classList.remove("Successful", "Uploading", "Error");

    if (state === FileUploadState.Submitted)
      image.classList.add("Successful");
    else if (FileUploadState.uploadingStates.has(state))
      image.classList.add("Uploading");
    else
      image.classList.add("Error");
  }

  handleEvent(event) {
    if (event instanceof FileUploadedEvent && event.target === this.parentComponent)
      this.addFile(event.data);
    else if (event instanceof FileUploadStatusChangedEvent) {
      const image = this.images.querySelector(
        `.Image > img[data--name="${event.upload.id}"], .Image > img[data--name="${event.upload.uuid}"]`
      );

      if (image)
        this.updateImageState(image.parentElement, event.upload.state);
    }
    else
      super.handleEvent(event);
  }

  load(value) {
    this.reconcileImages();
  }

  async reconcileImages() {
    let files = [];

    if (this.isEditable())
      files = await application.fileStore.getMatches("target", this.uploadArea.URI);

    this.removeDeletedImages(files);
    this.refreshThumbnails();
    await this.restoreImages(files);
  }

  removeDeletedImages(files) {
    const abortedUuids = new Set(
      files
        .filter(file => file.state === FileUploadState.Aborted && file.uuid)
        .map(file => file.uuid)
    );

    for (const container of this.images.querySelectorAll(".Image")) {
      const element = container.querySelector("[data--name]");

      if (element && abortedUuids.has(element.dataset.Name))
        container.remove();
    }
  }

  refreshThumbnails() {
    for (const container of this.images.querySelectorAll(".Image")) {
      const element = container.querySelector("[data--name]");

      if (element)
        this.refreshThumbnail(element);
    }
  }

  async refreshThumbnail(element) {
    const image = element.tagName === "IMG" ? element : element.querySelector("img");

    if (image) {
      const file = await this.resolveThumbnail(element.dataset.Name);

      if (file && file.thumbnail !== null)
        image.src = URL.createObjectURL(new Blob([file.thumbnail]));
    }
  }

  async resolveThumbnail(id) {
    let result = await application.pageHandler.retrieveThumbnail(id);

    if (!result || result.thumbnail === null)
      result = await this.downloadThumbnail(id);

    return result;
  }

  async restoreImages(files) {
    for (const file of files)
      await this.restoreImage(file);
  }

  async restoreImage(file) {
    if (this.shouldRestore(file)) {
      const fileWithThumbnail = await application.fileStore.getThumbnail(file.id);

      if (fileWithThumbnail)
        this.addImage(fileWithThumbnail);
    }
  }

  shouldRestore(file) {
    return file.state !== FileUploadState.Forbidden
      && file.state !== FileUploadState.Aborted
      && !this.isDisplayed(file);
  }

  isDisplayed(file) {
    return (file.uuid && this.images.querySelector(`.Image > [data--name="${file.uuid}"]`) !== null)
      || this.images.querySelector(`.Image > [data--name="${file.id}"]`) !== null;
  }

  save() {
    return {};
  }

  get name() {
    return this.element.dataset.Name;
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

interactivityRegistration.register("ImageGrid", (element) => { return new ImageGrid(element) });


// ---------- File: WebSite.Page.Component.List.Panel.ts ----------
// @ts-nocheck
export class ListPanel extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineItems();
  }

  determineItems() {
    const query = new DomQuery(this.element);
    const items = query.getChildren(WithClass("Item"));

    for (const item of items) {
      if (item.classList.contains("Add"))
        item.childNodes[0].onclick = this.createToggleSectionHandler(item);
    }
  }

  createToggleSectionHandler(element) {
    return function (event) {
      if (element.classList.contains("Expanded"))
        element.classList.remove("Expanded");
      else
        element.classList.add("Expanded");
    };
  }
}

interactivityRegistration.register("ListPanel", function (element) { return new ListPanel(element); });


// ---------- File: WebSite.Page.Component.Map.ts ----------
// @ts-nocheck
const StyleMode = new Enumeration(["Initial", "Hover", "Select"]);
const MapMode = new Enumeration(["Normal", "Light", "Dark"]);

export class MapComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.zoomLevel = parseFloat(element.dataset.ZoomLevel);
    this.opacity = parseFloat(element.dataset.Opacity);
    this.interactive = element.dataset.Interactive === "true";
    this.mode = MapMode.fromText(element.dataset.Mode);
    this.locked = false;
    this.lockedClass = new HtmlClassSwitch(this.element, "Locked");
    this.legendEnabled = new HtmlClassSwitch(this.element, "LegendEnabled");

    this.map = null;
    this.resizeObserver = null;

    this.layers = null;
    this.inspector = null;

    this.determineElements();
    this.createMap();

    this.map.render();
    this.attachHandlers();
    this.refresh();
  }

  attachHandlers() {
    this.layerButton.addEventListener(
      "click",
      (event) => {
        if (!this.locked)
          this.toggleComponent(this.layers, event);
      }
    );

    if (this.legendButton !== null)
      this.legendButton.addEventListener(
        "click",
        (event) => {
          if (!this.locked)
            this.toggleComponent(this.legend, event);
        }
      );

    if (this.configurationButton !== null)
      this.configurationButton.addEventListener(
        "click",
        (event) => {
          if (!this.locked)
            this.toggleComponent(this.configuration, event);
        }
      );

    this.stylesheet.addEventListener(
      "change",
      (event) => {
        if (!this.locked)
          this.update(
            () => {
              this.refreshMap(false);
            }
          );
      }
    );

    this.restoreButton.addEventListener(
      "click",
      (event) => {
        if (!this.locked)
          this.restore();
      }
    );

    this.map.on("moveend",
      (event) => {
        if (!this.locked) {
          this.update(
            () => {
              if (this.interactive)
                this.refreshMap(false);
            }
          );
        }
      }
    );
  }

  bind() {
    this.map.updateSize();
  }

  observeResize() {
    this.resizeObserver = new ResizeObserver(
      () => {
        this.map.updateSize();
      }
    );

    this.resizeObserver.observe(this.map.getTargetElement());
  }

  createHoverInteraction() {
    const hover = new ol.interaction.Select({
      condition: ol.events.condition.pointerMove,
      style: WebPageMapComponentHoverStyle
    });

    hover.on("select", event => this.hover(event));
    return hover;
  }

  applyFilter(context) {
    switch (this.mode) {
      case MapMode.Light: {
        context.filter = "grayscale(90%)";
        context.globalCompositeOperation = "source-over";

        break;
      }
      case MapMode.Dark: {
        context.filter = "grayscale(90%) invert(80%) hue-rotate(180deg)";
        context.globalCompositeOperation = "source-over";

        break;
      }
    }
  }

  createMap() {
    const mapLayer = new ol.layer.Tile({
      source: new ol.source.OSM({
        wrapX: false
      })
    });

    mapLayer.on(
      "precompose",
      (event) => {
        if (event.context)
          this.applyFilter(event.context);
      }
    );

    mapLayer.on(
      "postcompose",
      (event) => {
        if (event.context)
          event.context.filter = "none";
      }
    );

    mapLayer.setOpacity(this.opacity);

    this.map = new ol.Map({
      target: this.element.childNodes[0].id,
      layers: [
        mapLayer
      ],
      view: new ol.View({
        center: ol.proj.fromLonLat([0, 0]),
        zoom: this.zoomLevel
      })
    });

    this.hoverInteraction = this.createHoverInteraction();
    this.selectInteraction = this.createSelectInteraction();

    this.map.addInteraction(this.hoverInteraction);
    this.map.addInteraction(this.selectInteraction);

    this.layerSelectors[0].layer = mapLayer;
    this.layerSelectors[0].onchange = this.createToggleLayerHandler(mapLayer, this.layerSelectors[0].selector);

    this.observeResize();
  }

  createSelectInteraction() {
    const select = new ol.interaction.Select({
      condition: ol.events.condition.select,
      style: WebPageMapComponentSelectStyle
    });
    select.on("select", event => this.select(event));
    return select;
  }

  createToggleLayerHandler(layer, selector) {
    return (event) => {
      this.update(
        () => {
          this.updateLayers();
          this.refreshMap(false);
        }
      );
    };
  }

  determineElements() {
    let query = new DomQuery(this.element);

    this.tooltip = query.getChild(WithClass("Tooltip"));

    const actions = query.getChild(WithClass("Actions"));
    query = new DomQuery(actions);

    this.components = query.getChild(WithClass("Components"));
    this.layerButton = query.getChild(WithClass("Layers"));
    this.legendButton = query.getChild(WithClass("Legend"));
    this.restoreButton = query.getChild(WithClass("Restore"));
    this.configurationButton = query.getChild(WithClass("Configuration"));

    query = new DomQuery(this.components);

    this.legend = query.getChild(WithClass("Legend"));
    this.layers = query.getChild(WithClass("Layers"));
    this.inspector = query.getChild(WithClass("Inspector"));
    this.configuration = query.getChild(WithClass("Configuration"));

    query = new DomQuery(this.configuration);
    this.stylesheet = query.getDescendant(WithTagName("TEXTAREA"));

    query = new DomQuery(this.layers);

    this.layerSelectors = query.getDescendants(WithClass("Tristate"));

    for (let index = 0; index < this.layerSelectors.length; index++) {
      const layerSelector = this.layerSelectors[index];

      layerSelector.selector = new Tristate(layerSelector);
      layerSelector.selector.index = index;
    }
  }

  getBounds() {
    const size = this.map.getSize();
    const view = this.map.getView();

    const extent = view.calculateExtent(size);

    const result = ol.proj.transformExtent(
      extent,
      ol.proj.get("EPSG:3857"),
      ol.proj.get("EPSG:4326")
    );

    return result;
  }

  handleEvent(event) {
    if (event instanceof VisibilityChangedEvent) {
      this.map.updateSize();
      this.updateViewPort();
    }
    else if (event instanceof AvailableSizeChangedEvent) {
      this.map.updateSize();
      this.updateViewPort();
    }
  }

  hasEnabledLayers() {
    let result = false;
    let index = 0;

    while (!result && index < this.layerSelectors.length) {
      result = this.layerSelectors[index].selector.state === "Enabled";
      index++;
    }

    return result;
  }

  createLegendTable(object, labels) {
    const exclude = ["style", "geometry", "orientation", "point-type", "point-source"];
    let table = document.createElement("table");
    let row, cell;

    const associatedValue = object.AssociatedValue;

    if (associatedValue !== undefined && associatedValue.length > 0) {
      row = table.insertRow();

      for (const property in associatedValue[0]) {
        const label = labels[property];

        cell = document.createElement("td");
        cell.innerHTML = label;

        row.appendChild(cell);
      }

      for (const element of associatedValue) {
        row = table.insertRow();

        for (var property in element) {
          cell = document.createElement("td");
          cell.innerHTML = element[property];

          row.appendChild(cell);
        }
      }
    }
    else {
      for (const property in object) {
        const label = labels[property];

        if (!exclude.includes(property) && label !== undefined) {
          row = table.insertRow();

          cell = document.createElement("td");
          cell.innerHTML = label;

          row.appendChild(cell);

          cell = document.createElement("td");
          cell.innerHTML = object[property];

          row.appendChild(cell);
        }
      }
    }

    if (table.rows.length === 0)
      table = null;

    return table;
  }

  hover(event) {
    var map = this;
    var source = event.mapBrowserEvent.originalEvent;
    var legend = this.tooltip;

    if (source.ctrlKey) {
      legend.innerHTML = "";

      if (event.selected.length > 0) {
        var feature = event.selected[0];
        var properties = feature.getProperties();
        var layer = map.hoverInteraction.getLayer(feature);

        var table = this.createLegendTable(properties, layer.labels);

        if (table !== null)
          legend.appendChild(table);
      }

      legend.style.position = "fixed";
      legend.style.left = source.clientX + "px";
      legend.style.top = source.clientY + "px";
    }
    else
      legend.innerHTML = "";
  }

  lock() {
    this.setLocked(true);
  }

  async refreshMap(updateViewPort) {
    this.lock();

    try {
      const response = await fetch(
        this.uri,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            Command: "Refresh",
            Value: {
              ZoomLevel: this.map.getView().getZoom()
            }
          })
        }
      );

      const data = await response.json();
      this.updateContents(data);

      if (updateViewPort)
        this.updateViewPort();
    }
    finally {
      this.unlock();
    }
  }

  refresh() {
    this.refreshMap(true);
  }

  restore() {
    this.lock();
    fetch(
      this.uri,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          Command: "Restore"
        })
      }
    )
      .then(response => response.json())
      .then(settings => {
        this.bounds = settings.Bounds;
        this.zoomLevel = settings.ZoomLevel;

        this.updateViewPort();
      })
      .finally(() => this.unlock());
  }

  select(event) {
    var map = this;
    var legend = this.inspector;
    legend.innerHTML = "";

    if (event.selected.length > 0) {
      var feature = event.selected[0];
      var properties = feature.getProperties();
      var layer = map.hoverInteraction.getLayer(feature);

      var table = this.createLegendTable(properties, layer.labels);

      if (table !== null)
        legend.appendChild(table);
    }
  }

  setLocked(locked) {
    this.locked = locked;
    this.lockedClass.setStatus(locked);
  }

  toggleComponent(component, event) {
    var object = this;
    var classes = new HtmlClasses(component);

    if (classes.contains("expanded"))
      removeClickOutsideListener(component.clickOutsideListener);
    else
      component.clickOutsideListener = connectClickOutsideListener(component, function (event) { object.toggleComponent(component, event); })

    classes.toggle("expanded");
    event.stopPropagation();
  }

  unlock() {
    this.setLocked(false);
  }

  update(callback) {
    var layers = new Array();

    for (var index = 1; index < this.layerSelectors.length; index++)
      layers.push(this.layerSelectors[index].selector.state);

    var bounds = this.getBounds();
    var bounds_ = null;

    if (!ol.extent.isEmpty(bounds)) {
      bounds_ = {
        "Left": bounds[0],
        "Top": bounds[1],
        "Right": bounds[2],
        "Bottom": bounds[3]
      };
    }

    this.client.sendJsonRequest(
      this.uri,
      {
        "Command": "Update",
        "Value": {
          "Layers": layers,
          "Bounds": bounds_,
          "ZoomLevel": this.map.getView().getZoom(),
          "Stylesheet": this.stylesheet.value
        }
      },
      callback
    );
  }

  updateContents(contents) {
    this.contents = contents.Layers;
    this.bounds = contents.Settings.Bounds;
    this.zoomLevel = contents.Settings.ZoomLevel;

    for (let index = 0; index < this.contents.length; index++) {
      const feature = this.contents[index];
      const layerSelector = this.layerSelectors[index + 1];
      let layer = null;

      if (feature !== null) {
        const vectorSource = new ol.source.Vector({
          features: (new ol.format.GeoJSON()).readFeatures(feature, { featureProjection: ol.proj.get("EPSG:3857") })
        });

        if (feature.Class === "Vector") {
          layer = new ol.layer.Vector({
            source: vectorSource,
            style: WebPageMapComponentStyle
          });
        }
        else if (feature.Class === "Heatmap") {
          const gradient = feature.properties.Gradient.substring(1, feature.properties.Gradient.length - 1).split(",");
          const scale = feature.properties.Scale;

          layer = new ol.layer.Heatmap({
            source: vectorSource,
            radius: 10,
            blur: 2,
            gradient: gradient,
            weight: (feature) => {
              return Math.max(0.25, parseFloat(feature.getProperties().style["stroke-width"]) / scale);
            }
          });
        }

        layer.setOpacity(feature.Opacity);
        layer.labels = feature.Labels;

        if (layerSelector.layer !== null)
          this.map.removeLayer(layerSelector.layer);

        if (layer !== null)
          this.map.addLayer(layer);
      }
      else if (layerSelector.layer !== null)
        this.map.removeLayer(layerSelector.layer);

      layerSelector.layer = layer;
      layerSelector.onchange = this.createToggleLayerHandler(layer, layerSelector.selector);
    }

    this.updateLegend(contents.Legend);
    this.updateLayers();
  }

  updateLegend(data) {
    const target = this.legend.childNodes[1].tBodies[0];
    target.innerHTML = "";

    for (const legend of data) {
      const row = document.createElement("tr");
      row.classList.add("LegendItem");

      const description = document.createElement("td");
      description.innerHTML = legend.Description;

      row.appendChild(description);

      const icon = document.createElement("td");
      icon.innerHTML = legend.Icon;

      row.appendChild(icon);
      target.appendChild(row);
    }

    this.legendEnabled.setStatus(data.length > 0);
  }

  updateLayer(layer, selector) {
    if (selector.state === "Enabled")
      selector.setEffect(true);
    else if (selector.state === "Neutral") {
      if (this.hasEnabledLayers())
        selector.setEffect(false);
      else
        selector.setEffect(true);
    }
    else if (selector.state === "Disabled")
      selector.setEffect(false);

    if (layer !== null && layer.getVisible() !== selector.effect)
      layer.setVisible(selector.effect);

    return (layer === null && selector.effect);
  }

  updateLayers() {
    let refresh = false;

    for (const layerSelector of this.layerSelectors)
      refresh = refresh || this.updateLayer(layerSelector.layer, layerSelector.selector);

    return refresh;
  }

  getExtent(bounds) {
    if (bounds) {
      let result = ol.extent.boundingExtent([[bounds[0], bounds[1]], [bounds[2], bounds[3]]]);

      if (!ol.extent.isEmpty(result))
        result = ol.proj.transformExtent(
          result,
          ol.proj.get("EPSG:4326"),
          ol.proj.get("EPSG:3857")
        );

      return result;
    }
    else
      return ol.extent.createEmpty();
  }

  updateViewPort() {
    const extent = this.getExtent(this.bounds);

    if (!ol.extent.isEmpty(extent)) {
      if (this.zoomLevel === -1)
        this.map.getView().fit(extent, this.map.getSize());
      else {
        this.map.getView().setCenter(ol.extent.getCenter(extent));

        if (this.map.getView().getZoom() !== this.zoomLevel)
          this.map.getView().setZoom(this.zoomLevel);
      }
    }
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

function WebPageMapComponentStyle(feature, resolution) {
  var styleFunction = new WebPageMapComponentStyleFunction();

  var fill = styleFunction.getFill(feature);
  var stroke = styleFunction.getStroke(feature);

  var styles = new Array();
  var style = styleFunction.createStyle(feature, fill, stroke);

  if (style !== null)
    styles.push(style);

  return styles;
}

function WebPageMapComponentStyleFunction() {
  this.createStyle = function (feature, fill, stroke) {
    var result = null;
    var type = feature.getGeometry().getType();

    if (type === "Point")
      result = this.createPointStyle(feature, fill, stroke);
    else
      result = this.createRegularStyle(fill, stroke);

    return result;
  }

  this.createPointStyle = function (feature, fill, stroke) {
    var size = feature.getProperties().style["stroke-width"];
    var pointstyle = feature.get("point-type");
    var orientation = feature.get("orientation");
    var result = null;

    if (pointstyle === "custom" && isChrome()) {
      result = new ol.style.Style({
        image: new ol.style.Icon({
          crossOrigin: "anonymous",
          color: fill,
          opacity: fill[3],
          src: "/Resource/" + feature.get("point-source"),
          imgSize: [size, size],
          rotation: orientation * Math.PI / 180,
        })
      });
    }
    else if (pointstyle !== "custom") {
      result = new ol.style.Style({
        image: new ol.style.Circle({
          radius: size,
          fill: new ol.style.Fill({
            color: fill
          }),
          stroke: new ol.style.Stroke({
            color: stroke.getColor(),
            lineDash: stroke.getLineDash()
          })
        })
      });
    }

    return result;
  }

  this.createRegularStyle = function (fill, stroke) {
    var result = null;

    if (fill != null && stroke != null) {
      result = new ol.style.Style({
        fill: new ol.style.Fill({
          color: fill
        }),
        stroke: stroke
      });
    }
    else if (fill != null) {
      result = new ol.style.Style({
        fill: new ol.style.Fill({
          color: fill
        })
      });
    }
    else if (stroke != null) {
      result = new ol.style.Style({
        stroke: stroke
      });
    }

    return result;
  }

  this.getFill = function (feature) {
    var style = feature.getProperties().style;
    var fill = ol.color.asArray(style.fill);

    if (style.opacity != null) {
      if (fill != null) {
        fill = fill.slice();
        fill[3] = style.opacity;
      }
    }

    return fill;
  }

  this.getStroke = function (feature) {
    var style = feature.getProperties().style;
    var stroke = ol.color.asArray(style.stroke);

    if (style.opacity != null) {
      if (stroke != null) {
        stroke = stroke.slice();
        stroke[3] = style.opacity;
      }
    }

    var strokeWidth = style["stroke-width"];
    var strokePattern = style["stroke-pattern"];

    return new ol.style.Stroke({
      color: stroke,
      width: strokeWidth,
      lineDash: strokePattern
    });
  }
}

function WebPageMapComponentHoverStyle(feature, resolution) {
  var styleFunction = new WebPageMapComponentStyleFunction();
  var strokeWidth = feature.getProperties().style["stroke-width"];

  var fill = styleFunction.getFill(feature);
  var stroke = new ol.style.Stroke({
    width: strokeWidth,
    color: "#1677b8"
  });

  var styles = new Array();
  var style = styleFunction.createStyle(feature, fill, stroke);

  if (style !== null)
    styles.push(style);

  return styles;
}

function WebPageMapComponentSelectStyle(feature, resolution) {
  var styleFunction = new WebPageMapComponentStyleFunction();
  var styles = new Array();

  var strokeWidth = feature.getProperties().style["stroke-width"];

  var fill = styleFunction.getFill(feature);
  var stroke = new ol.style.Stroke({
    width: strokeWidth + 2,
    color: "#FFFFFF"
  });

  var style = styleFunction.createStyle(feature, fill, stroke);

  if (style !== null)
    styles.push(style);

  var fill = [22, 119, 184, 0.25];
  var stroke = new ol.style.Stroke({
    width: strokeWidth,
    color: "#1677b8"
  });

  var style = styleFunction.createStyle(feature, fill, stroke);

  if (style !== null)
    styles.push(style);

  return styles;
}

interactivityRegistration.register("Map", function (element) { return new MapComponent(element); });


// ---------- File: WebSite.Page.Component.Object_.Action.ts ----------
// @ts-nocheck
export class ObjectActionComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.client = new HttpClient();
    this.updatingCounter = new HtmlClassCounter(this.element, "Updating");

    this.pristine = null;
    this._isDirty = false;

    this.determineElements();
    this.attachRefreshHandler();
  }

  attachRefreshHandler() {
    const query = new DomQuery(this.element);
    const item = query.getDescendant(WithClass("Refresh"));

    if (item !== null)
      item.addEventListener(
        "click",
        async (event) => {
          if (await this.canNavigate())
            this.refresh();
        }
      );

    window.addEventListener(
      "beforeunload",
      (event) => {
        if (this.isDirty) {
          event.preventDefault();
          event.returnValue = "";
        }
      }
    );
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.toolbar = new Toolbar(query.getDescendant(WithClass("Toolbar")), this);

    this.labels = new Labels(query.getChild(WithClass("Labels")));
    this.saveForm = new DomQuery(this.toolbar.element).getDescendant(WithClass("SaveObjectForm"));

    if (this.saveForm) {
      this.saveForm.addEventListener(
        "click",
        (event) => (
          this.sendActionRequest("Update", this.getForm(), () => { })
        )
      );

      this.trackChanges();
    }
  }

  getForm() {
    return this.content;
  }

  trackChanges() {
    this.resetDirtyState();
    const form = this.getForm();

    form.addEventListener("input", () => this.checkDirty());
    form.addEventListener("change", () => this.checkDirty());

    const fields = new DomQuery(this.element).getDescendants(WithClass("Field"));

    for (const field of fields) {
      if (field.component)
        field.component.addEventListener("change", (event) => this.checkDirty());
    }
  }

  serializeForm(form) {
    const data = new FormData(form);
    return new URLSearchParams(data).toString();
  }

  checkDirty() {
    const form = this.getForm();

    const currentState = this.serializeForm(form);
    this.isDirty = currentState !== this.pristine;
  }

  resetDirtyState() {
    const form = this.getForm();

    this.pristine = this.serializeForm(form);
    this.isDirty = false;
  }

  get isDirty() {
    return this._isDirty;
  }

  set isDirty(value) {
    this._isDirty = value;

    this.element.classList.toggle("Dirty", value);
    this.saveForm.disabled = !value;

    if (value)
      application.pageHandler.guards.add(this);
    else if (application.pageHandler)
      application.pageHandler.guards.delete(this);
  }

  async canNavigate(uri) {
    return new Promise(
      (resolve) => {
        if (this.isDirty) {
          const confirmationWindow = new ConfirmationWindowComponent(
            this.labels.UnsavedChangesWarning,
            this.labels.Yes,
            this.labels.No,
            () => {
              resolve(true);
            }
          );

          confirmationWindow.show();
        }
        else
          resolve(true);
      }
    );
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent) {
      if (this.refreshForSiblings && !this.isDirty)
        this.invalidate();
      else if (this.element.contains(event.field.element))
        this.sendRefreshRequest(RenderScope.Toolbar);
    }
    else
      super.handleEvent(event);
  }

  async validate() {
    this.refresh();
  }

  handleHttpCommandResponse(xmlResponse) {
    const contentType = xmlResponse.getResponseHeader("Content-Type");

    if (contentType.slice(0, 15) == "application/xml") {

      const response = xmlResponse.responseXML;
      const query = new DomQuery(response.documentElement);

      const updateScopeElement = query.getChild(WithTagName("UpdateScope"));
      let updateScope = RenderScope.Complete;

      if (updateScopeElement !== null)
        updateScope = RenderScope.fromText(updateScopeElement.getAttribute("Value"));

      this.sendRefreshRequest(updateScope);
    }

    this.updatingCounter.decrease();
  }

  refresh() {
    this.sendCommandRequest("<Refresh/>");
  }

  refreshWithScope(xmlResponse, scope) {
    let dummyElement = document.createElement("div");

    if (scope === RenderScope.Toolbar) {
      dummyElement.innerHTML = xmlResponse.responseText;

      const newToolbar = dummyElement.firstChild;
      this.toolbar.replace(newToolbar, true);

      this.attachRefreshHandler();
    }
    else {
      dummyElement.innerHTML = xmlResponse.responseText;
      dummyElement = dummyElement.firstChild;

      const newToolbar = dummyElement.childNodes[0];
      const newContent = dummyElement.childNodes[1];

      this.content = newContent;

      this.toolbar.replace(newToolbar, false);
      this.attachRefreshHandler();

      if (this.saveForm)
        this.trackChanges();
    }

    this.updatingCounter.decrease();
  }

  refreshFromResponse(xmlResponse) {
    this.refreshWithScope(xmlResponse, RenderScope.Complete);
  }

  sendActionRequest(action, form, callback) {
    const xmlRequest = newXmlRequest();

    let formData;

    if (form !== null)
      formData = new FormData(form);
    else
      formData = new FormData();

    formData.append("Action", action);
    this.updatingCounter.increase();

    xmlRequest.open("POST", this.uri, true);
    xmlRequest.setRequestHeader("Accept", "text/html;q=1, */*;q=0.9");
    xmlRequest.onreadystatechange = () => {
      if (xmlRequest.readyState == 4) {
        if (xmlRequest.status === 200) {
          const contentType = xmlRequest.getResponseHeader("Content-Type");

          if (contentType.slice(0, 15) == "application/xml") {
            const response = xmlRequest.responseXML;

            if (response.documentElement.hasAttribute("Location")) {
              const type = response.documentElement.getAttribute("Type");
              const redirect = response.documentElement.getAttribute("Location");

              if (type === "Download") {
                window.open(redirect);
                this.refresh();
              }
              else if (type === "Redirect") {
                if (!application.pageHandler.navigate(redirect)) {
                  this.fireDataChanged();
                  this.refresh();
                }
              }

              this.updatingCounter.decrease();
            }
            else {
              this.handleHttpCommandResponse(xmlRequest);
              this.fireDataChanged();
            }

            application.toastBox.addMessage(new ToastMessage(this.labels.ActionExecutedSuccessfully, "Success"));
          }
        }
        else if (xmlRequest.status === 400) {
          this.toolbar.state = ToolbarState.Warning;
          this.refreshFromResponse(xmlRequest);
          this.fireDataChanged();
        }
        else if (xmlRequest.status === 409 || xmlRequest.status === 500) {
          const division = document.createElement("div");
          division.innerHTML = xmlRequest.responseText;

          const error = new DomQuery(division).getDescendant(WithClass("Error"));
          application.toastBox.addMessage(new ToastMessage(error.firstChild, "Error"));

          this.updatingCounter.decrease();
        }

        callback();
      }
    };

    xmlRequest.send(formData);
  }

  sendCommandRequest(command) {
    this.updatingCounter.increase();

    this.client.sendXmlRequest(
      this.uri,
      "<Commands>" + command + "</Commands>",
      (xmlResponse) => { this.handleHttpCommandResponse(xmlResponse); }
    );
  }

  sendRefreshRequest(scope) {
    this.updatingCounter.increase();
    this.client.sendXmlRequest(
      this.uri,
      "<Render Scope=\"" + RenderScope.toText(scope) + "\"/>",
      (xmlResponse) => { this.refreshWithScope(xmlResponse, scope); }
    );
  }

  toggleAction(action) {
    this.sendCommandRequest("<Action Name=\"" + action + "\"/>");
  }

  get refreshForSiblings() {
    return this.element.dataset.RefreshForSiblings === "true";
  }

  get uri() {
    return this.element.dataset.Uri;
  }

  get content() {
    return this.element.childNodes[1];
  }

  set content(value) {
    interactivityRegistration.detach(this.content);
    this.element.replaceChild(value, this.content);
    interactivityRegistration.attach(this.content);
  }
}

interactivityRegistration.register("ObjectActionComponent", function (element) { return new ObjectActionComponent(element); });


// ---------- File: WebSite.Page.Component.Tab.Menu.ts ----------
// @ts-nocheck
function Tab(index, element) {
    this.determineState = function () {
        this.selected = new HtmlClassSwitch(this.element, "Selected").getStatus();
        this.add = new HtmlClassSwitch(this.element, "Add").getStatus();
    }

    this.index = index;
    this.element = element;
    this.selected = false;
    this.add = false;

    this.determineState();
}

export class TabMenu extends WebPageComponent {
  constructor(element) {
    super(element);

    this.tabs = new Array();
    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.hasAdd = false;
    this.determineTabs();
    this.addComponents();
  }

  determineTabs() {
    const query = new DomQuery(this.element);

    const tabElements = query.getChildren(WithTagName("LI"));

    for (let index = 0; index < tabElements.length; index++) {
      const tab = new Tab(index, tabElements[index]);
      this.tabs.push(tab);

      if (tab.add)
        this.hasAdd = true;
    }
  }

  addComponents() {
    if (this.hasAdd) {
      const expand = document.createElement("li");

      expand.classList.add("Expand");
      expand.onclick = (event) => {
        this.toggleAdd();
      };

      this.element.appendChild(expand, this.element);
    }
  }

  toggleAdd() {
    this.expanded.toggle();
  }
}

interactivityRegistration.register("TabMenu", function (element) { return new TabMenu(element); });


// ---------- File: WebSite.Page.Component.Tab.Panel.ts ----------
// @ts-nocheck
export class TabPage extends WebPageComponent {
  constructor(element, tab, index, interactive) {
    super(element);

    this.tab = tab;
    this.index = index;
    this.interactive = interactive

    this.page = element;
    this.page.component = this;

    this.determineElements();
  }

  addEventHandlers(panel) {
    this.tab.tabIndex = 0;

    this.tab.addEventListener(
      "click",
      (event) => {
        event.preventDefault();
        panel.selectTab(this.index, true);
      }
    );

    this.tab.addEventListener(
      "keydown",
      (event) => {
        this.handleKey(event, panel);
      }
    );

    if (this.tab.id.length > 0)
      window.addEventListener(
        "hashchange",
        (event) => {
          if (window.location.hash.substring(1) === this.tab.id)
            panel.selectTab(this.index, true);
        }
      );

    this.selectedTabSwitch = new HtmlClassSwitch(this.tab, "Selected");
    this.selectedPageSwitch = new HtmlClassSwitch(this.page, "Selected");
  }

  handleKey(event, panel) {
    if (event.code === "Space") {
      panel.selectTab(this.index, true);
      event.stopHandling();
    }
    else if (event.code === "Home") {
      panel.selectTab(panel.getNextTab(-1), true);
      event.stopHandling();
    }
    else if (event.code === "End") {
      panel.selectTab(panel.getPreviousTab(panel.childComponents.length), true);
      event.stopHandling();
    }
    else if (event.code === "ArrowLeft") {
      panel.selectTab(panel.getPreviousTab(this.index), true);
      event.stopHandling();
    }
    else if (event.code === "ArrowRight") {
      panel.selectTab(panel.getNextTab(this.index), true);
      event.stopHandling();
    }
  }

  determineElements() {
    this.content = this.page.childNodes[0];
    this.count = new DomQuery(this.tab).getChild(WithClass("Count"));
  }

  handleEvent(event) {
    if (event instanceof CountChangedEvent) {
      if (event.count > 0)
        this.count.innerText = event.count;
      else
        this.count.innerText = "";

      event.handled = true;
    }
    else
      super.handleEvent(event);
  }

  load(value) {
    if (this.decoratedComponent && this.mode === ControlMode.edit)
      this.decoratedComponent.load(value);
  }

  save() {
    if (this.mode === ControlMode.edit)
      return this.decoratedComponent.save()
    else
      return null;
  }

  select(enabled, updateFocus) {
    this.selectedTabSwitch.setStatus(enabled);
    this.selectedPageSwitch.setStatus(enabled);

    if (this.tab.id.length > 0 && enabled) {
      window.history.replaceState(
        { url: window.location.href },
        null,
        "#" + this.tab.id
      );

      if (updateFocus)
        this.tab.focus();
    }
  }

  async validate() {
    if (this.interactive)
      await this.reload();
  }

  async reload() {
    if (this.interactive)
      await fetch(
        this.uri,
        {
          method: "GET"
        }
      )
        .then((response) => this.reloadFromResponse(response));
  }

  async reloadFromResponse(response) {
    interactivityRegistration.detach(this.content);
    this.page.innerHTML = await (response.text());
    this.content = this.page.childNodes[0];
    interactivityRegistration.attach(this.content);
  }

  get enabled() {
    return this.tab.dataset.Enabled === "true";
  }

  set enabled(value) {
    if (this.enabled !== value) {
      this.invalidate();

      this.tab.dataset.Enabled = JSON.stringify(value);
      this.page.dataset.Enabled = JSON.stringify(value);
    }
  }

  get name() {
    return this.decoratedComponent.name;
  }

  get identifier() {
    return this.tab.dataset.Identifier;
  }

  get decoratedComponent() {
    return this.childComponents[0];
  }

  get uri() {
    return this.tab.dataset.Uri;
  }
}

export class TabPanel extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determinePages();
    this.attachPageEventHandlers();

    const fragment = window.location.hash.substring(1);

    for (const page of this.childComponents)
      if (page.tab.id.length > 0 && page.tab.id === fragment)
        this.selectTab(page.index, true);
  }

  determinePages() {
    const query = new DomQuery(this.element);

    const tabElements = new DomQuery(query.getChild(WithClass("Tabs"))).getChildren(WithTagName("LI"));
    const pageElements = new DomQuery(query.getChild(WithClass("Pages"))).getChildren(WithTagName("DIV"));

    for (let index = 0; index < tabElements.length; index++) {
      const page = new TabPage(pageElements[index], tabElements[index], index, this.interactive);
      page.parentComponent = this;

      this.childComponents.push(page);
    }
  };

  attachPageEventHandlers() {
    for (let index = 0; index < this.childComponents.length; index++)
      this.childComponents[index].addEventHandlers(this);
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent)
      this.invalidate();
    else
      super.handleEvent(event);
  }

  async validate() {
    if (this.interactive)
      await this.reload();
  }

  async reload() {
    if (this.interactive)
      await fetch(
        this.uri,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => this.reloadFromResponse(data));
  }

  reloadFromResponse(data) {
    for (const tab of data) {
      const tabPage = this.childComponents.find((element) => { return element.identifier === tab.Identifier });
      tabPage.enabled = tab.Enabled;
    }
  }

  getNextTab(index) {
    const result = this.childComponents.slice(index + 1).findIndex(tab => tab.enabled);
    return result === -1 ? index : result + index + 1;
  }

  getPreviousTab(index) {
    const result = this.childComponents.slice(0, index).findLastIndex(tab => tab.enabled);
    return result === -1 ? index : result;
  }

  selectTab(index, updateFocus) {
    if (index >= 0 && index < this.childComponents.length) {
      if (this.childComponents[index].enabled) {
        const selected = this.childComponents[index];

        if (this.interactive) {
          const formData = new FormData();
          formData.append("Active", selected.identifier);

          fetch(
            this.uri,
            {
              method: "POST",
              body: formData
            }
          );
        }

        for (const tab of this.childComponents) {
          if (tab.enabled) {
            tab.select(tab === selected, updateFocus);

            if (tab.content !== undefined && tab.content.component !== undefined)
              tab.content.component.handleEvent(new VisibilityChangedEvent(this));
          }
        }
      }
    }
  }

  get name() {
    return this.element.dataset.Name;
  }

  get interactive() {
    return this.element.dataset.Interactive === "true";
  }

  get uri() {
    return this.element.dataset.Uri;
  }
}

interactivityRegistration.register("TabPanel", function (element) { return new TabPanel(element); });


// ---------- File: WebSite.Page.Component.Table.ts ----------
// @ts-nocheck
var TableRenderScope = new Enumeration(["Toolbar", "Layout", "Header", "Rows", "Footer", "Complete", "Navigation"]);

function ColumnMapping(identifier, index, span) {
  this.identifier = identifier;
  this.index = index;
  this.span = span;
}

export class CommandMessage extends XmlMessage {
  constructor() {
    super();

    this.commands = new Array();
  }

  toXml() {
    const result = this.commands.join("");
    return `<Commands>${result}</Commands>`;
  }
}

export class RenderMessage extends XmlMessage {
  constructor(scopes) {
    super();

    this.scopes = scopes;
  }

  toXml() {
    let command = "<Render>"

    this.scopes.forEach(
      (scope) => {
        command = command + "<Scope Name=\"" + TableRenderScope.toText(scope) + "\"/>";
      }
    );

    command += "</Render>";
    return command;
  }
}

export class CountChangedEvent {
  constructor(count) {
    this.count = count;
  }
}

export class Table extends WebPageComponent {
  constructor(element) {
    super(element);

    this.element.tabIndex = "0";

    this.loadSettings(this.element);
    this.determineElements();
    this.initializeComponents();
    this.initializeCells();

    this.attachEventHandlers();
    this.attachNavigationHandlers();
    this.attachSearchHandler();
    this.attachMenuEventHandlers();
    this.attachViewHandlers();
    this.attachTableEventHandlers();
  }

  getTableElement() {
    return this.tableElement;
  }

  getRows() {
    return this.getTableElement().tBodies[0].rows;
  }

  getForm() {
    const form = this.tableElement.parentNode;

    if (form.tagName === "FORM")
      return form;
    else
      return null;
  }

  determineTableElement() {
    let parent = this.contents;

    if (this.useSiblingComponent)
      parent = new DomQuery(parent).getNthChild(WithTagName("FORM"), 0);

    return new DomQuery(parent).getChild(WithTagName("TABLE"));
  }

  columnClicked(columnIdentifier) {
    this.sendCommandRequest("<SortColumn Id=\"" + columnIdentifier + "\"/>");
  }

  updateSortColumn(element) {
    const columnIdentifier = element.getAttribute("ColumnIdentifier");
    const order = element.getAttribute("Order");

    for (const row of this.getColumnsRows()) {
      for (const cell of row.cells) {
        const id = cell.dataset.Identifier;
        const icon = new DomQuery(cell).getDescendant(WithClass("Sort"));

        if (icon !== null) {
          const classes = new HtmlClasses(icon);

          classes.remove("Ascending");
          classes.remove("Descending");

          if (id === columnIdentifier) {
            classes.add(order == 0 ? "Ascending" : "Descending");
          }
        }
      }
    }
  }

  getHeaderRowWithClass(className) {
    return Array.from(this.getTableElement().tHead.rows).find(row => nodeHasClass(row, className)) || null;
  }

  getHeaderRowsWithClass(className) {
    return Array.from(this.getTableElement().tHead.rows).filter(row => nodeHasClass(row, className));
  }

  getSearchRow() {
    return new DomQuery(this.toolbar.element).getDescendant(WithClass("Search"));
  }

  getSearchInput() {
    const row = this.getSearchRow();

    if (row !== null)
      return new DomQuery(row).getDescendant(WithTagName("INPUT"));
    else
      return null;
  }

  getFilterRows() {
    return this.getHeaderRowsWithClass("Filter");
  }

  getColumn(identifier) {
    const columnGroup = this.tableElement.firstChild;
    let column = null;

    for (const node of columnGroup.childNodes)
      if (node.dataset.Identifier === identifier)
        column = node;

    return column;
  }

  getColumnsRows() {
    return this.getHeaderRowsWithClass("Columns");
  }

  toggleFilter() {
    this.filterEnabled = !this.filterEnabled;
    this.sendCommandRequest("<Filter Visible=\"" + this.filterEnabled + "\"/>");
    this.updateFilterVisibility();
  }

  filterColumn(column, mode, expression) {
    this.filterEnabled = true;
    this.updateFilterVisibility();
    this.sendCommandRequest(
      "<Filter Visible=\"true\"/>" +
      "<FilterColumn Id=\"" + column + "\" Mode=\"" + escapeXMLAttributeValue(mode) + "\" Text=\"" + escapeXMLAttributeValue(expression) + "\"/>"
    );
  }

  setView(view) {
    if (view !== this.element.dataset.View) {
      this.element.dataset.View = view;
      this.sendCommandRequest("<View Value=\"" + this.element.dataset.View + "\"/>");
    }
  }

  updateFilterVisibility() {
    const rows = this.getFilterRows();

    for (const row of rows)
      setNodeClassEnabled(row, "Enabled", this.filterEnabled);
  }

  toggleLayoutPanel() {
    this.layoutPanel.open();
  }

  scheduleFilterOperation(operation) {
    this.filterTimer.kill();
    this.filterTimer.schedule(operation);
  }

  searchTextChanged(textBox) {
    if (textBox.value !== this.filterText) {
      this.filterText = textBox.value;
      this.scheduleFilterOperation(() => this.sendCommandRequest("<Search Text=\"" + escapeXMLAttributeValue(textBox.value) + "\"/>"));
    }
  }

  sendCommandRequest(command, blocking = true) {
    let message = null;

    if (this.requestQueue.getSize() >= 2) {
      const request = this.requestQueue.getLast();

      if (request.message instanceof CommandMessage) {
        message = request.message;
        message.commands.push(command);

        request.blocking = request.blocking || blocking;
      }
    }

    if (message === null) {
      message = new CommandMessage();
      message.commands.push(command);

      this.requestQueue.queue(
        this.uri,
        "POST",
        message,
        null,
        async (response) => {
          if (response.ok)
            await this.handleHttpCommandResponse(response);
        },
        blocking
      );
    }
  }

  async handleHttpCommandResponse(response) {
    const contentType = response.headers.get("Content-Type");

    if (contentType.slice(0, 15) == "application/xml") {
      const responseText = await response.text();
      const xml = new DOMParser().parseFromString(responseText, "application/xml");

      if (xml.documentElement.hasAttribute("Location")) {
        const type = xml.documentElement.getAttribute("Type");
        const redirect = xml.documentElement.getAttribute("Location");

        if (type === "Download") {
          window.open(redirect);
          this.refresh();
        }
        else if (type === "Redirect") {
          if (!application.pageHandler.navigate(redirect))
            this.refresh();
        }
      }
      else {
        const query = new DomQuery(xml.documentElement);
        const cursorElement = query.getChild(WithTagName("Cursor"));

        if (cursorElement !== null) {
          this.navigation.update(cursorElement);
          this.fireCountChangedEvent();
        }

        const scopesElement = query.getChild(WithTagName("Scopes"));
        const scopeElements = new DomQuery(scopesElement).getChildren(WithTagName("Scope"));

        const scopes = new Array();

        for (const scope of scopeElements)
          scopes.push(TableRenderScope.fromText(scope.getAttribute("Name")));

        this.invalidateScopes(scopes);
      }
    }
    else if (contentType.slice(0, 9) === "text/html")
      this.handleHttpRenderResponse(response);
  }

  sendActionRequest(action, form, callback) {
    let formData;

    if (form !== null)
      formData = new FormData(form);
    else
      formData = new FormData();

    formData.append("Action", action);
    formData.append("Selection", this.createSelectionElement());

    this.requestQueue.queue(
      this.uri,
      "POST",
      null,
      formData,
      async (response) => {
        if (response.ok) {
          await this.handleHttpCommandResponse(response);

          this.fireDataChanged();
          application.toastBox.addMessage(new ToastMessage(this.labels.ActionExecutedSuccessfully, "Success"));
        }
        else if (response.status === 400) {
          this.toolbar.state = ToolbarState.Warning;
          await this.refreshFromResponse(response);
          this.fireDataChanged();
        }
        else
          this.requestQueue.handleErrorResponse(response);

        callback();
      }
    );
  }

  sendRenderRequest(scopes) {
    this.requestQueue.queue(
      this.uri,
      "POST",
      new RenderMessage(scopes),
      null,
      async (response) => await this.handleHttpRenderResponse(response)
    );
  }

  handleHttpRenderScopeResponse(element, scope) {
    if (scope === TableRenderScope.Toolbar)
      this.replaceToolbar(element.firstChild, true);
    else if (scope === TableRenderScope.Layout)
      this.replaceLayoutPanel(element.firstChild.firstChild);
    else if (scope === TableRenderScope.Header)
      this.replaceHeader(element.firstChild.tHead, element.firstChild.firstChild);
    else if (scope === TableRenderScope.Rows)
      this.replaceBody(element.firstChild.firstChild);
    else if (scope === TableRenderScope.Footer)
      this.replaceFooter(element.firstChild.tFoot);
    else if (scope === TableRenderScope.Navigation)
      this.replaceNavigation(element.firstChild)
    else if (scope === TableRenderScope.Complete) {
      const newElement = element.firstChild;
      const newToolbar = new DomQuery(newElement).getChild(WithClass("Toolbar"));
      const newLayoutPanel = new DomQuery(newElement).getChild(WithClass("Layout"));
      const newTable = new DomQuery(newElement).getChild(WithClass("Contents")).firstChild;

      this.loadSettings(newElement);

      this.replaceTable(newTable);
      this.replaceToolbar(newToolbar, false);
      this.replaceLayoutPanel(newLayoutPanel);
    }
  }

  async handleHttpRenderResponse(response) {
    const dummyElement = document.createElement("div");
    dummyElement.innerHTML = await response.text();

    for (const element of dummyElement.firstChild.childNodes) {
      const scope = TableRenderScope.fromText(element.className);
      this.handleHttpRenderScopeResponse(element, scope);
    }

    this.renderStatus = true;
    this.updateFilterVisibility();

    if (this.selectAll !== null)
      this.selectAll.recalculate(this);

    this.getSize();
  }

  invalidateScopes(scopes) {
    for (const scope of scopes)
      this.invalidScopes.add(scope);

    if (this.invalidScopes.size !== 0) {
      this.sendRenderRequest(new Set(this.invalidScopes));
      this.invalidScopes.clear();
    }
  }

  replaceHeader(header, columnGroup) {
    interactivityRegistration.detach(this.tableElement.tHead);
    this.tableElement.replaceChild(header, this.tableElement.tHead);
    this.tableElement.replaceChild(columnGroup, this.tableElement.childNodes[0])
    interactivityRegistration.attach(header);

    this.createSelector();

    this.attachTableEventHandlers();
    this.fireChangedEvent(this.tableElement);
  }

  replaceFooter(footer) {
    if (footer !== null)
      this.tableElement.replaceChild(footer, this.tableElement.tFoot);
  }

  replaceNavigation(navigation) {
    this.element.replaceChild(navigation, this.navigation.element);

    this.navigation = new Navigation(navigation);
    this.attachNavigationHandlers();
  }

  attachEventHandlers() {
    this.element.addEventListener(
      "keydown",
      (event) => {
        // TODO: Verifying if the action form is enabled is a quick fix that should be removed once it is moved out of the table's dom element.
        if (!this.toolbar.hasActionEnabled() && !this.tableElement.contains(event.target) && event.code === "ArrowDown") {
          const rows = this.getRows();

          if (rows.length > 0)
            rows[0].focus();

          event.stopHandling();
        }
        else if (event.code === "F5") {
          this.refresh();
          this.element.focus();
          event.stopHandling();
        }
        else if (event.altKey && event.shiftKey && event.code === "KeyX") {
          this.toggleExpertMode();
          event.preventDefault();
        }
      }
    );
  }

  attachNavigationHandlers() {
    if (this.navigation.nextPage !== null) {
      this.navigation.nextPage.addEventListener("click", (event) => this.moveCursor("Up"));
      this.navigation.previousPage.addEventListener("click", (event) => this.moveCursor("Down"));
    }
    else {
      this.navigation.loadRows.addEventListener("click", (event) => this.setPageSize(this.navigation.increasePageSize(this.navigation.size)));
    }
  }

  moveCursor(direction) {
    this.sendCommandRequest("<CursorMove Direction=\"" + direction + "\"/>");
  }

  getSize() {
    this.sendCommandRequest("<Size/>", false);
  }

  setPageSize(count) {
    this.sendCommandRequest("<Cursor PageSize=\"" + count + "\"/>");
  }

  replaceBody(body) {
    interactivityRegistration.detach(this.tableElement.tBodies[0]);
    this.tableElement.replaceChild(body, this.tableElement.tBodies[0]);
    interactivityRegistration.attach(body);

    this.initializeCells();
    this.attachRowEventHandlers();
    this.fireChangedEvent(this.tableElement);
  }

  replaceTable(table) {
    interactivityRegistration.detach(this.contents.firstChild);
    this.contents.replaceChild(table, this.contents.firstChild);
    this.tableElement = this.determineTableElement();

    interactivityRegistration.attach(table);

    this.initializeCells();
    this.attachRowEventHandlers();
    this.createSelector();
    this.attachTableEventHandlers();
    this.fireChangedEvent(this.tableElement);
  }

  replaceToolbar(toolbar, persistForm) {
    this.toolbar.replace(toolbar, persistForm);

    if (this.toolbar.hasActionEnabled())
      this.element.classList.add("ActionEnabled");
    else
      this.element.classList.remove("ActionEnabled");

    this.attachMenuEventHandlers();
    this.attachViewHandlers();
  }

  replaceLayoutPanel(layoutPanel) {
    interactivityRegistration.detach(this.layoutPanel.element);
    this.element.replaceChild(layoutPanel, this.layoutPanel.element);
    interactivityRegistration.attach(layoutPanel);
    this.layoutPanel = new LayoutPanel(layoutPanel, this);
  }

  fireChangedEvent(newTable) {
    if (this.onChanged !== null)
      this.onChanged(newTable);
  }

  fireCountChangedEvent() {
    distributeEventUpHierarchy(new CountChangedEvent(this.navigation.total), this);
  }

  selectRow(checkBox) {
    const tableRow = new DomQuery(checkBox).getAncestor(WithTagName("TR"));
    setNodeClassEnabled(tableRow, "selectedRow", checkBox.checked);
  }

  selectAllRows(checked) {
    this.selectRange(0, this.getRows().length - 1, checked);
  }

  selectRange(low, high, checked) {
    const rows = this.getRows();

    for (let index = low; index <= high; index++) {
      const row = rows[index];
      const cell = row.cells[0];
      const checkBoxToChange = cell.getElementsByTagName("input")[0];

      if (checkBoxToChange != null && checkBoxToChange.checked !== checked && !checkBoxToChange.disabled) {
        checkBoxToChange.checked = checked;
        this.selectRow(checkBoxToChange);
      }
    }
  }

  createRowHotHandler(row, flag) {
    return function (event) {
      setHot(row, event, flag);
    };
  }

  createRowClickedHandler(row, uri) {
    return function (event) {
      const source = getEvent(event).getSource();

      if (shouldHandleMouseClick(row, source))
        openUrl(event, uri);
    };
  }

  attachRowEventHandlers() {
    for (const row of this.getRows()) {
      const component = new TableRow(row, this);

      if (component.uri !== null) {
        row.addEventListener("mouseover", this.createRowHotHandler(row, true));
        row.addEventListener("mouseout", this.createRowHotHandler(row, false));
        row.addEventListener("click", this.createRowClickedHandler(row, component.uri));
      }

      if (this.cellActionsEnabled)
        this.attachCellActionHandlers(row);
    }
  }

  attachCellActionHandlers(row) {
    for (const cell of row.cells) {
      if (cell.dataset.Column !== undefined && nodeHasClass(cell, "display"))
        new TableCellActions(this, cell);
    }
  }

  determineCellActionsEnabled() {
    return new DomQuery(this.element.parentNode).getAncestor((node) => nodeHasClass(node, "Suggest") || nodeHasClass(node, "PopUp")) === null;
  }

  refresh() {
    this.invalidateScopes([TableRenderScope.Toolbar, TableRenderScope.Header, TableRenderScope.Rows, TableRenderScope.Footer, TableRenderScope.Navigation]);
  }

  refreshFromResponse(http) {
    this.handleHttpRenderResponse(http);
  }

  attachColumnSortHandlers() {
    let totalSpan = 0;

    for (const row of this.getColumnsRows()) {
      for (const cell of row.cells) {
        const classes = new HtmlClasses(cell);

        if (classes.contains("Column")) {
          const columnIdentifier = cell.dataset.Identifier;

          const caption = new DomQuery(cell).getDescendant(WithClass("Caption"));
          caption.classList.add("Action");

          caption.addEventListener(
            "click",
            (event) => {
              this.columnClicked(columnIdentifier);
            }
          );

          this.columnIdentifierIndexMapping[columnIdentifier] = new ColumnMapping(columnIdentifier, totalSpan, cell.colSpan);
          totalSpan += cell.colSpan;
        }
      }
    }
  }

  resizeColumn(columnIdentifier, delta) {
    const column = this.getColumn(columnIdentifier);

    const reference = document.createElement("span");
    reference.innerHTML = "0";
    reference.style.visibility = "hidden";
    reference.style.fontSize = window.getComputedStyle(this.tableElement.tBodies[0]).fontSize;
    reference.style.fontWeight = "bold";
    reference.style.display = "block"
    reference.style.width = "min-content"

    document.body.appendChild(reference);
    const ratio = parseFloat(window.getComputedStyle(reference).width);
    document.body.removeChild(reference);

    const width = Math.max(parseFloat(column.style.width) + delta / ratio, 6);
    column.style.width = width + "ch";
  }

  commitColumnSize(columnIdentifier) {
    const column = this.getColumn(columnIdentifier);
    const width = parseFloat(column.style.width);
    const command = "<Resize Id=\"" + columnIdentifier + "\" Width=\"" + width + "\"/>";

    this.sendCommandRequest(command);
  }

  startResize() {
    this.tableElement.style.userSelect = "none";
  }

  finishResize() {
    this.tableElement.style.userSelect = "";
  }

  attachColumnResizeHandler(cell) {
    let pageX, column;

    cell.addEventListener(
      "mousedown",
      (event) => {
        pageX = event.pageX;
        column = event.target;

        this.startResize();
        cell.classList.add("Dragging");
      }
    );

    document.addEventListener(
      "mousemove",
      (event) => {
        if (column !== undefined) {
          if (pageX !== undefined)
            this.resizeColumn(column.dataset.Identifier, event.pageX - pageX);

          pageX = event.pageX;
        }
      }
    );

    document.addEventListener(
      "mouseup",
      (event) => {
        if (column !== undefined) {
          this.commitColumnSize(column.dataset.Identifier);
          event.stopPropagation();

          cell.classList.remove("Dragging");
          this.finishResize();
        }

        pageX = undefined;
        column = undefined;
      }
    );

    cell.onclick = (event) => {
      event.stopPropagation();
    };
  }

  attachColumnResizeHandlers() {
    for (const row of this.getColumnsRows()) {
      for (const cell of row.cells) {
        const resizer = new DomQuery(cell).getDescendant(WithClass("Resizer"));

        if (resizer !== null)
          this.attachColumnResizeHandler(resizer);
      }
    }
  }

  createColumnFilterHandler() {
    return () => {
      this.scheduleFilterOperation(
        () => {
          let command = "";
          let filters = 0;

          for (const field of this.filters) {
            const expression = field.getFilterText();
            const mode = field.getFilterMode();

            if (field.initialFilterText !== expression || field.initialFilterMode !== mode)
              command = command + "<FilterColumn Id=\"" + field.getId() + "\" Mode=\"" + escapeXMLAttributeValue(mode) + "\" Text=\"" + escapeXMLAttributeValue(expression) + "\"/>";

            field.initialFilterText = field.getFilterText();
            field.initialFilterMode = field.getFilterMode();

            const rows = this.getColumnsRows();

            for (const row of rows) {
              for (const cell of row.cells) {
                if (cell.dataset.Identifier === field.getId()) {
                  const icon = new DomQuery(cell).getDescendant(WithClass("Filter"));

                  if (icon !== null) {
                    const classes = new HtmlClasses(icon);

                    if (expression.length > 0) {
                      classes.add("Value");
                      filters++;
                    }
                    else
                      classes.remove("Value");
                  }
                }
              }
            }
          }

          const toggleFilter = new DomQuery(this.element).getDescendant(WithClass("ToggleFilter"));

          if (filters > 0)
            toggleFilter.childNodes[0].innerText = filters;
          else
            toggleFilter.childNodes[0].innerText = "";

          this.sendCommandRequest(command);
        }
      );
    }
  }

  attachSearchHandler() {
    const searchInput = this.getSearchInput();

    if (searchInput !== null) {
      this.filterText = searchInput.value;
      searchInput.addEventListener("input", (event) => this.searchTextChanged(searchInput))
    }
  }

  attachColumnFilterHandlers() {
    this.filters = new Array();

    for (const row of this.getFilterRows()) {
      for (const cell of row.cells) {
        const classes = new HtmlClasses(cell);
        const query = new DomQuery(cell);

        if (classes.contains("Column")) {
          const element = query.getDescendant(WithClass("Box"));
          const id = cell.dataset.Identifier;

          if (element !== null)
            this.filters.push(new FilterField(element, this.createColumnFilterHandler(), id));
        }
      }
    }
  }

  attachMenuEventHandlers() {
    this.attachToolbarButtonEventHandler("ToggleFilter", (event) => { this.toggleFilter(); });
    this.attachToolbarButtonEventHandler("Refresh", (event) => { this.refresh(); });
    this.attachToolbarButtonEventHandler("Layout", (event) => { this.toggleLayoutPanel(); });
  }

  toggleAction(action) {
    this.element.classList.add("ActionEnabled");
    this.sendCommandRequest(this.createSelectionElement() + "<Action Name=\"" + action + "\"/>");
  }

  attachViewHandlers() {
    const view = new DomQuery(this.element).getDescendant(WithClass("View"));

    if (view !== null) {
      const auto = new DomQuery(view).getChild(WithClass("Auto"));
      const list = new DomQuery(view).getChild(WithClass("List"));
      const columns = new DomQuery(view).getChild(WithClass("Columns"));
      const tiles = new DomQuery(view).getChild(WithClass("Tiles"));

      auto.addEventListener("click", (event) => this.setView("Auto"));
      list.addEventListener("click", (event) => this.setView("List"));
      columns.addEventListener("click", (event) => this.setView("Columns"));
      tiles.addEventListener("click", (event) => this.setView("Tiles"));
    }
  }

  attachToolbarButtonEventHandler(action, handler) {
    const query = new DomQuery(this.element);
    const item = query.getDescendant(WithClass(action));

    if (item !== null)
      item.addEventListener("click", handler);
  }

  attachTableEventHandlers() {
    this.attachColumnSortHandlers();
    this.attachColumnFilterHandlers();
    this.attachColumnResizeHandlers();

    if (this.selectAll !== null)
      this.selectAll.checkBox.addEventListener(
        "change",
        (event) => {
          this.selectAllRows(this.selectAll.checkBox.getValue());
          this.fireSelectionChangedEvent();
        }
      );

    this.onSelectionChanged = () => {
      this.sendCommandRequest(this.createSelectionElement());
    }
  }

  createSelectionElement() {
    let result = "<Selection>"
    const selection = this.getSelectedRows();

    for (const row of selection)
      result = result + "<Row>" + escapeXMLCharacterData(row) + "</Row>";

    result = result + "</Selection>";
    return result;
  }

  handleInitialRenderTime() {
    if (this.renderTime === "Immediate") {
      this.renderStatus = true;
      this.getSize();
    }
    else if (this.renderTime === "Deferred")
      this.refresh();
  }

  assureRendered() {
    if (!this.renderStatus)
      this.refresh();
  }

  getSelectedRows() {
    const rows = this.getRows();
    const result = new Array();

    for (const row of rows)
      if (row.tableRow.selected)
        result.push(row.dataset.Identifier);

    return result;
  }

  getSelectedRowCount() {
    const rows = this.getRows();
    let count = 0;

    for (const row of rows)
      if (row.tableRow.selected)
        count++;

    return count;
  }

  collectPublishedActions() {
    const selectedRows = this.collectSelectedRows();
    const candidates = new Map();

    if (selectedRows.length > 0) {
      this.initializeActionCandidates(candidates, selectedRows[0]);

      for (const row of selectedRows.slice(1))
        this.intersectActionCandidates(candidates, row);
    }

    return this.buildActionsFromCandidates(candidates);
  }

  collectSelectedRows() {
    const result = [];

    for (const row of this.getRows())
      if (row.tableRow && row.tableRow.selected)
        result.push(row);

    return result;
  }

  initializeActionCandidates(candidates, row) {
    for (const [name, entry] of this.collectRowPublishedActions(row))
      candidates.set(name, { action: entry.action, items: [entry.component] });
  }

  intersectActionCandidates(candidates, row) {
    const rowActions = this.collectRowPublishedActions(row);

    for (const name of [...candidates.keys()]) {
      const entry = rowActions.get(name);

      if (entry !== undefined)
        candidates.get(name).items.push(entry.component);
      else
        candidates.delete(name);
    }
  }

  buildActionsFromCandidates(candidates) {
    const result = [];

    for (const candidate of candidates.values())
      result.push({ name: candidate.action.name, caption: candidate.action.caption, execute: candidate.action.execute, items: candidate.items });

    return result;
  }

  collectRowPublishedActions(row) {
    const result = new Map();

    for (const cell of row.cells) {
      const component = this.findCellMainComponent(cell);

      if (component !== null) {
        for (const action of component.getPublishedActions())
          result.set(action.name, { action: action, component: component });
      }
    }

    return result;
  }

  findCellMainComponent(cell) {
    const elements = Array.from(cell.querySelectorAll("*"));
    const element = elements.find((candidate) => candidate.component !== undefined);
    return element !== undefined ? element.component : null;
  }

  getRowCount() {
    const rows = this.getRows();
    let count = 0;

    for (const row of rows) {
      const cell = row.cells[0];
      const checkBox = cell.getElementsByTagName("input")[0];

      if (checkBox != null && !checkBox.disabled)
        count++;
    }

    return count;
  }

  createSelector() {
    this.selectAll = null;

    if (this.rowSelectorEnabled) {
      const element =
        new DomPathQuery(this.tableElement)
          .getChild(WithTagName("THEAD"))
          .getChild(WithClass("Columns"))
          .getChild(WithClass("rowSelector"))
          .getChild(function (node) { return node.component !== undefined && node.component instanceof CheckBoxField })
          .getElement();

      if (element !== null) {
        this.selectAll = new Selector(element);
        this.selectAll.recalculate(this);
      }
    }
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent) {
      if (this.refreshMode === RefreshMode.ForSiblings)
        this.invalidate();
      else if (this.element.contains(event.field.element))
        this.invalidateScopes([TableRenderScope.Toolbar]);
    }
    else
      super.handleEvent(event);
  }

  handleError(error) {
    application.toastBox.addMessage(new ToastMessage(this.labels.FailedToLoadTable, "Warning"));
  }

  async validate() {
    this.invalidateScopes([TableRenderScope.Complete]);
  }

  loadSettings(element) {
    this.filterEnabled = element.dataset.FilterEnabled === "true";
    this.rowSelectorEnabled = element.dataset.RowSelectorEnabled === "true";
    this.useSiblingComponent = element.dataset.UseSiblingComponent === "true";
    this.renderTime = element.dataset.RenderTime;
    this.view = element.dataset.View;

    this.element.tabIndex = "0";
    this.renderStatus = false;
    this.lastSelected = null;
  }

  initializeComponents() {
    this.updatingCounter = new HtmlClassCounter(this.element, "Updating");
    this.busy = new HtmlClassSwitch(this.element, "Busy");
    this.expertMode = new HtmlClassSwitch(this.element, "Expert");

    this.requestQueue = new RequestQueue(this);
    this.previousQueueSize = 0;
    this.requestQueue.listeners.push((event) => {
      if (event instanceof QueueSizeChangedEvent) {
        while (this.previousQueueSize < event.size) {
          this.updatingCounter.increase();
          this.previousQueueSize++;
        }

        while (this.previousQueueSize > event.size) {
          this.updatingCounter.decrease();
          this.previousQueueSize--;
        }

        this.busy.setStatus(this.requestQueue.requests.find((request) => { return request.blocking; }) !== undefined);
      }
    });

    this.invalidScopes = new Set();
    this.columnIdentifierIndexMapping = new Object();
    this.onChanged = null;

    this.filterTimer = new Timer(250);
    this.filterText = "";
    this.updateFilterVisibility();

    this.cellActionsEnabled = this.determineCellActionsEnabled();

    this.attachRowEventHandlers();
    this.createSelector();
  }

  initializeCells() {
    const header = this.getColumnsRows()[0];
    let columnIndex = 0;

    for (const column of header.cells) {
      const caption = new DomQuery(column).getDescendant(WithClass("Cell"));

      for (const row of this.getRows()) {
        if (caption !== null) {
          const node = caption.cloneNode(true);
          row.cells[columnIndex].prepend(node);
        }
      }

      columnIndex += column.colSpan;
    }

    for (const row of this.getRows()) {
      const subs = new DomQuery(row).getChildren(WithClass("Sub"));

      for (const sub of subs) {
        const field = sub.childNodes[sub.childNodes.length - 2];

        if (field.nodeType === Node.ELEMENT_NODE) {
          if ("Value" in field.dataset) {
            if (field.dataset.Value.length === 0)
              sub.classList.add("Empty");
          }
          else if (field.innerText.length === 0)
            sub.classList.add("Empty");
        }
        else if (field.nodeType === Node.TEXT_NODE && field.textContent.length === 0)
          sub.classList.add("Empty");
      }

      const last = subs.findLast((element) => !element.classList.contains("Empty"));

      if (last !== undefined)
        last.classList.add("Last");
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.contents = query.getChild(WithClass("Contents"));
    this.tableElement = this.determineTableElement();

    this.toolbar = new Toolbar(query.getChild(WithClass("Toolbar")), this);

    this.navigation = new Navigation(query.getChild(WithClass("NavigationBar")));
    this.layoutPanel = new LayoutPanel(query.getChild(WithClass("Layout")), this);
    this.labels = new Labels(query.getChild(WithClass("Labels")));
  }

  bind() {
    this.handleInitialRenderTime();
  }

  toggleExpertMode() {
    this.expertMode.toggle();
  }

  get uri() {
    return this.element.dataset.Uri;
  }

  set uri(uri) {
    this.element.dataset.Uri = uri;
  }
}

export class LayoutPanel extends WebPageComponent {
  constructor(element, table) {
    super(element);

    this.table = table;
    this.visible = new HtmlClassSwitch(element, "Visible");
    this.sourceColumn = null;
    this.dropped = false;
    this.projection = null;
    this.predefined = null;
    this.layoutDropDown = null;
    this.shareButton = null;
    this.confirmationWindow = null;

    this.attachEventHandlers();
    this.bind();
  }

  createColumnDragStartHandler(column) {
    return (event) => {
      this.sourceColumn = column;
      this.sourceIndex = this.columns.indexOf(column);

      column.classList.add("Moving");
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.setData("text/plain", "move-column");
    };
  }

  createColumnDragEndHandler(column) {
    return (event) => {
      if (!this.dropped) {
        if (this.columns.indexOf(column) < this.sourceIndex)
          this.moveColumn(this.sourceIndex + 1);
        else
          this.moveColumn(this.sourceIndex);
      }

      this.sourceColumn.classList.remove("Moving");
      this.sourceColumn = null;
      this.dropped = false;
    };
  }

  createOnDragOverHandler() {
    return (event) => {
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";

      this.moveColumn(this.determineTargetIndex(event.target.offsetTop + event.offsetY));
    };
  }

  createOnDragLeaveHandler(column) {
    return (event) => {
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
    };
  }

  createOnDragExitHandler(column) {
    return (event) => {
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
    };
  }

  createOnDragEnterHandler(column) {
    return (event) => {
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
    };
  }

  createOnDropHandler(column) {
    return (event) => {
      event.preventDefault();
      this.dropColumn();
    };
  }

  getColumnMiddle(column) {
    return column.offsetTop + column.offsetHeight / 2;
  }

  determineTargetIndex(offsetY) {
    let result = 0;

    while (result < this.columns.length && this.getColumnMiddle(this.columns[result]) < offsetY)
      result++;

    return result;
  }

  moveColumn(targetIndex) {
    const sourceIndex = this.columns.indexOf(this.sourceColumn);

    if (targetIndex !== sourceIndex && targetIndex !== sourceIndex + 1) {
      const targetColumn = this.columns[targetIndex];

      this.projection.insertBefore(this.sourceColumn, targetColumn);
      this.columns = new DomQuery(this.projection).getChildren(WithClass("Column"));
    }
  }

  dropColumn() {
    this.updateProjection();
    this.dropped = true;
  }

  updateProjection() {
    this.table.sendCommandRequest("<Projection>" + this.getCurrentProjectionAsXml() + "</Projection>");
  }

  attachEventHandlers() {
    this.projection = new DomQuery(this.element).getDescendant(WithClass("Projection"));
    this.projection.ondragover = this.createOnDragOverHandler();
    this.projection.ondragleave = this.createOnDragLeaveHandler();
    this.projection.ondragenter = this.createOnDragEnterHandler();
    this.projection.ondragexit = this.createOnDragExitHandler();
    this.projection.ondrop = this.createOnDropHandler();

    this.columns = new DomQuery(this.projection).getChildren(WithClass("Column"));

    for (const column of this.columns) {
      const checkBox = column.childNodes[0].component;
      checkBox.addEventListener(
        "change",
        (event) => {
          this.updateProjection();
        }
      );

      column.ondragstart = this.createColumnDragStartHandler(column);
      column.ondragend = this.createColumnDragEndHandler(column);
      column.draggable = true;
    }
  }

  handleLayoutDropDownChanged() {
    this.table.sendCommandRequest("<SelectLayout Name=\"" + escapeXMLAttributeValue(this.layoutDropDown.getValue()) + "\"/>");
    this.close();
  }

  saveLayout() {
    const layoutName = this.layoutName.getValue();
    this.table.sendCommandRequest("<SaveLayout Name=\"" + escapeXMLAttributeValue(layoutName) + "\"/>");
    this.close();

    application.toastBox.addMessage(new ToastMessage(this.table.labels.ActionExecutedSuccessfully, "Success"));
  }

  shareLayout() {
    const layoutName = this.layoutName.getValue();
    this.table.sendCommandRequest("<ShareLayout Name=\"" + escapeXMLAttributeValue(layoutName) + "\"/>");
    this.close();

    application.toastBox.addMessage(new ToastMessage(this.table.labels.ActionExecutedSuccessfully, "Success"));
  }

  createOnLayoutDropDownChangedHandler() {
    return (event) => {
      this.handleLayoutDropDownChanged();
    };
  }

  bind() {
    this.closeButton = new DomQuery(this.element).getDescendant(WithClass("Close"));
    this.closeButton.addEventListener("click", () => { this.close(); });

    this.predefined = new DomQuery(this.element).getDescendant(WithClass("Predefined"));

    this.layoutDropDown = this.getDescendant(new ComponentWithName("Layout"));
    this.layoutDropDown.addEventListener("change", this.createOnLayoutDropDownChangedHandler());

    this.layoutName = this.getDescendant(new ComponentWithName("Name"));
    this.saveButton = new DomQuery(this.element).getDescendant(WithClass("Save"));
    this.shareButton = new DomQuery(this.element).getDescendant(WithClass("Share"));

    if (this.saveButton !== null)
      this.saveButton.addEventListener("click", (event) => this.saveLayout());

    if (this.shareButton !== null)
      this.shareButton.addEventListener("click", (event) => this.shareLayout());
  }

  getCurrentProjectionAsXml() {
    let result = "";

    for (const column of this.columns)
      result += "<Column Identifier=\"" + column.dataset.Identifier + "\" Index=\"" + column.dataset.Index + "\" Visible=\"" + column.childNodes[0].component.getValue() + "\"/>";

    return result;
  }

  open() {
    this.visible.setStatus(true);

    this.clickOutsideListener = connectClickOutsideListener(
      this.element.childNodes[0],
      () => {
        this.close();
      }
    );
  }

  close() {
    this.visible.setStatus(false);
    removeClickOutsideListener(this.clickOutsideListener);
  }
}

function Navigation(element) {
  this.determineElements = function () {
    const query = new DomQuery(this.element);

    this.information = query.getChild(WithClass("Information"));
    this.loadRows = query.getChild(WithClass("LoadRows"));
    this.nextPage = query.getChild(WithClass("NextPage"));
    this.previousPage = query.getChild(WithClass("PreviousPage"));

    this.determineButtonStates();
  }

  this.determineButtonStates = function () {
    if (this.loadRows !== null)
      this.loadRows.disabled = this.total === null || this.size >= this.total || this.size === 1000;
    else {
      this.nextPage.disabled = this.total === null || this.offset + this.size >= this.total;
      this.previousPage.disabled = this.offset === 0;
    }
  }

  this.increasePageSize = function (pageSize) {
    if (pageSize === this.initialPageSize)
      return 250;
    else if (pageSize < 1000)
      return pageSize + 250;
    else
      return pageSize;
  }

  this.update = function (xml) {
    this.information.innerText = xml.getAttribute("Label");
    this.offset = xml.getAttribute("Offset");
    this.initialPageSize = xml.getAttribute("InitialPageSize");
    this.size = xml.getAttribute("PageSize");

    if (xml.hasAttribute("Total"))
      this.total = xml.getAttribute("Total");

    this.determineButtonStates();
  }

  Object.defineProperty(this, "initialPageSize", {
    get: function () {
      return parseInt(this.information.getAttribute("data--initial-page-size"));
    },
    set: function (size) {
      this.information.setAttribute("data--initial-page-size", size);
    }
  });

  Object.defineProperty(this, "offset", {
    get: function () {
      return parseInt(this.information.getAttribute("data--offset"));
    },
    set: function (offset) {
      this.information.setAttribute("data--offset", offset);
    }
  });

  Object.defineProperty(this, "size", {
    get: function () {
      return parseInt(this.information.getAttribute("data--page-size"));
    },
    set: function (size) {
      this.information.setAttribute("data--page-size", size);
    }
  });

  Object.defineProperty(this, "total", {
    get: function () {
      if (this.information.hasAttribute("data--total"))
        return parseInt(this.information.getAttribute("data--total"));
      else
        return null;
    },
    set: function (total) {
      this.information.setAttribute("data--total", total);
    }
  });

  this.element = element;
  this.determineElements();
}

export class Selector extends WebPageComponent {
  constructor(element) {
    super(element);

    this.checkBox = element.component;

    this.count = document.createElement("span");
    this.count.classList.add("Count");

    this.element.parentNode.appendChild(this.count);
  }

  recalculate(table) {
    const rowCount = table.getRowCount();
    const selected = table.getSelectedRowCount();

    if (selected > 0)
      this.count.innerHTML = selected;
    else
      this.count.innerHTML = "";

    this.checkBox.input.indeterminate = false;

    if (rowCount == 0 || selected == 0)
      this.checkBox.input.checked = false;
    else if (selected < rowCount)
      this.checkBox.input.indeterminate = true;
    else
      this.checkBox.input.checked = true;
  }
}

export class GroupingTable extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
  }

  expandOrCollapse(element) {
    const classes = new HtmlClasses(element);

    classes.toggle("collapsed");
    classes.toggle("expanded");
  }

  createOnClickHandler(item) {
    return () => {
      const body = new DomQuery(item).getAncestor(WithClass("expandable"));
      this.expandOrCollapse(body);
    };
  }

  attachItemHandlers(element) {
    element.onclick = this.createOnClickHandler(element);
  }

  attachItemsHandlers(elements) {
    for (const element of elements)
      this.attachItemHandlers(new DomQuery(element).getChild(WithClass("category")));
  }

  determineElements() {
    this.attachItemsHandlers(new DomQuery(this.element).getDescendants(WithClass("expandable")));
  }
}

export class MasterTableRow extends WebPageComponent {
  constructor(element) {
    super(element);

    this.detailsElement = element.nextSibling;
    this.determineElements();
  }

  expandOrCollapse(element, event) {
    const source = event.getSource();

    if (shouldHandleMouseClick(element, source)) {
      const classes = new HtmlClasses(this.detailsElement);
      classes.toggle("Collapsed");
      classes.toggle("Expanded");
    }
  }

  createOnClickHandler(item) {
    return (event) => {
      this.expandOrCollapse(item, getEvent(event));
    };
  }

  attachItemHandler(element) {
    element.onclick = this.createOnClickHandler(element);
  }

  determineElements() {
    this.attachItemHandler(this.element);
  }
}

export class FilterField extends WebPageComponent {
  constructor(element, handler, id) {
    super(element);

    this.handler = handler;
    this.id = id;

    this.button = element.childNodes[0];
    this.button.tabIndex = -1;

    this.target = element.childNodes[1].component;
    this.form = element.childNodes[2];

    this.fields = null;

    this.filterMode = null;
    this.formState = new HtmlClassSwitch(this.form, "Collapsed");
    this.clickOutsideHandler = null;

    this.determineElements();
    this.attachEventHandlers();

    this.initialFilterText = this.getFilterText();
    this.initialFilterMode = this.getFilterMode();
  }

  attachEventHandlers() {
    this.element.onkeydown = (event) => {
    };

    this.target.addEventListener("input", (event) => { this.handler(); });
    this.button.onclick = (event) => { this.toggleForm(event); };

    for (const field of this.fields)
      field.onchange = (event) => { this.handler(); };
  }

  determineElements() {
    this.fields = new DomQuery(this.form).getDescendants(WithTagName("INPUT"));
  }

  getId() {
    return this.id;
  }

  getFilterText() {
    const value = this.target.getValue();
    return value !== null ? value : "";
  }

  getFilterMode() {
    for (const field of this.fields) {
      if (field.checked)
        this.filterMode = field.getAttribute("value");
    }

    return this.filterMode;
  }

  toggleForm(event) {
    this.formState.toggle();

    if (!this.form.classList.contains("Collapsed")) {
      this.clickOutsideListener = connectClickOutsideListener(this.form, (event) => { this.toggleForm(event); });
      this.fields[0].focus();
    }
    else if (this.clickOutsideListener != null)
      removeClickOutsideListener(this.clickOutsideListener);

    event.stopPropagation();
  }
}

export class QuickActions {
  constructor(element, row) {
    this.element = element;
    this.row = row;

    this.initialize();
  }

  initialize() {
    const query = new DomQuery(this.element);

    this.button = query.getChild(WithTagName("BUTTON"));
    this.button.addEventListener(
      "click",
      (event) => {
        this.toggle();
        event.stopPropagation();
      }
    );

    this.actions = query.getDescendants(WithClass("QuickAction"));
    this.expand = new HtmlClassSwitch(this.element, "Expanded");
    this.rowSwitch = new HtmlClassSwitch(this.row, "QuickActionSelected");
  }

  toggle() {
    this.expand.toggle();
    this.rowSwitch.toggle();

    if (this.expand.getStatus()) {
      this.clickOutsideListener = connectClickOutsideListener(
        this.element,
        () => {
          this.toggle();
        }
      );
    }
    else
      removeClickOutsideListener(this.clickOutsideListener);
  }
}

let openCellActions = null;

export class TableCellActions {
  constructor(table, cell) {
    this.table = table;
    this.cell = cell;
    this.popup = null;
    this.pointerLeft = null;
    this.selected = new HtmlClassSwitch(cell, "CellActionsSelected");

    this.attachEventHandlers();
  }

  attachEventHandlers() {
    this.cell.addEventListener(
      "mouseenter",
      (event) => {
        this.pointerLeft = event.clientX;
        this.open();
      }
    );

    this.cell.addEventListener("mouseleave", (event) => { this.close(); });
  }

  open() {
    if (this.popup === null) {
      const content = this.createContent();

      if (content !== null)
        this.popup = new PopUp(content, this.cell, false, null, 400);
    }

    if (this.popup !== null) {
      if (openCellActions !== null && openCellActions !== this)
        openCellActions.close();

      this.popup.open(this.pointerLeft);

      this.selected.setStatus(true);
      openCellActions = this;
    }
  }

  close() {
    if (this.popup !== null)
      this.popup.close();

    this.selected.setStatus(false);
  }

  createContent() {
    let result = null;
    const actions = this.createActions();

    if (actions.length > 0) {
      result = document.createElement("div");
      result.className = "CellActions";

      for (const action of actions)
        result.appendChild(action);
    }

    return result;
  }

  createActions() {
    const result = new Array();
    const mode = this.determineFilterMode();
    const value = this.cell.textContent.replace(/\s+/g, " ").trim();

    for (const link of this.createLinks())
      result.push(link);

    if (value.length > 0)
      result.push(this.createCopyButton(value));

    if (mode !== null && this.cell.dataset.FilterValue !== undefined)
      result.push(this.createFilterButton(mode, this.cell.dataset.FilterValue));

    return result;
  }

  createLinks() {
    const result = new Array();
    const suggest = new DomQuery(this.cell).getDescendant(WithClass("Suggest"));

    if (suggest !== null) {
      for (const card of suggest.querySelectorAll("tr.Card")) {
        if (new DomQuery(card.parentNode).getAncestor(WithClass("Suggest")) === suggest) {
          const main = new DomQuery(card).getChild(WithClass("Main"));

          if (main !== null && main.dataset.Uri !== undefined)
            result.push(this.createLink(main));
        }
      }
    }

    return result;
  }

  createLink(main) {
    const link = document.createElement("a");

    link.className = "Open";
    link.href = main.dataset.Uri;
    link.title = main.textContent.replace(/\s+/g, " ").trim();
    link.addEventListener("click", (event) => { this.close(); });

    return link;
  }

  createCopyButton(value) {
    const button = document.createElement("button");

    button.className = "Copy";
    button.title = this.table.labels.Copy.textContent;
    button.addEventListener("click", (event) => { this.copy(value); });

    return button;
  }

  createFilterButton(mode, value) {
    const button = document.createElement("button");

    button.className = "Filter";
    button.title = this.table.labels.FilterOnThisValue.textContent;
    button.addEventListener("click", (event) => { this.filter(mode, value); });

    return button;
  }

  determineFilterMode() {
    let result = null;
    const column = this.cell.dataset.Column;

    if (column !== undefined) {
      for (const row of this.table.getFilterRows()) {
        for (const filterCell of row.cells) {
          if (filterCell.dataset.Identifier === column && filterCell.dataset.FilterMode !== undefined)
            result = filterCell.dataset.FilterMode;
        }
      }
    }

    return result;
  }

  copy(value) {
    this.close();

    navigator.clipboard.writeText(value)
      .then(() => { application.toastBox.addMessage(new ToastMessage(this.table.labels.ValueCopiedSuccessfully, "Success")); })
      .catch((error) => { application.toastBox.addMessage(new ToastMessage(this.table.labels.FailedToCopyValue, "Error")); });
  }

  filter(mode, value) {
    this.close();
    this.table.filterColumn(this.cell.dataset.Column, mode, value);
  }
}

interactivityRegistration.register("Table", function (element) { return new Table(element); });
interactivityRegistration.register("grouping", function (element) { return new GroupingTable(element); });
interactivityRegistration.register("Master", function (element) { return new MasterTableRow(element); });


// ---------- File: WebSite.Page.Component.Table.Row.ts ----------
// @ts-nocheck
export class TableRow {
  constructor(element, table) {
    this.element = element;
    this.element.tabIndex = "0";
    this.element.tableRow = this;
    this.table = table;

    this.checkBoxField = null;
    this.checkBox = null;
    this.quickActions = null;

    this.determineElements();
    this.attachHandlers();
  }

  isSelectable() {
    return this.rowSelectorCell !== null;
  }

  select(selectRange) {
    if (selectRange && this.table.lastSelected !== null)
      this.table.selectRange(Math.min(this.table.lastSelected, this.element.sectionRowIndex), Math.max(this.table.lastSelected, this.element.sectionRowIndex), true);
    else {
      this.table.selectRange(this.element.sectionRowIndex, this.element.sectionRowIndex, !this.selected);

      if (this.selected)
        this.table.lastSelected = this.element.sectionRowIndex;
    }

    this.table.fireSelectionChangedEvent();
  }

  determineElements() {
    this.rowSelectorCell = new DomQuery(this.element).getChild(WithClass("rowSelector"));

    if (this.rowSelectorCell !== null) {
      this.checkBoxField = new DomQuery(this.rowSelectorCell).getChild(WithClass("CheckBoxField"));

      if (this.checkBoxField !== null)
        this.checkBox = this.checkBoxField.childNodes[0];
    }

    const quickActions = new DomQuery(this.element).getDescendant(WithClass("QuickActions"));

    if (quickActions !== null)
      this.quickActions = new QuickActions(quickActions, this.element);
  }

  attachHandlers() {
    this.addKeyEventHandlers();

    if (this.quickActions !== null)
      this.addQuickActionEventHandlers();

    if (this.table.rowSelectorEnabled)
      this.addRowSelectorEventHandlers();
  }

  addKeyEventHandlers() {
    this.element.addEventListener(
      "keydown",
      (event) => {
        if (event.target === this.element) {
          if (event.code === "ArrowUp") {
            if (this.element.previousSibling !== null)
              this.element.previousSibling.focus();

            event.stopHandling();
          }
          else if (event.code === "ArrowDown") {
            if (this.element.nextSibling !== null)
              this.element.nextSibling.focus();

            event.stopHandling();
          }
          else if (this.isSelectable() && event.code === "Space") {
            this.select(event.shiftKey);
            event.stopHandling();
          }
          else if (this.uri !== null && event.code === "Enter") {
            if (this.uri !== null)
              this.element.click();
          }
          else if (this.table.selectAll !== null && event.code === "KeyA" && event.ctrlKey) {
            this.table.selectAllRows(!event.shiftKey);
            this.table.fireSelectionChangedEvent();

            event.stopHandling();
          }
          else if (event.code === "Home") {
            this.element.parentNode.childNodes[0].focus();
            event.stopHandling();
          }
          else if (event.code === "End") {
            this.element.parentNode.childNodes[this.element.parentNode.childNodes.length - 1].focus();
            event.stopHandling();
          }
        }
      }
    );
  }

  addQuickActionEventHandlers() {
    for (const action of this.quickActions.actions) {
      action.addEventListener(
        "click",
        (event) => {
          event.stopPropagation();
          this.table.selectAllRows(false);
          this.selected = true;
          this.table.selectRow(this.checkBox);

          const actionComponent = this.table.getDescendant((component) => {
            return (component instanceof ObjectAction) && component.name === action.dataset.Name;
          });

          if (actionComponent.requiresConfirmation || actionComponent.requiresConfirmationWindow)
            this.table.fireSelectionChangedEvent();

          actionComponent.open();
        }
      );
    }
  }

  addRowSelectorEventHandlers() {
    if (this.checkBox !== null) {
      if (this.selected)
        this.table.selectRow(this.checkBox);

      this.checkBox.addEventListener(
        "change",
        (event) => {
          this.table.selectRow(this.checkBox);

          if (this.selected)
            this.table.lastSelected = this.element.sectionRowIndex;

          this.table.fireSelectionChangedEvent();
        }
      );

      this.checkBoxField.addEventListener(
        "click",
        (event) => {
          this.select(event.shiftKey);
          this.element.focus();

          event.stopPropagation();
          event.preventDefault();
        }
      );

      this.rowSelectorCell.addEventListener(
        "click",
        (event) => {
          event.stopPropagation();
        }
      );

      this.rowSelectorCell.addEventListener(
        "mousedown",
        (event) => {
          if (event.shiftKey)
            event.preventDefault();
        }
      );
    }
  }

  get uri() {
    return this.element.dataset.Uri ?? null;
  }

  get selected() {
    return this.checkBox !== null && this.checkBox.checked;
  }

  set selected(value) {
    this.checkBox.checked = value;
  }
}


// ---------- File: WebSite.Page.Component.TableOfContents.ts ----------
// @ts-nocheck
export class TableOfContents extends WebPageComponent {
  constructor(element) {
    super(element);

    this.items = new Array();

    this.target = document.querySelector("main");
    this.viewPort = this.element.childNodes[1];

    this.determineElements();
    this.attachHandlers();
    this.handleScroll();
  }

  attachHandlers() {
    this.target.addEventListener(
      "scroll",
      (event) => {
        this.handleScroll();
      }
    );
  }

  determineElements() {
    this.nodes = new DomQuery(this.element).getDescendants(WithTagName("LI"));
    const items = new DomQuery(this.element).getDescendants(WithTagName("A"));

    for (const item of items)
      this.items.push(new TableOfContentsItem(item.parentElement.parentElement, item, this.target));

    this.items.sort(function (left, right) {
      if (left.reference.offsetTop > right.reference.offsetTop)
        return -1
      else if (left.reference.offsetTop < right.reference.offsetTop)
        return 1
      else
        return 0;
    })
  }

  handleScroll() {
    let result = false;
    let active = null;

    for (const item of this.items) {
      if (item.isActive() && !result) {
        result = true;
        item.element.classList.add("Active");

        active = item;
      }
      else
        item.element.classList.remove("Active");
    }

    if (active !== null) {
      if (active.item.offsetTop < this.viewPort.scrollTop || active.item.offsetTop + active.item.offsetHeight > this.viewPort.scrollTop + this.viewPort.offsetHeight)
        this.viewPort.scrollTop = active.item.offsetTop;
    }
  }
}

export class TableOfContentsItem extends WebPageComponent {
  constructor(element, item, target) {
    super(element);

    this.item = item;
    this.target = target;
    this.reference = document.getElementById(decodeURIComponent(this.item.getAttribute("href").substring(1)));
  }

  isActive() {
    return (this.reference !== null) && (this.target.scrollTop >= this.reference.offsetTop);
  }
}

interactivityRegistration.register("TableOfContents", function (element) { return new TableOfContents(element); });


// ---------- File: WebSite.Page.Component.Toolbar.ts ----------
// @ts-nocheck
var ToolbarState = new Enumeration(["None", "Warning", "Error", "Submitted"]);

export class Toolbar extends WebPageComponent {
  constructor(element, parentComponent) {
    super(element);

    this.parentComponent = parentComponent;
    this.state = ToolbarState.None;

    this.warning = new HtmlClassSwitch(this.element, "Warning");
    this.successful = new HtmlClassSwitch(this.element, "Successful");
    this.error = new HtmlClassSwitch(this.element, "Error");

    this.determineElements();
    this.attachHandlers();

    this.element.component = this;
  }

  attachHandlers() {
    connectClickOutsideListener(
      this.element,
      () => { this.successful.setStatus(false); }
    );

    if (this.actionForm !== null)
      this.actionForm.onsubmit = (event) => { return false; };

    for (const group of this.groups)
      new ActionGroup(group);

    this.publishClientActions();
  }

  publishClientActions() {
    this.renderPublishedActions(this.parentComponent.collectPublishedActions());
  }

  renderPublishedActions(actions) {
    if (this.publishedActions !== null) {
      while (this.publishedActions.firstChild !== null)
        this.publishedActions.removeChild(this.publishedActions.firstChild);

      for (const action of actions)
        this.publishedActions.appendChild(this.createPublishedActionButton(action));
    }
  }

  createPublishedActionButton(action) {
    const objectAction = document.createElement("span");
    objectAction.classList.add("ObjectAction", "Secondary");
    objectAction.dataset.Name = action.name;

    const caption = document.createElement("button");
    caption.classList.add("Caption");
    caption.title = action.caption;
    caption.type = "button";

    const icon = document.createElement("span");
    icon.classList.add("Icon");

    caption.appendChild(icon);

    const name = document.createElement("span");
    name.classList.add("Name");
    name.textContent = action.caption;

    caption.appendChild(name);

    caption.addEventListener(
      "click",
      async () => {
        const updatingCounter = this.parentComponent.updatingCounter;
        caption.disabled = true;

        if (updatingCounter !== null)
          updatingCounter.increase();

        try {
          await action.execute(action.items);
        }
        finally {
          caption.disabled = false;

          if (updatingCounter !== null)
            updatingCounter.decrease();

          this.publishClientActions();
        }
      }
    );

    objectAction.appendChild(caption);
    return objectAction;
  }

  createKeyHandler() {
    return (event) => {
      if (event.code === "ArrowLeft") {
        this.focus(this.focusedItemIndex - 1);

        event.stopPropagation();
        event.preventDefault();
      }
      else if (event.code === "ArrowRight") {
        this.focus(this.focusedItemIndex + 1);

        event.stopPropagation();
        event.preventDefault();
      }
      else if (event.code === "Home") {
        this.focus(0);

        event.stopPropagation();
        event.preventDefault();
      }
      else if (event.code === "End") {
        this.focus(this.buttons.length - 1);

        event.stopPropagation();
        event.preventDefault();
      }
    }
  }

  determineElements() {
    let query = new DomQuery(this.element);

    this.groups = query.getDescendants(WithClass("ActionGroup"));
    this.iconBar = query.getChild(WithClass("IconBar"));
    this.actionForm = query.getChild(WithClass("ActionForm"));
    this.actionBar = query.getChild(WithClass("ActionBar"));
    this.actionFeedback = query.getDescendant(WithClass("ActionFeedback"));

    query = new DomQuery(this.actionBar)
    this.menu = query.getChild(WithClass("Menu"));
    this.publishedActions = query.getChild(WithClass("PublishedActions"));
    this.objectActions = query.getDescendants(WithClass("ObjectAction"));

    this.form = new DomQuery(this.actionForm).getChild(WithTagName("FORM"));

    this.initializeButtons();

    if (this.menu)
      this.initializeMenu();
  }

  focus(index) {
    if (index >= 0 && index < this.buttons.length) {
      this.buttons[this.focusedItemIndex].tabIndex = -1;
      this.buttons[index].tabIndex = 0;
      this.buttons[index].focus();

      this.focusedItemIndex = index;
    }
  }

  handleAction(action) {
    const objectAction = this.objectActions.find(element => element.dataset.Name === action);

    if (objectAction !== undefined)
      objectAction.component.open();
    else
      this.parentComponent.sendCommandRequest("<Action Name=\"" + action + "\"/>");
  }

  handleEvent(event) {
    if (event instanceof MenuActionEvent) {
      this.handleAction(event.action);
      event.handled = true;
    }
    else
      super.handleEvent(event);
  }

  hasActionEnabled() {
    return this.objectActions.some((action) => { return action.classList.contains("Active"); });
  }

  initializeButtons() {
    this.buttons = new Array();
    const buttons = new DomQuery(this.iconBar).getDescendants((element) => { return element.tagName === "BUTTON" & !element.disabled; });

    for (const button of buttons)
      this.buttons.push(button);

    for (const button of this.buttons) {
      button.tabIndex = -1;
      button.addEventListener("keydown", this.createKeyHandler());
    }

    if (this.buttons.length > 0)
      this.buttons[0].tabIndex = 0;

    this.focusedItemIndex = 0;
  }

  initializeMenu() {
    const query = new DomQuery(this.menu);
    const menuActions = query.getDescendants(WithClass("MenuOnly"));

    if (menuActions.length === 0)
      this.menu.classList.add("Empty");
  }

  replace(toolbar, persistForm) {
    interactivityRegistration.detach(this.iconBar);
    interactivityRegistration.detach(this.actionBar);
    interactivityRegistration.detach(this.actionFeedback);

    const query = new DomQuery(toolbar);
    const iconBar = query.getChild(WithClass("IconBar"));
    const actionBar = query.getChild(WithClass("ActionBar"));
    const actionForm = query.getChild(WithClass("ActionForm"));
    const actionFeedback = query.getChild(WithClass("ActionFeedback"));
    const form = new DomQuery(actionForm).getChild(WithTagName("FORM"));

    this.element.replaceChild(iconBar, this.iconBar);
    this.element.replaceChild(actionBar, this.actionBar);
    this.element.replaceChild(actionFeedback, this.actionFeedback);

    const replaceForm = !persistForm || this.form === null || form === null || this.form.id !== form.id;

    if (replaceForm) {
      interactivityRegistration.detach(this.actionForm)
      this.element.replaceChild(actionForm, this.actionForm);
    }

    this.updateState();
    this.determineElements();
    this.attachHandlers();

    if (replaceForm)
      interactivityRegistration.attach(this.actionForm);

    interactivityRegistration.attach(this.iconBar);
    interactivityRegistration.attach(this.actionBar);
    interactivityRegistration.attach(this.actionFeedback);
  }

  updateState() {
    this.successful.setStatus(this.state === ToolbarState.Submitted);
    this.warning.setStatus(this.state === ToolbarState.Warning);
    this.error.setStatus(this.state === ToolbarState.Error);

    this.state = ToolbarState.None;
  }
}


// ---------- File: WebSite.Page.Component.UploadArea.ts ----------
// @ts-nocheck
export class FileUploadedEvent {
  constructor(target, data) {
    this.target = target;
    this.data = data;
  }
}

function UploadRow(element, file) {
  this.build = function () {
    this.fileNameCell = this.element.appendChild(document.createElement("td"));
    this.fileNameCell.className = "FileName";
    this.fileNameCell.innerHTML = this.file.name;

    this.progressBar = new ProgressBar(1);
    this.progressBarCell = this.element.appendChild(document.createElement("td"));
    this.progressBarCell.appendChild(this.progressBar.element);

    this.actionCell = this.element.appendChild(document.createElement("td"));
  }

  this.cancel = function () {
    this.aborted = true;
    this.button.disabled = true;
    this.button.innerHTML = "Cancelled";
    this.element.classList.add("Cancelled");
  }

  this.createCancelButton = function (cancel) {
    this.button = document.createElement("button");
    this.button.innerHTML = "Cancel";
    this.button.className = "button";
    this.button.addEventListener(
      "click",
      (event) => {
        this.cancel();
        return false;
      }
    );

    this.actionCell.appendChild(this.button);
  }

  this.setProgress = function (progress, phase) {
    this.progressBar.setProgress(progress, phase);
  }

  this.element = element;
  this.file = file;

  this.aborted = false;
  this.build();
}

export class UploadArea extends FileDropZone {
  constructor(element) {
    super(element);

    this.build();
    this.initialize();
  }

  buildToolbar() {
    this.labels = new Labels(new DomQuery(this.element).getChild(WithClass("Labels")));

    const file = document.createElement("input");
    file.type = "file";

    const label = document.createElement("label");
    label.appendChild(file);
    label.appendChild(this.labels.Browse);

    const toolbar = document.createElement("div");
    toolbar.classList.add("Toolbar");
    toolbar.appendChild(this.labels.Upload);
    toolbar.appendChild(label);

    return toolbar;
  }

  build() {
    this.decoratedComponent = this.element.firstChild.component;
    this.name = this.decoratedComponent.name;

    const decoratedElement = this.element.firstChild;

    this.toolbar = this.buildToolbar();
    this.element.prepend(this.toolbar);

    this.fileInput = new DomQuery(this.toolbar).getDescendant(WithTagName("INPUT"));
    this.fileInput.multiple = true;
    this.fileInput.accept = this.element.dataset.Accept;
    this.fileInput.addEventListener(
      "input",
      (event) => {
        this.handleFiles(this.fileInput.files);
      }
    );

    this.uploadImage = this.element.insertBefore(document.createElement("div"), decoratedElement);
    this.uploadImage.className = "UploadImage";

    this.progressArea = this.element.insertBefore(document.createElement("div"), decoratedElement);
    this.progressArea.className = "ProgressArea";

    this.messages = this.element.insertBefore(document.createElement("ul"), decoratedElement);

    this.hidden = new HtmlClassSwitch(this.progressArea, "Hidden");
    this.hidden.setStatus(true);

    this.progressTable = this.progressArea.appendChild(document.createElement("table"));
    this.progressTable.className = "data";
    this.progressTable.appendChild(this.createTableHeaderRow());
  }

  save() {
    return this.decoratedComponent.save();
  }

  load(value) {
    this.decoratedComponent.load(value);
  }

  async createFile(file, uploadRow, callback) {
    const formData = new FormData();
    formData.append("FileName", file.name);
    formData.append("FileSize", file.size);

    const response = await fetch(
      this.URI,
      {
        method: "POST",
        body: formData
      }
    );

    if (response.ok && response.headers.get("content-type") === "application/json") {
      const body = await response.json();
      uploadRow.location = body.Target;

      this.processFile(file, uploadRow, callback);
    }
  }

  createFinalCallbackFunction(uploadRow, callback) {
    return () => {
      this.decoratedComponent.refresh();
      this.fireDataChanged();

      if (!uploadRow.aborted) {
        uploadRow.button.disabled = true;
        uploadRow.button.innerHTML = "Finished";
        uploadRow.element.classList.add("Finished");
      }

      if (callback !== null)
        callback();
    };
  }

  createProcessFileFunction(file, uploadRow, callback) {
    return () => {
      this.createFile(file, uploadRow, callback);
    };
  }

  createProcessFilePartFunction(part, uploadRow, callback) {
    return () => {
      this.processFilePart(part, uploadRow, callback);
    };
  }

  createTableHeaderRow() {
    const row = document.createElement("tr");

    const fileNameHeader = row.appendChild(document.createElement("th"));
    fileNameHeader.innerHTML = "File";

    const progressBarHeader = row.appendChild(document.createElement("th"));
    progressBarHeader.innerHTML = "Progress";

    const cancelButtonHeader = row.appendChild(document.createElement("th"));
    cancelButtonHeader.innerHTML = "Action";

    return row;
  }

  createUploadRow(file) {
    const element = this.progressTable.appendChild(document.createElement("tr"));
    element.className = "UploadRow";

    return new UploadRow(element, file);
  }

  handleEvent(event) {
    if (event instanceof FileUploadStatusChangedEvent && event.upload.target === this.URI && event.upload.state === FileUploadState.Submitted) {
      this.decoratedComponent.refresh();
      this.fireDataChanged();
    }
  }

  handleFiles(files) {
    if (this.shouldHandlePartitioned(files) || !('serviceWorker' in navigator))
      this.processFiles(files);
    else
      this.registerFiles(files);
  }

  shouldHandlePartitioned(files) {
    let result = this.allowPartitioning;

    if (result) {
      let index = 0;

      while (!result && index < files.length) {
        result = files[index].size > this.partSize;
        index++;
      }
    }

    return result;
  }

  initialize() {
    this.URI = this.element.dataset.Uri;
    this.maximumSize = parseInt(this.element.dataset.MaximumSize);
    this.allowPartitioning = this.element.dataset.AllowPartition === "true";

    if (this.allowPartitioning)
      this.partSize = parseInt(this.element.dataset.PartSize);
    else
      this.partSize = this.maximumSize;

    this.initializeDropZone();
  }

  async processFilePart(part, uploadRow, callback) {
    if (!uploadRow.aborted) {
      const formData = new FormData();
      formData.append("FileName", part.name);
      formData.append("Index", part.index);
      formData.append("Contents", part.blob);

      try {
        const response = await fetch(
          uploadRow.location,
          {
            method: "POST",
            body: formData
          }
        );

        if (response.ok) {
          const progress = (part.offset + part.blob.size) / uploadRow.file.size;
          uploadRow.setProgress([progress * 100], 0);
        }
      }
      finally {
        if (callback !== null)
          callback();
      }
    }
    else if (callback !== null)
      callback();
  }

  processFile(file, uploadRow, callback) {
    const reader = new FileReader();

    reader.onload = (event) => {
      const bytes = new Uint8Array(event.target.result);

      uploadRow.createCancelButton();

      const parts = new Array();
      let offset = 0;
      let remainder = file.size;

      while (remainder > 0) {
        const partSize = Math.min(remainder, this.partSize);
        parts.push({ "offset": offset, "size": partSize });

        offset += partSize;
        remainder = file.size - offset;
      }

      let callback_ = this.createFinalCallbackFunction(uploadRow, callback);

      for (let index = parts.length - 1; index >= 0; index--) {
        const part = parts[index];
        part.blob = new Blob([bytes.subarray(part.offset, part.offset + part.size)]);
        part.name = file.name;
        part.index = index;

        callback_ = this.createProcessFilePartFunction(part, uploadRow, callback_);
      }

      if (callback_ !== null)
        callback_();
    };

    reader.readAsArrayBuffer(file);
  }

  registerFile(file) {
    return new Promise((resolve, reject) => {
      if (!this.validateFile(file, this.element.dataset.Accept)) {
        application.fileStore.add({
          target: this.URI,
          name: file.name,
          contents: null,
          size: file.size,
          state: FileUploadState.Forbidden,
          attempts: 0,
          progress: 0,
          problems: [
            {
              Message: "Unsupported file type",
              Severity: "Error"
            }
          ],
          location: null,
          uuid: null
        });

        resolve();
      }
      else if (file.size > this.maximumSize) {
        application.fileStore.add({
          target: this.URI,
          name: file.name,
          contents: null,
          size: file.size,
          state: FileUploadState.Forbidden,
          attempts: 0,
          progress: 0,
          problems: [
            {
              Message: "Cannot upload file. File size over " + this.maximumSize / (1000 * 1000) + "MB",
              Severity: "Error"
            }
          ],
          location: null
        });

        resolve();
      }
      else {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const fileData = {
            target: this.URI,
            name: file.name,
            contents: new Uint8Array(event.target.result),
            size: file.size,
            state: FileUploadState.Initial,
            attempts: 0,
            progress: 0,
            problems: [],
            location: null
          };

          await application.fileStore.add(fileData);

          const renderer = new ThumbnailRenderer();
          const thumbnail = await renderer.renderThumbnail(fileData);

          distributeEventDownHierarchy(
            new FileUploadedEvent(
              this,
              await application.pageHandler.persistThumbnail(fileData, thumbnail)
            ),
            this
          );

          resolve();
        };
        reader.onerror = (event) => {
          resolve();
        };
        reader.onabort = (event) => {
          resolve();
        };

        reader.readAsArrayBuffer(file);
      }
    });
  }

  registerFiles(files) {
    let task = new Promise(
      (resolve, reject) => {
        this.fileInput.disabled = true;
        resolve();
      }
    );

    for (const file of files)
      task = task.then(() => this.registerFile(file));

    task = task.then(() => {
      this.fileInput.value = null;
      this.fileInput.disabled = false;
    });
  }

  processFiles(files) {
    const uploadRows = new Array();

    for (let i = 0; i < files.length; i++)
      uploadRows.push(this.createUploadRow(files[i]));

    const listener = (event) => {
      event.preventDefault();
      return event.returnValue = "Are you sure you want to exit?";
    };

    window.addEventListener("beforeunload", listener);
    let callback = () => { window.removeEventListener("beforeunload", listener); };

    for (let index = files.length - 1; index >= 0; index--) {
      const file = files[index];
      const uploadRow = uploadRows[index];

      if (!this.validateFile(file, this.element.dataset.Accept))
        uploadRow.progressBarCell.innerHTML = "Unsupported file type";
      else if (file.size > this.maximumSize)
        uploadRow.progressBarCell.innerHTML = "Cannot upload file. File size over " + this.maximumSize / (1000 * 1000) + "MB";
      else
        callback = this.createProcessFileFunction(file, uploadRow, callback);
    }

    if (callback !== null)
      callback();
  }
}

interactivityRegistration.register("UploadArea", function (element) { return new UploadArea(element); });


// ---------- File: WebSite.Search.ts ----------
// @ts-nocheck
export class SearchComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.uri = this.element.dataset.Uri;
    this.active = new HtmlClassSwitch(this.element, "Active");
    this.input = new DomQuery(this.element).getDescendant(WithClass("Field")).component;
    this.results = new DomQuery(this.element).getDescendant(WithTagName("UL"));
    this.labels = new Labels(new DomQuery(this.element).getDescendant(WithClass("Labels")));
    this.searchTimer = new Timer(400);
    this.searchResults = new Array();
    this.abortController = null;

    this.loadingCount = 0;
    this.loading = new HtmlClassSwitch(this.element, "Loading");

    this.closeButton = new DomQuery(this.element).getDescendant(WithClass('Close'));

    if (this.closeButton !== null)
      this.closeButton.addEventListener(
        "click",
        (event) => {
          this.close();
        }
      );

    this.loadingIndicator = new LoadingIndicator();
    this.element.childNodes[0].appendChild(this.loadingIndicator.element);

    window.addEventListener(
      "keydown",
      (event) => {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA" && !this.active.getStatus() && event.key === "/") {
          this.open();

          event.preventDefault();
          event.stopPropagation();
        }
      }
    );

    this.element.addEventListener(
      "keydown",
      (event) => {
        if (this.active.getStatus() && event.key === "Escape") {
          this.close();

          event.preventDefault();
          event.stopPropagation();
        }
      }
    );

    this.input.addEventListener(
      "keydown",
      (event) => {
        if (event.key === "ArrowDown" && this.results.childNodes.length > 0) {
          this.focusFirstResult();
          event.preventDefault();
        }
      }
    );

    this.input.addEventListener(
      "input",
      (event) => {
        this.scheduleSearchOperation();
      }
    );
  }

  scheduleSearchOperation() {
    this.searchTimer.kill();
    this.searchTimer.schedule(
      () => {
        this.search(this.input.getValue());
      }
    )
  }

  clear() {
    this.results.innerHTML = "";
    this.searchResults = new Array();
  }

  close() {
    this.input.input.blur();
    this.active.setStatus(false);
    removeClickOutsideListener(this.clickOutsideListener);
  }

  open() {
    this.active.setStatus(true);

    if (this.input.getValue().length === 0)
      this.prepare();

    this.input.focus();
    this.input.input.select();

    this.clickOutsideListener = connectClickOutsideListener(
      this.element.childNodes[0],
      () => {
        this.close();
      }
    );
  }

  prepare() {
    this.clear();
    this.enterSearch();

    application.entityStore.getAll()
      .then((data) => {
        const available = data.filter(element => element.Current !== null);
        this.renderResults("", available);
      })
      .finally(() => {
        this.leaveSearch();
      });
  }

  renderResults(query, results) {
    const groups = new Map();

    for (const result of results) {
      if (!this.searchResults.includes(result.Uri)) {
        if (!groups.has(result.Category)) {
          groups.set(result.Category, new Array());
        }

        const target = groups.get(result.Category);
        target.push(result);
        this.searchResults.push(result.Uri);
      }
    }

    for (const [name, group] of groups) {
      const regularExpression = query.length > 0 ? new RegExp(query, "gi") : null;

      const groupTitle = document.createElement("span");
      groupTitle.classList.add("Title");
      groupTitle.innerHTML = `${name} (${group.length})`

      const groupResults = document.createElement("ul");

      const groupElement = document.createElement("li");
      groupElement.classList.add("Group");
      groupElement.classList.add(group[0].Type);
      groupElement.appendChild(groupTitle);
      groupElement.appendChild(groupResults);

      this.results.appendChild(groupElement);

      for (const result of group) {
        const title = document.createElement("span");
        title.classList.add("Title");
        title.innerHTML = regularExpression ? result.Title.replace(regularExpression, "<strong>$&</strong>") : result.Title;

        let details = null;

        if (result.Details.length > 0) {
          details = document.createElement("span");
          details.classList.add("Details");
          details.innerHTML = regularExpression ? result.Details.replace(regularExpression, "<strong>$&</strong>") : result.Details;
        }

        const uri = document.createElement("span");
        uri.classList.add("Uri");
        uri.innerText = new URL(result.Uri).pathname;

        const resultElement = document.createElement("span");
        resultElement.appendChild(title);

        if (details !== null)
          resultElement.appendChild(details);

        resultElement.appendChild(uri);

        if (result.Class)
          resultElement.classList.add(result.Class);

        const link = document.createElement("a");
        link.appendChild(resultElement);
        link.href = result.Uri;

        link.addEventListener(
          "click",
          (event) => {
            this.close();
          }
        );

        const item = document.createElement("li");
        item.classList.add("Result");
        item.appendChild(link);
        item.tabIndex = "0";

        if (result.State) {
          item.classList.add(SynchronizationState.toText(result.State));

          const actions = document.createElement("span");
          actions.classList.add("Actions");

          const component = new ConfirmationWindowComponent(
            this.labels.DeleteConfirmationMessage,
            this.labels.Confirm,
            this.labels.Cancel,
            () => {
              this.delete(result.Uri);
              this.search(query);
            },
            ConfirmationClass.Delete,
            this.element.childNodes[0]
          );

          const deleteButton = document.createElement("button");
          deleteButton.classList.add("Delete");
          deleteButton.addEventListener(
            "click",
            (event) => {
              component.show();

              event.stopPropagation();
              event.preventDefault();
            }
          );

          actions.appendChild(deleteButton);
          resultElement.appendChild(actions);
        }

        groupResults.appendChild(item);

        item.addEventListener(
          "keydown",
          (event) => {
            if (event.key === "ArrowUp") {
              this.focusPreviousResult(item);
              event.preventDefault();
            }
            else if (event.key === "ArrowDown") {
              this.focusNextResult(item);
              event.preventDefault();
            }
            else if (event.key === "Enter") {
              item.firstChild.click();
              event.preventDefault();
            }
          }
        );
      }
    }
  }

  async delete(url) {
    await application.entityStore.delete(url);
  }

  focusFirstResult() {
    const results = new DomQuery(this.results).getDescendants(WithClass("Result"));
    results[0].focus();
  }

  focusPreviousResult(item) {
    const results = new DomQuery(this.results).getDescendants(WithClass("Result"));
    const index = results.indexOf(item);

    if (index > 0) {
      results[index - 1].focus();
    }
  }

  focusNextResult(item) {
    const results = new DomQuery(this.results).getDescendants(WithClass("Result"));
    const index = results.indexOf(item);

    if (index < results.length - 1) {
      results[index + 1].focus();
    }
  }

  enterSearch() {
    this.loadingCount++;

    if (this.loadingCount === 1) {
      this.loading.setStatus(true);
      this.loadingIndicator.setStatus(true);
    }
  }

  leaveSearch() {
    this.loadingCount--;

    if (this.loadingCount === 0) {
      this.loading.setStatus(false);
      this.loadingIndicator.setStatus(false);
    }
  }

  search(query) {
    if (this.abortController)
      this.abortController.abort();

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.clear();

    application.entityStore.getAll()
      .then((data) => {
        const match = data.filter(
          element =>
            element.Current !== null
            && (
              element.Title.toLowerCase().includes(query.toLowerCase())
              || element.Details.toLowerCase().includes(query.toLowerCase())
            )
        );

        this.renderResults(query, match);
      });

    if (query.length > 2) {
      this.enterSearch();

      fetch(
        this.uri,
        {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            Query: query
          }),
          signal
        }
      )
        .then(response => response.json())
        .then(data => {
          this.renderResults(query, data);
        })
        .catch(error => { })
        .finally(() => {
          this.leaveSearch();
        });
    }
  }
}

interactivityRegistration.register("SearchComponent", function (element) { return new SearchComponent(element); });


// ---------- File: WebSite.Toolbar.ts ----------
// @ts-nocheck
export class WebSiteToolbar extends WebPageComponent {
  constructor(element) {
    super(element);

    this.expanded = new HtmlClassSwitch(this.element, "Expanded");

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    this.toggle.addEventListener(
      "click",
      (event) => {
        this.expanded.toggle();
      }
    );
  }

  bind() {
    if (this.searchButton !== null) {
      const searchComponent = new DomQuery(document.documentElement).getDescendant(WithClass("SearchComponent"));

      this.searchButton.addEventListener(
        "click",
        (event) => {
          searchComponent.component.open();
        }
      );
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.toggle = query.getChild(WithClass("Toggle"));
    this.searchButton = new DomQuery(this.element).getDescendant(WithClass("SearchButton"));

    const userMenu = query.getDescendant(WithClass("User"));

    if (userMenu)
      this.userMenu = new UserBox(userMenu);
  }
}

export class UserBox extends WebPageComponent {
  constructor(element) {
    super(element);

    this.user = new DomQuery(this.element).getDescendant(WithClass("User"));
    this.determineUser();
  }

  async determineUser() {
    try {
      const response = await fetch(
        application.resolve("SignIn/Status"),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      const data = await response.json();

      if (data.SignedIn)
        application.store.set("User", data.User);
      else
        application.store.delete("User");
    }
    catch (error) {
      const user = await application.store.get("User");

      if (user)
        this.user.innerText = user;
    }
  }
}

interactivityRegistration.register(
  "WebSiteToolbar",
  (element) => {
    return new WebSiteToolbar(element, true);
  }
);


// ---------- File: ContentManagement.Message.ts ----------
// @ts-nocheck
function Message(element) {
  this.determineChildren = function () {
    var messageElements = new DomQuery(new DomQuery(this.element).getChild(WithClass("Messages"))).getChildren(WithClass("Message"));

    for (var index = 0; index < messageElements.length; index++)
      this.children.push(new Message(messageElements[index]));
  }

  this.getLastMessage = function () {
    if (this.children.length > 0)
      return this.children[this.children.length - 1].getLastMessage();
    else
      return this;
  }

  this.getMessageWithId = function (id) {
    if (this.id === id)
      return this;
    else {
      var result = null;
      var index = 0;

      while (result === null && index < this.children.length) {
        result = this.children[index].getMessageWithId(id);
        index++;
      }

      return result;
    }
  }

  this.getMessageList = function () {
    var messages = new Array();

    for (var index = 0; index < this.children.length; index++) {
      var message = this.children[index];
      messages.push(message);
      messages = messages.concat(message.getMessageList());
    }

    return messages;
  }

  this.attachClickHandlers = function () {
    var object = this;

    this.contentsElement.onclick = function (event) {
      object.selected.toggle();

      if (object.listener !== null)
        object.listener(object);
    }
  }

  this.element = element;
  this.id = element.dataset.Id;
  this.children = new Array();

  this.determineChildren();
  this.contentsElement = new DomQuery(this.element).getChild(WithClass("Contents"));
  this.selected = new HtmlClassSwitch(this.element, "Selected");
  this.attachClickHandlers();
}

export class MessageThreadAddMessage extends XmlMessage {
  constructor(target, content) {
    super();

    this.target = target;
    this.content = content;
  }

  toXml() {
    return "<Add Target=\"" + escapeXMLAttributeValue(this.target) + "\">" + escapeXMLCharacterData(this.content) + "</Add>";
  }
}

export class MessageThreadDeleteMessages extends XmlMessage {
  constructor() {
    super();

    this.ids = new Array();
  }

  toXml() {
    let result = "<Delete>";

    for (let index = 0; index < this.ids.length; index++)
      result += "<Message Id=\"" + this.ids[index] + "\"/>";

    result += "</Delete>";
    return result;
  }

  add(id) {
    this.ids.push(id);
  }
}

export class MessageThreadRenderMessage extends XmlMessage {
  constructor(content) {
    super();

    this.content = content;
  }

  toXml() {
    return "<Render/>";
  }
}

export class MessageThread extends WebPageComponent {
  constructor(element) {
    super(element);

    this.id = element.dataset.Id;
    this.uri = element.dataset.Uri;
    this.inputArea = null;
    this.inputButton = null;
    this.requestQueue = new RequestQueue(this);
    this.messages = new Array();
    this.progressSwitch = new HtmlClassSwitch(this.element, "InProgress");
    this.toolbarSwitch = null;
    this.replySwitch = null;

    this.addInputArea();
    this.determineMessages();
  }

  async handleRenderResponse(response, messageId) {
    const newContents = document.createElement("div");
    newContents.innerHTML = await response.text();

    const newThreadElement = newContents.firstChild;
    this.threadElement.innerHTML = newThreadElement.innerHTML;

    this.determineMessages();
    this.addListener();
    this.messageSelectionChanged();

    this.scrollTo(this.getMessageWithId(messageId));
    this.progressSwitch.setStatus(false);
  }

  async handleAddResponse(response) {
    this.inputArea.value = "";

    const element = new DOMParser().parseFromString(await response.text(), "application/xml").documentElement;
    let messageId = null;

    if (element.tagName === "Message")
      messageId = element.getAttribute("Id");

    this.requestQueue.queue(
      this.uri,
      "POST",
      new MessageThreadRenderMessage(),
      null,
      (response) => this.handleRenderResponse(response, messageId)
    );
  }

  addMessage() {
    const content = this.inputArea.value;

    if (content !== "") {
      const selectedMessages = this.getSelectedMessages();
      let target = "";

      if (selectedMessages.length === 0)
        target = this.id;
      else if (selectedMessages.length === 1)
        target = selectedMessages[0].id;

      if (target !== "") {
        this.progressSwitch.setStatus(true);

        this.requestQueue.queue(
          this.uri,
          "POST",
          new MessageThreadAddMessage(target, content),
          null,
          (response) => this.handleAddResponse(response)
        );
      }
    }
  }

  createAddMessageHandler() {
    return (event) => {
      this.addMessage();
    };
  }

  addInputArea() {
    this.inputArea = document.createElement("textarea");

    this.inputButton = document.createElement("input");
    this.inputButton.className = "Add";
    this.inputButton.type = "button";
    this.inputButton.onclick = this.createAddMessageHandler();

    this.inputDivision = document.createElement("div");
    this.inputDivision.className = "Input";
    this.inputDivision.appendChild(this.inputArea);
    this.inputDivision.appendChild(this.inputButton);

    this.element.appendChild(this.inputDivision);
    this.replySwitch = new HtmlClassSwitch(this.inputDivision, "Reply");
  }

  determineMessages() {
    const messageElements = new DomQuery(new DomQuery(this.element).getChild(WithClass("Contents"))).getChildren(WithClass("Message"));
    this.messages = new Array();

    for (const messageElement of messageElements)
      this.messages.push(new Message(messageElement));
  }

  getLastMessage() {
    if (this.messages.length > 0)
      return this.messages[this.messages.length - 1].getLastMessage();
    else
      return null;
  }

  getMessageWithId(id) {
    let result = null;
    let index = 0;

    while (result === null && index < this.messages.length) {
      result = this.messages[index].getMessageWithId(id);
      index++;
    }

    return result;
  }

  getMessageList() {
    let messages = new Array();

    for (const message of this.messages) {
      messages.push(message);
      messages = messages.concat(message.getMessageList());
    }

    return messages;
  }

  addListener() {
    const messageList = this.getMessageList();
    const listener = this.createListener();

    for (const message of messageList)
      message.listener = listener;
  }

  scrollTo(message) {
    if (message !== null) {
      const messageContents = new DomQuery(message.element).getChild(WithClass("Contents"));
      const messageRectangle = messageContents.getBoundingClientRect();

      const threadRectangle = this.threadElement.getBoundingClientRect();
      const delta = messageRectangle.bottom - threadRectangle.top - threadRectangle.height + 14;

      this.threadElement.scrollTop += delta;
    }
  }

  handleDeleteResponse(response) {
    this.requestQueue.queue(
      this.uri,
      "POST",
      new MessageThreadRenderMessage(),
      null,
      (response) => this.handleRenderResponse(response, "") // TODO: Is this correct for MessageId?
    );
  }

  deleteMessages() {
    const message = new MessageThreadDeleteMessages();
    const selectedMessages = this.getSelectedMessages();

    for (const selected of selectedMessages)
      message.add(selected.id);

    this.progressSwitch.setStatus(true);
    this.requestQueue.queue(
      this.uri,
      "POST",
      message,
      null,
      (response) => this.handleDeleteResponse(response)
    );
  }

  bind() {
    let query = new DomQuery(this.element);

    this.toolbarElement = query.getChild(WithClass("Toolbar"));
    this.threadElement = query.getChild(WithClass("Contents"));

    query = new DomQuery(this.toolbarElement);

    this.countElement = query.getChild(WithClass("Count"));
    this.deleteAction = query.getChild(WithClass("Delete"));

    query = new DomQuery(this.deleteAction);

    this.deleteButton = query.getChild(WithTagName("INPUT"));
    this.deleteButton.addEventListener("click", (event) => { this.confirmationWindow.show(); });

    const confirmationLabels = new Labels(query.getChild(WithClass("Labels")));

    this.confirmationWindow = new ConfirmationWindowComponent(confirmationLabels.Confirmation, confirmationLabels.Confirm, confirmationLabels.Cancel, () => this.deleteMessages(), ConfirmationClass.Delete);
    this.toolbarSwitch = new HtmlClassSwitch(this.toolbarElement, "Visible");
    this.scrollTo(this.getLastMessage());

    new HtmlClassSwitch(this.threadElement, "Loaded").setStatus(true);
    this.addListener();
  }

  getSelectedMessages() {
    const messages = this.getMessageList();
    const selectedMessages = new Array();

    for (const message of messages) {
      if (message.selected.getStatus())
        selectedMessages.push(message);
    }

    return selectedMessages;
  }

  enableInput(enabled) {
    this.inputArea.disabled = !enabled;
    this.inputButton.disabled = !enabled;
  }

  messageSelectionChanged() {
    const selectedMessages = this.getSelectedMessages();

    this.toolbarSwitch.setStatus(selectedMessages.length > 0);
    this.replySwitch.setStatus(selectedMessages.length > 0);

    this.countElement.innerHTML = selectedMessages.length;
    this.enableInput(selectedMessages.length <= 1);
  }

  createListener() {
    return (message) => {
      this.messageSelectionChanged();
    };
  }

  handleError(error) {
    // TODO: Implement.
  }
}

interactivityRegistration.register("MessageThread", function (element) { return new MessageThread(element); });



